"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gestePosition = exports.gesteConsommable = exports.gestePansementCompressif = exports.gesteDamageControl = exports.gesteKitProtection = exports.gesteCeinturePelvienne = exports.gesteSectionCordon = exports.gesteGuedel = exports.gesteSmur = exports.gesteSmurVniDetails = exports.gesteSmurVni = exports.gesteSmurOxygenation = exports.gesteE = exports.gesteMatelasDepression = exports.gesteEcharpe = exports.gesteD = exports.gesteC = exports.hemorragieControleeHeure = exports.rcpParTemoin = exports.gesteB = exports.gesteSmur35v2_2_Cols = exports.gesteSmur35v2 = exports.gesteSmurKitSondes = exports.gesteSmurConditionnement = exports.gesteSmurReanimation = exports.gesteSmurRespiratoire = exports.gesteSmurIntubation = exports.inhalation = exports.gesteSmur35 = exports.gesteRespiratoireSamu = exports.exsufflationSmur = exports.ventilationNonInvasiveSmur = exports.intubationSmur = exports.gesteSmurAerosol = exports.materielDebitO2 = exports.aerosolNombre = exports.debitO2 = exports.materielO2 = exports.gesteA = exports.lvaSimple = exports.stabilisationRachis = exports.pisteSkiable = exports.bilanPompiers = exports.equipeVehicule = exports.signatureIao = exports.structureAccueil = exports.vehiculesIntervention = exports.idExporteur = exports.idRedacteursAutres = exports.idRedacteur = void 0;
exports.noFlow = exports.heureSupposeeAcrTemoin = exports.acrEtco2Max = exports.gesteAutres = exports.attelleDepression = exports.traitementLesions = exports.compressionAbdo = exports.causeSupposeeAcr = exports.anamneseHoro = exports.examenHoro = exports.hypotheseDiagHoro = exports.makeGesteExcelSyntheseEvolution = exports.gesteSyntheseEvolutionExcel = exports.gestePositionArrivee = exports.pls = exports.positionAttente = exports.gesteSettings = exports.gestePathologie = exports.gesteBilanSanguin = exports.gesteIntraOsseuseSelect = exports.makeGesteExcelVvp = exports.gesteVvpExcel = exports.gesteSondages = exports.gesteTemoin = exports.gestesEntrepris = exports.temoinAcrGestes = exports.temoinType = exports.gesteSmurMce = exports.gesteTechnique = exports._85_gesteTechnique = exports.gesteVvp = exports.gesteScope = exports.prelevementSanguin = exports.echecPose = exports.ecgEcgPrescription = exports.gesteRCP = exports.nbChocTotal = exports.gestePlancheMasser = exports.gesteACT = exports.gesteDegagementUrg = exports.gesteRetournementCollier = exports.gesteCollierCervical = exports.gesteRetournementUrgence = exports.gesteInsufflation = exports.gesteRetraitCasqueAvantSecours = exports.gesteRetraitCasque = exports.gesteMaintienTete = exports.gesteLiberationOBVA = exports.claquesDos = exports.gestePuyDuFou = void 0;
exports.categorisationV2Obj = exports.categorisationObj = exports.ficheTransport = exports.decision = exports.priorisation = exports.ticketNumMotif = exports.natureReel = exports.motifInter = exports.ticketAdressePrimo = exports.primoIntervenant = exports.equipage = exports.makeExcelEquipes = exports.equipesExcel = exports.contact = exports.representantLegal = exports.contactInfos = exports.medecinTraitant = exports.circulatoire = exports.boitesASang = exports.trc = exports.marbrures = exports.sensationDeSoif = exports.paleurs = exports.pouls = exports.detresseCirculatoire = exports.circulatoireVital = exports.controleHemorragie = exports.hemorragieDetailsObj = exports.circulatoireABCDE = exports.circulatoireNRC = exports.circonstancielSamu13 = exports.circonstanciel = exports.maladieMalaiseField = exports.adresseIntervention = exports.contexteHorsAvp = exports.atteinteCirconstanciel = exports.atteinteCirconstancielAccidents = exports.lieuIntervention = exports.circonstances = exports.securiteFields = exports.situationAutreField = exports.makeExcelTemoins = exports.temoinsExcel = exports.pathologie = exports.anamnese = exports.acr = exports._85_acr = exports.changementDEADSA = exports.heureDebutEvt = exports.lowFlow = void 0;
exports.lesionnel = exports.identiteSamu13 = exports.identite = exports.heureNaissanceObj = exports.caisseObj = exports.mutuelleObj = exports.footerPdf = exports.headerPdf = exports.drm = exports.sexe = exports.sexeObj = exports.securiteSociale = exports.secuObj = exports.victimeAdresse = exports.dateNaissance = exports.dateNaissanceObj = exports.age = exports.ageObj = exports.ageEstime = exports.ageEstimeForAgeEstimeObj = exports.ageForAgeEstimeObj = exports.nomNaissance = exports.prenomNom = exports.imc = exports.poidsTaille = exports.hypotheseDiag = exports.expositionLesionnel = exports.surfaceBrulure = exports.examen = exports.douleurThoracique = exports.devenir = exports.devenirHoraires = exports.heureRetourBase = exports.heureArriveeEpmu = exports.heureArriveeRenfortSmur = exports.heureLiberationBrancard = exports.heureFinMedicalisation = exports.heureArriveeServiceReceveur = exports.heureDepartVersCh = exports.heureDepartDesLieux = exports.heureArriveeSurLieux = exports.heureDepartVersLieux = exports.heureTransmissionInitiale = exports.heureDeclenchement = exports.devenirInfos = exports.suggestionCh = exports.modeEvacVecteur = exports.modeTransport = exports.evolutions = exports.equipeInfos = void 0;
exports.qrstPQRST = exports.tPqrst = exports.sPqrst = exports.qrPqrst = exports.pPqrst = exports.observationsSampler = exports.evenementSampler = exports.risquesSampler = exports.lunchSampler = exports.passeMedSampler = exports.medicamentSampler = exports.allergieSampler = exports.signeSampler = exports.opqrst = exports.obva = exports.obvaVoieAerienne = exports.obvaSelectObj = exports.obstetriqueWithCategory = exports.obstetrique = exports.apgarWithCategory = exports.apgar = exports.makeObstetriqueApgarExcel = exports.obstetriqueApgarExcel = exports.obstetriqueApgar = exports.obstetriqueApgarT5 = exports.obstetriqueApgarT1 = exports.accouchement = exports.fast = exports.nihss = exports.nihssScore = exports.nihssSansFast = exports.nihssMotriciteMembreFast = exports.nihssParalysieFacialeFast = exports.neurologique = exports.neurologiqueSansFast = exports.convulsionsInterval = exports.convulsionsDureeSec = exports.convulsions = exports.pupillesBilateral = exports.orientationField = exports.agitation = exports.pciDureeMinSec = exports.pciDureeSec = exports.pci = exports.neuroHeureAppDeficitFast = exports.neuroTroubleParoleFast = exports.neurologiqueFast = exports.neurologiqueVital = exports.medicaments = exports.lesionnelProtocol = void 0;
exports._85_eAbcdeGeste = exports.eAbcdeGeste = exports.dAbcdeGeste = exports.cAbcdeGeste = exports.bAbcdeGeste = exports.aAbcdeGeste = exports._85_aAbcdeGeste = exports.xAbcdeGeste = exports._85_eAbcde = exports.eAbcde = exports._85_dAbcde = exports.dAbcde = exports._85_cAbcde = exports.cAbcde = exports.bAbcde = exports.aAbcde = exports.pisu = exports.gassppe = exports.situation = exports.xAbcde = exports._85_xabcdeGeste = exports._85_xabcde = exports.hemorragie = exports.multiparam = exports.surveillances = exports.transportPedia = exports.transportPediaFlatten = exports.transportPediaVentilationControlee = exports.transportPediaConditionnementSmur = exports.transportPediaPriseEnChargeSmur = exports.transportPediaConditionnement = exports.transportPediaInitial = exports.mortInattendue = exports.mortInattendueFlatten = exports.mortInattendueEnvironnementCouchage = exports.mortInattendueEnvironnement = exports.mortInattenduePriseEnCharge = exports.mortInattendueExamenSecoursArrivee = exports.mortInattendueExamenSecoursDecouverte = exports.secoursRoutier = exports.accidentsAutre = exports.accidentField = exports.sampler = exports.mhta = exports.rcp = exports.respiration = exports.respiratoireVital = exports.respirationReguliereABCDE = exports.respirationReguliereNRC = exports.pqrst = void 0;
exports.crsDamage = exports.crsImmo = exports.crsRcp = exports.crsVni = exports.crsVenti = exports.crsVentiIntu = exports.crsVentiPreOxy = exports.crsVentiOxy = exports.crsSondage = exports.crsPositionTransport = exports.crsAbordsVascu = exports.crsMonitoring = exports.allGeste = exports.gesteEffectue = exports.gesteEffectueSansABCDE = void 0;
const utils = __importStar(require("../utils"));
const utils_1 = require("../utils");
const data_1 = require("../data");
exports.idRedacteur = [
    {
        '@type': 'text',
        key: 'ed3ffdb9-d446-4d32-a9a3-0a5a34500f7d',
        label: 'Identifiant rédacteur initial',
        value: (bilan) => bilan.intervention.author,
    },
];
exports.idRedacteursAutres = [
    {
        '@type': 'text',
        key: '7e1297e2-75ce-4b26-ae95-0cc080d8743c',
        label: 'Identifiant des autres rédacteurs',
        value: (bilan) => bilan.authors && bilan.authors.length > 1
            ? bilan.authors
                .filter(e => e.qualified_name !== bilan.intervention.author)
                .map(e => e.qualified_name)
                .join(', ')
            : null,
    },
];
exports.idExporteur = [
    {
        '@type': 'text',
        key: '87216c79-41d4-431f-832a-bb07d1c4392b',
        label: 'Identifiant exporteur',
        value: (bilan) => {
            if (bilan.author.includes('@')) {
                return bilan.author.split('(')[1].replace(')', '');
            }
            else {
                return bilan.author;
            }
        },
        webDisplay: 'none',
    },
];
/* TODO En attente du merge */
exports.vehiculesIntervention = [
/* <TemplateFieldText>{
'@type': 'text',
key: '569cddcb-b697-4d86-b49f-7fd95b950e7f',
label: 'Véhicules de la prise en charge',
value: (bilan: SyoApiBilan) => {
  if (!bilan.vehicles || bilan.vehicles.length === 0) return null;
  // const temp = uniq(bilan.vehicles.map(v => `${v.name} (${v.performer})`));
  // return temp.length === 0 ? null : temp.join(', ');
  const temp: string[] = [];
  bilan.vehicles.map(p => {
    temp.push(`${p.performer}: ${p.names.join(', ')}`);
  });
  return temp.length === 0 ? null : temp.join(' - ');
},
}, */
];
exports.structureAccueil = [
    {
        '@type': 'text',
        key: 'a8055e49-c249-4fdf-979c-9e355237071f',
        label: "Structure d'accueil",
        value: (bilan) => {
            if (bilan.devenir.hopital !== undefined && bilan.devenir.hopital !== null) {
                return `${bilan.devenir.hopital.nom.replace('Z - A SUPPRIMER', '(PLUS EN SERVICE)')} - ${bilan.devenir.hopital.ville} (${bilan.devenir.hopital.departement})`;
            }
            return null;
        },
    },
];
exports.signatureIao = [
    {
        '@type': 'text',
        key: '82814ace-2d68-482b-b1d8-a7f92d65d870',
        label: 'Signature IAO',
        value: (bilan) => bilan.equipe.signature_iao,
    },
];
exports.equipeVehicule = [
    {
        '@type': 'text',
        key: 'a24550b4-a93a-4af3-a10e-e1fcecbf6167',
        label: 'Véhicule initial',
        value: (bilan) => bilan.equipe.vehicule,
    },
];
exports.bilanPompiers = [
    {
        '@type': 'text',
        key: 'a24550b4-a93a-4af3-a10e-e1fcecbf6167',
        label: 'Bilan Pompiers',
        value: (bilan) => bilan.equipe.vehicule,
    },
];
exports.pisteSkiable = [
    {
        '@type': 'text',
        key: 'e474227a-49c8-4047-a656-f4217675e596',
        label: 'Piste skiable - Nom',
        value: (bilan) => bilan.victime?.nom_piste_skiable?.split('@#').join(', '),
    },
    {
        '@type': 'integer',
        key: '9fd28b74-be1b-45be-a1af-86466d1846be',
        label: 'Piste skiable - Balise',
        value: (bilan) => bilan.victime?.balise_piste_skiable,
    },
];
exports.stabilisationRachis = [
    {
        '@type': 'tristate',
        key: '23966f6c-942f-4715-98e1-721f270210eb',
        label: 'Stabilisation du rachis',
        value: (bilan) => bilan.geste.stabilisation_du_rachis,
    }
];
exports.lvaSimple = [
    {
        '@type': 'tristate',
        key: '56280d3b-b203-4723-9118-2246da942903',
        label: 'LVA simple',
        value: (bilan) => bilan.geste?.lva_simple,
    }
];
exports.gesteA = [
    ...exports.stabilisationRachis,
    {
        '@type': 'tristate',
        key: '3981cf0e-2734-4dd4-b222-d5cfe23e8464',
        label: 'Basculement de la tête / élévation du menton',
        value: (bilan) => bilan.geste.basculement_tete,
    },
    {
        '@type': 'tristate',
        key: '6ddf0616-d6f8-4667-996a-006e6c927414',
        label: 'LVA traumatique',
        value: (bilan) => bilan.geste.lva_traumatique,
    },
    {
        '@type': 'tristate',
        key: '255edf93-9d1c-448b-822b-0a5607216029',
        label: 'LVA non traumatique',
        value: (bilan) => bilan.geste.lva_non_traumatique,
    },
    ...exports.lvaSimple,
    {
        '@type': 'tristate',
        key: 'ea636fdb-ae24-46b5-a939-5e26758dcd7a',
        label: 'Extraction digitale',
        value: (bilan) => bilan.geste.extraction_digitale,
    },
    {
        '@type': 'tristate',
        key: '0c5dc610-8216-457b-bd0b-6c3598d71ad3',
        label: 'Aspiration',
        value: (bilan) => bilan.geste.aspiration,
    },
    {
        '@type': 'tristate',
        key: 'da1431ba-636f-4d89-a424-1fa0f6b0bd59',
        label: 'Retrait du dentier',
        value: (bilan) => bilan.geste.retrait_dentier,
    },
    {
        '@type': 'tristate',
        key: '5037d20d-bab4-4238-b538-1f7e4be39455',
        label: 'Pince de Magill',
        value: (bilan) => bilan.geste.pince_magill,
    },
    {
        '@type': 'tristate',
        key: 'cf52de94-b00b-47d9-a56d-d362518dea65',
        label: 'Compression thoracique',
        value: (bilan) => bilan.geste?.compression_thoracique,
    },
];
exports.materielO2 = [
    {
        '@type': 'select',
        key: 'fe729204-31e4-40fb-958a-ebd426a0087e',
        label: "Dispositif d'oxygénothérapie",
        options: [
            { value: 1, label: 'Aucun' },
            { value: 2, label: 'Masque HC' },
            { value: 3, label: 'Lunettes O2' },
            { value: 4, label: 'Masque Moyenne concentration' },
            { value: 5, label: 'Intubation' },
            { value: 6, label: 'BAVU' },
        ],
        value: (bilan) => {
            if (!bilan.geste.dispositif_oxygeno) {
                if (bilan.geste.lunettes_o2 === 'y') {
                    return 3;
                }
                else if (bilan.geste.masque_hc === 'y') {
                    return 2;
                }
                else if (bilan.geste.masque_mc === 'y') {
                    return 4;
                }
            }
            else {
                return bilan.geste.dispositif_oxygeno;
            }
        },
    },
];
exports.debitO2 = [
    {
        '@type': 'integer',
        key: '0ef6fbfe-7fe8-4175-90de-12fc389beb0a',
        label: "Inhalations d'O2",
        unit: 'L/min',
        value: (bilan) => (bilan.geste.inha <= 0 ? null : bilan.geste.inha),
    },
    {
        '@type': 'integer',
        key: 'e3e56995-7956-45ac-a901-9bc5a538eac6',
        label: 'Débit oxygène',
        unit: 'L/min',
        value: (bilan) => bilan.circulatoire?.debit_oxygene && bilan.circulatoire?.debit_oxygene <= 0
            ? null
            : bilan.circulatoire?.debit_oxygene,
    },
    {
        '@type': 'time',
        key: '150d98cc-a406-4636-a143-a01a6b2c31ee',
        label: 'O2 - Heure',
        value: (bilan) => (bilan.circulatoire.horodatage_o2 ? bilan.circulatoire.horodatage_o2 : null),
    },
];
exports.aerosolNombre = [
    {
        '@type': 'integer',
        key: 'c2c87d73-fa43-48bc-97a1-72635fe25f18',
        label: 'Aérosol - Nombre',
        value: (bilan) => bilan.geste.aerosol_nombre,
    },
];
exports.materielDebitO2 = [...exports.materielO2, ...exports.debitO2];
exports.gesteSmurAerosol = [
    {
        '@type': 'tristate',
        key: '5c2d218f-8e30-49d6-9031-25a51ab28119',
        label: 'Aérosol',
        value: (bilan) => bilan.geste.aerosol,
    },
    ...exports.aerosolNombre,
    {
        '@type': 'text',
        key: '338546f0-a9ea-4552-898d-ab0410507777',
        label: 'Aérosol - Produit',
        value: (bilan) => bilan.geste.aerosol_produit_samu35,
    },
    {
        '@type': 'tristate',
        key: 'efa89ad3-a37a-4ec4-bc6f-da74de1f88e3',
        label: 'Aérosol - Sous O2',
        value: (bilan) => bilan.geste.aerosol_oxy_samu35,
    },
];
exports.intubationSmur = [
    {
        '@type': 'select',
        key: 'dbc84dea-a0e7-4932-b062-9eaaf0869e37',
        label: 'Intubation',
        options: [
            { value: 1, label: 'Oui' },
            { value: 2, label: 'Non' },
            { value: 3, label: 'Échec' },
        ],
        value: (bilan) => bilan.geste.intubation_samu35,
    },
];
exports.ventilationNonInvasiveSmur = [
    {
        '@type': 'select',
        key: 'a51801e3-7980-4ebd-b534-10c470ae03d7',
        label: 'VNI',
        options: [
            { value: 1, label: 'Oui' },
            { value: 2, label: 'Non' },
            { value: 3, label: 'Échec' },
        ],
        value: (bilan) => bilan.geste?.ventilation_non_invasive,
    }
];
exports.exsufflationSmur = [
    {
        '@type': 'tristate',
        key: '08aead02-7437-4c99-bf02-85c78a76be23',
        label: "Exsufflation d'urgence",
        value: (bilan) => bilan.geste?.exsufflation_samu35,
    }
];
exports.gesteRespiratoireSamu = [
    ...exports.materielO2,
    ...exports.aerosolNombre,
    ...exports.exsufflationSmur,
    ...exports.ventilationNonInvasiveSmur,
    ...exports.intubationSmur
];
exports.gesteSmur35 = [
    ...exports.intubationSmur,
    {
        '@type': 'select',
        key: '9a80e7ec-92ca-4bd0-aed3-78897873af6d',
        label: 'Intubation paramètres',
        options: [
            { value: 1, label: 'VACI' },
            { value: 2, label: 'CPAP' },
            { value: 3, label: 'VNI' },
            { value: 4, label: 'VAC' },
            { value: 5, label: 'VSAI' },
            { value: 6, label: 'Optiflow' },
        ],
        value: (bilan) => bilan.geste.intubation_setting_samu35,
    },
    {
        '@type': 'select',
        key: 'a3e69881-6fa2-485a-9ac5-d4cd6fc6e6d4',
        label: 'Intubation diamètres',
        options: [
            { value: 30, label: '3.0' },
            { value: 35, label: '3.5' },
            { value: 40, label: '4.0' },
            { value: 45, label: '4.5' },
            { value: 50, label: '5.0' },
            { value: 55, label: '5.5' },
            { value: 60, label: '6.0' },
            { value: 65, label: '6.5' },
            { value: 70, label: '7.0' },
            { value: 75, label: '7.5' },
            { value: 80, label: '8.0' },
            { value: 85, label: '8.5' },
            { value: 90, label: '9.0' },
            { value: 95, label: '9.5' },
            { value: 100, label: '10.0' },
        ],
        value: (bilan) => bilan.geste.intubation_diametre_samu35,
    },
    {
        '@type': 'multitristate',
        key: '68ef0a0d-1fa7-4771-a3a5-ab4cfe40393b',
        label: 'Intubation type',
        options: (bilan) => [
            { value: bilan.geste?.intubation_type_mandrin_eshmann, label: "Mandrin d'Eschmann" },
            { value: bilan.geste?.intubation_type_mandrin_souple, label: 'Mandrin souple' },
            { value: bilan.geste?.intubation_type_videolaryngoscope, label: 'Vidéolaryngoscope' },
            { value: bilan.geste?.intubation_type_fastrach, label: 'Fastrach' },
            { value: bilan.geste?.intubation_type_cricothyroidotomie, label: 'Cricothyroïdotomie' },
        ],
    },
    {
        '@type': 'select',
        key: '0a25af17-7ce7-41d3-a2e1-45ed97c19d02',
        label: 'Positionnement',
        options: [
            { value: 1, label: 'Demi-assis' },
            { value: 2, label: 'Décubitus strict' },
            { value: 3, label: 'PLS' },
            { value: 4, label: 'Proclive à 30°' },
        ],
        value: (bilan) => bilan.geste.positionnement_samu35,
    },
    {
        '@type': 'select',
        key: 'e37c91f4-24b5-42f0-85fd-8e63d6a9e59e',
        label: 'Immobilisation',
        options: [
            { value: 1, label: 'Minerve ou Collier cervical' },
            { value: 2, label: 'Matelas à depression' },
            { value: 3, label: 'Attelle de traction (côté)' },
            { value: 4, label: 'Attelle de membre (localisation)' },
            { value: 5, label: 'Ceinture pelvienne' },
        ],
        value: (bilan) => bilan.geste.immobilisation_samu35,
    },
    {
        '@type': 'select',
        key: '7cb9bdd1-44f2-45d0-a3e5-7a9381d1215f',
        label: 'MCE',
        options: [
            { value: 1, label: 'Manuel' },
            { value: 2, label: 'Planche à masser' },
            { value: 3, label: 'Choc' },
        ],
        value: (bilan) => bilan.geste.massage_samu35,
    },
    {
        '@type': 'select',
        key: '68cb3b9d-826f-443d-a4d4-e6ca3c894e4f',
        label: 'Voie veineuse',
        options: [
            { value: 1, label: 'VVP' },
            { value: 2, label: 'IO' },
            { value: 3, label: 'Remplissage' },
        ],
        value: (bilan) => bilan.geste.circulatoire_samu35,
    },
    {
        '@type': 'integer',
        key: 'a8ae754a-ce65-4700-be57-822b1a1c94a5',
        label: 'Voie veineuse - Quantité',
        value: (bilan) => !bilan.geste.nb_circulatoire_samu35 || bilan.geste?.nb_circulatoire_samu35 <= 0
            ? null
            : bilan.geste.nb_circulatoire_samu35,
    },
    {
        '@type': 'select',
        key: '2b50e160-0a3f-46fd-9f1f-7f3085244331',
        label: 'Circulatoire type',
        options: [
            { value: 1, label: 'Main' },
            { value: 2, label: 'Bras' },
            { value: 3, label: 'Jambe' },
            { value: 4, label: 'Pied' },
        ],
        value: (bilan) => bilan.geste.type_circulatoire_samu35_position,
    },
    {
        '@type': 'select',
        key: '3bcb0988-21fd-43ab-9449-bc99aed8eddf',
        label: 'Voie veineuse - Localisation',
        options: [
            { value: 1, label: 'Épaule' },
            { value: 2, label: 'Tibia' },
            { value: 3, label: 'Malléole' },
        ],
        value: (bilan) => bilan.geste.type_circulatoire_samu35,
    },
    {
        '@type': 'select',
        key: '077b452f-ad23-4408-bedc-46598ba609f2',
        label: 'Voie veineuse - Direction',
        options: [
            { value: 1, label: 'D' },
            { value: 2, label: 'G' },
        ],
        value: (bilan) => bilan.geste.direction_circulatoire_samu35,
    },
    {
        '@type': 'tristate',
        key: '1053a53e-b5bf-40e8-abeb-5537499d8442',
        label: 'Kit cyano',
        value: (bilan) => bilan.geste.cyano_kit_samu35,
    },
    {
        '@type': 'select',
        key: '210630e1-8ddb-40e2-afdc-3bd99bd3fa7d',
        label: 'Kit damage control',
        options: [
            { value: 1, label: 'Garrot tourniquet' },
            { value: 2, label: 'Pansement' },
            { value: 3, label: 'Pansement hémostatique' },
        ],
        value: (bilan) => bilan.geste.damage_control_kit_samu35,
    },
    {
        '@type': 'integer',
        key: '49e1c8cc-c748-48c8-8635-acc2bb2ab775',
        label: 'Garrot nombre',
        value: (bilan) => !bilan.geste.garrot_number_samu35 || bilan.geste.garrot_number_samu35 <= 0
            ? null
            : bilan.geste.garrot_number_samu35,
    },
    {
        '@type': 'select',
        key: '75d2eaa7-8c0e-4e1b-b9a5-46ba40700eec',
        label: 'Garrot localisation',
        options: [
            { value: 1, label: 'Main' },
            { value: 2, label: 'Bras' },
            { value: 3, label: 'Jambe' },
            { value: 4, label: 'Pied' },
        ],
        value: (bilan) => bilan.geste.garrot_location_samu35,
    },
    {
        '@type': 'select',
        key: 'cdfbb62e-f92a-4d6e-abaa-61ed540f4ca5',
        label: 'Garrot direction',
        options: [
            { value: 1, label: 'D' },
            { value: 2, label: 'G' },
        ],
        value: (bilan) => bilan.geste.garrot_direction_samu35,
    },
    {
        '@type': 'time',
        key: 'e2ae9737-3549-4ae0-8e7c-5314ea147935',
        label: 'Garrot heure',
        value: (bilan) => bilan.geste.garrot_date_samu35,
    },
    {
        '@type': 'select',
        key: 'f8cedcba-f9d3-48fd-9c8f-5b81ce7867fd',
        label: 'Pré-oxygénation',
        options: [
            { value: 1, label: 'Lunette' },
            { value: 2, label: 'Masque simple' },
            { value: 3, label: 'MHC' },
            { value: 4, label: 'BAVU' },
            { value: 5, label: 'Optiflow' },
            { value: 6, label: 'VNI' },
        ],
        value: (bilan) => bilan.geste.pre_oxygenation_samu35,
    },
    {
        '@type': 'integer',
        key: '3d371dbe-68d9-4e85-b502-69e0e3c683a1',
        label: 'Paramètres fio2',
        unit: '%',
        value: (bilan) => !bilan.geste.settings_fio2_samu35 || bilan.geste.settings_fio2_samu35 <= 0
            ? null
            : bilan.geste.settings_fio2_samu35,
    },
    {
        '@type': 'integer',
        key: 'dc4a270f-52e2-4158-9753-d4be36fa7d32',
        label: 'Paramètres aide',
        unit: 'cm',
        value: (bilan) => !bilan.geste.settings_aide_samu35 || bilan.geste.settings_aide_samu35 <= 0
            ? null
            : bilan.geste.settings_aide_samu35,
    },
    {
        '@type': 'integer',
        key: 'ee7d1354-5804-42c3-81be-14ec9f99e451',
        label: 'Paramètres peep',
        unit: 'cm',
        value: (bilan) => !bilan.geste.settings_peep_samu35 || bilan.geste.settings_peep_samu35 <= 0
            ? null
            : bilan.geste.settings_peep_samu35,
    },
    {
        '@type': 'integer',
        key: 'd864cbd3-2c25-43e2-a5ec-a5d988f48c19',
        label: 'Paramètres pression plateau',
        unit: 'cm',
        value: (bilan) => !bilan.geste.settings_pression_plateau_samu35 || bilan.geste.settings_pression_plateau_samu35 <= 0
            ? null
            : bilan.geste.settings_pression_plateau_samu35,
    },
    {
        '@type': 'integer',
        key: 'aabc0b10-3d12-4d5d-8018-4ff1ccf4b597',
        label: 'Paramètres débit',
        unit: 'L/min',
        value: (bilan) => !bilan.geste.settings_debit_samu35 || bilan.geste.settings_debit_samu35 <= 0
            ? null
            : bilan.geste.settings_debit_samu35,
    },
    {
        '@type': 'integer',
        key: '49baccfb-7873-486f-8bc9-4a6b365ac2cf',
        label: 'Paramètres vt',
        unit: 'mL',
        value: (bilan) => !bilan.geste.settings_vt_samu35 || bilan.geste.settings_vt_samu35 <= 0 ? null : bilan.geste.settings_vt_samu35,
    },
    {
        '@type': 'integer',
        key: '01806369-bae1-4c09-8613-1d5afe94b75e',
        label: 'Paramètres fréquence',
        value: (bilan) => !bilan.geste.settings_fr_samu35 || bilan.geste.settings_fr_samu35 <= 0 ? null : bilan.geste.settings_fr_samu35,
    },
    {
        '@type': 'integer',
        key: '387fbee5-2159-4723-968c-1b05b7b9d3bd',
        label: 'Paramètres Pmax',
        unit: 'cm',
        value: (bilan) => !bilan.geste.settings_p_max_samu35 || bilan.geste.settings_p_max_samu35 <= 0
            ? null
            : bilan.geste.settings_p_max_samu35,
    },
    {
        '@type': 'integer',
        key: 'face8718-3cb0-4b5a-b26b-47168e091ee0',
        label: 'I / E',
        value: (bilan) => !bilan.geste.i_sur_e_samu35 || bilan.geste.i_sur_e_samu35 <= 0 ? null : bilan.geste.i_sur_e_samu35,
    },
    ...exports.exsufflationSmur,
    {
        '@type': 'tristate',
        key: '7bd028b1-5430-4c03-9153-77b9d017c026',
        label: 'Études/Protocoles/Registres',
        value: (bilan) => bilan.geste.etu_prot_reg_samu35,
    },
    {
        '@type': 'text',
        key: '63557589-7dc2-409e-8eb0-c67c082ed5fc',
        label: 'Études/Protocoles/Registres - Nom',
        value: (bilan) => bilan.geste.etu_prot_reg_name_samu35,
    },
    {
        '@type': 'tristate',
        key: '74f8c63f-f822-447c-8f02-0bb972dac283',
        label: 'Réchauffement',
        value: (bilan) => bilan.geste.rechauffement_samu35,
    },
    {
        '@type': 'tristate',
        key: '6eab2f74-c6e1-4577-b0fc-af2f8058c15c',
        label: 'Réduction luxation',
        value: (bilan) => bilan.geste.red_luxation_samu35,
    },
    {
        '@type': 'text',
        key: '4a3b9625-7f40-4e40-8a34-fef7c6b98b2a',
        label: 'Réduction luxation - Position',
        value: (bilan) => bilan.geste.red_luxation_position_samu35,
    },
    {
        '@type': 'select',
        key: '8932844c-d310-406c-bdca-0a17a05f094d',
        label: 'Sonde',
        options: [
            { value: 1, label: 'Urinaire' },
            { value: 2, label: 'Naso-gastrique' },
            { value: 3, label: 'Blakemore' },
        ],
        value: (bilan) => bilan.geste.sondage_samu35,
    },
    {
        '@type': 'tristate',
        key: '9ee0e102-2af9-4aa4-93ba-b9deaf489cb2',
        label: 'Tamponnement',
        value: (bilan) => bilan.geste.tamponnement_samu35,
    },
    {
        '@type': 'tristate',
        key: '299bd734-ced4-48d8-b530-48df60d52d43',
        label: 'Thoracostomie de secours',
        value: (bilan) => bilan.geste.thoracostomie_samu35,
    },
    {
        '@type': 'tristate',
        key: 'b8c935e8-e069-42c5-a986-a21d476a78b3',
        label: 'Transfusion',
        value: (bilan) => bilan.geste.transfusion_value_samu35,
    },
    {
        '@type': 'select',
        key: 'a9756607-6148-41d9-a27d-47b16e167d7d',
        label: 'Transfusion - Type',
        options: [
            { value: 1, label: 'CG' },
            { value: 2, label: 'Plaquettes' },
            { value: 3, label: 'PFC' },
        ],
        value: (bilan) => bilan.geste.transfusion_type_samu35,
    },
    {
        '@type': 'integer',
        key: '19905836-22fa-431e-b951-e7511f033580',
        label: 'Transfusion - Nombre',
        value: (bilan) => !bilan.geste.transfusion_nombre_samu35 || bilan.geste.transfusion_nombre_samu35 <= 0
            ? null
            : bilan.geste.transfusion_nombre_samu35,
    },
    {
        '@type': 'tristate',
        key: '0883c729-6072-4a13-9ee3-b5d600e99e41',
        label: 'Oxygénation',
        value: (bilan) => bilan.geste.oxygenation,
    },
    {
        '@type': 'tristate',
        key: 'c6f9be89-c00f-42a2-a7f6-278784cdbcb3',
        label: 'Lunette',
        value: (bilan) => bilan.geste.lunette,
    },
    {
        '@type': 'integer',
        key: 'd88b7677-d284-47f4-8d50-673a8aa40668',
        label: 'Lunette - Débit',
        value: (bilan) => !bilan.geste.lunette_debit || bilan.geste.lunette_debit <= 0 ? null : bilan.geste.lunette_debit,
    },
    {
        '@type': 'tristate',
        key: '812b7de2-3dce-4235-b7f2-ed8bac6c3ba0',
        label: 'Masque',
        value: (bilan) => bilan.geste.masque,
    },
    {
        '@type': 'integer',
        key: '5f4d6b4e-8582-432c-a239-0d6a16642a59',
        label: 'Masque - Débit',
        value: (bilan) => !bilan.geste.masque_debit || bilan.geste.masque_debit <= 0 ? null : bilan.geste.masque_debit,
    },
    {
        '@type': 'tristate',
        key: '35e566f5-3622-418a-a0ff-0f5509f10ba0',
        label: 'MHC',
        value: (bilan) => bilan.geste.mhc,
    },
    {
        '@type': 'integer',
        key: '94744e53-9ae8-4a32-91fe-e8aac10da973',
        label: 'MHC - Débit',
        value: (bilan) => !bilan.geste.mhc_debit || bilan.geste.mhc_debit <= 0 ? null : bilan.geste.mhc_debit,
    },
    {
        '@type': 'tristate',
        key: '3e9f1e8c-7e52-4118-aba8-4cda7a7f1e86',
        label: 'Remplissage',
        value: (bilan) => bilan.geste.remplissage_samu35,
    },
    {
        '@type': 'tristate',
        key: '2c36e28d-2218-4a2f-bdf7-d1d1e544afdb',
        label: 'Remplissage',
        value: (bilan) => bilan.geste.remplissage_samu35,
    },
    {
        '@type': 'text',
        key: '203238cf-2b1a-4516-8bf9-30ad0c47df25',
        label: 'Remplissage - Produit',
        value: (bilan) => bilan.geste.remplissage_produit_samu35,
    },
    {
        '@type': 'integer',
        key: '4ef4966e-64aa-49c2-8914-b94d3ddfc0d7',
        label: 'Remplissage - Quantité',
        value: (bilan) => !bilan.geste.remplissage_quantite_samu35 || bilan.geste.remplissage_quantite_samu35 <= 0
            ? null
            : bilan.geste.remplissage_quantite_samu35,
    },
    {
        '@type': 'tristate',
        key: '30712e7d-0018-4f90-bb44-87b4493654b4',
        label: 'VV',
        value: (bilan) => bilan.geste.vv_samu35,
    },
    {
        '@type': 'select',
        key: '616645ae-ebcb-4e15-833c-299577cb9485',
        label: 'ECG type',
        options: [
            { value: 1, label: 'Critique' },
            { value: 2, label: 'Non critique' },
        ],
        value: (bilan) => bilan.geste.ecg_type_samu35,
    },
    {
        '@type': 'tristate',
        key: '2d2f2fcc-d6e7-437f-aa58-ab67458b7395',
        label: 'IO',
        value: (bilan) => bilan.geste.io_samu35,
    },
    {
        '@type': 'select',
        key: '3e65f89e-a0eb-497e-8e4f-91fc6d51efcc',
        label: 'IO - Localisation',
        options: [
            { value: 1, label: 'Épaule' },
            { value: 2, label: 'Tibia' },
            { value: 3, label: 'Malléole' },
        ],
        value: (bilan) => bilan.geste.io_loc_samu35,
    },
    {
        '@type': 'select',
        key: '6a03f86e-e8d1-433e-9288-5309fb1d6264',
        label: 'IO - Direction',
        options: [
            { value: 1, label: 'D' },
            { value: 2, label: 'G' },
        ],
        value: (bilan) => bilan.geste.io_dir_samu35,
    },
    {
        '@type': 'select',
        key: '3488dde1-6798-49af-9014-33fc7e28d8fe',
        label: 'VVP - Localisation',
        options: [
            { value: 1, label: 'Épaule' },
            { value: 2, label: 'Tibia' },
            { value: 3, label: 'Malléole' },
        ],
        value: (bilan) => bilan.geste.vvp_loc_samu35,
    },
    {
        '@type': 'select',
        key: '7f0b2978-9b30-445f-842c-503322b53d99',
        label: 'VVP - Direction',
        options: [
            { value: 1, label: 'D' },
            { value: 2, label: 'G' },
        ],
        value: (bilan) => bilan.geste.vvp_dir_samu35,
    },
    {
        '@type': 'select',
        key: 'd2508510-32d8-4ce3-9b00-246d6f3a838d',
        label: 'VVP - Diamètre',
        options: [
            { value: 14, label: '14' },
            { value: 16, label: '16' },
            { value: 18, label: '18' },
            { value: 20, label: '20' },
            { value: 22, label: '22' },
            { value: 24, label: '24' },
        ],
        value: (bilan) => bilan.geste.vvp_nombre_select_samu35,
    },
    {
        '@type': 'integer',
        key: '8dfa0475-1dd9-46a2-80d8-d0beaaf652a2',
        label: 'VC - Nombre',
        value: (bilan) => !bilan.geste.voie_central_nombre_samu35 || bilan.geste.voie_central_nombre_samu35 <= 0
            ? null
            : bilan.geste.voie_central_nombre_samu35,
    },
    {
        '@type': 'integer',
        key: 'acb732e4-5cbb-4637-b3e0-b418ed10b41f',
        label: 'VC - Taille',
        value: (bilan) => !bilan.geste.voie_central_taille_samu35 || bilan.geste.voie_central_taille_samu35 <= 0
            ? null
            : bilan.geste.voie_central_taille_samu35,
    },
    {
        '@type': 'select',
        key: 'e69a1d24-3cac-484e-9d55-2db9280874f8',
        label: 'VC - Localisation',
        options: [
            { value: 1, label: 'Épaule' },
            { value: 2, label: 'Tibia' },
            { value: 3, label: 'Malléole' },
        ],
        value: (bilan) => bilan.geste.voie_central_localisation_samu35,
    },
    {
        '@type': 'select',
        key: '28040e4d-7fc8-4a22-a425-36baf833c580',
        label: 'VC - Direction',
        options: [
            { value: 1, label: 'D' },
            { value: 2, label: 'G' },
        ],
        value: (bilan) => bilan.geste.voie_central_direction_samu35,
    },
    {
        '@type': 'tristate',
        key: 'dfaf994c-527a-4a66-8267-211770647d62',
        label: 'A jeun',
        value: (bilan) => bilan.geste.a_jeun_samu35,
    },
    {
        '@type': 'dateTime',
        key: '9e2bae5c-dfb0-44b2-bf39-3ed17fcbfc94',
        label: 'A jeun depuis',
        value: (bilan) => {
            return {
                time: bilan.geste.a_jeun_time_samu35,
                date: bilan.geste.a_jeun_date_samu35,
            };
        },
    },
    {
        '@type': 'tristate',
        key: '677464e0-7827-4810-8b6a-54043f838f88',
        label: 'Antidotes',
        value: (bilan) => bilan.geste.antidotes_samu35,
    },
    {
        '@type': 'text',
        key: 'a2be6c02-003f-4482-8339-139d28c96dc7',
        label: 'Antidotes - Nom',
        value: (bilan) => bilan.geste.antidotes_nom_samu35,
    },
];
exports.inhalation = [
    {
        '@type': 'tristate',
        key: 'af048ac3-4d46-43e8-a179-d3066d3c594e',
        label: 'Inhalation',
        contentInverted: true,
        value: (bilan) => bilan.geste.smur_inhalation,
    },
];
exports.gesteSmurIntubation = [
    {
        '@type': 'integer',
        key: '3b406572-017d-4bdc-aab3-2ce158594338',
        label: 'Intubation - Diamètre',
        unit: 'mm',
        value: (bilan) => bilan.geste.smur_diametre,
    },
    {
        '@type': 'tristate',
        key: '9dea1bf7-65e3-43f1-9a89-38cf01c3fd96',
        label: 'Intubation difficile',
        value: (bilan) => bilan.geste.smur_intubation_difficile,
    },
];
exports.gesteSmurRespiratoire = [
    ...exports.gesteSmurAerosol,
    ...exports.exsufflationSmur,
    {
        '@type': 'tristate',
        key: 'f02a6fd9-fbcf-4923-8ebb-305438789318',
        label: 'Drain pleural',
        value: (bilan) => bilan.geste?.exsufflation_urgence_drain_pleural,
    },
    ...exports.ventilationNonInvasiveSmur,
    {
        '@type': 'multitristate',
        key: 'bd953edd-2de3-4dec-9efd-9b323eb2f73d',
        label: 'VNI - Mode',
        options: (bilan) => [
            { value: bilan.geste?.smur_vni, label: 'VNI' },
            { value: bilan.geste?.vni_mode_duo_levels, label: 'Duo-levels' },
            { value: bilan.geste?.vni_mode_optiflow, label: 'Optiflow' },
            { value: bilan.geste?.vni_mode_cpap, label: 'CPAP' },
        ],
    },
    {
        '@type': 'integer',
        key: 'ce60168b-b24c-44e7-bb31-ff284d889daf',
        label: 'VS-AI, VNI - FiO₂',
        unit: '%',
        value: (bilan) => bilan.geste?.vs_ai_vni_fio2,
    },
    {
        '@type': 'integer',
        key: '20d49dc9-a647-4275-9966-a467a54765e0',
        label: 'VS-AI, VNI - AI',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vs_ai_vni_ai,
    },
    {
        '@type': 'integer',
        key: '10febe0a-c896-4d84-8f6a-8b524c0a5210',
        label: 'VS-AI, VNI - PEP',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vs_ai_vni_pep,
    },
    {
        '@type': 'integer',
        key: '85a9ec31-9830-409c-bb4f-a40ea8e0cff2',
        label: 'VS-AI, VNI - Trigger Insp',
        unit: 'L/min',
        value: (bilan) => bilan.geste?.vs_ai_vni_trigger_insp,
    },
    {
        '@type': 'integer',
        key: '49a88667-c9ab-4bfc-b445-ba95296673de',
        label: 'VS-AI, VNI - Pente',
        unit: 'cmH₂O/s',
        value: (bilan) => bilan.geste?.vs_ai_vni_pente,
    },
    {
        '@type': 'integer',
        key: '6cdd8f1b-a084-466c-89fa-be49a0101c61',
        label: 'VS-AI, VNI - Trigger Exp',
        unit: '%',
        value: (bilan) => bilan.geste?.vs_ai_vni_trigger_exp,
    },
    {
        '@type': 'tristate',
        key: '57a2ae98-3972-44fb-bc7c-819343a2d98f',
        label: 'VNI - Duo-levels',
        value: (bilan) => bilan.geste?.vni_mode_duo_levels,
    },
    {
        '@type': 'integer',
        key: '4ebd8b2d-4092-4cf6-a667-7fe606ecdc51',
        label: 'Duo-levels - FiO₂',
        unit: '%',
        value: (bilan) => bilan.geste?.duo_levels_fio2,
    },
    {
        '@type': 'integer',
        key: '88fb19ee-1a9a-42ce-83bc-46489de96dc5',
        label: 'Duo-levels - PI',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.duo_levels_pi,
    },
    {
        '@type': 'integer',
        key: 'b6ae59c8-8633-4126-b7f9-74a9860cbe2e',
        label: 'Duo-levels - PEP',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.duo_levels_pep,
    },
    {
        '@type': 'integer',
        key: 'a12626c3-3d8f-404a-b98c-aa08fe779cda',
        label: 'Duo-levels - f mini',
        unit: 'c/min',
        value: (bilan) => bilan.geste?.duo_levels_f_mini,
    },
    {
        '@type': 'integer',
        key: '911c5b5f-cbbd-4298-913a-3912aa4dadf5',
        label: 'Duo-levels - Trigger Insp',
        unit: 'L/min',
        value: (bilan) => bilan.geste?.duo_levels_trigger_insp,
    },
    {
        '@type': 'integer',
        key: '2bd1408f-f982-4ad6-9095-2b304665c0c2',
        label: 'Duo-levels - Pente',
        unit: 'cmH₂O/s',
        value: (bilan) => bilan.geste?.duo_levels_pente,
    },
    {
        '@type': 'integer',
        key: 'dea75e5f-2e78-4a72-aad3-8f8e56692645',
        label: 'Duo-levels - Trigger Exp',
        unit: '%',
        value: (bilan) => bilan.geste?.duo_levels_trigger_exp,
    },
    {
        '@type': 'tristate',
        key: 'a433ecd7-875f-4572-8147-cb2a49e26418',
        label: 'VNI - Optiflow (Monnal T60 en mode "Oxygénothérapie à haut débit")',
        value: (bilan) => bilan.geste?.vni_mode_optiflow,
    },
    {
        '@type': 'integer',
        key: '049aedee-8ef3-4935-bbe5-9b5a89263824',
        label: "Optiflow - Débit d'O₂",
        unit: 'L/min',
        value: (bilan) => bilan.geste?.optiflow_debit_o2,
    },
    {
        '@type': 'integer',
        key: 'a18ecf4d-c6aa-4a56-bbd7-99ba7026de5e',
        label: 'Optiflow - FiO₂',
        unit: '%',
        value: (bilan) => bilan.geste?.optiflow_fio2,
    },
    {
        '@type': 'tristate',
        key: 'd81e0b62-f92e-48c7-b12a-08aa3846b669',
        label: 'VNI - CPAP',
        value: (bilan) => bilan.geste?.vni_mode_cpap,
    },
    {
        '@type': 'integer',
        key: '79494461-7a14-4072-a307-7e863152b06f',
        label: 'CPAP - FiO₂',
        unit: '%',
        value: (bilan) => bilan.geste?.cpap_fio2,
    },
    {
        '@type': 'integer',
        key: 'f272d29d-8f9e-4ea6-8243-efc61841b6cf',
        label: 'CPAP - CPAP / PEP',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.cpap_cpap_pep,
    },
    {
        '@type': 'tristate',
        key: 'e342ad6a-98b9-430b-ad65-6329f634301e',
        label: 'Intubation',
        value: (bilan) => bilan.geste.smur_intubation,
    },
    {
        '@type': 'tristate',
        key: 'a99acadc-59f6-463a-9999-80eb8bbce13d',
        label: 'Intubation préoxygénation',
        value: (bilan) => bilan.geste?.intubation_preoxygenation,
    },
    {
        '@type': 'multitristate',
        key: '507758cd-1690-403a-ba2b-df243379441c',
        label: 'Intubation préoxygénation - Type',
        options: (bilan) => [
            {
                value: bilan.geste?.intubation_preoxygenation_type_mhc,
                label: 'Masque Haute Concentration (MHC)',
            },
            { value: bilan.geste?.intubation_preoxygenation_type_vsaivni, label: 'VS-AI, VNI' },
            { value: bilan.geste?.intubation_preoxygenation_type_optiflow, label: 'Optiflow' },
        ],
    },
    {
        '@type': 'tristate',
        key: 'e3561127-7f5b-4f2a-8077-e44a5269671e',
        label: 'Intubation - Difficile',
        value: (bilan) => bilan.geste?.intubation_difficile,
    },
    {
        '@type': 'multitristate',
        key: '91b4a048-ba27-4ab9-a247-58547deaa07f',
        label: 'Intubation - Difficile - Type',
        options: (bilan) => [
            { value: bilan.geste?.intubation_type_mandrin_souple, label: 'Mandrin souple' },
            { value: bilan.geste?.intubation_type_mandrin_eshmann, label: "Mandrin d'Eschmann" },
            { value: bilan.geste?.intubation_type_videolaryngoscope, label: 'Vidéolaryngoscope' },
            { value: bilan.geste?.intubation_type_fastrach, label: 'Fastrach' },
            {
                value: bilan.geste?.intubation_type_cricothyroidotomie,
                label: 'Cricothyroïdotomie percutanée',
            },
        ],
    },
    {
        '@type': 'tristate',
        key: '7a230040-857b-421c-9eeb-bc5558863546',
        label: 'ISR',
        value: (bilan) => bilan.geste.isr,
    },
    ...exports.inhalation,
    {
        '@type': 'multitristate',
        key: '5ce9d7a7-5b92-459e-a8cb-fc421501ed8f',
        label: 'Intubation - Diamètre',
        options: (bilan) => [
            { value: bilan.geste?.intubation_diametre3, label: '3' },
            { value: bilan.geste?.intubation_diametre3_5, label: '3,5' },
            { value: bilan.geste?.intubation_diametre4, label: '4' },
            { value: bilan.geste?.intubation_diametre4_5, label: '4,5' },
            { value: bilan.geste?.intubation_diametre5, label: '5' },
            { value: bilan.geste?.intubation_diametre5_5, label: '5,5' },
            { value: bilan.geste?.intubation_diametre6, label: '6' },
            { value: bilan.geste?.intubation_diametre6_5, label: '6,5' },
            { value: bilan.geste?.intubation_diametre7, label: '7' },
            { value: bilan.geste?.intubation_diametre7_5, label: '7,5' },
            { value: bilan.geste?.intubation_diametre8, label: '8' },
            { value: bilan.geste?.intubation_diametre8_5, label: '8,5' },
        ],
    },
    {
        '@type': 'tristate',
        key: 'cbf8613b-658c-42d1-929b-b2636d037d44',
        label: 'Intubation - Mode',
        value: (bilan) => bilan.geste?.intubation_mode,
    },
    {
        '@type': 'tristate',
        key: 'ed1c138e-a4cd-4152-8da6-4a7e181aa609',
        label: 'Intubation - V(A)C (Ventilation Contrôlée ou Assistée Contrôlée en volume)',
        value: (bilan) => bilan.geste?.intubation_mode_vac,
    },
    {
        '@type': 'integer',
        key: 'ec2f62ca-704d-4470-a233-4ed95dcd3136',
        label: 'VAC - FiO₂',
        unit: '%',
        value: (bilan) => bilan.geste?.vac_fio2,
    },
    {
        '@type': 'integer',
        key: '53cdac31-4027-477b-9ce7-e968e7c28b4c',
        label: 'VAC - VT',
        unit: 'mL',
        value: (bilan) => bilan.geste?.vac_vt,
    },
    {
        '@type': 'integer',
        key: '1bd64232-fdc1-4d30-a2dd-1152f141b377',
        label: 'VAC - FR',
        unit: '/min',
        value: (bilan) => bilan.geste?.vac_fr,
    },
    {
        '@type': 'integer',
        key: 'f3e917f5-2cee-4e1a-a1eb-1e4eef166fdc',
        label: 'VAC - PEP',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vac_pep,
    },
    {
        '@type': 'integer',
        key: 'e3b54091-b0d9-456b-91d8-cffead42ed0b',
        label: 'VAC - I:E',
        value: (bilan) => bilan.geste?.vac_ie,
    },
    {
        '@type': 'integer',
        key: 'e2d6ea09-6531-45a1-86ac-8d7fdc2e1411',
        label: 'VAC - Trigger Insp',
        unit: 'L/min',
        value: (bilan) => bilan.geste?.vac_trigger_insp,
    },
    {
        '@type': 'integer',
        key: 'fb7ff9bc-9524-499d-bf6c-55295dfa7874',
        label: 'VAC - Tplat',
        unit: '%',
        value: (bilan) => bilan.geste?.vac_t_plat,
    },
    {
        '@type': 'tristate',
        key: '07ecaa07-80e3-4f9f-aa2e-ace4e72d5fd0',
        label: 'Intubation - VACI (Ventilation Assistée Contrôlée Intermittente)',
        value: (bilan) => bilan.geste?.intubation_mode_vaci,
    },
    {
        '@type': 'integer',
        key: 'e92a1be2-6a9d-4e59-bc19-ef2ce4f7fe53',
        label: 'VACI - FiO₂',
        unit: '%',
        value: (bilan) => bilan.geste?.vaci_fio2,
    },
    {
        '@type': 'integer',
        key: '67f86ce8-34ef-43ec-86f7-72a082204b0a',
        label: 'VACI - VT',
        unit: 'mL',
        value: (bilan) => bilan.geste?.vaci_vt,
    },
    {
        '@type': 'integer',
        key: 'f3d3b92d-1517-43a6-9f76-a1f20e09b38e',
        label: 'VACI - FR',
        unit: '/min',
        value: (bilan) => bilan.geste?.vaci_fr,
    },
    {
        '@type': 'integer',
        key: 'aca3ed1e-7e85-4bdf-847a-3afd0941a007',
        label: 'VACI - PEP',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vaci_pep,
    },
    {
        '@type': 'integer',
        key: '7f939b54-61fd-4138-b8c5-852d4d52c9f3',
        label: 'VACI - I:E',
        value: (bilan) => bilan.geste?.vaci_ie,
    },
    {
        '@type': 'integer',
        key: '2246c98a-a49e-4c65-9cbb-4c51f1209d84',
        label: 'VACI - Tins',
        unit: 'c/min',
        value: (bilan) => bilan.geste?.vaci_tins,
    },
    {
        '@type': 'integer',
        key: 'ac4f3c26-1275-4cc5-af47-ff95244dd329',
        label: 'VACI - Tplat',
        unit: '%',
        value: (bilan) => bilan.geste?.vaci_t_plat,
    },
    {
        '@type': 'integer',
        key: '94df8205-7ae2-4c67-95cc-fbd20eb35f60',
        label: 'VACI - Trigger Insp',
        unit: 'L/min',
        value: (bilan) => bilan.geste?.vaci_trigger_insp,
    },
    {
        '@type': 'integer',
        key: 'a6d85aac-4fd2-4058-ad0e-9ae617aacf9a',
        label: 'VACI - AI',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vaci_ai,
    },
    {
        '@type': 'integer',
        key: 'afe36632-6db6-4908-9c19-4b9504946b2b',
        label: 'VACI - Pente',
        unit: 'cmH₂O/s',
        value: (bilan) => bilan.geste?.vaci_pente,
    },
    {
        '@type': 'integer',
        key: '372e8e5d-b239-4fe6-b456-2b9aa00f0f5e',
        label: 'VACI - Trigger Exp',
        unit: '%',
        value: (bilan) => bilan.geste?.vaci_triggerexp,
    },
    {
        '@type': 'tristate',
        key: 'b06d8573-f2ad-4060-b970-7f368139015c',
        label: 'Intubation - VP(A)C (Ventilation Contrôlée ou Assistée Contrôlée en pression)',
        value: (bilan) => bilan.geste?.intubation_mode_vpac,
    },
    {
        '@type': 'integer',
        key: '47c92535-3207-4698-8915-9d3e06cf7cb9',
        label: 'VPAC - FiO₂',
        unit: '%',
        value: (bilan) => bilan.geste?.vpac_fio2,
    },
    {
        '@type': 'integer',
        key: 'd078f9da-af1e-466d-85a9-b8e40b99632c',
        label: 'VPAC - PI',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vpac_pi,
    },
    {
        '@type': 'integer',
        key: 'bcade560-5134-48f0-b4aa-84fa70ad87d2',
        label: 'VPAC - FR',
        unit: '/min',
        value: (bilan) => bilan.geste?.vpac_fr,
    },
    {
        '@type': 'integer',
        key: '09fca2c1-5f8a-4843-9071-40ef60efe4cb',
        label: 'VPAC - PEP',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vpac_pep,
    },
    {
        '@type': 'integer',
        key: '65bfc456-bcdf-4259-84e3-5bd984d7f795',
        label: 'VPAC - I:E',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vpac_ie,
    },
    {
        '@type': 'integer',
        key: 'e926a13c-2895-4686-976e-79426b849bfa',
        label: 'VPAC - Trigger Insp',
        unit: 'L/min',
        value: (bilan) => bilan.geste?.vpac_trigger_insp,
    },
    {
        '@type': 'integer',
        key: 'd2743b48-6dc0-4bb3-856c-7522f179beab',
        label: 'VPAC - Pente',
        unit: 'cmH₂O/s',
        value: (bilan) => bilan.geste?.vpac_pente,
    },
    {
        '@type': 'tristate',
        key: '1d0e25b4-2ae6-4451-9ae7-9bcd4c077d40',
        label: 'Intubation - VPACI (Ventilation Assistée Contrôlée Intermittente en pression)',
        value: (bilan) => bilan.geste?.intubation_mode_vpaci,
    },
    {
        '@type': 'integer',
        key: '91d9fb9e-9b2f-4d93-8d1c-e7ce3c1359fd',
        label: 'VPACI - FiO₂',
        unit: '%',
        value: (bilan) => bilan.geste?.vpaci_fio2,
    },
    {
        '@type': 'integer',
        key: '3a089e8d-64d0-4a94-a30b-fa7e59adfc56',
        label: 'VPACI - PI',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vpaci_pi,
    },
    {
        '@type': 'integer',
        key: 'c1ddf52b-ca6c-47dc-84be-4c4cf61777cc',
        label: 'VPACI - f VACI',
        unit: 'c/min',
        value: (bilan) => bilan.geste?.vpaci_pi,
    },
    {
        '@type': 'integer',
        key: 'f5a2c098-9254-461f-8ff2-54c0de0f5c4e',
        label: 'VPACI - PEP',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vpaci_pep,
    },
    {
        '@type': 'integer',
        key: '35a75941-49ca-4134-971a-f8429bcdae39',
        label: 'VPACI - Tins',
        unit: 'c/min',
        value: (bilan) => bilan.geste?.vpaci_tins,
    },
    {
        '@type': 'integer',
        key: 'f8dd0634-3dee-46d4-b490-6fb7ea0b796a',
        label: 'VPACI - Trigger Insp',
        unit: 'L/min',
        value: (bilan) => bilan.geste?.vpaci_trigger_insp,
    },
    {
        '@type': 'integer',
        key: '9a947800-9220-442b-8298-4cbc6c63f037',
        label: 'VPACI - AI',
        unit: 's',
        value: (bilan) => bilan.geste?.vpaci_ai_s,
    },
    {
        '@type': 'integer',
        key: '820a8b0e-0334-401e-8d71-466cd29a0cbe',
        label: 'VPACI - AI',
        unit: 'cmH₂O',
        value: (bilan) => bilan.geste?.vpaci_ai_cmh2o,
    },
    {
        '@type': 'integer',
        key: 'dccbe12b-9fb2-4299-8bff-526753141614',
        label: 'VPACI - TImax',
        unit: 's',
        value: (bilan) => bilan.geste?.vpaci_t_imax,
    },
    {
        '@type': 'integer',
        key: '45af1c6a-a399-476f-9e4c-afa716bfb05d',
        label: 'VPACI - Pente',
        unit: 'cmH₂O/s',
        value: (bilan) => bilan.geste?.vpaci_pente,
    },
    {
        '@type': 'integer',
        key: 'fbaa7568-5db2-463f-a1cd-b67d6d6919a1',
        label: 'VPACI - Trigger Exp',
        unit: '%',
        value: (bilan) => bilan.geste?.vpaci_trigger_exp,
    },
    {
        '@type': 'tristate',
        key: '62933540-6df6-4963-98bd-dbedeadcaea3',
        label: 'Intubation - CPV',
        value: (bilan) => bilan.geste?.intubation_mode_cpv,
    },
];
exports.gesteSmurReanimation = [
    {
        '@type': 'multitristate',
        key: 'eb11593e-e238-4d75-9633-76339eb49bd0',
        label: 'Voie Veineuse Périphérique (VVP)',
        options: (bilan) => [
            { value: bilan.geste?.voie_veineuse_peripherique, label: 'VVP' },
            { value: bilan.geste?.voie_intra_osseuse, label: 'IO' },
        ],
    },
    {
        '@type': 'integer',
        key: '0b04a3a3-445e-48d2-805c-69bcd3a65b71',
        label: 'VVP - Nombre',
        value: (bilan) => bilan.geste?.vvp_nombre,
    },
    {
        '@type': 'multitristate',
        key: '4f3b964e-2765-45d9-a1b0-494ccc56211b',
        label: 'VVP 1 - Taille',
        options: (bilan) => [
            { value: bilan.geste?.vvp_taille_catther14g_1, label: '14 G' },
            { value: bilan.geste?.vvp_taille_catther16g_1, label: '16 G' },
            { value: bilan.geste?.vvp_taille_catther18g_1, label: '18 G' },
            { value: bilan.geste?.vvp_taille_catther20g_1, label: '20 G' },
            { value: bilan.geste?.vvp_taille_catther22g_1, label: '22 G' },
            { value: bilan.geste?.vvp_taille_catther24g_1, label: '24 G' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '66e7ea6d-ac32-45ca-b661-622e47c6c413',
        label: 'VVP 1 - Localisation',
        options: (bilan) => [
            { value: bilan.geste?.vvp_localisation_catther_dos_main_1, label: 'Dos de la main' },
            { value: bilan.geste?.vvp_localisation_catther_poignet_1, label: 'Poignet' },
            { value: bilan.geste?.vvp_localisation_catther_avant_bras_1, label: 'Avant-bras' },
            { value: bilan.geste?.vvp_localisation_catther_plis_coude_1, label: 'Plis du coude' },
            { value: bilan.geste?.vvp_localisation_catther_dos_pied_1, label: 'Dos du pied' },
            { value: bilan.geste?.vvp_localisation_catther_cheville_1, label: 'Cheville' },
        ],
    },
    {
        '@type': 'multitristate',
        key: 'a2a36380-8bc9-47ea-b8a1-fa5fbf23e78f',
        label: 'VVP 1 - Côté',
        options: (bilan) => [
            { value: bilan.geste?.vvp_cote_catther_droit_1, label: 'Droit' },
            { value: bilan.geste?.vvp_cote_catther_gauche_1, label: 'Gauche' },
        ],
    },
    {
        '@type': 'integer',
        key: '993b133f-b8e6-44ce-b554-eee1b3de378f',
        unit: 'mL',
        label: 'VVP 1 - Remplissage',
        value: (bilan) => bilan.geste?.vvp_remplissage_1,
    },
    {
        '@type': 'multitristate',
        key: 'd36270d5-5655-4d99-ad92-bae6365e299a',
        label: 'VVP 2 - Taille',
        options: (bilan) => [
            { value: bilan.geste?.vvp_taille_catther14g_2, label: '14 G' },
            { value: bilan.geste?.vvp_taille_catther16g_2, label: '16 G' },
            { value: bilan.geste?.vvp_taille_catther18g_2, label: '18 G' },
            { value: bilan.geste?.vvp_taille_catther20g_2, label: '20 G' },
            { value: bilan.geste?.vvp_taille_catther22g_2, label: '22 G' },
            { value: bilan.geste?.vvp_taille_catther24g_2, label: '24 G' },
        ],
    },
    {
        '@type': 'multitristate',
        key: 'd387a572-274b-431f-83a7-aa8b55a1892d',
        label: 'VVP 2 - Localisation',
        options: (bilan) => [
            { value: bilan.geste?.vvp_localisation_catther_dos_main_2, label: 'Dos de la main' },
            { value: bilan.geste?.vvp_localisation_catther_poignet_2, label: 'Poignet' },
            { value: bilan.geste?.vvp_localisation_catther_avant_bras_2, label: 'Avant-bras' },
            { value: bilan.geste?.vvp_localisation_catther_plis_coude_2, label: 'Plis du coude' },
            { value: bilan.geste?.vvp_localisation_catther_dos_pied_2, label: 'Dos du pied' },
            { value: bilan.geste?.vvp_localisation_catther_cheville_2, label: 'Cheville' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '6e456735-f6c0-445d-b76c-2e7cfc5931e4',
        label: 'VVP 2 - Côté',
        options: (bilan) => [
            { value: bilan.geste?.vvp_cote_catther_droit_2, label: 'Droit' },
            { value: bilan.geste?.vvp_cote_catther_gauche_2, label: 'Gauche' },
        ],
    },
    {
        '@type': 'integer',
        key: '285f6170-1bf1-4c0e-836d-ecb8b10e202d',
        unit: 'mL',
        label: 'VVP 2 - Remplissage',
        value: (bilan) => bilan.geste?.vvp_remplissage_2,
    },
    {
        '@type': 'multitristate',
        key: '37a3280f-8434-4912-9bd8-f7c02fb7fc78',
        label: 'IO - Taille',
        options: (bilan) => [
            { value: bilan.geste?.io_taille_catther15g15mm, label: 'Rose 15 G, 15 mm, de 3 à 39 kg' },
            { value: bilan.geste?.io_taille_catther15g25mm, label: 'Bleue 15 G, 25 mm, dès 3 kg' },
            {
                value: bilan.geste?.io_taille_catther15g45mm,
                label: 'Jaune 15 G, 45 mm, patients ≥ 40 kg',
            },
        ],
    },
    {
        '@type': 'multitristate',
        key: '5d72e4c4-c906-4588-bbc8-5a0e10e93297',
        label: 'IO - Localisation',
        options: (bilan) => [
            { value: bilan.geste?.io_localisation_catther_tibia_distal, label: 'Tibia distal' },
            { value: bilan.geste?.io_localisation_catther_tibia_proximal, label: 'Tibia proximal' },
            { value: bilan.geste?.io_localisation_catther_femur_distal, label: 'Fémur distal' },
            {
                value: bilan.geste?.io_localisation_catther_tete_humerus,
                label: "Tête de l'humérus (>5 ans)",
            },
        ],
    },
    {
        '@type': 'multitristate',
        key: 'f716d109-9b4a-4d46-a1fd-b5b636876878',
        label: 'IO - Côté',
        options: (bilan) => [
            { value: bilan.geste?.io_cote_catther_droit, label: 'Droit' },
            { value: bilan.geste?.io_cote_catther_gauche, label: 'Gauche' },
        ],
    },
    {
        '@type': 'integer',
        key: '6223d433-bb69-46ae-a80c-46755913abcd',
        unit: 'mL',
        label: 'IO - Remplissage',
        value: (bilan) => bilan.geste?.io_remplissage,
    },
    {
        '@type': 'select',
        key: 'c65774c0-46f7-481a-8600-27332815ccfd',
        label: 'Voie veineuse profonde',
        options: [
            { value: 1, label: 'Voie Veineuse Centrale (VVC)' },
            { value: 2, label: 'PICC Line' },
        ],
        value: (bilan) => bilan.geste?.voie_veineuse_profonde,
    },
    {
        '@type': 'select',
        key: '556aba4a-cc4c-4229-9c65-8901da63373f',
        label: 'VVC - Nombre de lumières',
        options: [
            { value: 1, label: '2' },
            { value: 2, label: '3' },
        ],
        value: (bilan) => bilan.geste?.vvc_nb_lumieres,
    },
    {
        '@type': 'multitristate',
        key: '9f9e9c72-680c-4899-a192-3e2fea0f00d3',
        label: 'VVC - Localisation',
        options: (bilan) => [
            { value: bilan.geste?.vvc_localisation_jugulaire, label: 'Jugulaire' },
            { value: bilan.geste?.vvc_localisation_sous_clavier, label: 'Sous-clavier' },
            { value: bilan.geste?.vvc_localisation_femoral, label: 'Fémoral' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '3fdfc552-eaf1-46cc-93e8-52328180a39a',
        label: 'VVC - Côté',
        options: (bilan) => [
            { value: bilan.geste?.vvc_cote_droit, label: 'Droit' },
            { value: bilan.geste?.vvc_cote_gauche, label: 'Gauche' },
        ],
    },
    {
        '@type': 'integer',
        key: 'dc1d8270-87ae-4a67-9432-7113a392225e',
        unit: 'mL',
        label: 'VVC - Remplissage',
        value: (bilan) => bilan.geste?.vvc_remplissage,
    },
    {
        '@type': 'multitristate',
        key: 'f9eb833f-22bf-428e-ac9c-fd7697235918',
        label: 'PiccLine - Localisation',
        options: (bilan) => [
            { value: bilan.geste?.picc_line_localisation_basilique_humerale, label: 'Jugulaire' },
            { value: bilan.geste?.picc_line_localisation_cephalique, label: 'Sous-clavier' },
        ],
    },
    {
        '@type': 'multitristate',
        key: 'b035af90-8763-4643-b7e7-474c39f1e05d',
        label: 'PiccLine - Côté',
        options: (bilan) => [
            { value: bilan.geste?.picc_line_cote_droit, label: 'Droit' },
            { value: bilan.geste?.picc_line_cote_gauche, label: 'Gauche' },
        ],
    },
    {
        '@type': 'integer',
        key: 'a37613cb-dac5-4d81-be77-766ff8eb653c',
        unit: 'mL',
        label: 'PiccLine - Remplissage',
        value: (bilan) => bilan.geste?.picc_line_remplissage,
    },
    {
        '@type': 'tristate',
        key: '83d182d7-6cf0-4088-aa5a-34a0319df0af',
        label: 'Cathéter artériel (KTA)',
        value: (bilan) => bilan.geste?.catheter_arteriel_kta,
    },
    {
        '@type': 'multitristate',
        key: 'ed2a831f-51c6-4d05-973d-32389fd903da',
        label: 'KTA - Localisation',
        options: (bilan) => [
            { value: bilan.geste?.kta_localisation_radial, label: 'Radial' },
            { value: bilan.geste?.kta_localisation_femoral, label: 'Fémoral' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '392095d9-49af-49df-a869-5ac75b031849',
        label: 'KTA - Côté',
        options: (bilan) => [
            { value: bilan.geste?.kta_cote_droit, label: 'Droit' },
            { value: bilan.geste?.kta_cote_gauche, label: 'Gauche' },
        ],
    },
    {
        '@type': 'tristate',
        key: '2961361e-57bd-44ca-9d3c-65765bba775d',
        label: 'Réanimation Cardio-Pulmonaire (RCP)',
        color: 'red',
        value: (bilan) => bilan.geste?.rcp,
    },
    {
        '@type': 'tristate',
        key: '1dde8af8-448c-4e9e-95d1-48273abe31ce',
        label: 'RCP - Écho cardiaque',
        value: (bilan) => bilan.geste?.rcp_echo_cardiaque,
    },
    {
        '@type': 'multitristate',
        key: '1dde8af8-448c-4e9e-95d1-48273abe31ce',
        label: 'RCP - MCE',
        options: (bilan) => [
            { value: bilan.geste?.smur_mce, label: 'Manuel' },
            { value: bilan.geste?.planche_a_masser, label: 'Lucas 3' },
        ],
    },
    {
        '@type': 'tristate',
        key: '166b2e86-6bab-42c7-a615-6a1625ba0aad',
        label: 'RCP - CEE',
        value: (bilan) => bilan.geste?.cee_samu35,
    },
    {
        '@type': 'multitristate',
        key: '270146bd-184a-4204-ad0e-0f8bf49838f7',
        label: 'RCP - Type de CEE',
        options: (bilan) => [
            {
                value: bilan.geste?.rcp_cee_defibrillation_latero_laterale,
                label: 'Défibrillation latéro-latérale',
            },
            {
                value: bilan.geste?.rcp_cee_defibrillation_antero_posterieure,
                label: 'Défibrillation antéro-postérieure',
            },
            { value: bilan.geste?.rcp_cee_double_defibrillation, label: 'Double défibrillation' },
        ],
    },
    {
        '@type': 'integer',
        key: '4ed42999-fd4f-4f87-9df5-ab9721297743',
        label: 'RCP - CEE - Nombre',
        value: (bilan) => bilan.geste.nombre_chocs_inter,
    },
    ...exports.gesteSmurIntubation,
    {
        '@type': 'integer',
        key: 'faa17c2a-9aec-43d5-9e7a-7cabef67a30b',
        label: 'RCP - Intubation - EtCO2 max',
        unit: 'mmHg',
        value: (bilan) => bilan.geste?.rcp_intubation_etco2max,
    },
    {
        '@type': 'tristate',
        key: 'b2ab155e-b51e-4b30-94cc-108b4b8382d4',
        label: 'RCP - Ventilation au BAVU',
        value: (bilan) => bilan.geste?.rcp_intubation_bavu,
    },
    {
        '@type': 'tristate',
        key: '7b36cd71-4503-4bd8-a000-6e92044d8773',
        label: 'Assistance circulatoire ECMO',
        value: (bilan) => bilan.geste.ecmo,
    },
];
exports.gesteSmurConditionnement = [
    {
        '@type': 'multitristate',
        key: '018805b9-3b34-4f73-a6fd-fb12eec50b8e',
        label: 'Immobilisation',
        options: (bilan) => [
            { value: bilan.geste?.collier, label: 'Collier cervical' },
            { value: bilan.geste?.mid, label: 'MID' },
            {
                value: bilan.geste?.attelle_immobilisation_aliforme,
                label: "Attelle d'immobilisation de membre aliforme",
            },
            {
                value: bilan.geste?.attelle_depression,
                label: "Attelle d'immobilisation de membre & dépression",
            },
            { value: bilan.geste?.attelle_traction_femorale, label: 'Attelle de traction fémorale' },
            { value: bilan.geste?.ceinture_pelvienne, label: 'Ceinture pelvienne' },
            { value: bilan.geste?.echarpe, label: 'Écharpe / Contre écharpe' },
        ],
    },
    {
        '@type': 'multitristate',
        key: 'e9d6c640-1c73-4058-9066-d67cf75b47dc',
        label: 'Position du patient',
        options: (bilan) => [
            { value: bilan.geste?.decubitus, label: 'Decubitus' },
            { value: bilan.geste?.demi_assis, label: 'Demi-assis' },
            { value: bilan.geste?.pls, label: 'PLS' },
            { value: bilan.geste?.basculement_tete, label: 'Tête à 30°' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '107db54e-a6fb-4037-8d93-28e2ee8d5c0b',
        label: "Échographie au point d'intervention (POCUS)",
        options: (bilan) => [
            { value: bilan.geste?.e_fast, label: 'e-FAST' },
            { value: bilan.geste?.cardio_vasculaire, label: 'Cardio-vasculaire' },
            { value: bilan.geste?.abdominal, label: 'Abdominal' },
            { value: bilan.geste?.trans_cranien, label: 'Trans-crânien' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '107db54e-a6fb-4037-8d93-28e2ee8d5c0b',
        label: 'Sédation-analgésie et anesthésie',
        options: (bilan) => [
            { value: bilan.geste?.antalgie, label: 'Antalgie (MEOPA, titration morphine...)' },
            {
                value: bilan.geste?.sedation_analgesie_procedurale,
                label: 'Sédation-analgésie procédurale (morphine et un hypnotique +/- une benzodiazépine)',
            },
            {
                value: bilan.geste?.anesthesie_loco_regionale,
                label: 'Anesthésie loco-régionale (bloc ilio-facial...)',
            },
            {
                value: bilan.geste?.anesthesie_generale,
                label: 'Anesthésie générale avec ISR pour intubation',
            },
            {
                value: bilan.geste?.anesthesie_generale_entretien,
                label: "Entretien d'une anesthésie générale",
            },
            { value: bilan.geste?.curatisation, label: 'Curatisation (continue ou par boli)' },
        ],
    },
    {
        '@type': 'select',
        key: '836d4aaa-cfcd-4aba-8303-b8bca3cd081c',
        label: 'Transport nv né ou nourrisson',
        options: [
            { value: 1, label: 'Couveuse' },
            { value: 2, label: "Matelas d'immobilisation à dépression (MID)" },
        ],
        value: (bilan) => bilan.geste?.transport_nv_ne_nourrisson,
    },
    {
        '@type': 'tristate',
        key: 'a801bc6e-d119-4516-ad3e-5a17049fb8eb',
        label: 'Accouchement',
        value: (bilan) => bilan.geste?.accouchement,
    },
    {
        '@type': 'dateTime',
        key: '543cc009-1cba-46f5-a26e-4f36910b8704',
        label: 'Accouchement - Date',
        value: (bilan) => {
            return {
                time: bilan.geste?.time_accouchement,
                date: bilan.geste?.date_accouchement,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: '6d0c7e2b-034d-42cb-bc97-3ec5cfef9bef',
        label: 'Accouchement - Délivrance',
        value: (bilan) => {
            return {
                time: bilan.geste?.time_delivrance,
                date: bilan.geste?.date_delivrance,
            };
        },
    },
    {
        '@type': 'select',
        key: 'efc7e138-032a-4d39-96b7-160cdd75323a',
        label: 'Accouchement - Transport du nouveau-né',
        options: [
            { value: 1, label: 'Couveuse' },
            { value: 2, label: 'Peau-à-peau' },
        ],
        value: (bilan) => bilan.geste?.transport_nv_ne,
    },
    {
        '@type': 'tristate',
        key: 'c8b50f4c-fa11-46c6-ba2d-188f4d48b2b1',
        label: 'Transfusion',
        value: (bilan) => bilan.geste?.transfusion_char,
    },
    {
        '@type': 'integer',
        key: '23c9d06c-990c-4c72-b018-11c81e0a4f5f',
        label: 'Transfusion - Nombre CGR',
        value: (bilan) => bilan.geste?.nb_cgr,
    },
    {
        '@type': 'integer',
        key: '653cfc8c-af29-40f0-a18a-d483899875c4',
        label: 'Transfusion - Nombre plaquettes',
        value: (bilan) => bilan.geste?.nb_plaquettes,
    },
    {
        '@type': 'integer',
        key: '40480a4d-112d-446c-b366-ae31f9c96af3',
        label: 'Transfusion - Nombre plasma',
        value: (bilan) => bilan.geste?.nb_plasma,
    },
    {
        '@type': 'tristate',
        key: 'abcdd942-e58d-4671-94c3-c0925896221f',
        label: 'Thrombolyse',
        value: (bilan) => bilan.geste?.thrombolyse,
    },
    {
        '@type': 'tristate',
        key: 'f57de26c-5161-4564-8844-7d1cad057d5b',
        label: 'Thrombolyse - AVC',
        value: (bilan) => bilan.geste?.avc,
    },
    {
        '@type': 'tristate',
        key: 'c2936d49-64d5-49a4-b38f-77138f3d75b9',
        label: 'Thrombolyse - SCA avec sus-ST',
        value: (bilan) => bilan.geste?.sca_sus_st,
    },
    {
        '@type': 'tristate',
        key: '2f709216-56a1-4e7f-ba31-548995b19b71',
        label: 'Thrombolyse - Embolie pulmonaire',
        value: (bilan) => bilan.geste?.embolie_pulmonaire,
    },
    {
        '@type': 'tristate',
        key: '2cf0343f-0847-4efa-8ce3-ef10f6a00546',
        label: 'Entraînement ÉlectroSystolique Externe (EESE)',
        value: (bilan) => bilan.geste.entrainement_systolique_externe,
    },
    {
        '@type': 'integer',
        key: 'fca8bc4d-e2e1-4bc8-b6db-10e0857cac62',
        unit: 'bpm',
        label: 'EESE - Fréquence',
        value: (bilan) => bilan.geste?.frequence,
    },
    {
        '@type': 'integer',
        key: '3105a3a9-5c98-4175-9776-8a78eaac1faa',
        label: 'EESE - Intensité',
        unit: 'mA',
        value: (bilan) => bilan.geste?.intensite,
    },
    {
        '@type': 'tristate',
        key: '9fa1092b-3517-4b5c-be00-352976628d6e',
        label: 'Garrot pneumatique (GPN) et/ou tourniquet',
        value: (bilan) => bilan.geste?.garrot_pneumatique_tourniquet,
    },
    {
        '@type': 'time',
        key: 'bc6a077c-df8b-4977-8adc-ca38afab88a6',
        label: 'Garrot heure',
        value: (bilan) => bilan.geste.garot_heure,
    },
    {
        '@type': 'tristate',
        key: '9fa1092b-3517-4b5c-be00-352976628d6e',
        label: 'Trachéotomie',
        value: (bilan) => bilan.geste?.tracheotomie,
    },
    {
        '@type': 'tristate',
        key: 'a6efbc73-9d25-4f88-b38f-d84a44c86c89',
        label: 'Trachéotomie - Ventilation spontanée',
        value: (bilan) => bilan.geste?.ventilation_spontanee,
    },
    {
        '@type': 'tristate',
        key: 'c7767567-9c40-4dcc-bdf6-52c21577b15b',
        label: 'Trachéotomie - Oxygénation',
        value: (bilan) => bilan.geste?.oxygenation,
    },
    {
        '@type': 'tristate',
        key: '0833cb4e-1158-4b66-bd43-a8e8ae17ae56',
        label: 'Trachéotomie - Ventilation mécanique',
        value: (bilan) => bilan.geste?.ventilation_mecanique,
    },
];
exports.gesteSmurKitSondes = [
    {
        '@type': 'multitristate',
        key: '5bb2483d-d58d-44b7-8875-0199557c7a52',
        label: 'Sondage',
        options: (bilan) => [
            { value: bilan.geste?.sondage_gastrique, label: 'Sondage naso-gastrique' },
            { value: bilan.geste?.sondage_urinaire, label: 'Sondage urinaire' },
            { value: bilan.geste?.drain_sus_pubien, label: 'Drain sus pubien' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '5bb2483d-d58d-44b7-8875-0199557c7a52',
        label: 'Damage control',
        options: (bilan) => [
            { value: bilan.geste?.garrot_pneumatique_tourniquet, label: 'Garrot pneumatique tourniquet' },
            { value: bilan.geste?.pansement_champ_sterile, label: 'Pansements et champs stériles' },
            { value: bilan.geste?.pansement_hemostatique, label: 'Pansement hémostatique (Quikclot...)' },
            { value: bilan.geste?.coussin_hemostatique, label: 'Coussin hémostatique (CHUT)' },
            { value: bilan.geste?.pansement_israelien, label: 'Pansement compressif israélien' },
            {
                value: bilan.geste?.pansement_compressif_trois_cotes,
                label: 'Pansement compressif 3 côtés',
            },
            { value: bilan.geste?.couverture_survie, label: 'Couverture de survie' },
            { value: bilan.geste?.couverture_chauffante, label: 'Couverture chauffante' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '5bb2483d-d58d-44b7-8875-0199557c7a52',
        label: 'Brûlures',
        options: (bilan) => [
            { value: bilan.geste?.douche_eau, label: "Douche à l'eau à 15° pendant 15min et +" },
            {
                value: bilan.geste?.pose_brule_stop,
                label: 'Compresse stérile Hydrogel, gardé moins de 30min (BrulStop...)',
            },
            { value: bilan.geste?.hydroxocobalamine, label: 'Hydroxocobalamine (Cyanokit)' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '3e09a798-3f4d-4da5-8f69-63da215e55e1',
        label: 'Drain pleural',
        options: (bilan) => [
            {
                value: bilan.geste?.valisette_aspiration_pleur_evac_clampee,
                label: "Valisette d'aspiration (Pleur-Evac...) clampée (ou en aspiration)",
            },
            { value: bilan.geste?.valve_anti_retour_heimlich, label: 'Valve anti-retour de Heimlich' },
        ],
    },
    {
        '@type': 'multitristate',
        key: 'b3293e5d-b1b0-439e-80ee-28b7a4cbdf6b',
        label: 'Drains abdomino-rénaux',
        options: (bilan) => [
            { value: bilan.geste?.drain_tubulaire_manovac, label: 'Drain(s) tubulaire sur Manovac' },
            { value: bilan.geste?.drain_kehr, label: 'Drain(s) de Kehr' },
            { value: bilan.geste?.lame, label: 'Lame(s)' },
            { value: bilan.geste?.redons, label: 'Redons' },
        ],
    },
    {
        '@type': 'multitristate',
        key: '6f307485-03e5-4380-8c34-e691fbc15e95',
        label: 'Stomie(s)',
        options: (bilan) => [
            { value: bilan.geste?.gastrostomie, label: 'Gastrostomie' },
            { value: bilan.geste?.jejunostomie, label: 'Jejunostomie' },
            { value: bilan.geste?.ileostomie, label: 'Ileostomie' },
            { value: bilan.geste?.colostomie, label: 'Colostomie' },
            { value: bilan.geste?.stomie_urinaire, label: 'Stomie urinaire' },
        ],
    },
];
exports.gesteSmur35v2 = [
    {
        '@type': 'permission',
        key: '20525c81-7000-4d4b-b2bd-b835ad0d1f36',
        permission: ['assessment:gestes:samu35'],
        children: [
            {
                '@type': 'category',
                key: 'f2683d4b-7677-49dc-abe2-91fce7513e77',
                columns: 1,
                className: 'cardGridLarge',
                title: 'Respiratoire',
                children: [...exports.gesteSmurRespiratoire],
            },
            {
                '@type': 'category',
                key: 'f2683d4b-7677-49dc-abe2-91fce7513e77',
                columns: 1,
                className: 'cardGridLarge',
                title: 'Réanimation',
                children: [...exports.gesteSmurReanimation],
            },
            {
                '@type': 'category',
                key: 'f2683d4b-7677-49dc-abe2-91fce7513e77',
                columns: 1,
                className: 'cardGridLarge',
                title: 'Conditionnement',
                children: [...exports.gesteSmurConditionnement],
            },
            {
                '@type': 'category',
                key: '77133432-c586-4530-b661-f380a82e814d',
                columns: 1,
                className: 'cardGridLarge',
                title: 'Kit / Sondes',
                children: [...exports.gesteSmurKitSondes],
            },
        ],
    },
];
exports.gesteSmur35v2_2_Cols = [
    {
        '@type': 'permission',
        key: '20525c81-7000-4d4b-b2bd-b835ad0d1f36',
        permission: ['assessment:gestes:samu35'],
        children: [
            {
                '@type': 'category',
                key: 'f2683d4b-7677-49dc-abe2-91fce7513e77',
                columns: 2,
                className: 'cardGridLarge',
                title: 'Respiratoire',
                children: [...exports.gesteSmurRespiratoire],
            },
            {
                '@type': 'category',
                key: 'f2683d4b-7677-49dc-abe2-91fce7513e77',
                columns: 2,
                className: 'cardGridLarge',
                title: 'Réanimation',
                children: [...exports.gesteSmurReanimation],
            },
            {
                '@type': 'category',
                key: 'f2683d4b-7677-49dc-abe2-91fce7513e77',
                columns: 2,
                className: 'cardGridLarge',
                title: 'Conditionnement',
                children: [...exports.gesteSmurConditionnement],
            },
            {
                '@type': 'category',
                key: '77133432-c586-4530-b661-f380a82e814d',
                columns: 2,
                className: 'cardGridLarge',
                title: 'Kit / Sondes',
                children: [...exports.gesteSmurKitSondes],
            },
        ],
    },
];
exports.gesteB = [
    {
        '@type': 'tristate',
        key: 'e43ae3f0-328b-4372-92d8-12aa767c45b7',
        label: 'Ventilation assistée',
        value: (bilan) => bilan.geste.ventilation_assistee,
    },
    {
        '@type': 'tristate',
        key: '72fbaa87-2985-4189-95b9-840e4a221236',
        label: 'Observation thorax',
        value: (bilan) => bilan.geste.observation_thorax,
    },
    ...exports.materielDebitO2,
    {
        '@type': 'tristate',
        key: 'ac6f6ca0-8d03-4bbd-878a-433469929791',
        label: 'Auscultation pulmonaire',
        value: (bilan) => bilan.geste.auscultation_pulmonaire,
    },
    {
        '@type': 'tristate',
        key: 'ef4908e5-3179-4443-b200-6b093c0f3424',
        label: 'Pansement 3 côtés',
        value: (bilan) => {
            if (bilan.geste.pansement3_cotes === ('n' || 'y'))
                return bilan.geste.pansement3_cotes;
            return bilan.geste.pansement_trois_cotes;
        },
    },
    {
        '@type': 'select',
        key: '2ef1f7fa-cd1a-42d2-bfbd-6da9458e6580',
        label: 'Exsufflation aiguille',
        options: [
            { value: 0, label: 'Médio-claviculaire' },
            { value: 1, label: 'Sous-axillaire' },
        ],
        value: (bilan) => bilan.geste?.exsufflation_aiguille,
    },
];
exports.rcpParTemoin = [
    {
        '@type': 'tristate',
        key: 'db03bb0b-3bff-49a7-94c7-b902fd6dbf18',
        label: 'RCP par témoin',
        value: (bilan) => bilan.geste.rcp_temoin,
    }
];
exports.hemorragieControleeHeure = [
    {
        '@type': 'time',
        key: '1b41cc5f-6b8b-4508-a92a-2f5c9fa05102',
        label: 'Hémorragie controlée - Heure de pose',
        value: (bilan) => bilan.geste.hemorragie_controlee_heure ? bilan.geste?.hemorragie_controlee_heure : null,
    }
];
exports.gesteC = [
    {
        '@type': 'tristate',
        key: 'a9738077-56d9-4032-8d0c-4098dfcd0fd8',
        label: 'RCP',
        value: (bilan) => bilan.geste.rcp,
    },
    {
        '@type': 'time',
        key: '1e49e49e-ad85-4a5e-a1f6-8c0402c936a4',
        label: 'Heure début RCP',
        value: (bilan) => bilan.geste.rcp_date ? null : bilan.geste.rcp_heure,
    },
    ...exports.rcpParTemoin,
    {
        '@type': 'tristate',
        key: 'a5c20abc-df47-4b0f-9856-b80fc418ed43',
        label: 'Pansement type H',
        value: (bilan) => bilan.geste.pansement_type_h_raw,
    },
    {
        '@type': 'time',
        key: 'b219e906-1f66-40ba-838a-b1449138bd2f',
        label: 'Pansement type H',
        value: (bilan) => bilan.geste.pansement_type_h,
    },
    {
        '@type': 'tristate',
        key: '0c5ea184-7aee-4a92-b53d-f4b5c0fc657e',
        label: 'Pansement hémostatique',
        value: (bilan) => bilan.geste.pansement_hemostatique,
    },
    {
        '@type': 'tristate',
        key: '550c7ece-e379-4202-9020-e414eb946a49',
        label: 'Pansement hémostatique efficace',
        value: (bilan) => bilan.geste.pansement_hemostatique_efficace,
    },
    {
        '@type': 'time',
        key: '24dcdb66-96fe-43f9-b141-aa22bad3647e',
        label: 'Pansement hémostatique heure',
        value: (bilan) => bilan.geste.pansement_hemostatique_heure,
    },
    ...exports.hemorragieControleeHeure,
    {
        '@type': 'tristate',
        key: '0d5bc64b-d8db-408b-8af7-969a3fb53489',
        label: 'Attelle à traction fémur',
        permission: ['assessment:c:gestes:attelle_traction_femur:visible'],
        value: (bilan) => bilan.geste.attelle_traction,
    },
    {
        '@type': 'text',
        key: 'ab5feb61-6694-4ae2-a627-266816d926eb',
        label: 'Commentaires cardiologiques',
        value: (bilan) => bilan.geste.commentaire_cardiologique,
    },
    {
        '@type': 'tristate',
        key: 'cb1ebd01-93a6-4980-862b-2dda726d71a1',
        label: 'IOT',
        value: (bilan) => bilan.geste?.iot,
    },
    {
        '@type': 'select',
        key: 'c06279c2-e2a2-47d7-a73c-c8c4eeba5c5a',
        label: 'IOT - Taille',
        options: [
            { value: 0, label: '3' },
            { value: 1, label: '6' },
            { value: 2, label: '6,5' },
            { value: 3, label: '7' },
            { value: 4, label: '7,5' },
            { value: 5, label: '8' },
        ],
        value: (bilan) => bilan.geste?.taille_iot,
    },
    {
        '@type': 'integer',
        key: 'e311fd21-a31c-40fa-a4e5-cdc9d4ab8517',
        label: 'IOT - Repère',
        value: (bilan) => bilan.geste?.repere_iot,
    },
    {
        '@type': 'tristate',
        key: 'af0c1484-a2f8-4085-b7e9-c2c2ccb7585a',
        label: 'Dispositif supraglotitque',
        value: (bilan) => bilan.geste?.dispositif_supraglottique,
    },
    {
        '@type': 'select',
        key: '765eac0b-ec89-4de1-b183-bd4d6981ee12',
        label: 'Dispositif supraglotitque - Taille',
        options: [
            { value: 0, label: '1' },
            { value: 1, label: '2' },
            { value: 2, label: '3' },
        ],
        value: (bilan) => bilan.respiration?.taille_dispositif_supra_glottique,
    },
];
exports.gesteD = [
    {
        '@type': 'tristate',
        key: 'd858d93b-b824-4d17-b63f-4dde17572a2a',
        label: 'PLS',
        value: (bilan) => bilan.geste.pls,
    },
    {
        '@type': 'select',
        key: '0252b15f-521a-4fca-8323-e58cf0863dcd',
        label: 'PLS',
        options: [{ value: 1, label: 'PLS' }],
        value: (bilan) => bilan.geste?.pls_seul,
    },
    {
        '@type': 'select',
        key: '9afee9fb-79d5-4713-9db4-37734958b336',
        label: 'CC puis PLS à deux',
        options: [
            { value: 1, label: 'CC' },
            { value: 2, label: 'PLS à deux' },
        ],
        value: (bilan) => bilan.geste?.cc_puis_pls_a_2,
    },
    {
        '@type': 'tristate',
        key: '2963035a-0f35-4b6e-b30f-25cd01f8fc7a',
        label: 'Resucrage',
        value: (bilan) => bilan.geste?.resucrage,
    },
    {
        '@type': 'text',
        key: '688796e3-e810-401e-8132-59ef9c50096b',
        label: 'Commentaire',
        value: (bilan) => bilan.geste.commentaire_neurologique,
    },
];
exports.gesteEcharpe = [
    {
        '@type': 'tristate',
        key: '67af65c5-a934-497e-b254-4ac3a60f515c',
        label: 'Écharpe',
        value: (bilan) => bilan.geste.echarpe,
    },
];
exports.gesteMatelasDepression = [
    {
        '@type': 'tristate',
        key: 'bd889b46-513b-4f87-abea-8f657336339d',
        label: 'Matelas à dépression',
        value: (bilan) => bilan.geste.matelas_depression,
    },
];
exports.gesteE = [
    {
        '@type': 'tristate',
        key: '26d1555d-a3cf-480d-9786-021a90147345',
        label: 'Protection thermique',
        value: (bilan) => bilan.geste.protection_thermique,
    },
    {
        '@type': 'tristate',
        key: 'b2e58080-144d-4d96-b279-748fd33220e5',
        label: 'Aide à la prise de médicaments',
        contentInverted: true,
        value: (bilan) => bilan.geste.aide_prise_medicaments,
    },
    {
        '@type': 'tristate',
        key: '8b779f27-f983-48cf-a8e9-5e562a11ddc8',
        label: 'Attelle cervico-thoracique',
        value: (bilan) => bilan.geste.attelle_cervico_thoracique,
    },
    {
        '@type': 'tristate',
        key: '59a0ef3f-38e8-4a4e-adf9-41a3ba00f1d2',
        label: 'Attelle à traction',
        permission: ['!assessment:c:gestes:attelle_traction_femur:visible'],
        value: (bilan) => bilan.geste.attelle_traction,
    },
    {
        '@type': 'tristate',
        key: 'db4fa5e1-3979-4183-98f3-3ac4374323cc',
        label: 'Attelle boa',
        value: (bilan) => bilan.geste.attelle_boa,
    },
    {
        '@type': 'tristate',
        key: '4f3c1243-57f1-45df-a7ff-bca05f925509',
        label: 'Attelle simple',
        value: (bilan) => bilan.geste.attelle,
    },
    {
        '@type': 'tristate',
        key: '54168899-8988-429e-96f7-56846fd59b88',
        label: 'Brancard cuillère',
        value: (bilan) => bilan.geste.brancard_cuillere,
    },
    ...exports.gesteEcharpe,
    {
        '@type': 'tristate',
        key: 'bb16d0a3-819c-4477-b96e-77d9b4f3975b',
        label: 'Maintien os long fracturé',
        value: (bilan) => bilan.geste.maintien_os_long_fracture,
    },
    {
        '@type': 'tristate',
        key: '8352a972-b70c-4970-ad92-ae659edc0ca5',
        label: 'MID',
        value: (bilan) => bilan.geste.mid,
    },
    ...exports.gesteMatelasDepression,
    {
        '@type': 'tristate',
        key: 'bd1f1f88-cf9d-4f82-b01f-b56d1ab5358f',
        label: 'Plan dur',
        value: (bilan) => bilan.geste.plandur,
    },
    {
        '@type': 'tristate',
        key: 'da956d84-0273-49bd-b086-5c3a125a4941',
        label: 'Poche de froid',
        value: (bilan) => bilan.geste.poche_froid,
    },
    {
        '@type': 'tristate',
        key: 'bc5ce422-70de-4f72-9dcf-7f8c4c7fc1fe',
        label: 'Protection de plaie',
        value: (bilan) => bilan.geste.protection_plaie,
    },
    {
        '@type': 'tristate',
        key: 'ccb1024a-22c8-4af6-ad32-5ec4507c9925',
        label: 'Réalignement de membre',
        value: (bilan) => bilan.geste.realignement_membre,
    },
    {
        '@type': 'tristate',
        key: '3c0ba3fd-e628-44ef-a90f-f58978430398',
        label: 'Refroidissement',
        value: (bilan) => bilan.geste.refroidissement,
    },
    {
        '@type': 'tristate',
        key: '7v0ba3fd-a555-44ef-p08d-f58978430398',
        label: 'Gestion hypothermie',
        value: (bilan) => bilan.geste?.gestion_hypothermie,
    },
    {
        '@type': 'tristate',
        key: '2c2ba3fd-m456-28ef-a90f-f58978430398',
        label: 'Gestion hyperthermie',
        value: (bilan) => bilan.geste?.gestion_hyperthermie,
    },
    {
        '@type': 'tristate',
        key: '18b296b8-9c4a-4476-ae00-469a99c860d2',
        label: 'Techniques de relevage',
        value: (bilan) => bilan.geste?.relevage_technique,
    },
    {
        '@type': 'tristate',
        key: '782c2278-5a86-4c8c-87eb-6c5a82d0c18e',
        label: 'Relevage',
        value: (bilan) => bilan.geste?.relevage,
    },
    {
        '@type': 'multiselect',
        key: '27b521ca-2429-40bf-9094-d28d181116b6',
        label: 'Relevage - Type',
        options: [
            { value: 1, label: 'Relevage simple' },
            { value: 2, label: 'Brancard cuillère' },
            { value: 3, label: 'Pont' },
            { value: 4, label: 'Plan dur' },
            { value: 5, label: 'ACT' },
            { value: 6, label: 'BOA' },
        ],
        value: (bilan) => bilan.geste?.relevage_type,
    },
    {
        '@type': 'tristate',
        key: 'd735ab89-bf1e-4a9e-b236-4256f637981f',
        label: 'Pose brûle stop',
        value: (bilan) => bilan.geste.pose_brule_stop,
    },
];
exports.gesteSmurOxygenation = [
    ...exports.inhalation,
    {
        '@type': 'integer',
        key: 'd09c0571-3384-4a0d-9a9e-16f98bf00ba0',
        label: 'Débit',
        unit: 'l/min',
        value: (bilan) => bilan.geste.smur_debit,
    },
    {
        '@type': 'select',
        key: '00947b84-1171-4927-bf2a-65889e5a8055',
        label: 'Dispositif',
        options: [
            { value: 1, label: 'Lunettes' },
            { value: 2, label: 'Masque haute concentration' },
        ],
        value: (bilan) => bilan.geste.smur_dispositif,
    },
];
exports.gesteSmurVni = [
    {
        '@type': 'tristate',
        key: 'f981c447-93a5-4d3e-936b-400f83aa8d98',
        label: 'Ventilation Non Invasive',
        value: (bilan) => bilan.geste.smur_vni,
    },
];
exports.gesteSmurVniDetails = [
    {
        '@type': 'integer',
        key: '252a4613-dc22-4722-b860-6a7d724b0c2b',
        label: 'FiO2',
        unit: '%',
        value: (bilan) => bilan.geste.smur_vni_fio2,
    },
    {
        '@type': 'integer',
        key: '300c53bb-6b19-4119-bbb7-17959ebb6d0d',
        label: 'AI',
        unit: 'cm H2O',
        value: (bilan) => bilan.geste.smur_vni_ai,
    },
    {
        '@type': 'integer',
        key: 'b51f3980-6598-49f2-89e8-142cca12ca97',
        label: 'PEEP',
        unit: 'cm H2O',
        value: (bilan) => bilan.geste.smur_vni_peep,
    },
    {
        '@type': 'integer',
        key: '83592d7c-fc45-490e-9c4c-30ee107060b3',
        label: 'Trigger',
        unit: 'mbar',
        value: (bilan) => bilan.geste.smur_vni_trigger,
    },
];
exports.gesteSmur = [
    ...exports.gesteSmurOxygenation,
    ...exports.gesteSmurAerosol,
    ...exports.gesteSmurVni,
    ...exports.gesteSmurVniDetails,
    ...exports.gesteSmurIntubation,
    {
        '@type': 'tristate',
        key: '9da0b246-30a0-4b6b-b141-a130142c2641',
        label: 'Ventilation Invasive',
        value: (bilan) => bilan.geste.smur_vi,
    },
    {
        '@type': 'select',
        key: '0ac90f65-ac3b-4ec2-83bf-3810c47e75ac',
        label: 'Ventilation Invasive',
        options: [
            { value: 1, label: 'Lunettes - VSAI' },
            { value: 2, label: 'Masque haute concentration - VAC' },
        ],
        value: (bilan) => bilan.geste.smur_vi2,
    },
    {
        '@type': 'integer',
        key: '5e45a610-b294-4b7d-9fa1-771ceed49f5e',
        label: 'VT',
        unit: 'mL',
        value: (bilan) => bilan.geste.smur_vi_vt,
    },
    {
        '@type': 'integer',
        key: 'd1d52571-5210-4a6a-82cf-690155ee0557',
        label: 'FR',
        unit: ' cpm',
        value: (bilan) => bilan.geste.smur_vi_fr,
    },
    {
        '@type': 'integer',
        key: 'cf291caf-c813-4359-89d5-6f4246ce9fa1',
        label: 'FiO2',
        unit: '%',
        value: (bilan) => bilan.geste.smur_vi_fio2,
    },
    {
        '@type': 'integer',
        key: 'db1414f9-a02c-43f9-9023-d44408112800',
        label: 'PEEP',
        unit: 'cm H2O',
        value: (bilan) => bilan.geste.smur_vi_peep,
    },
    {
        '@type': 'integer',
        key: '1b3df76b-9476-49a7-9746-90d1a7fb385b',
        label: 'Trigger',
        unit: 'mbar',
        value: (bilan) => bilan.geste.smur_vi_trigger,
    },
    {
        '@type': 'text',
        key: '4285ba8f-3845-4c00-8b99-40877c3277ca',
        label: 'Précisions SMUR',
        value: (bilan) => bilan.geste.smur_precision,
    },
];
exports.gesteGuedel = [
    {
        '@type': 'tristate',
        key: '1a19e40f-5473-492a-ae32-0bcda599bc85',
        label: 'Canule de guedel',
        value: (bilan) => bilan.geste.guedel,
    },
    {
        '@type': 'select',
        key: 'f308ded8-dd14-481c-b6f3-ac1a64610e21',
        label: 'Taille guedel',
        options: [
            { value: 1, label: 'Taille 00' },
            { value: 2, label: 'Taille 0' },
            { value: 3, label: 'Taille 1' },
            { value: 4, label: 'Taille 2' },
            { value: 5, label: 'Taille 3' },
            { value: 6, label: 'Taille 4' },
        ],
        value: (bilan) => bilan.geste.guedel_taille,
    },
];
exports.gesteSectionCordon = [
    {
        '@type': 'tristate',
        key: '511004a9-eb80-4e17-9ae5-eefa7e49cc97',
        label: 'Section cordon ombilical',
        value: (bilan) => bilan.geste.section_cordon_ombilical,
    },
];
exports.gesteCeinturePelvienne = [
    {
        '@type': 'tristate',
        key: 'd560c909-2d23-40b5-92ff-596fca5bb409',
        label: 'Ceinture pelvienne',
        value: (bilan) => bilan.geste.ceinture_pelvienne,
    },
];
exports.gesteKitProtection = [
    ...exports.gesteCeinturePelvienne,
    {
        '@type': 'tristate',
        key: 'ac8246e3-4835-44e5-b342-adcfda58afd5',
        label: 'Kit membre sectionné',
        value: (bilan) => bilan.geste.kit_membre_sectionne,
    },
    {
        '@type': 'tristate',
        key: 'ac6452c3-4835-15z6-b342-zmpfjh58afd5',
        label: 'Kit brûlure',
        value: (bilan) => bilan.geste?.kit_brulure,
    },
    {
        '@type': 'tristate',
        key: '8ee01fad-7e89-42c8-9a17-61c34d03395a',
        label: 'Kit damage',
        value: (bilan) => bilan.geste.kit_damage,
    },
    {
        '@type': 'tristate',
        key: '886b872a-f3c9-4da7-abb0-7e7ab408c500',
        label: 'Kit hémorragie',
        value: (bilan) => bilan.geste?.kit_hemorragie,
    },
    {
        '@type': 'tristate',
        key: '9f756c46-b4f5-4d30-8041-16256680a71b',
        label: 'Kit accouchement',
        value: (bilan) => bilan.geste.kit_accouchement,
    },
    {
        '@type': 'tristate',
        key: '05003242-35b4-43d4-a817-503026c27495',
        label: 'Kit AES',
        value: (bilan) => bilan.geste.kit_aes,
    },
    {
        '@type': 'tristate',
        key: '88bd0e22-a88a-4c1f-9a1d-66475dc26f4f',
        label: 'Kit AEV',
        value: (bilan) => bilan.geste?.kit_aev,
    },
    {
        '@type': 'tristate',
        key: '6425c56c-cd0c-4d6e-bd21-7e271b9b9e14',
        label: 'Kit VVP',
        value: (bilan) => bilan.geste.kit_vvp,
    },
    {
        '@type': 'tristate',
        key: 'a46f1de7-51c5-4b81-b9da-93df45d80d63',
        label: 'Kit covid',
        value: (bilan) => bilan.geste.kit_covid,
    },
    {
        '@type': 'tristate',
        key: 'c7e48a05-96bc-46bc-86f1-d2a1c2bf9687',
        label: 'Kit infectieux',
        value: (bilan) => bilan.geste.kit_infectieux,
    },
    {
        '@type': 'tristate',
        key: '27a4c0e5-fbd6-43b5-a73d-45bbb3952989',
        label: 'Kit aspiration',
        value: (bilan) => bilan.geste?.kit_aspiration,
    },
    {
        '@type': 'tristate',
        key: '228afabc-d69a-4286-be1d-d0c7b562bee3',
        label: 'Lots BAVU',
        value: (bilan) => bilan.geste?.lots_bavu,
    },
    {
        '@type': 'tristate',
        key: '83e9a5a7-4898-41eb-85f6-ec33c1aa0036',
        label: 'Kit SINUS',
        value: (bilan) => bilan.geste?.kit_sinus,
    },
];
exports.gesteDamageControl = [
    {
        '@type': 'tristate',
        key: '484de601-59ec-4b53-885f-079ca33bcbc9',
        label: 'Acide tranexamique',
        value: (bilan) => bilan.geste?.acide_tranexamique,
    },
    {
        '@type': 'tristate',
        key: 'd1bf928d-b873-4f78-9f7b-8d7fca4a67dc',
        label: 'Garrot',
        value: (bilan) => bilan.geste.garrot,
    },
    {
        '@type': 'time',
        key: '872ee681-b2d0-470c-8811-88c55f1cd263',
        label: 'Garrot (heure)',
        value: (bilan) => bilan.geste.chugapan,
    },
    {
        '@type': 'time',
        key: 'b49cc1e1-686f-4372-ab4c-5eeae12d3548',
        label: 'Garrot (heure)',
        value: (bilan) => bilan.geste.garot_heure,
    },
    {
        '@type': 'tristate',
        key: 'd47c6f5f-9c8d-4637-a598-4c8296b491b5',
        label: 'Garrot 2',
        value: (bilan) => bilan.geste?.garrot_2,
    },
    {
        '@type': 'time',
        key: 'c42a2e41-b781-4266-8a84-0c99c5e9f532',
        label: 'Garrot 2 (heure)',
        value: (bilan) => bilan.geste?.garrot_heure_2,
    },
    {
        '@type': 'tristate',
        key: '7382f119-a984-4b1d-8203-341abb879a55',
        label: 'Quick lock',
        value: (bilan) => bilan.geste.quick_lock,
    },
];
exports.gestePansementCompressif = [
    {
        '@type': 'tristate',
        key: 'fe64bed9-2f89-4626-9eef-841a0052561d',
        label: 'Compression manuelle',
        value: (bilan) => bilan.geste.compr_manuelle,
    },
    {
        '@type': 'tristate',
        key: '8362c1f1-ed18-47ef-94b3-bd9ea610feb0',
        label: 'Pansement compressif',
        value: (bilan) => bilan.geste.pansement_compressif,
    },
    {
        '@type': 'tristate',
        key: '9d0995f4-0d8b-48fe-a6d7-59151ce8ea2d',
        label: 'Pansement compressif efficace',
        value: (bilan) => bilan.geste?.pansement_compressif_efficace,
    },
    {
        '@type': 'tristate',
        key: '10159030-fb80-4268-8a15-800e67553feb',
        label: 'Pansement compressif',
        value: (bilan) => bilan.geste?.pansementCompressifTristate,
    },
    {
        '@type': 'time',
        key: '9129d9a3-f449-400f-b4cb-68ff98a37840',
        label: 'Pansement compressif',
        value: (bilan) => bilan.geste.pansementCompressif,
    },
    {
        '@type': 'tristate',
        key: '0697af09-ded6-4e81-9e12-c76ba6ebb68b',
        label: 'Compresses imbibées',
        value: (bilan) => bilan.geste?.compresses_imbibees,
    },
    {
        '@type': 'tristate',
        key: 'd5e81fef-6f9d-4d09-a913-72b9f1e53c31',
        label: 'Pansement israélien',
        value: (bilan) => bilan.geste?.pansement_israelien,
    },
    ...exports.gesteDamageControl,
];
exports.gesteConsommable = [
    {
        '@type': 'integer',
        key: 'f9254651-f409-4258-87e9-314355042d35',
        label: 'Compresses hémostatiques',
        value: (bilan) => !bilan.geste.compresses_hemostatiques || bilan.geste.compresses_hemostatiques <= 0
            ? null
            : bilan.geste.compresses_hemostatiques,
    },
    {
        '@type': 'integer',
        key: '8bb46fea-8376-43c6-9a4e-1ab1bacf405b',
        label: 'Compresses hydrogel 10*10',
        value: (bilan) => !bilan.geste.compresse_hydrogel_10_10 || bilan.geste.compresse_hydrogel_10_10 <= 0
            ? null
            : bilan.geste.compresse_hydrogel_10_10,
    },
    {
        '@type': 'integer',
        key: '1f75c492-0765-4ed5-b58d-93935625bc62',
        label: 'Compresses hydrogel 20*20',
        value: (bilan) => !bilan.geste.compresse_hydrogel_20_20 || bilan.geste.compresse_hydrogel_20_20 <= 0
            ? null
            : bilan.geste.compresse_hydrogel_20_20,
    },
];
exports.gestePosition = [
    {
        '@type': 'select',
        key: 'bc14ef68-0177-4665-89f8-2e148326458f',
        label: 'Position',
        options: [
            { value: 1, label: 'Libre' },
            { value: 2, label: 'Demi-assise' },
            { value: 3, label: 'PLS' },
            { value: 4, label: 'Sur le dos / Décubitus dorsal' },
            { value: 5, label: 'Autre' },
            { value: 6, label: 'Genoux fléchis' },
            { value: 7, label: 'Assis jambes pendantes' },
            { value: 8, label: 'Jambes relevées' },
        ],
        value: (bilan) => bilan.geste.position,
    },
];
exports.gestePuyDuFou = [
    {
        '@type': 'tristate',
        key: '43660a95-38d9-44af-aadf-37caac67ec15',
        label: 'Bilan médecin',
        color: 'green',
        value: (bilan) => bilan.geste.bilan_medecin,
        scope: ['puy_du_fou'],
    },
    {
        '@type': 'text',
        key: 'd860b1eb-050a-4a6a-b6b9-67d31def0d85',
        label: 'Conclusion',
        value: (bilan) => bilan.geste.conclusion,
        scope: ['puy_du_fou'],
    },
    {
        '@type': 'text',
        key: 'a6ad89ac-1b11-4ded-8ba1-2d70dcb4853d',
        label: 'Prescription',
        value: (bilan) => bilan.geste.prescription,
        scope: ['puy_du_fou'],
    },
];
exports.claquesDos = [
    {
        '@type': 'tristate',
        key: 'b65ee35c-f3ed-4b0b-8f0e-0e8a70f989fa',
        label: 'Claques dans le dos',
        value: (bilan) => bilan.geste.claquesDos,
    }
];
exports.gesteLiberationOBVA = [
    ...exports.claquesDos,
    {
        '@type': 'tristate',
        key: 'a39444ca-8598-470a-8383-b731e0daac07',
        label: 'Heimlich',
        value: (bilan) => bilan.geste.heimlich,
    },
    {
        '@type': 'tristate',
        key: '872022c4-f29e-4f58-b7ac-b9c6bc0ee524',
        label: 'Désobstruction des VA',
        value: (bilan) => bilan.geste.desobstruction_va,
    },
    {
        '@type': 'multiselect',
        key: '2ee4c945-8267-4c8e-818f-c612b7fad9f7',
        label: 'Désobstruction - Geste',
        options: [
            { value: 1, label: 'Aucun' },
            { value: 2, label: 'Claque dans le dos' },
            { value: 3, label: 'Compressions thoraciques' },
            { value: 4, label: 'Heimlich / Compression abdominale' },
        ],
        value: (bilan) => bilan.geste?.desobstruction_geste,
    },
];
exports.gesteMaintienTete = [
    {
        '@type': 'tristate',
        key: '91261267-fc46-45b7-b103-8fea01443f88',
        label: 'Maintien tête',
        value: (bilan) => bilan.geste.maintien_tete,
    },
];
exports.gesteRetraitCasque = [
    {
        '@type': 'tristate',
        key: 'fefbf396-4dd6-4dd0-ab35-b7e07be6e59d',
        label: 'Retrait de casque',
        value: (bilan) => bilan.geste.ret_casque,
    },
];
exports.gesteRetraitCasqueAvantSecours = [
    {
        '@type': 'tristate',
        key: '8fedacf3-568c-411e-867b-e83c3b78bf56',
        label: "Casque retiré avant l'arrivée des secours",
        value: (bilan) => bilan.geste.sr_casque_retire_avant_secours,
    },
];
exports.gesteInsufflation = [
    {
        '@type': 'integer',
        key: '1331461f-099d-482d-b648-4b908cac5d9d',
        label: "Insufflations d'O2",
        unit: cUser => utils.hasPerm(cUser, 'assessment:gestes:insufflation_nbr_min') ||
            utils.hasPerm(cUser, 'assessment:b:gestes:insufflation:unit_nbr_min')
            ? 'Nbr/min'
            : 'L/min',
        value: (bilan) => (bilan.geste.insu <= 0 ? null : bilan.geste.insu),
    },
];
exports.gesteRetournementUrgence = [
    {
        '@type': 'tristate',
        key: 'c15c5dcc-e11e-48f1-8880-6ebc8ac7fd36',
        label: "Retournement d'urgence",
        value: (bilan) => bilan.geste.retournement,
    },
];
exports.gesteCollierCervical = [
    {
        '@type': 'tristate',
        key: 'd1b12c1a-v8z6-6c5-9273-8e823d49b28f',
        label: 'Collier cervical',
        value: (bilan) => bilan.geste.collier,
    },
];
exports.gesteRetournementCollier = [...exports.gesteRetournementUrgence, ...exports.gesteCollierCervical];
exports.gesteDegagementUrg = [
    {
        '@type': 'tristate',
        key: '1eb6365c-fba6-4708-8257-6bee4a98df24',
        label: "Dégagement d'urgence",
        value: (bilan) => bilan.geste.dega_ur,
    },
];
exports.gesteACT = [
    {
        '@type': 'tristate',
        key: 'd2cde388-501c-4495-8479-67401ba81183',
        label: 'ACT',
        value: (bilan) => bilan.geste.act,
    },
];
exports.gestePlancheMasser = [
    {
        '@type': 'tristate',
        key: '176413a1-866f-4181-95cc-ce4a05fa47ea',
        label: 'Planche à masser',
        value: (bilan) => bilan.geste.planche_a_masser,
    },
];
exports.nbChocTotal = [
    {
        '@type': 'integer',
        key: 'fbbd522f-458e-45ae-aa2e-shj568ca6f3',
        label: "Nombre total de chocs de l'intervention",
        value: (bilan) => bilan.geste.nombre_chocs_inter,
    }
];
exports.gesteRCP = [
    {
        '@type': 'tristate',
        key: 'e627fd1b-3178-4672-b41a-02010f39510f',
        label: 'Défibrillation',
        value: (bilan) => bilan.geste.defibrillation_smur,
    },
    {
        '@type': 'integer',
        key: 'c6cab0ed-d3ff-46e8-bc4e-4a66fb5ecf28',
        label: 'Nombre de chocs du DAE public',
        unit: ' chocs',
        value: (bilan) => bilan.geste.dae_chocs,
    },
    {
        '@type': 'integer',
        key: 'fccd522f-458e-45ae-aa2e-eae1122ca6f3',
        label: 'Nombre de chocs',
        value: (bilan) => bilan.geste.nombre_chocs,
    },
    {
        '@type': 'integer',
        key: 'de7ba65f-c253-471c-bc8a-1cb46e9cbb4b',
        label: 'Nombre de chocs avant médicalisation',
        value: (bilan) => bilan.geste.nombre_chocs_avant_med,
    },
    ...exports.nbChocTotal,
    {
        '@type': 'integer',
        key: '39e9d259-bb78-40ed-a28c-8abb6790395b',
        label: 'Intensité',
        value: (bilan) => bilan.geste.intensite,
    },
];
exports.ecgEcgPrescription = [
    {
        '@type': 'tristate',
        key: '0e3b0e14-2841-4b49-a873-c7ed435e16aa',
        label: 'ECG',
        value: (bilan) => bilan.geste.ecg,
    },
    {
        '@type': 'text',
        key: 'faac9596-4a49-4d5f-bea9-d2efbb75f2a4',
        label: 'ECG sur prescription médicale, source',
        value: (bilan) => bilan.geste.ecg_sur_prescription_medicale_source,
    }
];
exports.echecPose = [
    {
        '@type': 'tristate',
        key: '8523e585-d1ad-4c75-94c0-5f49469b3e74',
        label: 'Échec de pose',
        color: 'red',
        value: (bilan) => bilan.geste?.echec_pose_state,
    },
    {
        '@type': 'multiselect',
        key: '90616a51-0ea5-4248-9a55-8055b5027e7f',
        label: 'Échec de pose',
        options: [
            { value: 1, label: 'VVP' },
            { value: 2, label: 'DIO' },
            { value: 3, label: 'TL' },
        ],
        value: (bilan) => bilan.geste.echec_pose,
    }
];
exports.prelevementSanguin = [
    {
        '@type': 'tristate',
        key: '965aa68d-64e6-469f-b83a-7afc5a0968b2',
        label: 'Bilan sanguin',
        value: (bilan) => bilan.geste.bilan_sanguin,
    },
    {
        '@type': 'tristate',
        key: 'a93ccdbb-2be8-4119-93d4-2001d19182a4',
        label: 'Prélèvement sanguin',
        value: (bilan) => bilan.geste.prelevement_sanguin,
    },
    {
        '@type': 'time',
        key: '8d496a40-21bf-45e3-b9ce-c49cb1a8ec23',
        label: 'Prélèvement sanguin - Heure',
        value: (bilan) => `${bilan.circulatoire?.heure_prelevement_sanguin}`,
    }
];
exports.gesteScope = [
    {
        '@type': 'tristate',
        key: '44cdfcc0-8d2b-40d5-9634-0907b0a827ac',
        label: 'Scope',
        value: (bilan) => bilan.geste.scope,
    },
    {
        '@type': 'tristate',
        key: 'a424af48-73a4-42af-943e-2e3e93dacfd2',
        label: 'Surv. scope',
        value: (bilan) => bilan.geste.surv_scope,
    },
];
exports.gesteVvp = [
    {
        '@type': 'multiselect',
        key: '1b96280e-9975-4730-9535-bee41cfa6897',
        label: 'VVP',
        options: [
            { value: 0, label: 'RAS' },
            { value: 1, label: 'Autre G' },
            { value: 2, label: 'Autre D' },
            { value: 3, label: 'Coude G' },
            { value: 4, label: 'Coude D' },
            { value: 5, label: 'Avant-bras G' },
            { value: 6, label: 'Avant-bras D' },
            { value: 7, label: 'Main G' },
            { value: 8, label: 'Main D' },
        ],
        value: (bilan) => bilan.geste.vvp_localisation,
    },
    {
        '@type': 'select',
        key: '03a5317a-4fa1-4dcb-b721-5b20b1e63ead',
        label: 'VVP Cathéter',
        options: [
            { value: 1, label: 'Cathéter 14G (protégé)' },
            { value: 2, label: 'Cathéter 16G' },
            { value: 3, label: 'Cathéter 18G' },
            { value: 4, label: 'Cathéter 20G' },
            { value: 5, label: 'Cathéter 22G' },
            { value: 6, label: 'Cathéter 24G' },
        ],
        value: (bilan) => bilan.geste.vvp_diametre,
    },
    {
        '@type': 'text',
        key: '1de2d71d-013b-442f-b934-b4042742d53b',
        label: 'VVP numéro de kit',
        value: (bilan) => bilan.geste.vvp_numero_kit,
    },
    {
        '@type': 'table',
        key: '0552839b-1e0f-4b4f-9ce6-2697eddedf3d',
        label: 'VVP',
        value: (bilan) => bilan.voie_veineuse_peripheriques || [],
        template: 'GESTE_VVP',
    },
];
exports._85_gesteTechnique = [
    ...exports.ecgEcgPrescription,
    ...exports.gesteScope,
    ...exports.gesteVvp,
    ...exports.echecPose,
    ...exports.prelevementSanguin
];
exports.gesteTechnique = [
    {
        '@type': 'multiselect',
        key: '26bb4690-20bc-466b-bdc4-6d83aafe544d',
        label: 'Gestes techniques',
        options: [
            { value: 1, label: 'VVP' },
            { value: 2, label: 'ECG' },
            { value: 3, label: 'Aérosol' },
            { value: 4, label: 'Injection IV' },
            { value: 5, label: 'Administration sublinguale' },
            { value: 6, label: 'Injection intra-rectale' },
            { value: 7, label: 'Injection intra-musculaire' },
            { value: 8, label: 'Tube laryngé' },
            { value: 9, label: 'Intra osseuse' },
            { value: 10, label: 'CO air expiré' },
            { value: 11, label: 'CO Rad57' },
            { value: 12, label: 'Officier santé' },
            { value: 13, label: 'Attelle traction fémur' },
            { value: 14, label: 'Pansement israélien' },
            { value: 15, label: 'VNI' },
            { value: 16, label: 'Ceinture pelvienne' },
            { value: 17, label: 'CPAP' },
            { value: 18, label: 'Exsufflation bilatérale' },
        ],
        value: (bilan) => bilan.geste.choix_gestes,
    },
    {
        '@type': 'text',
        key: 'a93d3b73-05bf-43d4-96ef-849f2b77a141',
        label: 'Gestes techniques sur prescription médicale',
        value: (bilan) => bilan.geste.geste_technique_sur_prescription_medicale,
    },
    {
        '@type': 'text',
        key: '485ce1a2-710e-4bd5-8c86-7e54697abe96',
        label: 'Gestes médicaux (réservé médecin)',
        value: (bilan) => bilan.geste.geste_medical,
    },
    ...exports.echecPose,
];
exports.gesteSmurMce = [
    {
        '@type': 'tristate',
        key: 'af485726-f0d0-4ad5-9765-3d99bba91921',
        label: 'Massage cardiaque externe',
        value: (bilan) => bilan.geste.smur_mce,
    },
];
exports.temoinType = [
    {
        '@type': 'select',
        key: 'b8c67022-10cb-475b-b8f9-92990fdaecc4',
        label: 'Témoin type',
        options: [
            { value: 0, label: 'Secouriste' },
            { value: 1, label: 'Paramédical' },
            { value: 2, label: 'Médecin' },
            { value: 3, label: 'Famille' },
            { value: 4, label: 'Autres' },
            { value: 5, label: 'Médecin / Infirmier' },
            { value: 6, label: 'Accompagnement' },
            { value: 7, label: 'Témoin de passage' },
            { value: 8, label: 'Secouriste professionnel' },
        ],
        value: (bilan) => bilan.geste.temoin_type,
    },
    {
        '@type': 'text',
        key: '0eada034-eb8a-4361-afd6-4aadb3fe7fb1',
        label: 'Témoin type - Autre',
        value: (bilan) => bilan.geste.temoin_type_autre,
    },
];
exports.temoinAcrGestes = [
    {
        '@type': 'multitristate',
        key: '9070ed66-b7c0-41e3-8ee4-9ffc75a70d80',
        label: 'Gestes effectués',
        options: (bilan) => [
            { value: bilan.geste?.temoin_bouche_a_bouche, label: 'Bouche à bouche' },
            { value: bilan.geste?.temoin_mce, label: 'MCE' },
            { value: bilan.geste?.temoin_dea_public, label: 'DEA public' },
            { value: bilan.geste?.is_chocs, label: 'Chocs effectués' },
        ],
    }
];
exports.gestesEntrepris = [
    {
        '@type': 'multiselect',
        key: '2b736bad-0cdc-4b8d-9a53-287c862efa40',
        label: 'RCP gestes entrepris',
        options: [
            { value: 1, label: 'PLS' },
            { value: 2, label: 'Ventilation artificielle' },
            { value: 3, label: 'MCE seul' },
            { value: 4, label: 'MCE plus ventilation' },
            { value: 5, label: 'Pas de gestes' },
            { value: 6, label: 'Pose DAE' },
            { value: 7, label: 'Bouche à bouche' },
        ],
        value: (bilan) => bilan.geste.rcp_geste_entrepris,
    }
];
exports.gesteTemoin = [
    {
        '@type': 'tristate',
        key: 'db48e5fb-2357-4939-aacf-b32374a2c7f4',
        label: 'Témoin',
        value: (bilan) => bilan.geste.temoin,
    },
    ...exports.temoinType,
    ...exports.gesteSmurMce,
    {
        '@type': 'tristate',
        key: '9c9774c6-59b8-41e3-9da7-996afa73cc2d',
        label: 'Chocs (DAE)',
        value: (bilan) => bilan.geste.is_chocs,
    },
    {
        '@type': 'tristate',
        key: 'c4d06375-603b-4dd8-8512-11020650bf10',
        label: 'Arrêt hémorragie',
        value: (bilan) => bilan.geste.arret_hemorragie,
    },
    {
        '@type': 'tristate',
        key: '958fff9a-2cad-4127-9943-1ae896a6935a',
        label: 'Désobstruction',
        value: (bilan) => bilan.geste.desobstruction,
    },
    {
        '@type': 'tristate',
        key: 'f5d81950-a43e-4b02-902c-918ef7bac44b',
        label: 'Mobilisation',
        value: (bilan) => bilan.geste.mobilisation,
    },
    {
        '@type': 'text',
        key: '13fbee14-8434-4523-93e6-a2166f623f1d',
        label: 'Observations',
        value: (bilan) => bilan.geste.commentaire,
    },
    {
        '@type': 'tristate',
        key: '84b6a793-2b17-49c6-8e40-ca3d7e6c550a',
        label: 'Témoin PLS',
        value: (bilan) => bilan.geste.temoin_pls,
    },
    ...exports.temoinAcrGestes,
    ...exports.gestesEntrepris,
    {
        '@type': 'dateTime',
        key: '1983733a-cc49-4393-ae60-cc2c75eb6161',
        label: 'Heure de pose du DAE public',
        value: (bilan) => {
            return {
                date: bilan.geste.temoin_dea_public_date,
                time: bilan.geste.temoin_dea_public_time,
            };
        },
    },
];
exports.gesteSondages = [
    {
        '@type': 'tristate',
        key: '72b4aba8-2bbd-4d9d-99bd-364e1a4fb6c8',
        label: 'Sondage naso-gastrique',
        value: (bilan) => bilan.geste.sondage_gastrique,
    },
    {
        '@type': 'integer',
        key: '836d3df7-9bad-40fb-9daa-578165e59b63',
        label: 'Sondage naso-gastrique - Taille',
        value: (bilan) => bilan.geste?.sondage_gastrique_taille,
    },
    {
        '@type': 'tristate',
        key: 'd71ea690-ff05-4659-bbd7-9075d710c1c4',
        label: 'Sondage urinaire',
        value: (bilan) => bilan.geste.sondage_urinaire,
    },
    {
        '@type': 'tristate',
        key: '1a60065b-97bd-49c1-8e58-7b9b057c76b8',
        label: 'Drain sus pubien',
        value: (bilan) => bilan.geste?.drain_sus_pubien,
    },
];
exports.gesteVvpExcel = [
    {
        '@type': 'select',
        key: '5d33f47b-1aa6-48b3-8ec7-ba5db2d8d17e',
        label: 'Localisation',
        options: [
            { value: 1, label: 'Coude droit' },
            { value: 2, label: 'Coude gauche' },
            { value: 3, label: 'Avant-bras droit' },
            { value: 4, label: 'Avant-bras gauche' },
            { value: 5, label: 'Main droite' },
            { value: 6, label: 'Main gauche' },
            { value: 7, label: 'Autre' },
        ],
        value: elem => elem?.localisation,
    },
    {
        '@type': 'select',
        key: '4fb5b679-597b-49fa-ad79-434e1e52d74c',
        label: 'Taille',
        options: [
            { value: 6, label: '14G' },
            { value: 1, label: '16G' },
            { value: 2, label: '18G' },
            { value: 3, label: '20G' },
            { value: 4, label: '22G' },
            { value: 5, label: '24G' },
        ],
        value: elem => elem?.taille,
    },
];
const makeGesteExcelVvp = () => {
    return [
        {
            '@type': 'tableItem',
            key: 'e0e3fa64-167d-4996-8bc4-65c0e0860e9d',
            children: [...exports.gesteVvpExcel],
        },
    ];
};
exports.makeGesteExcelVvp = makeGesteExcelVvp;
exports.gesteIntraOsseuseSelect = [
    {
        '@type': 'select',
        key: '8adf97ac-9f0d-4d37-80cf-f87b562dc7d1',
        label: 'Intra-osseuse',
        options: [
            { value: 1, label: 'Transtibiale' },
            { value: 2, label: 'Transhumérale' },
        ],
        value: (bilan) => bilan.geste.intraosseuse,
    },
];
exports.gesteBilanSanguin = [
    {
        '@type': 'integer',
        key: '3add6ef7-2f02-4e01-a1b7-4c620fa4651c',
        label: 'Tube bleau',
        value: (bilan) => bilan.geste.bilan_sanguin_tube_bleu,
    },
    {
        '@type': 'integer',
        key: 'c371c3ff-661e-432d-ad24-e547369666aa',
        label: 'Tube vert',
        value: (bilan) => bilan.geste.bilan_sanguin_tube_vert,
    },
    {
        '@type': 'integer',
        key: 'f222f12b-0d75-41fa-9662-d823fb86470b',
        label: 'Tube mauve',
        value: (bilan) => bilan.geste.bilan_sanguin_tube_mauve,
    },
    {
        '@type': 'integer',
        key: '43d1c724-770f-4714-a1b8-cbad5835c080',
        label: 'Tube violet',
        value: (bilan) => bilan.geste.bilan_sanguin_tube_violet,
    },
    {
        '@type': 'integer',
        key: '7b52387e-6dc3-47cd-8408-8cd5fd70179e',
        label: 'Tube gris',
        value: (bilan) => bilan.geste.bilan_sanguin_tube_gris,
    },
];
exports.gestePathologie = [
    {
        '@type': 'multiselect',
        key: '924e0495-21cc-4e70-b8d9-353dd7a79da3',
        label: 'Pathologie',
        options: [
            { value: 1, label: 'Médecine / Médical' },
            { value: 2, label: 'Chirurgie' },
            { value: 3, label: 'Psychiatrie' },
            { value: 4, label: 'Ophtalmologie' },
            { value: 5, label: 'Gynécologie' },
            { value: 6, label: 'ORL' },
            { value: 7, label: 'Autre' },
        ],
        value: (bilan) => bilan.geste.pathologie,
    },
    {
        '@type': 'select',
        key: '5e892bc0-8bd5-4ff2-8f26-7fbe9755539a',
        label: 'Pathologie médical',
        options: [
            { value: 1, label: 'Douleur Thoracique' },
            { value: 2, label: 'Intoxication Alimentaire' },
            { value: 3, label: 'Intoxication OH' },
            { value: 4, label: 'Autre.s' },
        ],
        value: (bilan) => bilan.geste.pathologie_medical,
    },
    {
        '@type': 'select',
        key: '7379059a-079d-4dc8-b9ab-ff9fcb4af4c7',
        label: 'Pathologie chirurgie',
        options: [
            { value: 1, label: 'Chirurgie plaie' },
            { value: 2, label: 'Chirurgie brûlure' },
            { value: 3, label: 'Chirurgie chute' },
            { value: 4, label: 'Chirurgie impact' },
            { value: 5, label: 'Pansement suivi' },
            { value: 6, label: 'Autre.s' },
        ],
        value: (bilan) => bilan.geste.pathologie_chirurgie,
    },
    {
        '@type': 'select',
        key: 'e5e94bc9-647a-4d01-ac8c-1c390ba4ec78',
        label: 'Pathologie psychiatrie',
        options: [
            { value: 1, label: "Crise d'angoisse" },
            { value: 2, label: 'Intoxication med' },
            { value: 3, label: 'Agitation' },
            { value: 4, label: 'Autre.s' },
        ],
        value: (bilan) => bilan.geste.pathologie_psychatrie,
    },
    {
        '@type': 'select',
        key: '6abcedd0-ad76-4bc9-9181-a5f415411a88',
        label: 'Pathologie ophtalmologie',
        options: [
            { value: 1, label: 'Irritation' },
            { value: 2, label: 'Corps étranger' },
            { value: 3, label: 'Traumatisme' },
            { value: 4, label: 'Autre.s' },
        ],
        value: (bilan) => bilan.geste.pathologie_ophtalmologie,
    },
    {
        '@type': 'select',
        key: 'e1efa17d-f401-452b-85c3-663eb1532c5c',
        label: 'Pathologie gynécologie',
        options: [
            { value: 1, label: 'Accouchement' },
            { value: 2, label: 'Grossesse' },
            { value: 3, label: 'Règles douloureuses' },
            { value: 4, label: 'Métrorragie' },
            { value: 5, label: 'Autre.s' },
        ],
        value: (bilan) => bilan.geste.pathologie_gyneco,
    },
    {
        '@type': 'select',
        key: '4ae6c80f-f0b3-4062-8dcc-a3ae9604313a',
        label: 'Pathologie ORL',
        options: [
            { value: 1, label: 'Épistaxis' },
            { value: 2, label: 'Otite' },
            { value: 3, label: 'Rhinopharyngite' },
            { value: 4, label: 'Autre.s' },
        ],
        value: (bilan) => bilan.geste.pathologie_orl,
    },
    {
        '@type': 'select',
        key: 'e317aafb-c539-42fb-b29b-8d8484e3fec3',
        label: 'Pathologie autre',
        options: [
            { value: 1, label: 'Agression' },
            { value: 2, label: 'Certificat' },
            { value: 3, label: 'Impliqué' },
            { value: 4, label: 'Autre.s' },
        ],
        value: (bilan) => bilan.geste.pathologie_autre,
    },
];
exports.gesteSettings = [
    {
        '@type': 'integer',
        key: 'dfb1fc5c-6969-4668-b949-2013a39b2e1e',
        label: 'Tins',
        unit: 'c/min',
        value: (bilan) => bilan.geste.settings_tins_samu35,
    },
    {
        '@type': 'integer',
        key: '257fb069-778c-4556-92f8-6675632fe229',
        label: 'AI',
        unit: 'cmH₂0',
        value: (bilan) => bilan.geste.settings_ai_samu35,
    },
    {
        '@type': 'integer',
        key: 'edc9f855-f029-477a-8914-0ee04da53f24',
        label: 'Pente',
        unit: 'cmH₂0/s',
        value: (bilan) => bilan.geste.settings_pente_samu35,
    },
    {
        '@type': 'integer',
        key: '7f2b900f-cc09-4c06-ba49-c5f3061a3649',
        label: 'Trigger Insp',
        unit: 'L/min',
        value: (bilan) => bilan.geste.settings_trigger_insp_samu35,
    },
    {
        '@type': 'integer',
        key: '4dc6476b-4ffb-4af8-8b25-7ffb81265a76',
        label: 'Trigger Exp',
        unit: '%',
        value: (bilan) => bilan.geste?.trigger_exp_samu35,
    },
    {
        '@type': 'integer',
        key: 'c4996cad-570d-4e19-b676-7ef9d5529a8a',
        label: 'fVACI',
        unit: 'c/min',
        value: (bilan) => bilan.geste.settings_fvaci_samu35,
    },
    {
        '@type': 'integer',
        key: '92562ccf-a43b-4f0a-96be-9079907a5076',
        label: 'CPAP',
        unit: 'cmH₂0',
        value: (bilan) => bilan.geste.settings_cpap_samu35,
    },
    {
        '@type': 'integer',
        key: '0dbcb41e-eeae-432f-9b31-199fcb6fb0d9',
        label: 'PI',
        unit: 'cmH₂0',
        value: (bilan) => bilan.geste.settings_pi_samu35,
    },
    {
        '@type': 'integer',
        key: '3c8f47ad-9669-43e6-9cc1-88a40f0a5337',
        label: 'f mini',
        unit: 'c/min',
        value: (bilan) => bilan.geste.settings_fmini_samu35,
    },
    {
        '@type': 'integer',
        key: 'db925ea8-b0d3-48c6-aa62-9e7387055d49',
        label: 'TImax',
        unit: 's',
        value: (bilan) => bilan.geste.settings_timax_samu35,
    },
];
exports.positionAttente = [
    {
        '@type': 'tristate',
        key: '52620b9a-4a41-476f-89a9-839f1a064569',
        label: 'Position attente',
        value: (bilan) => bilan.geste?.position_attente,
    }
];
exports.pls = [
    {
        '@type': 'tristate',
        key: '84b6a793-2b17-49c6-8e40-ca3d7e6c550a',
        label: 'PLS',
        contentInverted: true,
        value: (bilan) => bilan.geste.temoin_pls,
    },
];
exports.gestePositionArrivee = [
    {
        '@type': 'select',
        key: '668be29e-bc32-4f59-bee8-f25cfc176d8f',
        label: 'Position à notre arrivée',
        options: [
            { value: 1, label: 'Debout' },
            { value: 2, label: 'Assis' },
            { value: 3, label: 'Plat dos' },
            { value: 4, label: 'Plat ventre' },
            { value: 5, label: 'Recroquevillé' },
            { value: 6, label: 'Autre' },
            { value: 7, label: 'Jambes relevées' },
            { value: 8, label: 'Libre' },
            { value: 9, label: 'Demi assise' },
            { value: 10, label: 'Sur le dos' },
            { value: 11, label: 'PLS' },
            { value: 12, label: 'Jambes fléchies' },
        ],
        value: (bilan) => bilan.geste.position_arrivee,
    },
    ...exports.positionAttente,
];
exports.gesteSyntheseEvolutionExcel = [
    {
        '@type': 'time',
        key: '8e17c32e-9691-4cc4-a359-298c7e1064eb',
        label: 'Heure',
        value: elem => elem?.heure,
    },
    {
        '@type': 'text',
        key: 'b803feec-4b7c-4638-96d7-cc3e8ea77b6f',
        label: 'Évolution',
        value: elem => elem?.evolution,
    }
];
const makeGesteExcelSyntheseEvolution = () => {
    return [
        {
            '@type': 'tableItem',
            key: '49adbd97-1024-4158-9924-035293c3b492',
            children: [...exports.gesteSyntheseEvolutionExcel],
        },
    ];
};
exports.makeGesteExcelSyntheseEvolution = makeGesteExcelSyntheseEvolution;
exports.hypotheseDiagHoro = [
    {
        '@type': 'dateTime',
        key: 'e1568e95-c721-4ca5-91a4-fbe3a3eb2375',
        label: 'Date conclusion',
        value: (bilan) => {
            return {
                time: bilan.geste?.conslusion_time,
                date: bilan.geste?.conclusion_date,
            };
        },
    }
];
exports.examenHoro = [
    {
        '@type': 'dateTime',
        key: '3a46a93d-fc2d-49c3-b299-007b3f714fc5',
        label: 'Date examen',
        value: (bilan) => {
            return {
                time: bilan.geste?.examen_time,
                date: bilan.geste?.examen_date,
            };
        },
    }
];
exports.anamneseHoro = [
    {
        '@type': 'dateTime',
        key: 'c1f7d63a-2beb-42c7-9998-d0ab6736d42e',
        label: 'Autre date',
        value: (bilan) => {
            return {
                time: bilan.geste?.autre_time,
                date: bilan.geste?.autre_date,
            };
        },
    }
];
exports.causeSupposeeAcr = [
    {
        '@type': 'text',
        key: '64411914-ccb4-459b-a9e1-fbeac0fbc389',
        label: "Cause supposée de l'ACR",
        value: (bilan) => bilan.geste?.acr_cause_supposee?.split('@#').join(', '),
    },
    {
        '@type': 'text',
        key: 'e431b35b-9bb0-452c-9418-0e900be47421',
        label: "Cause supposée de l'ACR",
        value: (bilan) => bilan.geste.acr_cause_supposee_libre,
    }
];
exports.compressionAbdo = [
    {
        '@type': 'tristate',
        key: 'c27bf02a-aae1-4d79-a7ca-20cb7514eb6d',
        label: 'Compression abdominale',
        value: (bilan) => bilan.geste.compr_abdo,
    }
];
exports.traitementLesions = [
    {
        '@type': 'tristate',
        key: 'cdb95df7-f21f-4248-a363-f3a09bdabec3',
        label: 'Traitements des lésions',
        value: (bilan) => bilan.geste?.traitement_lesions,
    }
];
exports.attelleDepression = [
    {
        '@type': 'tristate',
        key: '469a85c3-c2dd-411e-909d-142ed8ae3eff',
        label: 'Atelle à dépression',
        value: (bilan) => bilan.geste.attelle_depression,
    }
];
exports.gesteAutres = [
    ...exports.traitementLesions,
    {
        '@type': 'text',
        key: 'f94b467d-18f7-4d92-865d-23d40a305ebe',
        label: 'Geste',
        value: (bilan) => bilan.geste.gestes_generic?.split('@#').join(', '),
    },
    {
        '@type': 'tristate',
        key: 'aa861f7d-65bc-45dc-a0dd-8a223f39180e',
        label: 'Refus de soins',
        value: (bilan) => (0, utils_1.boolToChar)(bilan.geste.refus_de_soins),
    },
    ...exports.gestePositionArrivee,
    {
        '@type': 'tristate',
        key: '7e10d29b-86a5-4168-9aed-7f9845aa7373',
        label: 'Canule oropharyngée',
        value: (bilan) => bilan.geste.canule_oropharyngee,
    },
    {
        '@type': 'tristate',
        key: '00db8b1c-19b9-41bf-8f8a-e950d2a31425',
        label: 'POMPY',
        value: (bilan) => bilan.geste.pompy,
    },
    {
        '@type': 'tristate',
        key: '06052dc6-40f0-4d55-b709-513d2025790e',
        label: 'Enfant calme',
        contentInverted: true,
        value: (bilan) => bilan.geste.enfant_calme,
    },
    {
        '@type': 'tristate',
        key: 'adc35796-8911-41da-9471-ed47804a5495',
        label: 'Communication favorisée',
        contentInverted: true,
        value: (bilan) => bilan.geste.communication_favoriser,
    },
    {
        '@type': 'tristate',
        key: 'ed4ec945-fe3d-4d19-b575-4c0fd912a040',
        label: 'PLS victime trauma',
        value: (bilan) => bilan.geste.pls_vict_trauma,
    },
    {
        '@type': 'tristate',
        key: 'cdab24f2-604d-46eb-8738-16807cb42da9',
        label: 'PLS victime non trauma',
        value: (bilan) => bilan.geste.pls_vict_non_trauma,
    },
    {
        '@type': 'multiselect',
        key: 'fb45a1d4-c633-4557-ad11-fdd4634f3e30',
        label: 'Sets et Lots',
        options: [
            { value: 1, label: 'Kit accouchement' },
            { value: 2, label: 'Sets membre sectionné' },
            { value: 3, label: 'Lots SNV' },
            { value: 4, label: 'Set AES' },
            { value: 5, label: 'Set risques infectieux' },
        ],
        value: (bilan) => bilan.geste.sets_lots,
    },
    {
        '@type': 'tristate',
        key: '0f923941-2228-4ddb-b4ac-b99eac9ad21e',
        label: 'Lot SNV',
        value: (bilan) => bilan.geste?.lot_snv,
    },
    {
        '@type': 'tristate',
        key: 'b642827e-71fa-4ffb-a142-a9060e388e21',
        label: 'Pansement',
        value: (bilan) => bilan.geste.pansement,
    },
    {
        '@type': 'text',
        key: '3d4c788d-5fc3-4acd-9ebb-2d41e4cb3971',
        label: 'Plainte principale de la victime',
        value: (bilan) => bilan.victime?.plainte_principale,
    },
    ...exports.causeSupposeeAcr,
    {
        '@type': 'time',
        key: 'a0ce67ba-2a31-4c53-8c3e-26602ae5f857',
        label: 'Heure pose DSA',
        value: (bilan) => bilan.geste.date_pose,
    },
    {
        '@type': 'text',
        key: 'd7a382d5-98b8-4aac-9fe7-79a312893e31',
        label: 'Numéro de série DSA',
        value: (bilan) => bilan.geste?.numero_serie_appareil,
    },
    {
        '@type': 'tristate',
        key: '501f90cc-bbc8-4660-b471-f8bc74af6256',
        label: 'DSA électrodes',
        value: (bilan) => bilan.geste.electrode_dsa,
    },
    {
        '@type': 'text',
        key: '4e791e84-7a3c-46ad-90dd-9f66a0b91353',
        label: 'Électrodes n° lot',
        value: (bilan) => bilan.geste?.numero_lot_electrodes,
    },
    {
        '@type': 'time',
        key: '42a2ab21-9816-41db-aede-63bec4625553',
        label: "Heure début RCP",
        value: (bilan) => bilan.geste.rcp_date ? null : bilan.geste.rcp_heure,
    },
    {
        '@type': 'dateTime',
        key: '42a2ab21-9816-41db-aede-63bec4625553',
        label: "Heure début RCP",
        value: (bilan) => {
            return {
                time: bilan.geste.rcp_heure,
                date: bilan.geste.rcp_date,
            };
        }
    },
    ...exports.attelleDepression,
    {
        '@type': 'tristate',
        key: '8a2886d8-53de-4128-9750-1dec88983175',
        label: 'Atelle à dépression bras',
        value: (bilan) => bilan.geste?.attelle_depression_bras,
    },
    {
        '@type': 'tristate',
        key: '8bfdfdc6-a828-4978-8940-7fc62d35f1f5',
        label: 'Atelle à dépression jambe',
        value: (bilan) => bilan.geste?.attelle_depression_jambe,
    },
    {
        '@type': 'tristate',
        key: '32d60df7-8b9f-46e2-85bf-dcd09378f510',
        label: 'Contre écharpe',
        value: (bilan) => bilan.geste.contre_echarpe,
    },
    {
        '@type': 'tristate',
        key: 'dcbbe2fc-bea5-4784-9f2b-d79c9d826df4',
        label: 'Écharpe oblique',
        value: (bilan) => bilan.geste.echarpe_oblique,
    },
    {
        '@type': 'tristate',
        key: '40e3755b-7f6d-4ac1-9194-a7384703e26e',
        label: 'Brancard lame',
        value: (bilan) => bilan.geste.brancard_lame,
    },
    {
        '@type': 'tristate',
        key: '03b05118-0daf-45b7-96be-ea15214cc7cd',
        label: 'Brancard souple',
        value: (bilan) => bilan.geste.brancard_souple,
    },
    {
        '@type': 'tristate',
        key: 'e96fa591-f132-4e56-96dd-37be9e88d2d3',
        label: 'Pont simple',
        value: (bilan) => bilan.geste.pont_simple,
    },
    {
        '@type': 'tristate',
        key: '3f9be9d3-c5c6-4d86-9460-7eb56657dd44',
        label: 'Pont amélioré',
        value: (bilan) => bilan.geste.pont_ameliore,
    },
    {
        '@type': 'tristate',
        key: '7c4d1749-8061-42fa-8c9d-dff5e5b14453',
        label: 'Pont à 3',
        value: (bilan) => bilan.geste.pont_neerlandais_3,
    },
    {
        '@type': 'tristate',
        key: '6b066ab9-5fb0-48d3-b19f-be7bf9ee0a12',
        label: 'Pont à 4',
        value: (bilan) => bilan.geste.pont_neerlandais_4,
    },
    {
        '@type': 'dateTime',
        key: '2f1e32b9-f854-488d-8010-806bf5e3a08a',
        label: 'Heure arrêt de la RCP',
        value: (bilan) => {
            return {
                time: bilan.geste.rcp_arret_time,
                date: bilan.geste.rcp_arret_date,
            };
        },
    },
    {
        '@type': 'select',
        key: '20ae5fdd-f5de-4c68-81af-55b1f1fc2dcf',
        label: 'RCP arrêt par',
        options: [
            { value: 1, label: 'Présence médicale' },
            { value: 2, label: 'Sur décision du médecin régulateur' },
        ],
        value: (bilan) => bilan.geste.rcp_arret_par,
    },
    {
        '@type': 'multiselect',
        key: '6a3a7744-97e4-4428-9867-1b8c1e86b994',
        label: 'Pas de RCP (raisons)',
        options: [
            { value: 1, label: 'Raideur cadavérique' },
            { value: 2, label: 'Putréfaction' },
            { value: 3, label: 'Tête séparée du tronc' },
        ],
        value: (bilan) => bilan.geste.pas_rcp_raison,
    },
    {
        '@type': 'tristate',
        key: '084f891b-e6e1-4f4c-bedc-d9f89484d667',
        label: 'Arrêt RCP par téléphone',
        value: (bilan) => bilan.geste?.rcp_arret_telephone,
    },
    {
        '@type': 'dateTime',
        key: 'a808a062-5d3f-48b7-813a-730a60ae005b',
        label: 'Arrêt RCP par téléphone - Date',
        value: (bilan) => {
            return {
                time: bilan.geste.rcp_arret_telephone_time,
                date: bilan.geste.rcp_arret_telephone_date,
            };
        },
    },
    ...exports.hypotheseDiagHoro,
    ...exports.examenHoro,
    ...exports.anamneseHoro,
    {
        '@type': 'tristate',
        key: 'e6f4dd0b-ec0d-4253-b808-471a81bfd26b',
        label: 'DAE',
        value: (bilan) => bilan.geste?.dae,
    },
    {
        '@type': 'tristate',
        key: 'cc91148a-ff9e-4629-8e89-afaee57be812',
        label: 'DAE posé par témoin',
        value: (bilan) => bilan.geste.dae_temoin,
    },
    {
        '@type': 'tristate',
        key: 'cc91148a-ff9e-4629-8e89-afaee57be812',
        label: 'DAE posé par témoin',
        value: (bilan) => bilan.geste.dae_temoin,
    },
    {
        '@type': 'tristate',
        key: 'cc91148a-ff9e-4629-8e89-afaee57be812',
        label: 'DAE posé par témoin',
        value: (bilan) => bilan.geste.dae_temoin,
    },
    {
        '@type': 'text',
        key: '88df3558-15b6-42f1-ab2e-5267886685ad',
        label: 'Provenance DAE',
        value: (bilan) => bilan.geste.dae_provenance,
    },
    {
        '@type': 'tristate',
        key: '17a423dd-a733-49ec-91a9-ee94e50a3410',
        label: 'Appui-tête',
        value: (bilan) => bilan.geste.sr_appui_tete,
    },
    {
        '@type': 'integer',
        key: '1dd97cac-4a72-4e64-99f2-0d2d1c043ff2',
        label: 'Choc',
        value: (bilan) => bilan.geste.chocs,
    },
    {
        '@type': 'text',
        key: '80baa4c3-862e-4c01-8166-c9bfc72c2eb0',
        label: 'Commentaire',
        value: (bilan) => bilan.geste.commentaire_env,
    },
    {
        '@type': 'integer',
        key: '4d38520e-2c6b-4675-add9-b478c17674e7',
        label: 'Défibrillation',
        unit: ' chocs',
        value: (bilan) => (bilan.geste.defibrillation !== 0 ? bilan.geste.defibrillation : null),
    },
    {
        '@type': 'tristate',
        key: 'd2585b28-32eb-4f03-aed2-9df861446391',
        label: 'Aspiration trachéale',
        value: (bilan) => bilan.geste.aspirationtra,
    },
    {
        '@type': 'select',
        key: 'ecfabd81-2c6f-4c3e-b4bd-0179c09de564',
        label: 'Aspiration trachéale sonde',
        options: [
            { value: 8, label: '8 CH' },
            { value: 14, label: '14 CH' },
            { value: 16, label: '16 CH' },
        ],
        value: (bilan) => bilan.geste.aspirationtra_sonde,
    },
    {
        '@type': 'tristate',
        key: 'ce2e8caa-0d4f-47d9-bc37-31c421e0357b',
        label: 'CT6',
        value: (bilan) => bilan.geste.ct6,
    },
    {
        '@type': 'tristate',
        key: 'c0401a36-f5a4-44dc-a27c-d0ce71be555a',
        label: 'Désinfection',
        value: (bilan) => bilan.geste.desinfection,
    },
    ...exports.ecgEcgPrescription,
    {
        '@type': 'multitristate',
        key: '5c3b16a3-2644-42e3-aa0c-de3c51038fe9',
        label: 'ECG',
        options: (bilan) => [
            { value: bilan.geste?.ecg_douze_derivations, label: '12 dérivations' },
            { value: bilan.geste?.ecg_droite_posterieure, label: 'Droite et postérieure' },
            { value: bilan.geste?.ecg_non, label: 'Non' },
        ],
    },
    {
        '@type': 'tristate',
        key: 'a29716e3-4f10-4eb4-9d26-0464c3b96a81',
        label: 'ECG sur prescription médicale',
        value: (bilan) => bilan.geste.ecg_sur_prescription_medicale,
    },
    ...exports.prelevementSanguin,
    {
        '@type': 'dateTime',
        key: '3d658209-2464-47d7-8d4c-4c1f44204ad2',
        label: 'ECG sur prescription médicale, date de libération',
        value: (bilan) => {
            return {
                time: bilan.geste?.ecg_sur_prescription_medicale_time,
                date: bilan.geste?.ecg_sur_prescription_medicale_date,
            };
        },
    },
    {
        '@type': 'text',
        key: '664bd87e-6075-41b2-99ee-8dda1df78ef4',
        label: 'ECG - Commentaires',
        value: (bilan) => bilan.geste?.ecg_commentaire,
    },
    {
        '@type': 'tristate',
        key: '68753d3d-86ca-45e0-abc5-af13be6ef425',
        label: 'Intubation',
        value: (bilan) => bilan.geste.intu,
    },
    {
        '@type': 'tristate',
        key: 'a1956ccf-2fe0-4906-9f1b-90c2c8ed9cc0',
        label: 'Intubation trachéale',
        value: (bilan) => bilan.geste.intubationtra,
    },
    {
        '@type': 'text',
        key: 'f9c3ccea-eb39-46ad-a5b7-c66218266aae',
        label: 'Intubation orotrachéale numéro de lot',
        value: (bilan) => bilan.geste.iot_numero_de_lot,
    },
    {
        '@type': 'tristate',
        key: 'e5b69a35-3dbb-40d8-a61d-8f14e01a49ad',
        label: 'VVP',
        value: (bilan) => bilan.geste.vvp,
    },
    {
        '@type': 'tristate',
        key: '6df5c685-1926-41cd-b3e0-d375f71b0a44',
        label: 'Intra-osseuse',
        value: (bilan) => bilan.geste.intra_osseuse || bilan.geste.intraosseuse,
    },
    {
        '@type': 'tristate',
        key: 'fd7b8adb-1b31-4604-bcd9-7fcd8c5ec673',
        label: 'Voie veineuse centrale',
        value: (bilan) => bilan.geste.voie_veineuse_centrale,
    },
    {
        '@type': 'tristate',
        key: 'cc232384-fca9-4da7-8621-ec120da5ce3c',
        label: 'KTO',
        value: (bilan) => bilan.geste.kto,
    },
    {
        '@type': 'select',
        key: '02db9cf8-c249-437e-a720-ed9ca2134789',
        label: 'KTIO',
        options: [
            { value: 0, label: 'Trans tibiale' },
            { value: 1, label: 'Trans humérale' },
        ],
        value: (bilan) => bilan.geste?.ktio,
    },
    {
        '@type': 'select',
        key: '113f1dfc-5f74-4a86-b190-acc3325f8db7',
        label: 'KTIO - Taille',
        options: [
            { value: 1, label: 'Rose 15 mm' },
            { value: 2, label: 'Bleu 25 mm' },
            { value: 3, label: 'Jaune 45 mm' },
        ],
        value: (bilan) => bilan.geste.ktio_taille,
    },
    {
        '@type': 'tristate',
        key: 'c082012c-afc5-467d-a265-962a72792baa',
        label: 'Entraînement systolique externe',
        value: (bilan) => bilan.geste.entrainement_systolique_externe,
    },
    {
        '@type': 'tristate',
        key: '748f5fdb-ee6e-43ae-9b3f-c8576f07fe20',
        label: 'CPIA',
        value: (bilan) => bilan.geste.cpia,
    },
    ...exports.gesteSondages,
    ...exports.prelevementSanguin,
    ...exports.compressionAbdo,
    {
        '@type': 'tristate',
        key: '52c5e41c-9fe8-4e6a-905a-5577d325706e',
        label: 'Refus',
        value: (bilan) => bilan.geste.refus,
    },
    ...exports.gesteScope,
    {
        '@type': 'tristate',
        key: '4c59eb86-cab4-42bb-98e1-4b0a2803d1b9',
        label: 'Télétransmission',
        value: (bilan) => bilan.geste.teletrans,
    },
    {
        '@type': 'multiselect',
        key: 'e2c19f1b-2987-45c4-b6e5-635003e87233',
        label: 'Transfusion',
        options: [
            { value: 1, label: 'CGR' },
            { value: 2, label: 'PFC' },
            { value: 3, label: 'PLYO' },
        ],
        value: (bilan) => bilan.geste.transfusion,
    },
    {
        '@type': 'select',
        key: '9c032e6c-789b-45ce-80d7-95efb55da8d4',
        label: 'Tube laryngé',
        options: [
            { value: 3, label: 'Taille 3' },
            { value: 4, label: 'Taille 4' },
            { value: 5, label: 'Taille 5' },
        ],
        value: (bilan) => bilan.geste.tube_larynge_taille,
    },
    {
        '@type': 'tristate',
        key: '2186f4ae-1445-4f7d-bc75-38ca86beff53',
        label: 'Intubation oro-pharyngée',
        value: (bilan) => bilan.geste.intubation_oropharyngee,
    },
    {
        '@type': 'integer',
        key: '8548017c-33da-42de-9cee-43e94de726c4',
        label: 'Taille sonde oro-pharyngée',
        value: (bilan) => bilan.geste.tube_oropharynge_taille,
    },
    {
        '@type': 'select',
        key: '6b689d81-7292-4a73-ac50-f9ad1e4b9179',
        label: 'Taille lame oro-pharyngée',
        options: [
            { value: 1, label: 'Lame Miller n°1 (pédiatrique)' },
            { value: 2, label: 'Lame Mac n°2' },
            { value: 3, label: 'Lame Mac n°3' },
            { value: 4, label: 'Lame Mac n°4' },
        ],
        value: (bilan) => bilan.geste.lame_oropharynge_taille,
    },
    ...exports.gesteVvp,
    ...exports.gesteIntraOsseuseSelect,
    {
        '@type': 'tristate',
        key: 'b6f5aace-f29b-457d-acba-f5758ba9630c',
        label: 'Couverture chauffante',
        value: (bilan) => bilan.geste.couverture_chauffante,
    },
    {
        '@type': 'tristate',
        key: '4b4d1e2a-9872-48ee-b92a-d483ec589fb4',
        label: 'Couverture de survie',
        value: (bilan) => bilan.geste.couverture_survie,
    },
    {
        '@type': 'tristate',
        key: 'ff348cb5-b381-4134-82ed-ead3edc40eb7',
        label: "Suture d'urgence",
        value: (bilan) => bilan.geste.suture_urgence,
    },
    {
        '@type': 'tristate',
        key: 'af2955c9-0f03-4fe4-ac09-6cc3e192a1f2',
        label: 'Lavage occulaire',
        value: (bilan) => bilan.geste.lavage_occulaire,
    },
    {
        '@type': 'tristate',
        key: '7eca16eb-3579-47a6-a7d8-655937e9fc4c',
        label: 'Rinçage brulure chimique',
        value: (bilan) => bilan.geste.rincage_brulure_chimique,
    },
    {
        '@type': 'tristate',
        key: '7f2da341-39e9-4650-90ec-30f2a057d512',
        label: 'Solution rinçage',
        value: (bilan) => bilan.geste.solution_rincage,
    },
    {
        '@type': 'tristate',
        key: 'e26e84c7-b055-45d5-8489-5e657ed83f7c',
        label: "Gel d'eau",
        value: (bilan) => bilan.geste.gel_d_eau,
    },
    {
        '@type': 'tristate',
        key: '11d57c2e-2107-46a7-bdc7-a6092d216153',
        label: 'Immobilisation',
        value: (bilan) => bilan.geste.immobilisation,
    },
    {
        '@type': 'multiselect',
        key: 'd4052f0b-300a-4edb-822b-f5537e500781',
        label: 'Immobilisation - Type',
        options: [
            { value: 1, label: 'Écharpe' },
            { value: 2, label: 'Attelle' },
            { value: 3, label: 'Collier cervical' },
            { value: 4, label: 'Bloc de tête' },
            { value: 5, label: 'MID' },
            { value: 6, label: 'Plan dur' },
            { value: 7, label: 'Sangle araignée' },
        ],
        value: (bilan) => bilan.geste?.immobilisation_type,
    },
    {
        '@type': 'tristate',
        key: '772b8b0e-e1fa-4777-991c-6727d5ee21b7',
        label: 'Immobilisation tête',
        value: (bilan) => bilan.geste?.immobilisation_tete,
    },
    {
        '@type': 'tristate',
        key: '9c5fba08-2989-4fc5-a167-768c14f2a762',
        label: 'Nébulisateur',
        value: (bilan) => bilan.geste?.nebulisateur,
    },
    {
        '@type': 'tristate',
        key: 'd3e09a65-567d-4774-9c75-5b7f7f821a99',
        label: 'Nébulisation adulte',
        value: (bilan) => bilan.geste.nebulisation_adulte,
    },
    {
        '@type': 'tristate',
        key: 'd94dc25b-0272-4abe-b82f-6345b905abf7',
        label: 'Nébulisation pédiatrique',
        value: (bilan) => bilan.geste.nebulisation_pediatrique,
    },
    {
        '@type': 'permission',
        key: '5a2d5738-2c12-484f-bc23-c02d8e713edd',
        permission: ['!gestes:condense-sdis38:visible', '!assessment:gestes:onglet-rcp'],
        children: [...exports.gesteRCP],
    },
    {
        '@type': 'tristate',
        key: '9e2b14ef-8dc7-44a0-8a81-9cec15d36a27',
        label: 'Resucrage',
        value: (bilan) => bilan.geste?.resucrage,
    },
    ...exports.gesteACT,
    ...exports.gesteSectionCordon,
    ...exports.gestePlancheMasser,
    ...exports.gestePuyDuFou,
    ...exports.gestePathologie,
    ...exports.gesteConsommable,
    ...exports.gesteSettings,
    {
        '@type': 'text',
        key: '201fddb1-417a-45fe-841f-1210f20f29f7',
        label: 'Consommables utilisés',
        value: (bilan) => bilan.geste?.consommables_utilises,
    },
    {
        '@type': 'text',
        key: '26e6a720-8942-4f56-8ff9-4dbc4680a4e6',
        label: cUser => (utils.hasPerm(cUser, 'assessment:e:gestes:consommables:materiels:rename')
            ? 'Matériels utilisés'
            : 'Consommables utilisés'),
        value: (bilan) => bilan.geste?.materiels_utilises,
    },
    {
        '@type': 'text',
        key: '1433d5f1-60a6-449c-95bc-6a852d66dbd5',
        label: 'Conditionnement',
        value: (bilan) => bilan.geste?.conditionnement,
    },
    {
        '@type': 'text',
        key: '21fd30c0-4994-4e08-a008-95ea5175e9aa',
        label: 'Observations clinique',
        value: (bilan) => bilan.geste?.observation_clinique,
    },
];
exports.acrEtco2Max = [
    {
        '@type': 'integer',
        key: '3ec0c321-8de5-40ba-8cc8-486817a0e122',
        label: 'EtCO2 max durant RCP',
        unit: 'mmHg',
        value: (bilan) => bilan.acr?.etco2_max_rcp_float || bilan.acr?.etco2_max_rcp,
    },
];
exports.heureSupposeeAcrTemoin = [
    {
        '@type': 'dateTime',
        key: '0dd39c5e-2d36-465b-90ca-5ba6baf10beb',
        label: "Heure supposée de l'arrêt",
        value: (bilan) => {
            return {
                time: bilan.geste?.temoin_heure_supposee_acr_time,
                date: bilan.geste?.temoin_heure_supposee_acr_date,
            };
        },
    }
];
exports.noFlow = [
    {
        '@type': 'integer',
        key: '2af10b00-24fb-4439-962e-65d4e7fdafb4',
        label: 'No flow',
        unit: 'min',
        value: (bilan) => bilan.acr?.no_flow,
    }
];
exports.lowFlow = [
    {
        '@type': 'integer',
        key: '97171bc1-28e6-4dff-aea1-6c299a8926a5',
        label: 'Low flow',
        unit: 'min',
        value: (bilan) => bilan.acr?.low_flow,
    }
];
exports.heureDebutEvt = [
    {
        '@type': 'dateTime',
        key: 'a408b726-31ab-40e2-9773-e12b3b550d86',
        label: "Heure de début d'événement",
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_debut_evenement_time,
                date: bilan.devenir.heure_debut_evenement_date,
            };
        },
    }
];
exports.changementDEADSA = [
    {
        '@type': 'tristate',
        key: '3bd76d2f-8777-4a09-9327-5d19976022d8',
        label: 'Changement DEA par DSA',
        value: (bilan) => bilan.geste?.acr_dea_vers_dsa,
    }
];
exports._85_acr = [
    {
        '@type': 'category',
        key: '25d52554-f1c4-425f-acf9-653c0b47203e',
        columns: 1,
        className: 'cardGridLarge',
        title: 'Prise en charge par témoin',
        children: [
            ...exports.temoinType,
            ...exports.rcpParTemoin,
            ...exports.gestesEntrepris,
            ...exports.heureSupposeeAcrTemoin,
            ...exports.noFlow,
            ...exports.lowFlow,
            ...exports.temoinAcrGestes
        ],
    },
    {
        '@type': 'category',
        key: '25d52554-f1c4-425f-acf9-653c0b47203e',
        columns: 1,
        className: 'cardGridLarge',
        title: 'Prise en charge sapeur-pompier',
        children: [
            ...exports.heureDebutEvt,
            ...exports.causeSupposeeAcr,
            ...exports.changementDEADSA,
            ...exports.nbChocTotal
        ],
    }
];
exports.acr = [
    {
        '@type': 'category',
        key: '8cd9389c-97c5-4b36-b2b8-7ec8381f6f7e',
        columns: 3,
        className: 'cardGridLarge',
        children: [
            {
                '@type': 'category',
                key: '8cd9389c-97c5-4b36-b2b8-7ec8381f6f7e',
                columns: 1,
                className: 'cardGridLarge',
                children: [
                    {
                        '@type': 'date',
                        key: '2af49023-b38e-47cb-b84a-cbc675c02cbc',
                        label: "Date de l'arrêt",
                        value: (bilan) => bilan.acr?.date_arret_cardiaque,
                    },
                    {
                        '@type': 'date',
                        key: '739d31d4-55e0-4b18-9e95-b515b02b8aa7',
                        label: "Heure de l'arrêt",
                        value: (bilan) => bilan.acr?.time_arret_cardiaque,
                    },
                    ...exports.heureSupposeeAcrTemoin,
                    {
                        '@type': 'dateTime',
                        key: 'b76f8840-0e96-499e-ab06-e324a76ac36a',
                        label: 'Heure de RACS (si pouls >1min)',
                        value: (bilan) => {
                            return {
                                time: bilan.acr?.heure_racs_time,
                                date: bilan.acr?.heure_racs_date,
                            };
                        },
                    },
                    {
                        '@type': 'category',
                        key: '37dbea59-7dd3-4d3f-8fbf-c5eebe74d0ad',
                        columns: 1,
                        className: 'cardGridLarge',
                        title: 'Anamnèse / premiers gestes',
                        children: [
                            {
                                '@type': 'select',
                                key: '1b074152-5a39-4c66-9fc7-ffce02d20d1f',
                                label: "Type d'arrêt cardiaque",
                                options: [
                                    { value: 1, label: 'Médical', kind: 'negative' },
                                    { value: 2, label: 'Traumatique', kind: 'negative' },
                                    { value: 3, label: 'Intoxication', kind: 'negative' },
                                    { value: 4, label: 'Noyade', kind: 'negative' },
                                    { value: 5, label: 'Electrocution', kind: 'negative' },
                                    { value: 6, label: 'Asphyxie', kind: 'negative' },
                                ],
                                value: (bilan) => bilan.acr?.type_arret_cardiaque,
                            },
                            {
                                '@type': 'multiselect',
                                key: '564ca874-83e9-4674-a74f-60bb2170c559',
                                label: 'Cause AC Médical',
                                options: [
                                    { value: 1, label: 'Cardiaque', kind: 'negative' },
                                    { value: 2, label: 'Neurologique', kind: 'negative' },
                                    { value: 3, label: 'Respiratoire', kind: 'negative' },
                                    { value: 7, label: 'Autre / non connu' },
                                ],
                                value: (bilan) => bilan.acr?.cause_arret_cardique_medical,
                            },
                            {
                                '@type': 'multiselect',
                                key: 'a24b3724-b3a7-497a-b8af-71c9b9c37741',
                                label: 'Cause AC Traumatique',
                                options: [
                                    { value: 1, label: 'Arme blanche', kind: 'negative' },
                                    { value: 2, label: 'Arme à feu', kind: 'negative' },
                                    { value: 3, label: 'AVP', kind: 'negative' },
                                    { value: 4, label: 'Chute', kind: 'negative' },
                                    { value: 5, label: 'Hémorragie', kind: 'negative' },
                                    { value: 6, label: 'Pendaison', kind: 'negative' },
                                    { value: 7, label: 'Autre / non connu' },
                                ],
                                value: (bilan) => bilan.acr?.cause_arret_cardiaque_traumatique,
                            },
                            {
                                '@type': 'multiselect',
                                key: 'ffc42a40-2a6e-43ae-a1c3-80a69333d9af',
                                label: 'Cause AC Asphyxie',
                                options: [
                                    { value: 1, label: 'Fausse route', kind: 'negative' },
                                    { value: 2, label: 'Pendaison', kind: 'negative' },
                                    { value: 3, label: 'Strangulation', kind: 'negative' },
                                ],
                                value: (bilan) => bilan.acr?.cause_ac_asphyxie_input,
                            },
                            {
                                '@type': 'select',
                                key: 'bd1010a0-f102-484e-9d27-5db0bb10423c',
                                label: 'Cause AC Intoxication',
                                options: [
                                    { value: 1, label: 'Volontaire' },
                                    { value: 2, label: 'Involontaire' },
                                ],
                                value: (bilan) => bilan.acr?.cause_ac_intoxication_input,
                            },
                            {
                                '@type': 'text',
                                key: 'e2053c61-ec46-42fc-aea3-3c8d10cdfe0b',
                                label: 'Commentaires',
                                value: (bilan) => bilan.acr?.commentaire,
                            },
                        ],
                    },
                    {
                        '@type': 'category',
                        key: '25d52554-f1c4-425f-acf9-653c0b47203e',
                        columns: 1,
                        className: 'cardGridLarge',
                        title: 'Fin de prise en charge',
                        children: [
                            {
                                '@type': 'tristate',
                                key: '9f95f484-1af9-4561-bd4e-2f8d1401a4fa',
                                label: 'RACS > 1min',
                                color: 'green',
                                contentInverted: true,
                                value: (bilan) => utils.boolToChar(bilan.acr?.racs),
                            },
                            ...exports.noFlow,
                            ...exports.lowFlow
                        ],
                    },
                    {
                        '@type': 'category',
                        key: '1409e624-dbfe-44d1-ae9a-912ae5036c41',
                        columns: 1,
                        className: 'cardGridLarge',
                        title: 'Si transport, admission',
                        children: [
                            {
                                '@type': 'select',
                                key: 'eca5cb78-af2e-4366-b5b5-5ab6c7690b2c',
                                label: 'Devenir',
                                options: [
                                    { value: 1, label: 'RACS', kind: 'positive' },
                                    { value: 2, label: 'Décédé', kind: 'negative' },
                                    { value: 3, label: 'MCE manuel', kind: 'negative' },
                                    { value: 4, label: 'MCE automatique', kind: 'negative' },
                                ],
                                value: (bilan) => bilan.acr?.devenir,
                            },
                            {
                                '@type': 'multiselect',
                                key: '99cfc02e-8722-4208-81aa-781f4a22ef73',
                                label: 'Pupilles',
                                options: [
                                    { value: 1, label: 'Réactives', kind: 'positive' },
                                    { value: 2, label: 'Non réactives', kind: 'negative' },
                                    { value: 3, label: 'Symétriques', kind: 'positive' },
                                    { value: 4, label: 'Asymétriques', kind: 'negative' },
                                ],
                                value: (bilan) => bilan.acr?.pupilles,
                            },
                        ],
                    },
                ],
            },
            {
                '@type': 'category',
                key: '8c7137a3-bb0b-41aa-86ec-071989a9b395',
                columns: 1,
                className: 'cardGridLarge',
                children: [
                    {
                        '@type': 'category',
                        key: 'b6403d4e-a369-4c96-83f0-549090825883',
                        columns: 1,
                        className: 'cardGridLarge',
                        title: "Avant l'arrivée du SMUR",
                        children: [
                            {
                                '@type': 'category',
                                key: '8bb887d4-5b8d-42cc-be03-e9d9aae14c1f',
                                columns: 1,
                                className: 'cardGridLarge',
                                subtitle: 'Témoin',
                                children: [
                                    {
                                        '@type': 'select',
                                        key: 'a8185e0d-9b97-4b3e-bf16-3219438c766d',
                                        label: 'Témoin',
                                        options: [
                                            { value: 1, label: 'Pas de témoin' },
                                            { value: 2, label: 'Famille / proche' },
                                            { value: 3, label: 'Secouriste' },
                                            { value: 4, label: 'Prof de santé' },
                                            { value: 5, label: 'Autre' },
                                        ],
                                        value: (bilan) => bilan.acr?.temoins,
                                    },
                                    {
                                        '@type': 'tristate',
                                        key: '75da0dce-bb47-46c3-ab41-9ec47f017222',
                                        label: 'RCP Immédiate',
                                        color: 'green',
                                        contentInverted: true,
                                        value: (bilan) => utils.boolToChar(bilan.acr?.temoin_rcp_immediate),
                                    },
                                    {
                                        '@type': 'tristate',
                                        key: '9f73e541-c00e-4255-b6ba-db8be87dd2e0',
                                        label: 'MCE (Témoin)',
                                        color: 'green',
                                        contentInverted: true,
                                        value: (bilan) => utils.boolToChar(bilan.acr?.temoin_mce),
                                    },
                                    {
                                        '@type': 'tristate',
                                        key: 'b7c22e48-a584-4f4b-b669-c6a507773623',
                                        label: 'Ventilation (Témoin)',
                                        color: 'green',
                                        contentInverted: true,
                                        value: (bilan) => utils.boolToChar(bilan.acr?.temoin_ventilation),
                                    },
                                ],
                            },
                            {
                                '@type': 'category',
                                key: '3b9d9185-13cb-4e70-b7dc-02880cf8bea2',
                                columns: 1,
                                className: 'cardGridLarge',
                                subtitle: 'Premier intervenant',
                                children: [
                                    {
                                        '@type': 'tristate',
                                        key: 'b38380bb-30fc-448e-be15-eae97e46a6d4',
                                        label: 'RCP non spécialisée',
                                        color: 'green',
                                        contentInverted: true,
                                        value: (bilan) => utils.boolToChar(bilan.acr?.pi_rcp),
                                    },
                                    {
                                        '@type': 'select',
                                        key: '6036a176-0358-443d-9eca-de0f2abe247f',
                                        label: 'Premier intervenant',
                                        options: [
                                            { value: 1, label: 'SP' },
                                            { value: 2, label: 'Autre secouriste' },
                                            { value: 3, label: 'Autre' },
                                        ],
                                        value: (bilan) => bilan.acr?.pi_type,
                                    },
                                    {
                                        '@type': 'tristate',
                                        key: '55e62b8c-2482-4ac0-b811-691564baf52b',
                                        label: 'MCE (Premier intervenant)',
                                        color: 'green',
                                        contentInverted: true,
                                        value: (bilan) => utils.boolToChar(bilan.acr?.pi_mce),
                                    },
                                    {
                                        '@type': 'tristate',
                                        key: 'ac33b819-dab0-46c5-852c-6828d4c773e3',
                                        label: 'Ventilation (Premier intervenant)',
                                        color: 'green',
                                        contentInverted: true,
                                        value: (bilan) => utils.boolToChar(bilan.acr?.pi_ventilation),
                                    },
                                    {
                                        '@type': 'tristate',
                                        key: '1d78d458-0aa9-419e-ad27-dc408345a916',
                                        label: 'DSA/DAE présent',
                                        color: 'green',
                                        contentInverted: true,
                                        value: (bilan) => utils.boolToChar(bilan.acr?.dsa_present),
                                    },
                                    {
                                        '@type': 'text',
                                        key: '7ef85cfc-c22f-49d7-ae80-d8222d8eb4dc',
                                        label: 'Provenance DSA / DAE',
                                        value: (bilan) => bilan.geste?.dsa_provenance === 'NR' ? null : bilan.geste?.dsa_provenance,
                                    },
                                    {
                                        '@type': 'integer',
                                        key: '6fca24af-c139-4848-b7b5-316813907e65',
                                        label: 'Nombre de chocs délivrés',
                                        value: (bilan) => bilan.acr?.dsa_nombre_chocs,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                '@type': 'category',
                key: '0f13bd4c-c01e-4f9b-9433-4cdc37ac8f66',
                columns: 1,
                className: 'cardGridLarge',
                children: [
                    {
                        '@type': 'category',
                        key: '2c035311-cc74-4286-a041-481c26857717',
                        columns: 1,
                        className: 'cardGridLarge',
                        title: 'Prise en charge SMUR',
                        children: [
                            {
                                '@type': 'select',
                                key: '7bc1081b-7a4d-4dec-8b16-ba0df7cb1cd9',
                                label: 'Rythme initial',
                                options: [
                                    { value: 1, label: 'Asystole', kind: 'negative' },
                                    { value: 2, label: 'Rythme sans pouls', kind: 'negative' },
                                    { value: 3, label: 'Fibrillation Ventriculaire / TV sans pouls', kind: 'negative' },
                                    { value: 4, label: 'Activité spontanée', kind: 'negative' },
                                ],
                                value: (bilan) => bilan.acr?.rythme_initial,
                            },
                            {
                                '@type': 'tristate',
                                key: '7a2e931b-7a22-4519-8efe-afa3e1a784e0',
                                label: 'Réanimation SMUR',
                                color: 'green',
                                contentInverted: true,
                                value: (bilan) => utils.boolToChar(bilan.acr?.reanimation_smur),
                            },
                            {
                                '@type': 'tristate',
                                key: 'cca1ff01-29f7-40b1-af5e-4e33b2e6604f',
                                label: 'MCE',
                                contentInverted: true,
                                color: 'green',
                                value: (bilan) => utils.boolToChar(bilan.acr?.mce_boolean),
                            },
                            {
                                '@type': 'integer',
                                key: '14385835-26c9-4484-acf6-71141ee0a31c',
                                label: 'Choc',
                                value: (bilan) => bilan.acr?.shock_integer,
                            },
                            /*
                * VIGILANCE -> Inversement de la valeur le 15/06/23, à voir si ça ne pose pas de problème
              {
                "@type": "tristate",
                key: "d4636df0-7659-4834-b6d5-b32fee63af26",
                label: "Gasps",
                color: "green",
                contentInverted: true,
                value: (bilan) => utils.boolToChar(bilan.acr?.gasps)
              },
                * */
                            {
                                '@type': 'tristate',
                                key: 'd4636df0-7659-4834-b6d5-b32fee63af26',
                                label: 'Gasps',
                                color: 'red',
                                value: (bilan) => utils.boolToChar(bilan.acr?.gasps),
                            },
                            {
                                '@type': 'tristate',
                                key: 'c0956aff-ab61-4b15-a248-d57d94ac0b89',
                                label: 'Rigidité cadavérique',
                                color: 'red',
                                value: (bilan) => utils.boolToChar(bilan.acr?.rigidite_cadaverique),
                            },
                        ],
                    },
                    {
                        '@type': 'category',
                        key: '9be359d9-b4a4-4f52-a608-7973e4e04159',
                        columns: 1,
                        className: 'cardGridLarge',
                        title: 'Ventilation et injections',
                        children: [
                            {
                                '@type': 'select',
                                key: '0eaa60aa-a7f4-47d6-b74c-3b1545b380fd',
                                label: 'Ventilation',
                                options: [
                                    { value: 1, label: 'Intubation' },
                                    { value: 2, label: 'Dispositif supraglottique' },
                                    { value: 3, label: 'Masque' },
                                    { value: 4, label: 'Aucun' },
                                ],
                                value: (bilan) => bilan.acr?.ventilation_type,
                            },
                            {
                                '@type': 'select',
                                key: '7b23d275-3e95-45b6-b216-0a5098166f29',
                                label: 'Dispositif',
                                options: [
                                    { value: 1, label: 'IOT + BAVU' },
                                    { value: 2, label: 'IOT + VAC' },
                                    { value: 3, label: 'CPV' },
                                    { value: 4, label: 'ICO / Boussignac' },
                                    { value: 5, label: 'Masque' },
                                    { value: 6, label: 'Autre' },
                                ],
                                value: (bilan) => bilan.acr?.ventilation_dispositif || bilan.acr?.ventilation,
                            },
                            {
                                '@type': 'integer',
                                key: '34c9dc10-6417-4cf1-9600-af8ec4eaf909',
                                label: 'EtCO² initial',
                                unit: 'mmHg',
                                value: (bilan) => bilan.acr?.etco2_initial_rcp_float,
                            },
                            ...exports.acrEtco2Max,
                            {
                                '@type': 'select',
                                key: 'ba3549eb-2117-4796-878e-6dc109524784',
                                label: 'Injection',
                                options: [
                                    { value: 1, label: 'Aucun' },
                                    { value: 2, label: 'IV Périphérique' },
                                    { value: 3, label: 'Intra-osseuse' },
                                    { value: 4, label: 'IV centrale' },
                                    { value: 5, label: 'Endotrachéale' },
                                ],
                                value: (bilan) => bilan.acr?.injection_type,
                            },
                            {
                                '@type': 'integer',
                                key: 'ad728cd6-46e9-4b61-a39c-3122038e00cc',
                                label: "Dose totale d'adrénaline",
                                unit: 'mg',
                                value: (bilan) => bilan.acr?.injection_adrenaline_total,
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
exports.anamnese = [
    {
        '@type': 'text',
        key: '4263c7db-0fe9-4336-bac1-03f336ead529',
        label: 'Anamnèse',
        value: (bilan) => (bilan.geste.autre === 'NR' ? null : bilan.geste.autre),
    },
];
exports.pathologie = [
    {
        '@type': 'select',
        key: '5e73d0c2-ba98-4da8-a1b6-d8dac96d2312',
        label: 'Pathologie',
        options: [
            { value: 1, label: 'Médecine / Médical' },
            { value: 2, label: 'Chirurgie' },
            { value: 3, label: 'Psychatrie' },
            { value: 4, label: 'Ophtalmologie' },
            { value: 5, label: 'Gynecologie' },
            { value: 6, label: 'ORL' },
            { value: 7, label: 'Autre' },
        ],
        value: (bilan) => bilan.geste.pathologie,
    },
    {
        '@type': 'select',
        key: '4a75a812-ecdb-472a-acd6-a1ca093b9d9b',
        label: 'Pathologie médical',
        options: [
            { value: 1, label: 'Douleur Thoracique' },
            { value: 2, label: 'Intoxication Alimentaire' },
            { value: 3, label: 'Intoxication OH' },
            { value: 4, label: 'Autres(s)' },
        ],
        value: (bilan) => bilan.geste.pathologie_medical,
    },
    {
        '@type': 'select',
        key: 'bc58a284-92f7-41f3-8687-d627d344f83f',
        label: 'Pathologie chirurgie',
        options: [
            { value: 1, label: 'Chirurgie Plaie' },
            { value: 2, label: 'Chirurgie Brûlure' },
            { value: 3, label: 'Chirurgie Chute' },
            { value: 4, label: 'Chirurgie Impact' },
            { value: 5, label: 'Pansement suivi' },
            { value: 6, label: 'Autres(s)' },
        ],
        value: (bilan) => bilan.geste.pathologie_chirurgie,
    },
    {
        '@type': 'select',
        key: '7b73ac69-5028-4a23-97c1-b2f36643c669',
        label: 'Pathologie psychiatrie',
        options: [
            { value: 1, label: "Crise d'Angoisse" },
            { value: 2, label: 'Intoxication Med' },
            { value: 3, label: 'Agitation' },
            { value: 4, label: 'Autres(s)' },
        ],
        value: (bilan) => bilan.geste.pathologie_psychatrie,
    },
    {
        '@type': 'select',
        key: '6aeaef36-4115-4dda-9012-156879bf23ff',
        label: 'Pathologie ophtalmologie',
        options: [
            { value: 1, label: 'Irritation' },
            { value: 2, label: 'Corps étranger' },
            { value: 3, label: 'Traumatisme' },
            { value: 4, label: 'Autres(s)' },
        ],
        value: (bilan) => bilan.geste.pathologie_ophtalmologie,
    },
    {
        '@type': 'select',
        key: '5ea8c948-94eb-4083-8388-4e8d50c1551c',
        label: 'Pathologie gynéco',
        options: [
            { value: 1, label: 'Accouchement' },
            { value: 2, label: 'Grossese' },
            { value: 3, label: 'Règles douloureuses' },
            { value: 4, label: 'Metrorragie' },
            { value: 5, label: 'Autres(s)' },
        ],
        value: (bilan) => bilan.geste.pathologie_gyneco,
    },
    {
        '@type': 'select',
        key: '26529982-45dd-49f6-b99e-421569f6d831',
        label: 'Pathologie ORL',
        options: [
            { value: 1, label: 'Epistaxis' },
            { value: 2, label: 'Otite' },
            { value: 3, label: 'Rhinopharyngite' },
            { value: 4, label: 'Autres(s)' },
        ],
        value: (bilan) => bilan.geste.pathologie_orl,
    },
    {
        '@type': 'select',
        key: '8b18fa34-7fc7-4c07-b706-eb797e4a0aa9',
        label: 'Pathologie autre',
        options: [
            { value: 1, label: 'Agression' },
            { value: 2, label: 'Certificat' },
            { value: 3, label: 'Impliqué' },
            { value: 4, label: 'Autres(s)' },
        ],
        value: (bilan) => bilan.geste.pathologie_autre,
    },
];
exports.temoinsExcel = [
    {
        '@type': 'text',
        key: '038bcd42-7099-4609-838b-3b33814594ba',
        label: 'Nom',
        value: elem => elem?.lastName,
    },
    {
        '@type': 'text',
        key: 'd59f13a7-c5fc-4eaf-a2cf-547d556d0d27',
        label: 'Prénom',
        value: elem => elem?.firstName,
    },
    {
        '@type': 'text',
        key: '49d54848-862b-47d4-aeac-6ba941908586',
        label: 'Adresse',
        value: elem => elem?.address,
    },
    {
        '@type': 'text',
        key: 'dbe585a8-907f-476a-a5c5-1827baf371b2',
        label: 'Signature',
        value: elem => elem?.sign,
    },
];
const makeExcelTemoins = () => {
    return [
        {
            '@type': 'tableItem',
            key: 'fdf37595-99d0-4359-a426-0e5413dc4587',
            children: [...exports.temoinsExcel],
        },
    ];
};
exports.makeExcelTemoins = makeExcelTemoins;
exports.situationAutreField = [
    {
        '@type': 'tristate',
        key: '0093514d-94cf-4686-965e-c0b4b3bc814e',
        label: 'Autre',
        value: (bilan) => bilan.circonstance?.autre,
    }
];
exports.securiteFields = [
    {
        '@type': 'tristate',
        key: 'c42f68a8-8e3c-499a-be4b-c79f7cf4a2ac',
        label: 'CO',
        value: (bilan) => bilan.circonstance?.co,
    },
    {
        '@type': 'tristate',
        key: 'e80ba857-c0a4-472d-961a-789ac6d3fa70',
        label: 'Fumée',
        value: (bilan) => bilan.circonstance?.fumee,
    },
    {
        '@type': 'tristate',
        key: 'e5b588a2-ef5d-4fce-9c8d-2f1dd20c9f91',
        label: 'Milieu hostile',
        value: (bilan) => bilan.circonstance?.milieu_hostile,
    }
];
exports.circonstances = [
    {
        '@type': 'text',
        key: '7367c671-15e3-4850-b7d7-906191c7433c',
        label: 'Circonstances',
        value: (bilan) => (bilan.circonstance.commentaire === 'NR' ? null : bilan.circonstance.commentaire),
    },
    {
        '@type': 'integer',
        key: '15daa6eb-ed69-4cc9-85de-8915cbd5439f',
        label: 'Temps écoulé',
        unit: ' min',
        value: (bilan) => bilan.circonstance?.temps_minutes,
    },
    {
        '@type': 'text',
        key: 'd71260a0-7cf8-43c9-928d-2d9f35a7a63c',
        label: 'Contact',
        value: (bilan) => bilan.circonstance?.contact,
    },
    {
        '@type': 'text',
        key: 'c26e3d18-5641-4a04-9f2a-a466adfe7582',
        label: 'Téléphone',
        value: (bilan) => bilan.circonstance?.contact_phone,
    },
    {
        '@type': 'text',
        key: '80be8752-bf0c-4006-83dc-fc792d459c64',
        label: 'Autre motif',
        value: (bilan) => bilan.circonstance?.autre_motif,
    },
    {
        '@type': 'text',
        key: '4a92cc14-8968-4b5d-b7ee-83ab5c2db478',
        label: 'Nombre de victimes',
        value: (bilan) => bilan.circonstance?.nb_victimes,
    },
    {
        '@type': 'text',
        key: '32c4a67d-02a7-4072-839e-61769fc546dd',
        label: 'Autre service SLL',
        value: (bilan) => bilan.circonstance?.autre_service_sll,
    },
    {
        '@type': 'text',
        key: 'ba53401e-8ee6-4332-9465-5bb65cf51afd',
        label: 'Demande de renfort',
        value: (bilan) => bilan.circonstance?.demande_renforts,
    },
    ...exports.situationAutreField,
    ...exports.securiteFields,
    {
        '@type': 'table',
        key: '0b1e46ce-064a-4d14-9c3d-9dee2ab5de8c',
        label: 'Témoins - Synthèse',
        value: (bilan) => bilan.circonstance?.excel_temoins || [],
        template: 'TEMOINS',
    },
];
exports.lieuIntervention = [
    {
        '@type': 'text',
        key: '09f09f07-1b04-4097-b2fb-9e92e9a7d063',
        label: "Lieu d'intervention",
        value: (bilan) => bilan.circonstance.lieu === 'NR'
            ? null
            : bilan.circonstance.lieu === 'DOMICILEPERS'
                ? 'Domicile personnel'
                : bilan.circonstance.lieu,
    },
    {
        '@type': 'text',
        key: '09f09f07-1b04-4097-b2fb-9e92e9a7d063',
        label: "Lieu d'intervention (autre)",
        value: (bilan) => bilan.circonstance.lieu_autre
    },
];
exports.atteinteCirconstancielAccidents = [
    {
        '@type': 'select',
        key: '513b7d08-616d-4606-adc6-ac5cae9d1d85',
        label: 'Intoxication par',
        options: [
            { value: 1, label: 'Alcool', kind: 'negative' },
            { value: 2, label: "Fumée d'incendie", kind: 'negative' },
            { value: 3, label: 'Médicament', kind: 'negative' },
            { value: 4, label: 'Autre', kind: 'negative' },
            { value: 5, label: 'CO', kind: 'negative' },
        ],
        value: (bilan) => bilan.lesionnel.intoxication_par,
    },
    {
        '@type': 'multiselect',
        key: 'd892a659-d44d-4f9b-9048-0aa298ad395a',
        label: 'Intoxication par',
        options: [
            { value: 1, label: 'Alcool', kind: 'negative' },
            { value: 2, label: "Fumée d'incendie", kind: 'negative' },
            { value: 3, label: 'Médicament', kind: 'negative' },
            { value: 4, label: 'Autre', kind: 'negative' },
            { value: 5, label: 'CO', kind: 'negative' },
        ],
        value: (bilan) => bilan.lesionnel.intoxication_par_multi,
    },
    {
        '@type': 'text',
        key: 'bad0ef9c-d13e-4a51-ad65-c9fe4c8df2ae',
        label: 'Intoxication par (autre)',
        value: (bilan) => bilan.lesionnel.intoxication_par_autre,
    },
    {
        '@type': 'integer',
        key: '3b406d16-9a11-45e4-be93-cd77004349cc',
        label: 'CO',
        unit: ' ppm',
        value: (bilan) => bilan.lesionnel.co,
    },
    {
        '@type': 'integer',
        key: 'a1ee121f-3022-4514-bf4c-1072c00ba117',
        label: 'CO ambiant',
        unit: ' ppm',
        value: (bilan) => bilan.lesionnel.co_ambiant,
    },
];
// Atteinte circonstanciel SDIS 64
exports.atteinteCirconstanciel = [
    {
        '@type': 'multiselect',
        key: '292b9d50-ab44-4f78-ab54-587a19cfebb2',
        label: 'Motifs de non réanimation',
        options: [
            { value: 1, label: 'Décapitation' },
            { value: 2, label: 'Écrasement de la tête / Éclatement boite crânienne' },
            { value: 3, label: 'Destruction évidente du cerveau' },
            { value: 4, label: 'Raideur et lividité cadavérique' },
            { value: 5, label: 'Décomposition évidente des tissus' },
            { value: 6, label: 'Directive anticipé' },
        ],
        value: (bilan) => bilan.lesionnel.circonst_dcd,
    },
    {
        '@type': 'select',
        key: '2ac16870-8216-4380-91a9-6277069cf2ac',
        label: 'Soins psy',
        options: [
            { value: 1, label: 'Accepte les soins', kind: 'positive' },
            { value: 2, label: 'Hospitalisation sous contrainte', kind: 'negative' },
        ],
        value: (bilan) => bilan.lesionnel.soins_psy,
    },
    {
        '@type': 'tristate',
        key: 'f49752ab-484c-4e4e-b23c-5898b9a30123',
        label: 'Déclenchement intempestif',
        value: (bilan) => bilan.equipe.declanchement_intempestif,
    },
];
exports.contexteHorsAvp = [
    {
        '@type': 'multiselect',
        key: '608b80a4-930b-4e00-82b3-3af5c0e77eac',
        label: 'Hors AVP',
        options: [
            { value: 1, label: 'Chute' },
            { value: 2, label: 'Trouble psy' },
            { value: 3, label: 'Parturiente' },
            { value: 4, label: 'Intoxication' },
            { value: 5, label: 'Tentative de suicide' },
            { value: 6, label: 'ACR' },
            { value: 7, label: 'Rixe / agression' },
            { value: 8, label: 'Malaise' },
            { value: 9, label: 'Explosion' },
            { value: 10, label: 'Incendie' },
            { value: 11, label: 'Noyade' },
            { value: 12, label: 'Arme blanche' },
            { value: 13, label: 'Arme à feu' },
            { value: 14, label: 'Pendaison / strangulation' },
            { value: 15, label: 'Noyade' },
        ],
        value: (bilan) => bilan.circonstance.hors_avp,
    },
];
exports.adresseIntervention = [
    {
        '@type': 'text',
        key: '5094ad6d-94fe-4e9d-ab57-ae19b786b8a7',
        label: 'Adresse intervention',
        value: (bilan) => bilan.equipe.adresse,
    },
    {
        '@type': 'text',
        key: '2ddf35c6-6dbc-43d0-89dc-61f62e50ac51',
        label: 'Adresse intervention, précisions',
        value: (bilan) => bilan.equipe.adresse_precisions,
    },
];
exports.maladieMalaiseField = [
    {
        '@type': 'tristate',
        key: 'bcd2e164-406e-4a38-b211-bf7b5646e548',
        label: 'Maladie / malaise',
        color: 'red',
        value: (bilan) => bilan.circonstance?.maladie_malaise,
    }
];
exports.circonstanciel = [
    ...exports.lieuIntervention,
    ...exports.circonstances,
    {
        '@type': 'text',
        key: '45a3a720-7155-4aec-9326-d6f1b0d10afa',
        label: 'Observations',
        value: (bilan) => bilan.circonstance.observation,
    },
    {
        '@type': 'tristate',
        key: '09848270-9652-4802-8dae-b25eca6fa438',
        label: 'Accidents / blessé',
        color: 'red',
        value: (bilan) => bilan.circonstance.blesses,
    },
    ...exports.contexteHorsAvp,
    {
        '@type': 'integer',
        key: '0c8bf2b9-16e5-4fa6-8abc-4750aa7b5f46',
        label: 'Hauteur de chute',
        unit: 'm',
        value: (bilan) => bilan.circonstance.hauteur_chute,
    },
    {
        '@type': 'tristate',
        key: 'ac22afdc-ce8e-47e9-afe6-7ac1a44a561d',
        label: 'Maladie / malaise',
        color: 'red',
        value: (bilan) => bilan.circonstance.malaise,
    },
    ...exports.maladieMalaiseField,
    {
        '@type': 'text',
        key: '802e6310-a3bb-4d87-bf78-9d468add7d67',
        label: 'Autres missions',
        value: (bilan) => bilan.circonstance.autres_missions,
    },
    {
        '@type': 'integer',
        key: '8fb86ca3-bc31-4b5e-8f99-81f042772225',
        label: 'Temps',
        unit: 'min',
        value: (bilan) => bilan.circonstance.temps_min,
    },
    {
        '@type': 'text',
        key: 'b6386e96-66b1-43f7-876f-0514af7b4d81',
        label: 'Origine de l\'appel',
        value: (bilan) => bilan.victime?.origine_appel,
    },
];
exports.circonstancielSamu13 = [
    {
        '@type': 'text',
        // Ne pas changer l'UUID
        key: '5446f68c-e58d-4b0e-a99b-a9da17aaa4c2',
        label: 'Incident n°',
        value: (bilan) => bilan.equipe.intervention_num,
    },
    {
        '@type': 'text',
        key: 'e652d7f2-d9e1-4453-beed-eb24f1cdd525',
        label: 'Commune d\'intervention',
        value: (bilan) => {
            const parts = (bilan.equipe.adresse ?? "").split(" ");
            if (parts.length === 0) {
                return null;
            }
            if (parts[parts.length - 1].length !== 3) {
                return null;
            }
            return parts[parts.length - 1];
        },
    },
    ...exports.lieuIntervention,
    {
        '@type': 'text',
        // Ne pas changer l'UUID
        key: '642316b4-097d-4e35-8f21-18f2f485006e',
        label: 'Sous nature',
        value: (bilan) => bilan.circonstance.sous_nature,
    },
    {
        '@type': 'text',
        key: '69135474-0d0b-4b9b-b217-1c6baf92cbc7',
        label: 'Circonstance de l\'intervention',
        value: (bilan) => bilan.circonstance.circonstance_inter,
    },
    {
        '@type': 'text',
        key: '4a92cc14-8968-4b5d-b7ee-83ab5c2db478',
        label: 'Nombre de victimes',
        value: (bilan) => {
            if (bilan.circonstance?.nb_victimes == null || bilan.circonstance?.nb_victimes === '') {
                return null;
            }
            return `Nombre de victimes : ${bilan.circonstance?.nb_victimes}`;
        },
    },
];
exports.circulatoireNRC = [
    {
        '@type': 'tristate',
        key: '195ec8e3-7426-4893-a20f-a96ec7da418e',
        label: 'Bien frappé',
        color: 'green',
        value: (bilan) => bilan.circulatoire.frappe,
    },
    {
        '@type': 'tristate',
        key: 'd48b9a56-e914-48cf-a27c-4e467faabd11',
        label: 'Pouls régulier',
        color: 'green',
        value: (bilan) => bilan.circulatoire.regulier,
    },
    {
        '@type': 'tristate',
        key: '7a241255-b175-44a7-a28f-0a2cca213608',
        label: 'Pouls symétrique',
        color: 'green',
        value: (bilan) => bilan.circulatoire.symetrique,
    },
];
exports.circulatoireABCDE = [
    {
        '@type': 'tristate',
        key: '6528d412-3aef-4058-8137-5b1f0ffcc9bb',
        label: cUser => utils.hasPerm(cUser, 'assessment:c:primaire:difficilement-percu:label-pouls-mal-frappe')
            ? 'Pouls mal frappé'
            : 'Difficilement perçu / Filant',
        color: 'red',
        contentInverted: true,
        value: (bilan) => bilan.circulatoire.frappe,
    },
    {
        '@type': 'tristate',
        key: '581466c6-f182-43a7-8946-259c785519a1',
        label: 'Irrégulier',
        color: 'red',
        contentInverted: true,
        value: (bilan) => bilan.circulatoire.regulier,
    },
    {
        '@type': 'tristate',
        key: '50946e3c-82dc-44b3-aa74-37da8d26030e',
        label: 'Asymétrique',
        color: 'red',
        contentInverted: true,
        value: (bilan) => bilan.circulatoire.symetrique,
    },
    {
        '@type': 'select',
        key: 'db56364c-1f4b-41fe-b742-7b1ae1600a28',
        label: 'Fréquence / Estimation FC',
        options: [
            { value: 2, label: 'Normale', kind: 'positive' },
            { value: 4, label: 'Lente / Bradycardie', kind: 'negative' },
            { value: 8, label: 'Rapide / Tachycardie', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.frequence_evaluation,
    },
    {
        '@type': 'multiselect',
        key: '2e2bc84e-d00d-48ae-8d66-5c1113c3e3df',
        label: 'Douleur',
        options: [
            { value: 1, label: 'RAS', kind: 'positive' },
            { value: 2, label: 'Abdominale', kind: 'negative' },
            { value: 3, label: 'Bassin', kind: 'negative' },
            { value: 4, label: 'Fémur', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.recherche_douleur,
    },
    {
        '@type': 'multiselect',
        key: 'b7fe6a0b-744b-4177-9e88-7da9fb6cdf6f',
        label: 'Signe de précharge',
        options: [
            { value: 1, label: 'Aucun', kind: 'positive' },
            { value: 2, label: 'Œdème M inf', kind: 'negative' },
            { value: 3, label: 'Turgescence des jugulaires', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire?.signe_precharge,
    },
];
exports.hemorragieDetailsObj = {
    '@type': 'multiselect',
    key: '48ead32f-0d55-4351-b420-cbfa5f32fc43',
    label: 'Hémorragie',
    options: [
        { value: 1, label: 'Contrôlée', kind: 'positive' },
        { value: 2, label: 'Non contrôlée', kind: 'negative' },
        { value: 3, label: "Pas d'hémorragie", kind: 'positive' },
        { value: 4, label: 'Externe', kind: 'negative' },
        { value: 5, label: 'Interne', kind: 'negative' },
        { value: 6, label: 'Orifices naturels', kind: 'negative' },
    ],
    value: (bilan) => bilan.circulatoire.hemorragie_detail,
};
exports.controleHemorragie = [
    {
        '@type': 'tristate',
        key: 'dd75939c-b465-48f1-9379-076f4900a3dd',
        label: cUser => utils.hasPerm(cUser, 'assessment:x:primaire:hemorragie:hemorragie_controlee:visible')
            ? 'Hémorragie contrôlée'
            : "Contrôle de l'hémorragie",
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.circulatoire.controle_hemorragie,
    }
];
// Utilisé seul dans la section Vital du NRC
// À ajouter à circulatoire pour une section complète C du ABCDE et Circulatoire du NRC
exports.circulatoireVital = [
    {
        '@type': 'tristate',
        key: '61892c38-66f8-4004-ae28-af99f687081a',
        label: 'Hémorragie',
        color: 'red',
        value: (bilan) => bilan.circulatoire.hemorragie,
    },
    exports.hemorragieDetailsObj,
    ...exports.controleHemorragie,
    {
        '@type': 'integer',
        key: 'e4e09733-d1ce-4ffe-8a58-d5e1f36bb358',
        label: 'Quantité de sang perdue',
        unit: 'mL',
        value: (bilan) => bilan.circulatoire.hemorragie_quantite_sang,
    },
    {
        '@type': 'multiselect',
        key: '42353c27-a8ea-483f-ba45-65eef430ed9c',
        label: 'Localisation',
        options: [
            { value: 1, label: 'Tête', kind: 'negative' },
            { value: 2, label: 'Thorax', kind: 'negative' },
            { value: 3, label: 'Abdomen', kind: 'negative' },
            { value: 4, label: 'Membre sup', kind: 'negative' },
            { value: 5, label: 'Membre inf', kind: 'negative' },
            { value: 6, label: 'Gynéco-obstétrique', kind: 'negative' },
            { value: 7, label: 'Bassin', kind: 'negative' },
            { value: 8, label: 'Cuisse', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.localisation,
    },
    {
        '@type': 'tristate',
        key: '9fd74e7c-f850-45da-a083-10902d5db3d8',
        label: 'Arrêt cardiaque',
        color: 'red',
        value: (bilan) => bilan.circulatoire.arret_circulatoire,
    },
];
exports.detresseCirculatoire = [
    {
        '@type': 'tristate',
        key: 'cc675bab-b40a-4488-89da-15a090a01b9a',
        label: 'Détresse circulatoire',
        value: (bilan) => bilan.circulatoire?.detresse_circulatoire,
    },
];
exports.pouls = [
    {
        '@type': 'tristate',
        key: '56cc63b1-2219-4707-874a-52e6ecc34b24',
        label: 'Pouls filant',
        color: 'red',
        value: (bilan) => bilan.circulatoire.pouls_filant,
    },
    {
        '@type': 'tristate',
        key: '10ad171a-8fea-4fea-ac72-267d7536943c',
        label: 'Absence pouls',
        color: 'red',
        value: (bilan) => bilan.circulatoire.absence_pouls,
    },
    {
        '@type': 'tristate',
        key: '6d65cba3-e24e-4294-b08b-1b2668730e64',
        label: 'Pouls irrégulier',
        value: (bilan) => bilan.circulatoire?.pouls_irregulier,
    },
    {
        '@type': 'tristate',
        key: 'd8987104-bb58-4db5-9037-44875ea4c2dd',
        label: 'Normale',
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.circulatoire.normale,
    }
];
exports.paleurs = [
    {
        '@type': 'tristate',
        key: 'f31ef068-958e-48a9-80a8-7ac3cb3b83a9',
        label: 'Paleurs',
        value: (bilan) => bilan.circulatoire?.paleurs,
        color: 'red',
    }
];
exports.sensationDeSoif = [
    {
        '@type': 'tristate',
        key: 'fe1d2f75-a91e-42f7-8889-f1656ab3adf0',
        label: 'Sensation de soif',
        color: 'red',
        value: (bilan) => bilan.circulatoire.sensation_de_soif,
    }
];
exports.marbrures = [
    {
        '@type': 'tristate',
        key: '7894098f-a7c5-4dd9-abce-1cdb05ec31d0',
        label: 'Marbrures',
        color: 'red',
        value: (bilan) => bilan.circulatoire.marbrures,
    }
];
exports.trc = [
    {
        '@type': 'tristate',
        key: '2d289b0e-dbc9-4c4a-a46c-d62d08a20862',
        label: cUser => utils.hasPerm(cUser, 'assessment:c:primaire:trc:label-3-sec') ||
            utils.hasPerm(cUser, 'assessment:c:secondaire:trc:label-3-sec')
            ? 'TRC > 3 secs'
            : 'TRC > 2 secs',
        color: 'red',
        value: (bilan) => bilan.circulatoire.trc,
    },
    {
        '@type': 'integer',
        key: '98634bd2-ccab-4849-b18b-c9d1f57ccf05',
        label: 'TRC',
        unit: 'secs',
        value: (bilan) => bilan.circulatoire.trc_second,
    },
    {
        '@type': 'tristate',
        key: '54bdfa52-35cb-44ee-9f3d-083c0bd0e530',
        label: 'TRC centrale / périphérique normaux',
        color: 'red',
        value: (bilan) => bilan.circulatoire.trc_normale,
    },
    {
        '@type': 'select',
        key: '2c5885c9-ae5c-45eb-ae01-5841e306f3ab',
        label: 'TRC - Localisation',
        options: [
            { value: 0, label: 'Main gauche' },
            { value: 1, label: 'Main droite' },
            { value: 2, label: 'Pied gauche' },
            { value: 3, label: 'Pied droit' },
        ],
        value: (bilan) => bilan.circulatoire?.trc_localisation,
    }
];
exports.boitesASang = [
    {
        '@type': 'select',
        key: 'bf1ea486-5a6b-4b2e-a95b-4986b7474f0f',
        label: 'Boîtes à sang',
        options: [
            { value: 1, label: 'Normales', kind: 'positive' },
            { value: 2, label: 'Anormales', kind: 'negative' },
            { value: 3, label: 'Tête', kind: 'negative' },
            { value: 4, label: 'Thorax', kind: 'negative' },
            { value: 5, label: 'Bassin', kind: 'negative' },
            { value: 6, label: 'Fémur G', kind: 'negative' },
            { value: 7, label: 'Fémur D', kind: 'negative' },
            { value: 8, label: 'Abdomen', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.boites_a_sang,
    },
    {
        '@type': 'multiselect',
        key: '96fbfb54-d15d-4c73-9e98-82635d8620b3',
        label: 'Boîtes à sang (Zone)',
        options: [
            { value: 1, label: 'Fémur' },
            { value: 7, label: 'Fémur G' },
            { value: 8, label: 'Fémur D' },
            { value: 2, label: 'Abdomen' },
            { value: 3, label: 'Bassin' },
            { value: 4, label: 'Thorax' },
            { value: 6, label: 'Tête' },
            { value: 5, label: 'Tête (nourisson)' },
        ],
        value: (bilan) => bilan.circulatoire.boites_a_sang_zone,
    }
];
// C du ABCDE - Circulatoire du NRC
exports.circulatoire = [
    ...exports.circulatoireVital,
    ...exports.pouls,
    ...exports.sensationDeSoif,
    {
        '@type': 'multiselect',
        key: '7d5e9c39-6209-4718-ae53-a8db8c7ff1d9',
        label: 'Pâleurs',
        options: [
            { value: 1, label: 'Peau / muqueuses colorées', kind: 'positive' },
            { value: 2, label: 'Pâleurs conjonctives', kind: 'negative' },
            { value: 3, label: 'Pâleurs des muqueuses', kind: 'negative' },
            { value: 4, label: 'Marbrures', kind: 'negative' },
            { value: 5, label: 'Pâleurs cutanées', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.paleur,
    },
    ...exports.marbrures,
    {
        '@type': 'select',
        key: '9886a10a-0c0e-4d9c-aaea-741e2e38715b',
        label: 'Coloration de la peau',
        options: [
            { value: 1, label: 'Normale', kind: 'positive' },
            { value: 2, label: 'Pâleur', kind: 'negative' },
            { value: 3, label: 'Marbrures', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.colorisation,
    },
    {
        '@type': 'multiselect',
        key: '5d3f68b1-5b98-4199-9d64-10030fe997e5',
        label: 'Coloration des extrémités',
        options: [
            { value: 1, label: 'RAS', kind: 'positive' },
            { value: 2, label: 'Supérieur gauche', kind: 'negative' },
            { value: 4, label: 'Supérieur droit', kind: 'negative' },
            { value: 8, label: 'Inférieur gauche', kind: 'negative' },
            { value: 16, label: 'Inférieur droit', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique?.coloration_extremites_bilateral,
    },
    /*{ TODO ("A décommenter si le path est changé")
    "@type": "tristate",
    key: "bdade059-4319-4307-8ff7-8b3f585556de",
    label: "Colorisation",
    value: (bilan) => bilan.circulatoire.colorisation,
  },*/
    {
        '@type': 'tristate',
        key: '1e58861b-842d-42cf-a51d-4041efc5cd7a',
        label: 'Sueurs',
        color: 'red',
        value: (bilan) => bilan.respiration.sueurs,
    },
    {
        '@type': 'tristate',
        key: '14c1bb42-57f5-4b40-90c8-e6c0303f6bc5',
        label: 'Température de la peau anormale',
        color: 'red',
        value: (bilan) => bilan.circulatoire.peau_temperature_anormale,
    },
    {
        '@type': 'tristate',
        key: '293b53e5-92e2-4ccd-9a35-304d77ec6101',
        label: 'T° peau normale au touché',
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.circulatoire.temperature_peau_normal,
    },
    {
        '@type': 'select',
        key: 'ef8bbfdf-12fe-44e0-9af5-a47cbcec6f47',
        label: 'Température cutanée',
        options: [
            { value: 1, label: 'RAS', kind: 'positive' },
            { value: 2, label: 'Chaude', kind: 'negative' },
            { value: 3, label: 'Froide', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.peau_temperature,
    },
    {
        '@type': 'select',
        key: '57f343cb-90f4-4edd-acd7-cade4ec861e5',
        label: 'Humidité de la peau',
        options: [
            { value: 3, label: 'Normale' },
            { value: 1, label: 'Peau sèche' },
            { value: 2, label: 'Peau moite' },
        ],
        value: (bilan) => bilan.circulatoire.peau_humidite,
    },
    {
        '@type': 'tristate',
        key: 'c49f564b-19aa-4b38-be83-28033b52aff6',
        label: 'Froideur cutanée',
        color: 'red',
        value: (bilan) => bilan.circulatoire.froideur_cutanee,
    },
    {
        '@type': 'tristate',
        key: 'fe9bad25-69fe-48f0-b4e8-66f61bb94fc2',
        label: 'Pouls radial non perçu',
        color: 'red',
        value: (bilan) => bilan.circulatoire.absence_pouls_radial,
    },
    {
        '@type': 'multiselect',
        key: 'bbea7b9c-2fa7-4d26-b5ba-4de321fdb143',
        label: 'Pouls radial non perçu (bilatéral)',
        options: [
            { value: 0, label: 'RAS', kind: 'positive' },
            { value: 1, label: 'Côté gauche', kind: 'negative' },
            { value: 2, label: 'Côté droit', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.absence_pouls_radial_bilateral,
    },
    {
        '@type': 'multiselect',
        key: 'bbea7b9c-3fr6-4d26-m0bi-4de321fdb143',
        label: 'Pouls radial',
        options: [
            { value: 0, label: 'Bien frappé G', kind: 'positive' },
            { value: 1, label: 'Bien frappé D', kind: 'positive' },
            { value: 2, label: 'Filant G', kind: 'negative' },
            { value: 3, label: 'Filant D', kind: 'negative' },
            { value: 4, label: 'Irrégulier G', kind: 'negative' },
            { value: 5, label: 'Irrégulier D', kind: 'negative' },
            { value: 6, label: 'Asymétrique G', kind: 'negative' },
            { value: 7, label: 'Asymétrique D', kind: 'negative' },
            { value: 8, label: 'Absent G', kind: 'negative' },
            { value: 9, label: 'Absent D', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.pouls_radial_select,
    },
    {
        '@type': 'tristate',
        key: 'ba393366-79a8-44ee-9c69-5ba37ca715e5',
        label: 'Pouls carotidien',
        color: 'green',
        value: (bilan) => bilan.circulatoire.pouls_carotidien,
    },
    {
        '@type': 'select',
        key: '77865865-2bba-481a-9989-d32ab80e16c9',
        label: 'Pouls carotidien',
        options: [
            { value: 1, label: 'Bien frappé', kind: 'positive' },
            { value: 2, label: 'Filant', kind: 'negative' },
            { value: 3, label: 'Irrégulier', kind: 'negative' },
            { value: 4, label: 'Absent', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.pouls_carotidien_select,
    },
    {
        '@type': 'tristate',
        key: '2fc14d95-584a-4df3-808a-96193091bb98',
        label: 'Pouls périphérique perçu',
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.circulatoire.pouls_peripherique,
    },
    {
        '@type': 'tristate',
        key: 'ec708abb-5394-431a-ada8-b46745711211',
        label: 'Pouls central perçu',
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.circulatoire.pouls_central,
    },
    {
        '@type': 'multiselect',
        key: 'fa47afd0-abe1-4075-88c9-1d4aca7add65',
        label: "Signes d'insuffisance cardiaque",
        options: [
            { value: 1, label: 'Aucun', kind: 'positive' },
            { value: 2, label: 'IVG', kind: 'negative' },
            { value: 3, label: 'IVD', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.smur_insuffisance_cardiaque,
    },
    ...exports.trc,
    {
        '@type': 'tristate',
        key: '2b9701c4-626f-4e00-8f59-52769280cd48',
        label: 'Extrémités froides',
        color: 'red',
        value: (bilan) => bilan.circulatoire.extremites_froides,
    },
    {
        '@type': 'tristate',
        key: '48b20a15-b443-4e91-843e-0aad89d27b33',
        label: 'Troubles du rythme',
        color: 'red',
        value: (bilan) => bilan.circulatoire.smur_troubles_rythme,
    },
    {
        '@type': 'multiselect',
        key: 'b6aca931-6918-4f71-8e7d-828ff8323e60',
        label: 'Qualité de la circulation',
        options: [
            { value: 1, label: 'Bien frappé', kind: 'positive' },
            { value: 2, label: 'Régulier', kind: 'positive' },
            { value: 3, label: 'Conjonctives pâles', kind: 'negative' },
            { value: 4, label: 'Irrégulier', kind: 'negative' },
            { value: 5, label: 'Asymétrique', kind: 'negative' },
            { value: 6, label: 'TRC > 3sec', kind: 'negative' },
            { value: 7, label: 'Marbrures', kind: 'negative' },
            { value: 8, label: 'Sueurs', kind: 'negative' },
            { value: 9, label: 'Froideur cutanée', kind: 'negative' },
            { value: 10, label: 'Pâleurs', kind: 'negative' },
            { value: 11, label: 'Filant', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.qualite_circulation,
    },
    {
        '@type': 'select',
        key: 'a31679e9-2ccc-4d7e-9aea-eca6780f778a',
        label: 'Examen abdomen',
        options: [
            { value: 1, label: 'Souple', kind: 'positive' },
            { value: 2, label: 'Douloureux à la palpation', kind: 'negative' },
            { value: 3, label: 'Dur', kind: 'negative' },
            { value: 4, label: 'Présence de défense', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.examen_abdomen,
    },
    {
        '@type': 'multiselect',
        key: '26c10afb-3daa-4527-b3ff-a8614b58e80f',
        label: 'Examen fémurs',
        options: [
            { value: 0, label: 'Normal G', kind: 'positive' },
            { value: 1, label: 'Normal D', kind: 'positive' },
            { value: 2, label: 'Déformation G', kind: 'negative' },
            { value: 3, label: 'Déformation D', kind: 'negative' },
            { value: 4, label: 'Oedème G', kind: 'negative' },
            { value: 5, label: 'Oedème D', kind: 'negative' },
            { value: 6, label: 'Gonflement G', kind: 'negative' },
            { value: 7, label: 'Gonflement D', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.examen_femurs,
    },
    {
        '@type': 'select',
        key: 'df66bcc9-5c5d-41b4-9c5f-0393476aef9d',
        label: 'Examen bassin',
        options: [
            { value: 1, label: 'Absence de douleur', kind: 'positive' },
            { value: 2, label: 'Douleur spontanée', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.examen_bassin,
    },
    {
        '@type': 'tristate',
        key: '9ce33835-5a3a-4b33-b93e-bb2787714549',
        label: 'Douleur thoracique',
        color: 'red',
        contentInverted: true,
        value: (bilan) => bilan.circulatoire.douleur_thoracique,
    },
    {
        '@type': 'multiselect',
        key: '28de3b92-af37-4189-91d8-b213c23cfd74',
        label: 'Douleur Thoracique',
        options: [
            { value: 0, label: 'Oui', kind: 'negative' },
            { value: 1, label: 'Non', kind: 'positive' },
            { value: 2, label: 'Constrictive', kind: 'negative' },
            { value: 3, label: 'Précordiale', kind: 'negative' },
            { value: 4, label: 'Irradiation', kind: 'negative' },
            { value: 5, label: 'Signes associés', kind: 'negative' },
        ],
        // value: (bilan) => bilan.medic_info.douleur_thoracique,
        value: (bilan) => bilan.medic_info.douleur_thoracique == -1 ? 2 : bilan.medic_info.douleur_thoracique,
    },
    {
        '@type': 'tristate',
        key: 'd6a9ed25-7a85-43b1-bf46-640a99dec27e',
        label: 'Douleur thoracique - Toujours présente',
        color: 'red',
        value: (bilan) => bilan.circulatoire?.douleur_thoracique_toujours_presente,
    },
    {
        '@type': 'select',
        key: 'c0a5c7c4-ec2d-45d3-8fac-c2a69faf075a',
        label: 'Douleur thoracique - Qualité de la douleur',
        options: [
            { value: 1, label: 'Gêne', kind: 'negative' },
            { value: 2, label: 'Sensation de point', kind: 'negative' },
            { value: 3, label: 'Sensation de picotements', kind: 'negative' },
            { value: 4, label: 'Sensation de brûlure', kind: 'negative' },
            { value: 5, label: 'Sensation de serrage', kind: 'negative' },
            { value: 6, label: 'Irradiation', kind: 'negative' },
            { value: 7, label: 'Autre', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.douleur_thoracique_qualite,
    },
    {
        '@type': 'multiselect',
        key: 'c05cdb01-64b4-4401-8e45-df419d3dcc52',
        label: 'Douleur thoracique - Qualité de la douleur',
        options: [
            { value: 1, label: 'Gêne', kind: 'negative' },
            { value: 2, label: 'Sensation de point', kind: 'negative' },
            { value: 3, label: 'Sensation de picotements', kind: 'negative' },
            { value: 4, label: 'Sensation de brûlure', kind: 'negative' },
            { value: 5, label: 'Sensation de serrage', kind: 'negative' },
            { value: 6, label: 'Irradiation', kind: 'negative' },
            { value: 7, label: 'Autre', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.douleur_thoracique_qualite_multi,
    },
    {
        '@type': 'select',
        key: '8fae2ac6-c66e-4992-b7a6-b7df95c737bf',
        label: 'Douleur thoracique - Survenue',
        options: [
            { value: 1, label: 'Progressive', kind: 'negative' },
            { value: 2, label: 'Brutale', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.douleur_thoracique_survenue,
    },
    {
        '@type': 'select',
        key: 'bfb28249-847f-406e-bf73-8b791b373d96',
        label: 'Douleur thoracique - Provoqué par',
        options: [
            { value: 1, label: 'Au repos', kind: 'negative' },
            { value: 2, label: "À l'effort", kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.douleur_thoracique_provoque_par,
    },
    {
        '@type': 'multiselect',
        key: 'ca062f63-70d7-432c-a993-935218b49c2a',
        label: 'Douleur thoracique - Localisation',
        options: [
            { value: 1, label: 'Rétrosternal', kind: 'negative' },
            { value: 2, label: 'Côté droit', kind: 'negative' },
            { value: 3, label: 'Côté gauche', kind: 'negative' },
            { value: 4, label: 'Dorsale', kind: 'negative' },
            { value: 5, label: 'Sus ombilical', kind: 'negative' },
            { value: 6, label: 'Cou', kind: 'negative' },
            { value: 7, label: 'Bras droit', kind: 'negative' },
            { value: 8, label: 'Bras gauche', kind: 'negative' },
        ],
        value: (bilan) => bilan.circulatoire.douleur_thoracique_localisation,
    },
    {
        '@type': 'time',
        key: '2bdc7caf-e93d-4898-aad0-c190f41be76b',
        label: "Heure de début de l'incident",
        value: (bilan) => `${bilan.circulatoire?.temps_depuis_incident}`,
    },
    {
        '@type': 'dateTime',
        key: '165899fd-6eae-43eb-8771-774602fdf8fa',
        label: "Heure de début de l'incident",
        value: (bilan) => {
            return {
                time: bilan.circulatoire.temps_depuis_incident_time,
                date: bilan.circulatoire.temps_depuis_incident_date,
            };
        },
    },
    {
        '@type': 'time',
        key: '1c323c05-c0ad-4259-b600-6201c4443b4f',
        label: 'Heure de début',
        value: (bilan) => bilan.medic_info.heure_debut_douleur_poitrine,
    },
    {
        '@type': 'dateTime',
        key: '13667691-241c-4062-8607-3082d466d9dd',
        label: 'Heure de début',
        value: (bilan) => {
            return {
                time: bilan.medic_info.heure_debut_douleur_poitrine_time,
                date: bilan.medic_info.heure_debut_douleur_poitrine_date,
            };
        },
    },
    {
        '@type': 'time',
        key: '3a0bc917-9c6f-4932-a70a-2e52369dcbdc',
        label: 'ECG heure de réalisation',
        value: (bilan) => bilan.circulatoire.heure_realisation_ecg === null || bilan.circulatoire.heure_realisation_ecg === 'NR'
            ? null
            : bilan.circulatoire.heure_realisation_ecg,
    },
    {
        '@type': 'dateTime',
        key: 'ede06c37-ef4b-45e6-bbef-4270cdf622dc',
        label: 'ECG heure de réalisation',
        value: (bilan) => {
            return {
                time: bilan.circulatoire.heure_realisation_ecg_time,
                date: bilan.circulatoire.heure_realisation_ecg_date,
            };
        },
    },
    {
        '@type': 'tristate',
        key: '9329bffd-d2a3-450d-912b-9e9869344f3c',
        label: 'Per critique',
        color: 'red',
        value: (bilan) => bilan.circulatoire.per_critique,
    },
    {
        '@type': 'select',
        key: '01ca70bc-2ec3-4e96-90ba-7fc2b2300d5e',
        label: 'Nombre de dérivations',
        options: [
            { value: 1, label: 'Non' },
            { value: 2, label: '12 dérivations' },
            { value: 3, label: '17 dérivations' },
        ],
        value: (bilan) => bilan.circulatoire.nb_derivations,
    },
    {
        '@type': 'text',
        key: '106a72e3-4ba4-498d-8ed4-59a43ef8510b',
        label: 'Commentaire / Saignement occulte',
        value: (bilan) => bilan.circulatoire.commentaire,
    },
    ...exports.boitesASang,
    {
        '@type': 'select',
        key: 'dd0a3a79-3f18-450c-9114-3235b812b17c',
        label: 'KTIO',
        options: [
            { value: 1, label: 'Trans tibiale' },
            { value: 2, label: 'Trans humérale' },
        ],
        value: (bilan) => bilan.circulatoire?.ktio,
    },
    {
        '@type': 'select',
        key: '79638dcf-ea9c-4b34-ac54-827bb4782bbd',
        label: 'KTIO - Taille',
        options: [
            { value: 1, label: 'Rose' },
            { value: 2, label: 'Bleu' },
            { value: 3, label: 'Jaune' },
        ],
        value: (bilan) => bilan.circulatoire?.taille_ktio,
    },
    {
        '@type': 'tristate',
        key: '84dc3723-b12d-4b2b-b289-b1bbfd473eb6',
        label: 'Métrologie',
        color: 'green',
        value: (bilan) => bilan.circulatoire?.metrologie,
    },
    {
        '@type': 'integer',
        key: 'a0b825ef-a22b-44e6-a16f-c63816dca4a3',
        label: 'Tension moyenne',
        value: (bilan) => bilan.circulatoire?.tension_moyenne,
    },
    {
        '@type': 'tristate',
        key: '6a4e7537-fcea-4d66-ae39-ae7099c29a17',
        label: "Tension moyenne - Saisie par l'utilisateur",
        value: (bilan) => (bilan.circulatoire?.is_pam_entry_by_user === true ? 'y' : 'u'),
    },
    {
        '@type': 'tristate',
        key: 'b6a3751b-f0af-4c29-b161-131b281ae576',
        label: 'Paleur',
        value: (bilan) => bilan.circulatoire?.paleur_tristate,
        color: 'red',
    },
    ...exports.paleurs,
    {
        '@type': 'select',
        key: '9632a569-ba8f-40a6-b66f-ff89d406a77e',
        label: 'Pouls radial',
        options: [
            { value: 1, label: 'Non perçu' },
            { value: 2, label: 'Bien frappé' },
            { value: 3, label: 'Filant' },
        ],
        value: (bilan) => bilan.circulatoire?.pouls_radial,
    },
    ...exports.detresseCirculatoire
];
exports.medecinTraitant = [
    {
        '@type': 'text',
        key: '3397d434-94ea-41ff-ba11-65b818bd0b4b',
        label: 'Médecin traitant',
        value: (bilan) => bilan.victime.medecin_traitant,
    },
    {
        '@type': 'text',
        key: '7a5c316a-52a0-4d45-8a46-32074c6c6351',
        label: 'Téléphone médecin traitant',
        value: (bilan) => bilan.victime.medecin_num,
    },
];
exports.contactInfos = [
    {
        '@type': 'text',
        key: 'f73c0aee-3d20-42ca-a1ad-cfc130d3db7c',
        label: 'Nom',
        value: (bilan) => bilan.victime?.contact_nom,
    },
    {
        '@type': 'text',
        key: '4967de8a-c24c-4811-a39a-d0948d5ca720',
        label: 'Lien avec la personne',
        value: (bilan) => bilan.victime?.contact_lien,
    },
    {
        '@type': 'text',
        key: '0b8d98f0-a45a-4429-8b08-c59079ffd9d2',
        label: 'Téléphone',
        value: (bilan) => bilan.victime?.contact_telephone,
    },
];
exports.representantLegal = [
    {
        '@type': 'text',
        key: '9de87e2d-32be-42ba-ba52-55fc7a92934e',
        label: 'Représentant légal',
        value: (bilan) => bilan.victime?.representant_legal,
    },
    {
        '@type': 'text',
        key: '2975dc24-2217-460d-bd80-031fbe0b1188',
        label: 'Représentant légal - Adresse postale',
        value: (bilan) => bilan.victime?.adresse_postale_representant_legal,
    },
    {
        '@type': 'text',
        key: '26fad1fb-fc76-4f9d-891a-b09335a78167',
        label: 'Représentant légal - Téléphone',
        value: (bilan) => bilan.victime?.telephone_representant_legal,
    },
    {
        '@type': 'text',
        key: '8fb0d643-099c-414d-8ea0-674294d5cb92',
        label: 'Représentant légal - Email',
        value: (bilan) => bilan.victime?.email_representant_legal,
    },
];
exports.contact = [
    ...exports.contactInfos,
    ...exports.representantLegal,
    {
        '@type': 'tristate',
        key: '4fd6165c-ec0b-4086-adb4-2cb71650d27c',
        label: 'Personne contactée',
        color: 'green',
        value: (bilan) => (bilan.victime?.contact_prevenu ? 'y' : 'u'),
    },
    {
        '@type': 'text',
        key: 'f0b36f33-046b-458a-84c5-296a480b92d4',
        label: 'Téléphone parent',
        value: (bilan) => bilan.victime.telephone_parent,
    },
    {
        '@type': 'text',
        key: '3fa0978e-6118-41a0-9706-9921d77c3754',
        label: 'Téléphone témoin',
        value: (bilan) => bilan.victime.telephone_temoin,
    },
    ...exports.medecinTraitant,
];
exports.equipesExcel = [
    {
        '@type': 'time',
        key: '2c1ad97c-458b-4944-af64-172ba5743d5a',
        label: 'Heure',
        value: elem => elem?.heure,
    },
    {
        '@type': 'text',
        key: '704912a5-d073-4f49-89f8-7daddc747cd1',
        label: 'Véhicule',
        value: elem => elem?.vehicle,
    },
    {
        '@type': 'text',
        key: '02a3b38c-10dc-4623-b342-2defdc849526',
        label: 'Médecin',
        value: elem => elem?.medecin,
    },
    {
        '@type': 'text',
        key: '1f3ac9be-8912-4903-95bd-772fb0e1e2a4',
        label: 'Infirmier',
        value: elem => elem?.infirmier,
    },
    {
        '@type': 'text',
        key: 'f4bb25a4-f8de-423b-99c5-7bb405504298',
        label: 'Ambulancier',
        value: elem => elem?.ambulancier,
    },
    {
        '@type': 'text',
        key: '4a8fb13b-d92d-4ad1-95db-32194e2552ca',
        label: 'Stagiaire 1',
        value: elem => elem?.stagiaire1,
    },
    {
        '@type': 'text',
        key: 'b0137dba-4aa0-4bd4-96a1-b9e63436549b',
        label: 'Stagiaire 2',
        value: elem => elem?.stagiaire2,
    },
    {
        '@type': 'text',
        key: 'e435f713-e492-4972-820a-5b51617bef31',
        label: 'Conducteur',
        value: elem => elem?.conducteur,
    },
    {
        '@type': 'text',
        key: 'beec1b06-64cf-45af-9521-03ee19d29ec4',
        label: 'Équipier',
        value: elem => elem?.equipier,
    },
    {
        '@type': 'text',
        key: '1d5d79d1-18f5-446a-8d16-b4648d419520',
        label: 'Pilote',
        value: elem => elem?.pilote,
    },
    {
        '@type': 'text',
        key: '7cc26ddb-06ee-457b-a20a-9468167c210a',
        label: 'Assistant de vol',
        value: elem => elem?.assistant_vol,
    },
    {
        '@type': 'text',
        key: '5d0247e6-a1f9-42cf-be9d-8c6426a527e0',
        label: 'ARM',
        value: elem => elem?.arm,
    },
    {
        '@type': 'text',
        key: '6d07ed96-8fb7-4869-a5bc-75051e5ac841',
        label: 'ARM appel',
        value: elem => elem?.arm_appel,
    },
    {
        '@type': 'text',
        key: '5dc9341e-19c2-41b7-8a97-c60f530d8e33',
        label: 'ARM moyen',
        value: elem => elem?.arm_moyen,
    },
];
const makeExcelEquipes = () => {
    return [
        {
            '@type': 'tableItem',
            key: '886c099f-1f2c-4663-8a93-ad12de555607',
            children: [...exports.equipesExcel],
        },
    ];
};
exports.makeExcelEquipes = makeExcelEquipes;
exports.equipage = [
    {
        '@type': 'text',
        key: 'b5b56adf-9887-4358-9048-0638d3ad7770',
        label: 'Pilote',
        value: (bilan) => bilan.equipage_plaintext?.pilote === 'NR' ? null : bilan.equipage_plaintext?.pilote,
    },
    {
        '@type': 'text',
        key: '10e31353-7d54-4d11-b8a2-7ee8269eb068',
        label: 'Conducteur',
        value: (bilan) => bilan.equipage_plaintext?.conducteur === 'NR' ? null : bilan.equipage_plaintext?.conducteur,
    },
    {
        '@type': 'text',
        key: '2c62173e-de01-409c-ae6d-5d74c113949b',
        label: 'Médecin',
        value: (bilan) => bilan.equipage_plaintext?.medecin === 'NR' ? null : bilan.equipage_plaintext?.medecin,
    },
    {
        '@type': 'text',
        key: 'cd9dd652-5d02-4cf6-b622-e95377492807',
        label: 'Infirmier',
        value: (bilan) => bilan.equipage_plaintext?.infirmier === 'NR' ? null : bilan.equipage_plaintext?.infirmier,
    },
    {
        '@type': 'text',
        key: '57e2998d-9c0d-4c3d-a751-4523e8489b36',
        label: 'Ambulancier',
        value: (bilan) => bilan.equipage_plaintext?.ambulancier === 'NR' ? null : bilan.equipage_plaintext?.ambulancier,
    },
    {
        '@type': 'text',
        key: '7f539ea8-9397-4287-bc41-022355df9b27',
        label: 'Équipier',
        value: (bilan) => bilan.equipage_plaintext?.equipier === 'NR' ? null : bilan.equipage_plaintext?.equipier,
    },
    {
        '@type': 'text',
        key: '8596a317-e94d-4582-974c-0dd3f747785d',
        label: 'Stagiaire',
        value: (bilan) => bilan.equipage_plaintext?.stagiaire === 'NR' ? null : bilan.equipage_plaintext?.stagiaire,
    },
    {
        '@type': 'text',
        key: 'c284ad47-aec7-4e1f-8292-172befa7e2b8',
        label: 'Stagiaire 2',
        value: (bilan) => bilan.equipage_plaintext?.stagiaire_2 === 'NR' ? null : bilan.equipage_plaintext?.stagiaire_2,
    },
    {
        '@type': 'text',
        key: '365b65e5-8449-4e22-bc74-d5975806fbfb',
        label: 'ARM',
        value: (bilan) => (bilan.equipage_plaintext?.arm === 'NR' ? null : bilan.equipage_plaintext?.arm),
    },
    {
        '@type': 'text',
        key: 'e4c5a7d0-6d12-48c6-8198-cab4c782e336',
        label: 'ARM appel',
        value: (bilan) => bilan.equipage_plaintext?.arm_appel,
    },
    {
        '@type': 'text',
        key: '88050a67-eda4-4b9e-8503-b9e856040785',
        label: 'ARM moyen',
        value: (bilan) => bilan.equipage_plaintext?.arm_moyen,
    },
    {
        '@type': 'text',
        key: '96ad8420-6a1d-498b-8f79-ba7324ebf03a',
        label: 'Assistant de vol',
        value: (bilan) => bilan.equipage_plaintext?.assistant_vol === 'NR' ? null : bilan.equipage_plaintext?.assistant_vol,
    },
    {
        '@type': 'table',
        key: '8c0f1c79-b5ab-4849-b957-350db1edcc00',
        label: 'Équipage - Synthèse',
        value: (bilan) => bilan.equipage_lists || [],
        template: 'EQUIPAGE',
    },
];
exports.primoIntervenant = [
    {
        '@type': 'text',
        // Ne pas changer l'UUID
        key: '5446f68c-e58d-4b0e-a99b-a9da17aaa4c2',
        label: 'Numéro primo intervenant',
        value: (bilan) => bilan.equipe.intervention_num,
    },
];
// À afficher uniquement côté PDF
// Pour un ticket de départ complet ajouter ticketNumMotif
exports.ticketAdressePrimo = [...exports.adresseIntervention, ...exports.primoIntervenant];
exports.motifInter = [
    {
        '@type': 'text',
        key: '7d095c58-da68-4801-ab0d-e0ab0c0af733',
        label: "Motif d'intervention",
        value: (bilan) => bilan.circonstance.circonstances === 'NR' ? null : bilan.circonstance.circonstances,
    },
];
exports.natureReel = [
    {
        '@type': 'text',
        key: '6ca7c29e-b8c0-4332-8c40-fe315b36d3a1',
        label: 'Nature réelle',
        value: (bilan) => bilan.circonstance?.nature_reelle,
    },
    {
        '@type': 'text',
        key: '72537a98-039b-4b29-a6bb-0e5c1f7be8e2',
        label: 'Sous nature',
        value: (bilan) => bilan.circonstance?.sous_nature,
    },
];
exports.ticketNumMotif = [
    {
        '@type': 'integer',
        key: 'b2eb2982-79c0-470b-8676-f04cbb5aa203',
        label: 'Numéro de victime',
        value: (bilan) => bilan.victime.numero,
    },
    ...exports.motifInter,
    ...exports.natureReel,
];
exports.priorisation = [
    {
        '@type': 'uuid-string',
        key: '20d1eedc-c798-41fc-9dce-3f8701f27a74',
        label: 'Priorisation',
        value: (bilan) => bilan.priorisation_v2,
    },
];
exports.decision = [
    {
        '@type': 'multiselect',
        key: '6dce72d3-a68b-4ea8-ad91-c23912bcbe27',
        label: 'Décision',
        options: [
            { value: 1, label: 'Sortie blanche/annulée' },
            { value: 2, label: 'Renfort / DSM' },
            { value: 3, label: 'Laissé sur place' },
            { value: 4, label: 'DCD' },
            { value: 5, label: 'Transporté' },
            { value: 6, label: 'Refus de soins' },
            { value: 7, label: 'Avec réanimation' },
            { value: 8, label: 'Sans réanimation' },
            { value: 9, label: 'Cert. décès avec obstacle' },
            { value: 10, label: 'Cert. décès sans obstacle' },
            { value: 11, label: 'Transport non médicalisé' },
            { value: 12, label: 'Refus de transport' },
            { value: 13, label: 'Soins sur place' },
            { value: 14, label: 'Transport paramédicalisé' },
            { value: 15, label: 'Transport médicalisé' },
            { value: 16, label: 'Procédure SDIS/SAMU' },
            { value: 17, label: 'Personne non blessée' },
            { value: 18, label: 'Non blessé' },
            { value: 19, label: 'Renfort SMUR' },
            { value: 20, label: 'Renfort médical autre' },
            { value: 21, label: 'Avec arrêt de la réanimation par régulation SAMU' },
            { value: 22, label: "Prise en charge par forces de l'ordre" },
            { value: 23, label: 'Transport au domicile' },
            { value: 24, label: 'Transport non paramédicalisé' },
            { value: 25, label: 'Transport sur réquisition' },
            { value: 26, label: 'Relais ambulancier' },
            { value: 27, label: 'Relais hélicoptère' },
            { value: 28, label: 'Relais ambulance SMUR' },
        ],
        value: (bilan) => bilan.equipe.evacuation,
    },
    {
        '@type': 'uuid-array',
        key: '75e5c5b3-29c2-4e7f-8984-3f7c0dac37f6',
        label: 'Décision',
        value: (bilan) => bilan.equipe.evacuation_v2,
    },
];
exports.ficheTransport = [
    {
        '@type': 'category',
        key: '7ae7166c-49c2-49f1-bcac-151498327e72',
        columns: 1,
        className: 'cardGridLarge',
        subtitle: '',
        children: [
            {
                '@type': 'select',
                key: '50f4263e-760c-486c-8d25-399d571ed5e5',
                label: 'Décision',
                options: [
                    { value: 1, label: 'Laissé sur place' },
                    { value: 2, label: 'Refus de transport' },
                    { value: 3, label: 'Décédé' },
                    { value: 4, label: 'Bilan ne nécessitant pas de transport' },
                ],
                value: (bilan) => bilan.info_tech.ft_decision,
            },
            {
                '@type': 'text',
                key: 'af523427-dab4-41af-9e3c-917bbb1de5a5',
                label: 'Destination finale',
                value: (bilan) => bilan.info_tech.ft_destination_finale,
            },
            {
                '@type': 'select',
                key: '5fa539ad-c39e-4ac4-9b88-ae6d897670dc',
                label: 'Présence paramédicale',
                options: [
                    { value: 1, label: 'VSM' },
                    { value: 2, label: 'ISP' },
                    { value: 3, label: 'MCS' },
                    { value: 4, label: 'MSP' },
                    { value: 5, label: 'Autre professionnel de santé' },
                    { value: 6, label: 'SMUR' },
                    { value: 7, label: 'EPMU' },
                ],
                value: (bilan) => bilan.info_tech.ft_presence_paramedicale,
            },
            {
                '@type': 'text',
                key: '4866a1d6-b104-4d8f-8df6-4c34a84a6d3e',
                label: 'Observations',
                value: (bilan) => bilan.info_tech.ft_observations,
            },
            {
                '@type': 'tristate',
                key: 'e9548121-da0a-42a4-9f0e-b6749d8592b1',
                label: 'Transporté',
                contentInverted: true,
                value: (bilan) => bilan.info_tech.transported,
            },
        ],
    },
    {
        '@type': 'category',
        key: 'a0caeba6-07cf-4fa4-8190-77476ee8d7da',
        columns: 1,
        className: 'cardGridLarge',
        subtitle: 'VSAV',
        children: [
            {
                '@type': 'tristate',
                key: '8c714bcf-5b78-424f-bfb6-0671be084a41',
                label: 'VSAV',
                value: (bilan) => bilan.info_tech.ft_vsav,
            },
            {
                '@type': 'text',
                key: '6b1ad08c-1a59-4cc1-bcd9-6c024ac36544',
                label: 'VSAV - Destination',
                value: (bilan) => bilan.info_tech.ft_vsav_destination,
            },
            {
                '@type': 'text',
                key: '1004fb88-7430-4177-baa2-c18bd694110b',
                label: 'VSAV - Précisions',
                value: (bilan) => bilan.info_tech.ft_vsav_precisions,
            },
        ],
    },
    {
        '@type': 'category',
        key: 'e9184704-b739-4e31-83a4-26d3012008df',
        columns: 1,
        className: 'cardGridLarge',
        subtitle: 'SMUR',
        children: [
            {
                '@type': 'text',
                key: '19864e6f-b502-418a-a13c-ecb3708d51bb',
                label: 'SMUR',
                value: (bilan) => bilan.info_tech.ft_smur,
            },
            {
                '@type': 'dateTime',
                key: 'a018e79e-58d1-486d-840f-bd35dafcd317',
                label: 'SMUR - SLL',
                value: (bilan) => {
                    return {
                        time: bilan.info_tech.ft_smur_sll_time,
                        date: bilan.info_tech.ft_smur_sll_date,
                    };
                },
            },
            {
                '@type': 'text',
                key: '1f433db0-be82-48ca-9697-9417a88d386a',
                label: 'SMUR - Adresse',
                value: (bilan) => bilan.info_tech.ft_smur_adresse,
            },
            {
                '@type': 'text',
                key: '960ea4c7-e7df-4382-8f88-1a427459854e',
                label: 'SMUR - Adresse lat',
                value: (bilan) => bilan.info_tech.ft_smur_adresse_lat,
            },
            {
                '@type': 'text',
                key: 'cb94ead9-6e4f-4c59-8844-e46108f14a18',
                label: 'SMUR - Adresse lng',
                value: (bilan) => bilan.info_tech.ft_smur_adresse_lng,
            },
            {
                '@type': 'integer',
                key: 'fa1b097c-c093-4219-abfb-eac3aaefdcb2',
                label: 'SMUR - Kilométrage',
                unit: 'km',
                value: (bilan) => bilan.info_tech.ft_smur_km,
            },
        ],
    },
    {
        '@type': 'category',
        key: '62543f21-42cd-471f-adb1-df9eb20745c1',
        columns: 1,
        className: 'cardGridLarge',
        subtitle: 'SMUR 2',
        children: [
            {
                '@type': 'text',
                key: '9c3a9ffc-87d5-40c3-9451-d7e059fdd82f',
                label: 'SMUR 2',
                value: (bilan) => bilan.info_tech.ft_smur2,
            },
            {
                '@type': 'dateTime',
                key: '4eff56cc-c540-4462-9cdb-c33d69602ac7',
                label: 'SMUR 2 - SLL',
                value: (bilan) => {
                    return {
                        time: bilan.info_tech.ft_smur2_sll_time,
                        date: bilan.info_tech.ft_smur2_sll_date,
                    };
                },
            },
            {
                '@type': 'text',
                key: '50a9c373-a0b3-47e6-8edc-37e77f9e7927',
                label: 'SMUR 2 - Adresse',
                value: (bilan) => bilan.info_tech.ft_smur2_adresse,
            },
            {
                '@type': 'text',
                key: '2f9f82af-e1e3-4fff-9f9c-92f248835c38',
                label: 'SMUR 2 - Adresse lat',
                value: (bilan) => bilan.info_tech.ft_smur2_adresse_lat,
            },
            {
                '@type': 'text',
                key: 'c60bd029-88f6-4f52-9df7-1597693553de',
                label: 'SMUR 2 - Adresse lng',
                value: (bilan) => bilan.info_tech.ft_smur2_adresse_lng,
            },
            {
                '@type': 'integer',
                key: '8dac9f52-a677-4a63-99c3-ee06038ed417',
                label: 'SMUR 2 - Kilométrage',
                unit: 'km',
                value: (bilan) => bilan.info_tech.ft_smur2_km,
            },
        ],
    },
    {
        '@type': 'category',
        key: '427ed4b9-92f4-4b61-9549-bbe72f46d4ac',
        columns: 1,
        className: 'cardGridLarge',
        subtitle: 'Hélicoptère',
        children: [
            {
                '@type': 'text',
                key: '67153805-a083-41bc-9aa5-1f7082147624',
                label: 'Hélicoptère',
                value: (bilan) => bilan.info_tech.ft_helicoptere,
            },
            {
                '@type': 'text',
                key: 'a52a7e0d-f53c-471d-9fc1-d634b6b4881e',
                label: 'Hélicoptère - Précisions',
                value: (bilan) => bilan.info_tech.ft_helicoptere_precisions,
            },
        ],
    },
    {
        '@type': 'category',
        key: '7e1bb86e-88f0-40f5-967b-8363572a20aa',
        columns: 1,
        className: 'cardGridLarge',
        subtitle: 'Jonction',
        children: [
            {
                '@type': 'text',
                key: 'af12e08e-9162-45f3-b48e-a110bb6f46cc',
                label: 'Jonction',
                value: (bilan) => bilan.info_tech.ft_jonction,
            },
            {
                '@type': 'dateTime',
                key: '421050ec-50af-4c25-a431-a4cc00d4d52d',
                label: 'Jonction - SLL',
                value: (bilan) => {
                    return {
                        time: bilan.info_tech.ft_jonction_sll_time,
                        date: bilan.info_tech.ft_jonction_sll_date,
                    };
                },
            },
            {
                '@type': 'text',
                key: '7888d0a1-327d-42f4-bbce-b02477664d67',
                label: 'Jonction - Adresse',
                value: (bilan) => bilan.info_tech.ft_jonction_adresse,
            },
            {
                '@type': 'text',
                key: '915dca6c-1493-4b6a-aabf-0f7645aae4c2',
                label: 'Jonction - Adresse lat',
                value: (bilan) => bilan.info_tech.ft_jonction_adresse_lat,
            },
            {
                '@type': 'text',
                key: 'a12533b9-48d9-470c-9ef9-8010f1dd19fc',
                label: 'Jonction - Adresse lng',
                value: (bilan) => bilan.info_tech.ft_jonction_adresse_lng,
            },
        ],
    },
];
exports.categorisationObj = [
    {
        '@type': 'select',
        key: '73116746-9da9-4c29-a995-d7afbfd8cb50',
        label: 'Catégorisation',
        options: [
            { value: 1, label: 'Impliqué' },
            { value: 2, label: 'Urgence relative' },
            { value: 3, label: 'Urgence absolue' },
            { value: 4, label: 'Décédé' },
        ],
        permission: ['!assessment:transmission:categorisation:mort_evident'],
        value: (bilan) => bilan.victime.categorisation,
    },
    {
        '@type': 'select',
        key: '600c6678-6c8a-41fe-9a68-eceb7865d385',
        label: 'Catégorisation',
        options: [
            { value: 1, label: 'Non critique' },
            { value: 3, label: 'Critique' },
            { value: 4, label: 'État de mort évident' },
        ],
        permission: ['assessment:transmission:categorisation:mort_evident'],
        value: (bilan) => bilan.victime.categorisation,
    },
];
exports.categorisationV2Obj = {
    '@type': 'uuid-string',
    key: '4284f5fd-387b-44de-a6e3-eabf314fb999',
    label: 'Catégorisation',
    value: (bilan) => bilan.victime.categorisation_v2,
};
exports.equipeInfos = [
    /* {
    "@type": "tristate",
    key: "e8e58097-552f-476a-9916-8cf0bcde54cb",
    label: "Intervention cloturée",
    value: (bilan) => utils.boolToChar(bilan.equipe.intervention_cloture),
  }, */
    ...exports.categorisationObj,
    exports.categorisationV2Obj,
    {
        '@type': 'tristate',
        key: 'a2a200ca-77f0-4376-b6ae-2004970a1981',
        label: 'Appel 15',
        value: (bilan) => bilan.equipe.appel_15,
    },
    {
        '@type': 'tristate',
        key: '3c503cd2-242e-4437-af60-6f2727ba2613',
        label: 'SMUR au départ',
        value: (bilan) => bilan.equipe.smur_au_depart,
    },
    {
        '@type': 'tristate',
        key: 'cb27f9a8-8693-45cd-977e-fe3ecaa17e79',
        label: "Nécessité d'un SMUR",
        value: (bilan) => bilan.geste.need_smur,
    },
    {
        '@type': 'tristate',
        key: '4e0419d8-df19-46d0-9462-dd86224fb9f5',
        label: 'SMUR disponible',
        value: (bilan) => bilan.geste.smur_dispo,
    },
    {
        '@type': 'tristate',
        key: '38296811-de72-44e8-92fa-4101e226aa1f',
        label: 'ISP/MSP au départ',
        value: (bilan) => bilan.equipe.isp_msp_au_depart,
    },
    {
        '@type': 'multiselect',
        key: 'cd27aa8f-cfc9-442e-adf2-7350c9ebcf86',
        label: 'Présence médicale',
        options: [
            { value: 1, label: 'Aucune' },
            { value: 2, label: 'SMUR' },
            { value: 3, label: 'MSP' },
            { value: 4, label: 'Médecin de ville' },
            { value: 5, label: 'IDE libéral' },
            { value: 6, label: 'Autre' },
        ],
        value: (bilan) => bilan.equipe.presence_medicale,
    },
    {
        '@type': 'text',
        key: 'fa2381b0-76d4-4830-a852-b6296b8b085b',
        label: 'Présence médicale (autre)',
        value: (bilan) => bilan.equipe.presence_medicale_autre,
    },
    {
        '@type': 'text',
        key: 'beea7cfc-7a77-4f02-b295-616d7b87c715',
        label: 'Prise en charge médecin',
        value: (bilan) => bilan.equipe.prise_en_charge_medecin,
    },
    {
        '@type': 'text',
        key: '9267f139-8e8e-459b-9a77-98a29e63dfb0',
        label: 'Prise en charge infirmière',
        value: (bilan) => bilan.equipe.centre_secours,
    },
    {
        '@type': 'text',
        key: '20a49ab6-9284-476e-9524-4ae53e00d98e',
        label: 'Infirmerie',
        value: (bilan) => bilan.equipe.infirmerie,
    },
    {
        '@type': 'text',
        key: 'c8e77a40-17df-4b5a-b21a-15b9e1936679',
        label: 'Carroyage',
        value: (bilan) => bilan.equipe.carroyage,
    },
    {
        '@type': 'text',
        key: '9267f139-8e8e-459b-9a77-98a29e63dfb0',
        label: 'Prise en charge infirmière',
        value: (bilan) => bilan.equipe.prise_en_charge_infirmiere,
    },
    {
        '@type': 'text',
        key: '1f5ea591-974c-4a1e-874e-bdce44f8c13c',
        label: 'Prise en charge secouriste',
        value: (bilan) => bilan.equipe.prise_en_charge_secouriste,
    },
    {
        '@type': 'tristate',
        key: '2b067665-b158-4b63-896a-a037c4417c52',
        label: 'NOVI',
        value: (bilan) => bilan.equipe?.novi,
    },
    {
        '@type': 'text',
        key: '245406a2-ad7c-4063-b037-94c5f58fee4a',
        label: 'Observations',
        value: (bilan) => bilan.equipe.observations,
    },
    ...exports.decision,
    {
        '@type': 'select',
        key: '7420de5f-53fd-4611-981f-a5e49c651911',
        label: 'Cotation',
        options: [
            { value: 1, label: '0 - Intervention annulée' },
            { value: 2, label: '1 - Inutile une fois sur place' },
            { value: 3, label: "2 - Réalisation d'un bilan complet" },
            { value: 4, label: '3 - Soins prodigués' },
            { value: 5, label: '4 - Administration médicamenteuse' },
            { value: 6, label: '5 - Victime en AC ou polytraumatisée' },
        ],
        value: (bilan) => bilan.equipe.cotation,
    },
    {
        '@type': 'select',
        key: 'cb104249-408d-443b-aaf5-398d454886d8',
        label: 'Cotation CCMU',
        options: [
            { value: 1, label: 'P - Problème psychologique / psychiatrique' },
            { value: 2, label: '1 - État clinique jugé stable' },
            { value: 3, label: '2 - Pronostic fonctionnel stable' },
            { value: 4, label: "3 - Pronostic fonctionnel pouvant s'aggraver" },
            { value: 5, label: '4 - Pronostic vital engagé sans réanimation' },
            { value: 6, label: '5 - Pronostic vital engagé' },
            { value: 7, label: 'D - Décès' },
        ],
        value: (bilan) => bilan.equipe.cotation_ccmu,
    },
    {
        '@type': 'select',
        key: 'b3d15440-4744-4f86-98a9-ac7745595d47',
        label: 'Évolution victime',
        options: [
            { value: 1, label: 'Amélioration', kind: 'positive' },
            { value: 2, label: 'Stable', kind: 'positive' },
            { value: 3, label: 'Instable', kind: 'negative' },
            { value: 4, label: 'Aggravation', kind: 'negative' },
        ],
        value: (bilan) => bilan.medic_info.evolution,
    },
    {
        '@type': 'tristate',
        key: '2cf81e30-4c1b-464a-b464-abbcfd98ac36',
        label: 'Demande de renfort',
        value: (bilan) => bilan.geste.demande_renfort,
    },
    {
        '@type': 'tristate',
        key: '1485a114-1afb-41ca-af3f-c63d92341069',
        label: 'Demande de renfort médical',
        value: (bilan) => bilan.equipe.demande_renfort_medical,
    },
    {
        '@type': 'text',
        key: '71f97e19-8b24-40b9-aa03-f99360e47434',
        label: 'Receveur nom',
        value: (bilan) => bilan.equipe.receiver_name,
    },
    {
        '@type': 'select',
        key: 'a6df9eab-3961-446f-b46c-3bd216ce1767',
        label: 'Type de mission',
        options: [
            { value: 1, label: 'Primaire' },
            { value: 2, label: 'Secondaire' },
            { value: 3, label: 'De renfort' },
        ],
        permission: ['!mission:type:phase-evenement'],
        value: (bilan) => bilan.info_tech?.smur_mission || bilan.circonstance.type_mission,
    },
    {
        '@type': 'select',
        key: '22b63184-ec8e-406a-91bb-a132090db750',
        label: 'Phase événement',
        options: [
            { value: 1, label: 'Montage' },
            { value: 2, label: 'Exploitation' },
            { value: 3, label: 'Démontage' },
            { value: 4, label: 'Autre' },
        ],
        permission: ['mission:type:phase-evenement'],
        value: (bilan) => bilan.info_tech?.smur_mission || bilan.circonstance.type_mission,
    },
    {
        '@type': 'text',
        key: '502a0168-1344-408c-87c4-046649627d42',
        label: 'Phase événement',
        permission: ['mission:type:phase-evenement'],
        value: (bilan) => bilan.circonstance.type_mission_str,
    },
    {
        '@type': 'tristate',
        key: '1552d806-93fe-48dd-9d49-fee27ec778a7',
        label: 'Refus de signature',
        value: (bilan) => bilan.equipe.refus_signature,
    },
    {
        '@type': 'tristate',
        key: '3304c219-8cab-4531-b7ac-8e6f25920f97',
        label: 'Absence de signature',
        value: (bilan) => bilan.equipe.absence_signature,
    },
    {
        '@type': 'tristate',
        key: '0b09f9a6-3f6d-42dd-b735-0e151c9fee4e',
        label: 'Refus de dépose',
        value: (bilan) => bilan.equipe.refus_depose,
    },
    {
        '@type': 'select',
        key: 'c09f8baa-e400-4a37-ab8f-89de6bd4103a',
        label: 'État victime arrivée secours',
        options: [
            { value: 0, label: 'ARRÊT CARDIO RESPIRATOIRE' },
            { value: 10, label: 'DÉTRESSE NEUROLOGIQUE' },
            { value: 15, label: 'DÉTRESSE RESPIRATOIRE' },
            { value: 18, label: 'DÉTRESSE CIRCULATOIRE' },
            { value: 21, label: 'MALAISE' },
            { value: 22, label: 'ÉLECTRISE' },
            { value: 50, label: 'INTOXIQUÉ' },
            { value: 51, label: 'NOYÉ' },
            { value: 53, label: 'PENDU' },
            { value: 121, label: 'ATTEINTE TRAUMATIQUE' },
            { value: 122, label: 'BRULÉ' },
            { value: 123, label: 'AUTRE ÉTAT' },
            { value: 124, label: 'IVRESSE' },
            { value: 125, label: 'PARTURIENTE' },
            { value: 126, label: 'DOULEUR THORACIQUE' },
        ],
        value: (bilan) => typeof bilan.circonstance.etat_victime_arrivee_secours === 'string'
            ? parseInt(bilan.circonstance.etat_victime_arrivee_secours, 10)
            : bilan.circonstance.etat_victime_arrivee_secours,
    },
    {
        '@type': 'select',
        key: 'e583de34-e3d8-4d07-b68c-907f736e663e',
        label: 'État victime après secours',
        options: [
            { value: 1, label: '1 Amélioration' },
            { value: 2, label: '2 Stationnaire' },
            { value: 3, label: '3 Aggravation' },
            { value: 4, label: '4 Décès' },
        ],
        value: (bilan) => typeof bilan.circonstance.etat_victime_apres_secours === 'string'
            ? parseInt(bilan.circonstance.etat_victime_apres_secours, 10)
            : bilan.circonstance.etat_victime_apres_secours,
    },
    {
        '@type': 'select',
        key: '18ccf66c-6a50-43f8-9e5f-a337a9e37e3f',
        label: 'Cause probable',
        options: [
            { value: 0, label: 'INCENDIE' },
            { value: 1, label: 'ACCIDENT' },
            { value: 2, label: 'DEFAILLANCE' },
            { value: 3, label: 'AGRESSION' },
            { value: 4, label: 'IMPRUDENCE' },
            { value: 5, label: 'INCONNUE' },
            { value: 6, label: 'MALADIE / MALAISE' },
            { value: 7, label: 'INADVERTANCE' },
            { value: 8, label: 'TENTATIVE DE SUICIDE' },
        ],
        value: (bilan) => typeof bilan.circonstance.cause_probable === 'string'
            ? parseInt(bilan.circonstance.cause_probable, 10)
            : bilan.circonstance.cause_probable,
    },
    {
        '@type': 'tristate',
        key: '53446c85-6de3-4bf3-9a4b-169e77846bab',
        label: "Force de l'ordre",
        value: (bilan) => bilan.info_tech.force_de_ordre,
    },
    {
        '@type': 'tristate',
        key: '8cd14046-8e3e-4c9b-9dbf-26297f730828',
        label: 'Ambu privée',
        value: (bilan) => bilan.info_tech.ambu_privee,
    },
    ...exports.ficheTransport,
    {
        '@type': 'tristate',
        key: 'ace57934-455b-411e-afa9-0381ffd11064',
        label: 'Protocole A',
        value: (bilan) => bilan.equipe.protocole_a,
        color: 'green',
    },
    {
        '@type': 'tristate',
        key: '0bff3c32-f50e-4f21-b5d8-cd4e99b00063',
        label: 'Atelle bras',
        value: (bilan) => bilan.equipe.attelle_bras,
    },
    {
        '@type': 'tristate',
        key: '11e7bd8c-c47a-4011-b6ea-cc5ffddad2da',
        label: 'Atelle jambe',
        value: (bilan) => bilan.equipe.attelle_jambe,
    },
    {
        '@type': 'tristate',
        key: 'd53cf4b7-5a75-45fc-abd6-e5eb68ae109e',
        label: 'Plan dur',
        value: (bilan) => bilan.equipe.plan_dur,
    },
    {
        '@type': 'tristate',
        key: '07aa25cd-d0d7-453d-a018-fb3c8b627bbf',
        label: 'MID',
        value: (bilan) => bilan.equipe.mid_tristate,
    },
    {
        '@type': 'tristate',
        key: 'e9742e07-f14f-4f9a-bc22-9b58ac6155c7',
        label: 'Immobilisateur de tête',
        value: (bilan) => bilan.equipe.immobilisateur_de_tete_tristate,
    },
    {
        '@type': 'tristate',
        key: 'a475f8fd-76f3-4015-ba27-ab81b589e06c',
        label: 'Bouteille O2',
        value: (bilan) => bilan.equipe.bouteille_o2,
    },
    {
        '@type': 'text',
        key: 'c4f16b85-787f-4585-bc1a-68a58806e665',
        label: 'Signature V2',
        value: (bilan) => bilan.equipe?.signature_v2,
    },
    {
        '@type': 'text',
        key: 'e052b3e7-8963-4a85-b1db-755f06fb1f02',
        label: 'SMUR',
        value: (bilan) => bilan.equipe?.smur,
    },
    ...exports.equipage,
];
exports.evolutions = [
    {
        '@type': 'text',
        key: '963758f8-9c8b-43e9-9922-cdeb48d85427',
        label: 'Évolutions',
        value: (bilan) => bilan.geste.evolutions,
    },
    {
        '@type': 'table',
        key: 'f8326e83-799c-492e-a079-29abbad053dc',
        label: 'Évolutions - Synthèse',
        value: (bilan) => bilan.synthese_evolutions || [],
        template: 'GESTE_SYNTHESE_EVOLUTION',
    },
];
exports.modeTransport = [
    {
        '@type': 'select',
        key: '97c865b9-b6ac-4549-be66-d741a590e18c',
        label: 'Mode de transport',
        options: [
            { value: 1, label: 'Ambulance' },
            { value: 2, label: 'Pompiers' },
            { value: 3, label: 'Hélicoptère' },
            { value: 4, label: 'Propre moyens' },
        ],
        value: (bilan) => bilan.devenir.mode_transport,
    },
];
exports.modeEvacVecteur = [
    {
        '@type': 'select',
        key: 'ca36caad-d88f-4ba0-9880-095fb095e20a',
        label: "Mode d'évacuation / Vecteur",
        options: [
            { value: 1, label: 'Laissé sur place' },
            { value: 2, label: 'Refus de transport' },
            { value: 3, label: 'VSAV' },
            { value: 4, label: 'ASSU' },
            { value: 5, label: 'Décédé' },
            { value: 6, label: 'SMUR / AR' },
            { value: 7, label: 'Hélicoptère' },
            { value: 8, label: 'Propres moyens' },
            { value: 9, label: 'Bateau' },
            { value: 10, label: 'Train' },
            { value: 11, label: 'AP' },
            { value: 12, label: 'VTP' },
            { value: 13, label: 'Police' },
            { value: 14, label: 'Gendarmerie' },
            { value: 15, label: 'VSM' },
            { value: 16, label: 'VSAV + SMUR' },
            { value: 17, label: 'VSAV + VSM' },
            { value: 18, label: 'AP + VSM' },
            { value: 19, label: 'ASC' },
            { value: 20, label: 'Autre vecteur SDIS' },
            { value: 21, label: 'Ambulance privée' },
            { value: 22, label: 'Laissé sur place' }
        ],
        value: (bilan) => bilan.devenir.mode_evacuation,
    },
    {
        '@type': 'uuid-string',
        key: '542d09c4-4b9e-4875-9e1b-e6aa08fef663',
        label: "Mode d'évacuation / Vecteur",
        value: (bilan) => bilan.devenir.mode_evacuation_v2,
    },
    {
        // @Deprecated -- Champ supprimé
        '@type': 'tristate',
        key: '1abd18bd-2cc7-42d3-be82-e19bdd577eb2',
        color: 'green',
        label: "Présence d'un autre vecteur",
        value: (bilan) => bilan.devenir?.presence_autre_vecteur,
    },
];
exports.suggestionCh = [
    {
        '@type': 'text',
        key: '0c4fae95-f1fc-4468-8664-ea45173f5d31',
        label: 'Suggestion CH',
        value: (bilan) => bilan.devenir.suggestion_ch_v2,
    },
];
exports.devenirInfos = [
    ...exports.evolutions,
    {
        '@type': 'text',
        key: '605eb06e-d018-4dcf-b553-d304be6486f4',
        label: 'Doublure',
        value: (bilan) => bilan.devenir.doublure,
    },
    {
        '@type': 'text',
        key: 'db4b4f80-ea29-4a84-8ad1-1475abd8896c',
        label: 'Médecin sur place',
        value: (bilan) => bilan.devenir.nom_medecin,
    },
    {
        '@type': 'select',
        key: 'e4c999b7-ddd9-4561-bd8c-39140f2f88e2',
        label: "Mode de transport à l'infirmerie",
        options: [
            { value: 1, label: 'Golf' },
            { value: 2, label: 'Ambulance' },
            { value: 3, label: 'A pied' },
        ],
        value: (bilan) => bilan.geste.mode_transport_infirmerie,
        scope: ['puy_du_fou'],
    },
    ...exports.modeTransport,
    {
        '@type': 'select',
        key: '72a46662-6857-4140-bc21-2b0c0bd7a7d3',
        label: 'Consentement victime',
        options: [
            { value: 1, label: 'Consentement' },
            { value: 2, label: 'Pas en état' },
            { value: 3, label: 'Par tiers' },
            { value: 4, label: 'Refus' },
        ],
        value: (bilan) => bilan.geste.consentement,
    },
    ...exports.modeEvacVecteur,
    {
        '@type': 'text',
        key: '9f01c0a2-dfa9-4f22-aaec-12a58fbe892e',
        label: "Mode d'évacuation SUAP",
        value: (bilan) => bilan.devenir.mode_evacuation_suap,
    },
    {
        '@type': 'tristate',
        key: 'a96ce847-6a7e-4724-b452-9e1f956ec959',
        color: 'green',
        label: 'Évacuation avec SMUR',
        value: (bilan) => (bilan.devenir.mode_evacuation_smur === true ? 'y' : 'u'),
    },
    {
        '@type': 'tristate',
        key: '85ca34af-313d-4c14-beeb-12768554a7af',
        color: 'green',
        label: 'Évacuation avec médecin',
        value: (bilan) => (bilan.devenir.mode_evacuation_med === true ? 'y' : 'u'),
    },
    {
        '@type': 'tristate',
        key: '44115865-e684-4f06-b067-6c8118c2cffc',
        color: 'green',
        label: 'Évacuation avec infirmier',
        value: (bilan) => (bilan.devenir.mode_evacuation_infir === true ? 'y' : 'u'),
    },
    {
        '@type': 'selectEditable',
        key: '52ddd05b-4340-487e-9764-14530079dc2d',
        label: 'Cotation',
        options: [
            { value: 1, label: 'Blessure légère' },
            { value: 2, label: 'Blessure grave' },
            { value: 3, label: 'Intervention annulée' },
            { value: 4, label: 'Autre' },
        ],
        value: (bilan) => bilan.equipe.cotation_puy_du_fou,
        scope: ['puy_du_fou'],
        edit: 'fiche_bilan.equipe.cotation_puy_du_fou',
    },
    {
        '@type': 'select',
        key: 'bd31b6da-8e4a-4589-92e9-0e3b565041ae',
        label: 'Patient',
        options: [
            { value: 1, label: 'Retour site' },
            { value: 2, label: 'Retour domicile' },
            { value: 3, label: 'Évacuation SAMU' },
            { value: 4, label: 'Évacuation pompiers' },
            { value: 5, label: 'Évacuation associatif' },
            { value: 6, label: 'Évacuation ambulance privée' },
            { value: 7, label: 'Évacuation moyen personnel' },
            { value: 8, label: 'Refus de soin' },
        ],
        value: (bilan) => bilan.devenir.devenir_patient,
    },
    {
        '@type': 'text',
        key: '546e5ac2-c570-4eb8-bafc-da17a7376c8d',
        label: 'Devenir du patient',
        value: (bilan) => bilan.devenir.devenir_patient_str,
    },
    {
        '@type': 'text',
        key: '546e5ac2-c570-4eb8-bafc-da17a7376c8d',
        label: 'Établissement',
        value: (bilan) => bilan.devenir.devenir_etablissement,
    },
    {
        '@type': 'tristate',
        key: '1f5fbbaa-ad7c-4f3c-8f7e-b0618de1ad52',
        label: 'Délivrance ordonnance',
        contentInverted: true,
        value: (bilan) => bilan.devenir.devenir_delivrance_ordonnance,
    },
    {
        '@type': 'tristate',
        key: '3daa7bb8-00d3-4c75-96cd-f0b6f1308d44',
        label: 'Délivrance lettre',
        contentInverted: true,
        value: (bilan) => bilan.devenir.devenir_delivrance_lettre,
    },
    {
        '@type': 'tristate',
        key: '6c1d98d8-d4d2-4c9f-bd2d-0da19c1581e0',
        label: 'Délivrance certificat',
        contentInverted: true,
        value: (bilan) => bilan.devenir.devenir_delivrance_certificat,
    },
    {
        '@type': 'tristate',
        key: '44e3c8bb-7631-4ec8-9238-f879f1467e63',
        label: 'Accident du travail',
        value: (bilan) => bilan.devenir.devenir_accident_travail,
    },
    {
        '@type': 'text',
        key: '1ec71512-0b67-4601-8bc6-0f8404849e10',
        label: 'Type d\'accident du travail',
        value: (bilan) => bilan.devenir.devenir_type_accident,
    },
    {
        '@type': 'text',
        key: '410d08b7-a0d0-443c-86e8-c40cfdd7db8e',
        label: 'Nature d\'accident du travail',
        value: (bilan) => bilan.devenir.devenir_nature_accident,
    },
    {
        '@type': 'text',
        key: '02d9cb5c-e65d-4e86-8cf3-1d397f94d7e3',
        label: 'Organisation',
        value: (bilan) => bilan.devenir.devenir_orga,
    },
    {
        '@type': 'tristate',
        key: '03d9a4d6-c0ad-436f-a8b2-512b61e23077',
        label: 'Organisation prévénu',
        contentInverted: true,
        value: (bilan) => bilan.devenir.devenir_orga_prevnu,
    },
    ...exports.suggestionCh,
    {
        '@type': 'dateTime',
        key: 'ddc648a0-cd04-47ab-8ed6-10e256f12987',
        label: 'IAO - Heure de prise en charge',
        value: (bilan) => {
            return {
                time: bilan.devenir?.heure_prise_en_charge_iao_time,
                date: bilan.devenir?.heure_prise_en_charge_iao_date,
            };
        },
    },
    {
        '@type': 'tristate',
        key: '589e3274-6835-401b-82b8-7b3626cca666',
        label: 'IAO - Refus de signature',
        value: (bilan) => bilan.equipe.refus_signature_iao,
    },
];
exports.heureDeclenchement = [
    {
        '@type': 'time',
        key: '5705a7c3-abaa-411c-bf46-3727cb3d6226',
        label: 'Heure de déclenchement',
        value: (bilan) => bilan.devenir.heure_declenchement,
    },
    {
        '@type': 'dateTime',
        key: '54cc5039-2a74-4c5b-a1fd-80b8bd22edcb',
        label: 'Heure de déclenchement',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_declenchement_time,
                date: bilan.devenir.heure_declenchement_date,
            };
        },
    },
];
exports.heureTransmissionInitiale = [
    {
        '@type': 'dateTime',
        // Ne pas changer l'UUID
        key: 'e2c3056b-c339-4d8c-8676-9f3e25a19e58',
        label: 'Transmission initiale',
        value: (bilan) => {
            return {
                time: bilan?.intervention.created_at,
                date: bilan?.intervention.created_at,
            };
        },
    },
];
exports.heureDepartVersLieux = [
    {
        '@type': 'time',
        key: 'e9040b1e-3374-4746-b2f8-0bd7bf28e57f',
        label: 'Heure de départ vers les lieux',
        value: (bilan) => `${bilan.devenir?.heure_depart_vers_intervention}`,
    },
    {
        '@type': 'dateTime',
        key: '8ecf8535-874a-4771-8d6c-c314823d4b94',
        label: 'Heure de départ vers les lieux',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_depart_vers_intervention_time,
                date: bilan.devenir.heure_depart_vers_intervention_date,
            };
        },
    },
];
exports.heureArriveeSurLieux = [
    {
        '@type': 'dateTime',
        key: '2c6a4bd4-bed7-45a2-b40e-0762310c309d',
        label: "Heure d'arrivée sur les lieux",
        value: (bilan) => {
            return {
                time: bilan.equipe.heure_arrivee_intervention_time,
                date: bilan.equipe.heure_arrivee_intervention_date,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: '5503995a-cf3a-4a6c-81af-f6f15c4155fd',
        label: "Heure d'arrivée sur les lieux SMUR",
        value: (bilan) => {
            return {
                time: bilan.equipe.arrivee_sur_lieu_smur_time,
                date: bilan.equipe.arrivee_sur_lieu_smur_date,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: 'e869060a-bccd-424e-878a-5d5e85ed4eb2',
        label: "Heure d'arrivée sur les lieux contact de la victime",
        value: (bilan) => {
            return {
                time: bilan.equipe.arrivee_contact_victime_time,
                date: bilan.equipe.arrivee_contact_victime_date,
            };
        },
    },
];
exports.heureDepartDesLieux = [
    {
        '@type': 'time',
        key: 'd96740ae-1175-4da8-b130-65c55fd33669',
        label: 'Heure de départ des lieux',
        value: (bilan) => bilan.devenir.heure_quitte_lieux,
    },
    {
        '@type': 'dateTime',
        key: 'b37aba57-10e8-49f0-9879-28c36d888a20',
        label: 'Heure de départ des lieux',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_quitte_lieux_time,
                date: bilan.devenir.heure_quitte_lieux_date,
            };
        },
    },
];
exports.heureDepartVersCh = [
    {
        '@type': 'dateTime',
        key: '1a7d8bc5-53d2-4eaf-b79a-4eb8e34118f5',
        label: 'Heure de départ vers CH',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_depart_vers_ch_time,
                date: bilan.devenir.heure_depart_vers_ch_date,
            };
        },
    },
];
exports.heureArriveeServiceReceveur = [
    {
        '@type': 'dateTime',
        key: 'cbcebca7-8312-4753-ba0a-8e265e8b761f',
        label: "Heure d'arrivée au service receveur",
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_arrivee_ch_time,
                date: bilan.devenir.heure_arrivee_ch_date,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: 'f6300923-a153-462c-b815-e6f070430be3',
        label: 'Heure de départ du service receveur',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_depart_ch_time,
                date: bilan.devenir.heure_depart_ch_date,
            };
        },
    },
];
exports.heureFinMedicalisation = [
    {
        '@type': 'time',
        key: '77c5426b-09b9-4c5e-9e63-8b24d0a00d23',
        label: 'Heure de fin de médicalisation',
        value: (bilan) => `${bilan.devenir?.heure_fin_medicalisation}`,
    },
    {
        '@type': 'dateTime',
        key: '8ea6461b-ca55-4661-831b-1402ff96d485',
        label: 'Heure de fin de médicalisation',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_fin_medicalisation_time,
                date: bilan.devenir.heure_fin_medicalisation_date,
            };
        },
    },
];
exports.heureLiberationBrancard = [
    {
        '@type': 'dateTime',
        key: 'bc32f1a6-23c2-460c-9863-ab05b0506ae6',
        label: 'Heure de libération de brancard',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_liberation_brancard_time,
                date: bilan.devenir.heure_liberation_brancard_date,
            };
        },
    },
];
exports.heureArriveeRenfortSmur = [
    {
        '@type': 'time',
        key: '50fc5898-37da-41c4-a432-23cd0b85c6d7',
        label: "Heure d'arrivée SMUR",
        value: (bilan) => bilan.devenir?.heure_arrivee_smur,
    },
    {
        '@type': 'dateTime',
        key: '96d86338-00f5-4a61-a329-7f547073d9cb',
        label: "Heure d'arrivée SMUR",
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_arrivee_smur_time,
                date: bilan.devenir.heure_arrivee_smur_date,
            };
        },
    },
];
exports.heureArriveeEpmu = [
    {
        '@type': 'dateTime',
        key: 'e0b702f0-e6b4-424a-a647-48f4e0b9b3a7',
        label: "Heure d'arrivée EPMU",
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_arrivee_epmu_time,
                date: bilan.devenir.heure_arrivee_epmu_date,
            };
        },
    },
];
exports.heureRetourBase = [
    {
        '@type': 'dateTime',
        key: '8d37b8dc-9406-412a-a4a0-2918eeb1826f',
        label: 'Heure de retour à la base',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_retour_parc_time,
                date: bilan.devenir.heure_retour_parc_date,
            };
        },
    },
];
exports.devenirHoraires = [
    ...exports.heureTransmissionInitiale,
    ...exports.heureDebutEvt,
    ...exports.heureDeclenchement,
    ...exports.heureDepartVersLieux,
    ...exports.heureArriveeSurLieux,
    {
        '@type': 'dateTime',
        key: '12619c05-a09f-4c7d-b941-1fe34dbef7d8',
        label: 'Heure de prise en charge',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_prise_en_charge_time,
                date: bilan.devenir.heure_prise_en_charge_date,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: '76fc0bc1-6ee4-4cb8-a8eb-952825dcc4a2',
        label: "Heure d'appel régulation",
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_appel_regulation_time,
                date: bilan.devenir.heure_appel_regulation_date,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: 'bb25dc60-2473-4888-8076-d4488698f766',
        label: 'Heure convergence',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_convergence_time,
                date: bilan.devenir.heure_convergence_date,
            };
        },
    },
    ...exports.heureArriveeRenfortSmur,
    ...exports.heureArriveeEpmu,
    {
        '@type': 'tristate',
        key: '8af9fdec-2fb6-4292-a784-b3592d8fbad0',
        label: 'Présence de moyen(s) médicalisé(s)',
        value: (bilan) => bilan.geste?.presence_moyen_med,
    },
    {
        '@type': 'dateTime',
        key: '6666c4f8-e4b5-4d68-ae60-fd85f752470d',
        label: "Heure d'arrivée du premier moyen médicalisé",
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_arrivee_moyen_medicalise_time,
                date: bilan.devenir.heure_arrivee_moyen_medicalise_date,
            };
        },
    },
    {
        '@type': 'select',
        key: '46c54aa7-881a-40c5-9aa1-6568f6218b7b',
        label: 'Nature du premier moyen médicalisé',
        options: [
            { value: 1, label: 'SMUR' },
            { value: 2, label: 'ISP seul' },
            { value: 3, label: 'MSP seul' },
            { value: 4, label: 'Binôme MSP-ISP' },
            { value: 5, label: 'Autre' },
        ],
        value: (bilan) => bilan.geste.nature_moyen_med,
    },
    {
        '@type': 'dateTime',
        key: '314099bf-6d8f-4ae2-8305-ba2e4086c638',
        label: "Heure d'arrivée des renforts",
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_arrivee_renforts_time,
                date: bilan.devenir.heure_arrivee_renforts_date,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: '7d396891-4cdb-4476-86bf-e094779ca747',
        label: 'Heure de la relève',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_releve_time,
                date: bilan.devenir.heure_releve_date,
            };
        },
    },
    ...exports.heureDepartDesLieux,
    ...exports.heureDepartVersCh,
    ...exports.heureArriveeServiceReceveur,
    ...exports.heureFinMedicalisation,
    ...exports.heureLiberationBrancard,
    ...exports.heureRetourBase,
    {
        '@type': 'time',
        key: '53fdb1a0-0f3a-4e72-bd6e-81898211d090',
        label: 'Heure de décès',
        value: (bilan) => bilan.devenir.heure_deces,
    },
    {
        '@type': 'dateTimeV2',
        key: 'ebe51d93-aeff-400e-a8f3-45a3ce230a99',
        label: 'Heure de décès',
        value: (bilan) => bilan.devenir.heure_deces_v2,
    },
    {
        '@type': 'dateTime',
        key: '4638c39b-ba19-4acf-8efe-b9e1316c9e86',
        label: 'Heure de décès',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_deces_time,
                date: bilan.devenir.heure_deces_date,
            };
        },
    },
    {
        '@type': 'time',
        key: '3f97b798-edaa-459b-95cc-f73039d51907',
        label: 'Heure de dépose',
        value: (bilan) => bilan.devenir.heure_arrivee_ch,
    },
    {
        '@type': 'time',
        key: '878d02b5-6895-4f6e-9008-861ae20139a9',
        label: 'Heure de départ',
        value: (bilan) => bilan.devenir.heure_depart,
        scope: ['puy_du_fou'],
    },
    {
        '@type': 'time',
        key: '514d0370-32d8-4015-b05d-246df61e1026',
        label: 'Heure de retour dans le parc',
        value: (bilan) => `${bilan.devenir?.heure_retour_parc}`,
        scope: ['puy_du_fou'],
    },
    {
        '@type': 'dateTime',
        key: 'f72363bf-2a85-4aba-a177-61f455de7e1c',
        label: 'Heure de retour dans le parc',
        value: (bilan) => {
            return {
                time: bilan.devenir.heure_retour_parc_time,
                date: bilan.devenir.heure_retour_parc_date,
            };
        },
        scope: ['puy_du_fou'],
    },
    {
        '@type': 'time',
        key: 'bd907fff-501b-474b-8ada-17582af492b4',
        label: "Heure de fin d'intervention",
        value: (bilan) => bilan.equipe.heure_fin_inter,
        scope: ['puy_du_fou'],
    },
    {
        '@type': 'dateTime',
        key: 'cccc955a-193a-436e-946c-9f676c454d1c',
        label: "Heure de fin d'intervention",
        value: (bilan) => {
            return {
                time: bilan.equipe.heure_fin_inter_time,
                date: bilan.equipe.heure_fin_inter_date,
            };
        },
        scope: ['puy_du_fou'],
    },
];
exports.devenir = [...exports.devenirInfos, ...exports.devenirHoraires];
exports.douleurThoracique = [
    {
        '@type': 'time',
        key: 'e02f010d-5972-4ad1-907b-ec87385ec022',
        label: 'Début de la douleur thoracique',
        value: (bilan) => bilan.douleur_thoracique?.debut_douleur,
    },
    {
        '@type': 'dateTime',
        key: '73c284ca-4988-48c2-956e-e5f2705c7b73',
        label: 'Début de la douleur thoracique',
        value: (bilan) => {
            return {
                time: bilan.douleur_thoracique?.debut_douleur_time,
                date: bilan.douleur_thoracique?.debut_douleur_date,
            };
        },
    },
    {
        '@type': 'tristate',
        key: '1702baa5-6df7-430d-8937-3a1258ceafec',
        label: 'Épisode identique au cours des 7 derniers jours',
        color: 'red',
        value: (bilan) => bilan.douleur_thoracique?.episode_similaire,
    },
    {
        '@type': 'multiselect',
        key: 'e8c8950c-589f-4fca-9b17-b0b760e42a70',
        label: 'Type de douleur',
        options: [
            { value: 1, label: 'Aucune', kind: 'positive' },
            { value: 2, label: 'Persistante', kind: 'negative' },
            { value: 3, label: 'De repos', kind: 'negative' },
            { value: 4, label: "D'effort", kind: 'negative' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.type_douleur,
    },
    {
        '@type': 'multiselect',
        key: '471c5d26-9713-4fe5-9b51-5e6e07e5895e',
        label: 'Antécédents et FRCV',
        options: [
            { value: 1, label: 'Inconnus' },
            { value: 2, label: 'Aucun', kind: 'positive' },
            { value: 3, label: 'Dyslipidémie' },
            { value: 4, label: 'HTA' },
            { value: 5, label: 'Diabète' },
            { value: 6, label: 'Obésité / surpoids' },
            { value: 7, label: 'Tabagisme' },
            { value: 8, label: 'AVC / AIT' },
            { value: 9, label: 'Coronaropathie' },
            { value: 10, label: 'Angioplastie avec stent' },
            { value: 11, label: 'Angioplastie sans stent' },
            { value: 12, label: 'Hérédité' },
            { value: 13, label: 'TAVI' },
            { value: 14, label: 'Greffe cardiaque' },
            { value: 15, label: 'Pontage coronaire' },
            { value: 16, label: 'Remplacement valvulaire' },
            { value: 17, label: 'Pathologie aortique / vasculaire' },
            { value: 18, label: 'ACFA' },
            { value: 19, label: 'Défibrillateur' },
            { value: 20, label: 'Pacemaker' },
            { value: 21, label: 'TVP' },
            { value: 22, label: 'EP' },
            { value: 23, label: 'AOMI' },
            { value: 24, label: 'Insuffisance rénale' },
            { value: 25, label: 'Alzheimer' },
            { value: 26, label: "Perte d'autonomie" },
        ],
        value: (bilan) => bilan.douleur_thoracique?.atcd_frcv,
    },
    {
        '@type': 'text',
        key: '5243ceb5-bbdc-407c-867a-665016b05ef7',
        label: 'Antécédents et FRCV - Observations',
        value: (bilan) => bilan.douleur_thoracique?.atcd_frcv_observations,
    },
    {
        '@type': 'tristate',
        key: '5537e4e1-7e35-4ed5-9387-ca1454577823',
        label: 'Dyslipidémie traitée',
        color: 'green',
        contentInverted: true,
        value: (bilan) => utils.boolToChar(bilan.douleur_thoracique?.dyslipidemie_traitee),
    },
    {
        '@type': 'tristate',
        key: '641fbabd-5841-4d05-bfe7-3f369087d2a4',
        label: 'HTA traitée',
        color: 'green',
        contentInverted: true,
        value: (bilan) => utils.boolToChar(bilan.douleur_thoracique?.hta_traitee),
    },
    {
        '@type': 'select',
        key: 'de903d63-f08e-4bce-9d23-e75bd6740094',
        label: 'Type de diabète',
        options: [
            { value: 1, label: 'Type I' },
            { value: 2, label: 'Type II' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.type_diabete,
    },
    {
        '@type': 'tristate',
        key: '4d8d0d77-6940-476c-8a22-4dea576ea5b6',
        label: 'Diabète traité',
        color: 'green',
        contentInverted: true,
        value: (bilan) => utils.boolToChar(bilan.douleur_thoracique?.diabete_traite),
    },
    {
        '@type': 'tristate',
        key: '0e7ed242-8eda-4b1a-ace3-dd8a2228c659',
        label: 'Tabagisme actif',
        color: 'red',
        value: (bilan) => utils.boolToChar(bilan.douleur_thoracique?.tabagisme_actif),
    },
    {
        '@type': 'select',
        key: '64399711-6488-4fc9-8d8f-852e7f8fdfb9',
        label: 'AVC/AIT',
        options: [
            { value: 1, label: 'Ischémique', kind: 'negative' },
            { value: 2, label: 'Hémorragique', kind: 'negative' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.avc_ait_type,
    },
    {
        '@type': 'multiselect',
        key: '0d2fea60-1e3c-4681-a49e-2c8a8fa66c28',
        label: 'Traitements en cours',
        options: [
            { value: 1, label: 'Inconnus' },
            { value: 2, label: 'Aucun' },
            { value: 3, label: 'Aspirine' },
            { value: 4, label: 'Clopidogrel (PLAVIX®)' },
            { value: 5, label: 'Prasugrel (EFIENT®)' },
            { value: 6, label: 'Ticagrelor (BRILIQUE®)' },
            { value: 7, label: 'Dabigatran (PRADAXA®)' },
            { value: 8, label: 'Rivaroxaban (XARELTO®)' },
            { value: 9, label: 'Apixaban (ELIQUIS®)' },
            { value: 10, label: 'Edoxaban (LIXIANA®)' },
            { value: 11, label: 'B-Bloquant' },
            { value: 12, label: 'Statine' },
            { value: 13, label: 'IEC' },
            { value: 14, label: 'ARA 2' },
            { value: 15, label: 'HGPM' },
            { value: 16, label: 'AVK' },
            { value: 17, label: 'Ca-Bloquant' },
            { value: 18, label: 'Anti-Arythmique' },
            { value: 19, label: 'Diurétique' },
            { value: 20, label: 'Anti-Aldostérone' },
            { value: 21, label: 'Antidiabétique Oral' },
            { value: 22, label: 'Insuline' },
            { value: 23, label: 'Autre' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.traitements_en_cours,
    },
    {
        '@type': 'time',
        key: '7610ec84-f15a-4e56-a129-0e8c80f070b8',
        label: 'Heure du 1er ECG',
        value: (bilan) => bilan.douleur_thoracique?.premier_ecg,
    },
    {
        '@type': 'dateTime',
        key: '859704e8-450f-4c45-bc5c-1535fce47fb7',
        label: 'Heure du 1er ECG',
        value: (bilan) => {
            return {
                time: bilan.douleur_thoracique?.premier_ecg_time,
                date: bilan.douleur_thoracique?.premier_ecg_date,
            };
        },
    },
    {
        '@type': 'multiselect',
        key: 'd6d1b8d5-0d26-48a2-80cc-e2f05f006a44',
        label: 'Interprétation ECG',
        options: [
            { value: 1, label: 'Normal', kind: 'positive' },
            { value: 2, label: 'BBG', kind: 'negative' },
            { value: 3, label: 'Électro-entrainé', kind: 'negative' },
            { value: 4, label: 'BBD', kind: 'negative' },
            { value: 5, label: 'Flutter', kind: 'negative' },
            { value: 6, label: 'Ondes Q', kind: 'negative' },
            { value: 7, label: 'BAV type I', kind: 'negative' },
            { value: 8, label: 'BAV type II', kind: 'negative' },
            { value: 9, label: 'BAV type III', kind: 'negative' },
            { value: 10, label: 'Inversion ondes T', kind: 'negative' },
            { value: 11, label: 'Ondes T amples', kind: 'negative' },
            { value: 12, label: 'Sus décalage ST', kind: 'negative' },
            { value: 13, label: 'Sous décalage ST', kind: 'negative' },
            { value: 14, label: 'Lésions ischémiques', kind: 'negative' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.interpretation_ecg,
    },
    {
        '@type': 'multiselect',
        key: 'be36a910-42de-42da-8295-543501e7e3d5',
        label: 'Syndrôme coronarien',
        options: [
            { value: 1, label: 'SCA avec sus-TR persistant', kind: 'negative' },
            { value: 2, label: 'SCA avec sous-TR persistant', kind: 'negative' },
            { value: 3, label: 'Sus-TR transitiore', kind: 'negative' },
            { value: 4, label: 'Sous-TR transitiore', kind: 'negative' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.syndrome_coronarien,
    },
    {
        '@type': 'multiselect',
        key: 'c7e6823e-6ae2-456c-a942-c6b757a555dc',
        label: 'Territoire',
        options: [
            { value: 1, label: 'Antérieur', kind: 'negative' },
            { value: 2, label: 'Antéro-septal', kind: 'negative' },
            { value: 3, label: 'Inférieur', kind: 'negative' },
            { value: 4, label: 'Latéral', kind: 'negative' },
            { value: 5, label: 'Postérieur', kind: 'negative' },
            { value: 6, label: 'VD', kind: 'negative' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.territoire,
    },
    {
        '@type': 'multiselect',
        key: '224d7035-ed40-49ea-bcfb-571cfd37dca1',
        label: 'Troubles du rythme',
        options: [
            { value: 1, label: 'TV', kind: 'negative' },
            { value: 2, label: 'FV', kind: 'negative' },
            { value: 3, label: 'Asystole', kind: 'negative' },
            { value: 4, label: 'Activité électrique sans pouls', kind: 'negative' },
            { value: 5, label: 'Autre' },
            { value: 6, label: 'Non', kind: 'positive' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.troubles_rythme,
    },
    {
        '@type': 'multiselect',
        key: '84254665-2fd6-4889-ae36-6d9788120fcb',
        label: 'Diagnostique présumé',
        options: [
            { value: 2, label: 'SCA SUS ST', kind: 'negative' },
            { value: 3, label: 'SCA NON SUS ST', kind: 'negative' },
            { value: 4, label: 'AC/FA', kind: 'negative' },
            { value: 5, label: 'Péricardite', kind: 'negative' },
            { value: 6, label: 'Myocardite', kind: 'negative' },
            { value: 7, label: "Dissection d'aorte", kind: 'negative' },
            { value: 8, label: 'OAP', kind: 'negative' },
            { value: 9, label: 'EP', kind: 'negative' },
            { value: 10, label: 'Pneumothorax', kind: 'negative' },
            { value: 11, label: 'Pneumopathie', kind: 'negative' },
            { value: 12, label: 'Pleurésie', kind: 'negative' },
            { value: 13, label: 'Ulcère gastro-duodénal', kind: 'negative' },
            { value: 14, label: 'Anxiogène', kind: 'negative' },
            { value: 15, label: 'Origine pariétale', kind: 'negative' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.diagnostic_presume,
    },
    {
        '@type': 'multiselect',
        key: 'e14d2529-4462-47ae-bdd7-b3cf6dc95835',
        label: 'Complications',
        options: [
            { value: 1, label: 'Aucune', kind: 'positive' },
            { value: 2, label: 'Instabilité hémodynamique persistante', kind: 'negative' },
            { value: 3, label: 'Détresse respi / OAP', kind: 'negative' },
            { value: 4, label: 'Hémorragie interne', kind: 'negative' },
            { value: 5, label: 'Hémorragie majeur', kind: 'negative' },
            { value: 6, label: 'Chute PAS sup. ou égale 20mmHg', kind: 'negative' },
            { value: 7, label: 'Bradycardie extrême', kind: 'negative' },
            { value: 8, label: 'AC/FA', kind: 'negative' },
            { value: 9, label: 'FV/TV', kind: 'negative' },
            { value: 10, label: 'Choc cardiogénique', kind: 'negative' },
            { value: 11, label: 'Asystolie', kind: 'negative' },
            { value: 12, label: 'ACR: MCE', kind: 'negative' },
            { value: 13, label: 'ACR: CEE', kind: 'negative' },
            { value: 14, label: 'RACS', kind: 'negative' },
            { value: 15, label: 'Autre', kind: 'negative' },
        ],
        value: (bilan) => bilan.douleur_thoracique?.complications,
    },
    {
        '@type': 'tristate',
        key: '152fcf7b-a2fc-4592-81b8-036c6bd0efc4',
        label: 'Décès',
        color: 'red',
        value: (bilan) => bilan.douleur_thoracique?.deces,
    },
];
exports.examen = [
    {
        '@type': 'text',
        key: '1450f1f0-5d73-4932-89b4-ed562412bc69',
        label: 'Examen',
        value: (bilan) => bilan.geste.prescription || bilan.geste.examen,
    },
];
exports.surfaceBrulure = [
    {
        '@type': 'integer',
        key: '9c6fd2fe-c020-4860-8f16-16b6eb1dcd0b',
        label: 'Surface de brûlure',
        unit: '%',
        value: (bilan) => {
            if (bilan.lesionnel.surface_brulure == null || bilan.lesionnel.surface_brulure === 0) {
                return null;
            }
            else {
                return bilan.lesionnel.surface_brulure;
            }
        },
    },
    {
        '@type': 'integer',
        key: '6fd8722b-7669-42b7-972a-a014727e15ba',
        label: 'Surface de brûlure 3ème degré',
        unit: '%',
        value: (bilan) => bilan.lesionnel?.surface_3eme_degre,
    },
];
// E du ABCDE - Dans la section lésionnel du NRC
exports.expositionLesionnel = [
    {
        '@type': 'tristate',
        key: 'f9ec5be3-34c2-4fdf-8f37-9651f7a49fb2',
        label: 'Lésion apparente',
        color: 'red',
        value: (bilan) => bilan.lesionnel.aucune_lesion_apparente,
    },
    {
        '@type': 'tristate',
        key: 'ef4161dc-dc3a-46a9-a740-43ac549e6430',
        label: 'Plaies graves',
        color: 'red',
        value: (bilan) => bilan.lesionnel?.plaies_graves,
    },
    {
        '@type': 'tristate',
        key: '1fe10106-dc96-4922-ac67-89c916b6dba6',
        label: 'Traumatisme pénétrant',
        color: 'red',
        value: (bilan) => bilan.lesionnel.traumatisme_penetrant,
    },
    {
        '@type': 'tristate',
        key: 'aab72ed8-7dde-4a07-a07d-619e24ab7f08',
        label: 'Brûlure grave',
        color: 'red',
        value: (bilan) => bilan.lesionnel?.brulure_grave,
    },
    ...exports.surfaceBrulure,
    {
        '@type': 'select',
        key: '78323a0b-4136-4dd7-8af9-06d93d8c67b6',
        label: 'Degré de la brûlure',
        options: [
            { value: 4, label: 'Inconnu', kind: 'intermediate' },
            { value: 1, label: '1er degré', kind: 'negative' },
            { value: 2, label: '2eme degré', kind: 'negative' },
            { value: 3, label: '3eme degré', kind: 'negative' },
        ],
        value: (bilan) => bilan.lesionnel.brulure_degre,
    },
    {
        '@type': 'select',
        key: '5a335854-3c7d-45ad-b049-95a751098bf1',
        label: 'Surface',
        options: [
            { value: 2, label: '>10% (enfant)', kind: 'negative' },
            { value: 3, label: '>20% (adulte)', kind: 'negative' },
        ],
        value: (bilan) => bilan.lesionnel.surface_brulure_precision,
    },
    {
        '@type': 'select',
        key: '6fbd7c5e-6eba-4006-8b14-16cb39626f7d',
        label: 'Origine de la brûlure',
        options: [
            { value: 0, label: 'Inconnu', kind: 'intermediate' },
            { value: 1, label: 'Thermique', kind: 'negative' },
            { value: 2, label: 'Chimique', kind: 'negative' },
            { value: 3, label: 'Électrique', kind: 'negative' },
        ],
        value: (bilan) => bilan.lesionnel.origine_brulure,
    },
    {
        '@type': 'tristate',
        key: 'c2b00a3e-b517-420c-95a0-ed6a7117d155',
        label: "Situation d'hypothermie",
        color: 'red',
        value: (bilan) => bilan.lesionnel.situation_hypothermie,
    },
    {
        '@type': 'tristate',
        key: 'beced7c0-d8e9-4771-876e-6d43f22fc488',
        label: "Situation d'hyperthermie",
        color: 'red',
        value: (bilan) => bilan.lesionnel.situation_hyperthermie,
    },
    {
        '@type': 'tristate',
        key: '167878c9-af3d-4009-84e2-9b9fcfa5742c',
        label: 'Élément agravant',
        color: 'red',
        value: (bilan) => bilan.lesionnel?.element_agravant,
    },
    {
        '@type': 'tristate',
        key: '7489285c-c700-4d89-8587-a37b36c9d117',
        label: 'Membres sectionnés',
        color: 'red',
        value: (bilan) => bilan.lesionnel?.membres_sectionnes,
    },
    {
        '@type': 'tristate',
        key: '28585b2c-59aa-4736-9288-beacd6a687cc',
        label: 'Amputation jambe / bras / cuisse',
        color: 'red',
        value: (bilan) => bilan.lesionnel.amputation_jambe_bras_cuisse,
    },
    {
        '@type': 'tristate',
        key: '68d61f03-d3ed-4bb5-b7c7-69706345b6cf',
        label: 'Pouls en aval de la lésion',
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.lesionnel.pouls_aval_lesion,
    },
    {
        '@type': 'multiselect',
        key: '2e32b9db-8717-4514-bd01-31f5d3b9d68a',
        label: 'Signes digestifs',
        options: [
            { value: 1, label: 'Aucun', kind: 'positive' },
            { value: 2, label: 'Vomissements', kind: 'negative' },
            { value: 3, label: 'Nausées', kind: 'negative' },
            { value: 4, label: 'Douleur abdo', kind: 'negative' },
            { value: 5, label: 'Diarrhées', kind: 'negative' },
            { value: 6, label: 'Autre', kind: 'negative' },
        ],
        value: (bilan) => bilan.medic_info.signes_digestifs,
    },
    {
        '@type': 'multiselect',
        key: 'b86ac0fc-b6e9-4dd0-9fc4-15dd82c7af8c',
        label: 'Examen tête',
        options: [
            { value: 1, label: 'Aucun', kind: 'positive' },
            { value: 2, label: 'Enfoncement', kind: 'negative' },
            { value: 3, label: 'Écoulement oreille', kind: 'negative' },
            { value: 4, label: 'Écoulement nez', kind: 'negative' },
            { value: 5, label: 'Fracas dentaire', kind: 'negative' },
            { value: 6, label: 'Autre', kind: 'negative' },
        ],
        value: (bilan) => bilan.medic_info.examen_tete,
    },
    {
        '@type': 'multiselect',
        key: '9086c90c-eed5-4e8c-bcbd-86fde79f2e1b',
        label: 'Examen rachis',
        options: [
            { value: 1, label: 'Normal', kind: 'positive' },
            { value: 2, label: 'Douleur', kind: 'negative' },
            { value: 3, label: 'Hématome', kind: 'negative' },
            { value: 4, label: 'Plaie', kind: 'negative' },
        ],
        value: (bilan) => bilan.medic_info.examen_rachis,
    },
    {
        '@type': 'multiselect',
        key: '65cf0978-5c88-4bd7-8c95-51a597dbc7b0',
        label: 'Examen thorax',
        options: [
            { value: 1, label: 'Normal', kind: 'positive' },
            { value: 2, label: 'Douleur', kind: 'negative' },
            { value: 3, label: 'Hématome', kind: 'negative' },
            { value: 4, label: 'Plaie', kind: 'negative' },
        ],
        value: (bilan) => bilan.medic_info.examen_thorax,
    },
    {
        '@type': 'text',
        key: 'd68f1818-464f-4218-ab7b-33b63f3b8dba',
        label: 'Commentaire',
        value: (bilan) => bilan.lesionnel.commentaire_smur,
    },
    {
        '@type': 'text',
        key: 'fa786c12-9ac7-4e16-b6bb-19ee573e2571',
        label: 'Peau',
        value: (bilan) => bilan.lesionnel.commentaire_peau_smur,
    },
    {
        '@type': 'text',
        key: '01208fe6-dcbe-41b0-880b-1e60e27b9f77',
        label: 'Abdomen',
        value: (bilan) => bilan.lesionnel.commentaire_abdomen_smur,
    },
    {
        '@type': 'text',
        key: '24c76642-8abd-4cc6-bc55-9e830eb7220d',
        label: 'Urines',
        value: (bilan) => bilan.lesionnel.commentaire_urine_smur,
    },
    {
        '@type': 'text',
        key: 'd970dbdc-28ad-49d0-a3de-2495bf9c1e5a',
        label: 'Sang',
        value: (bilan) => bilan.lesionnel.commentaire_sang_smur,
    },
    {
        '@type': 'integer',
        key: 'ab8a7689-6398-4f1d-ac30-a9aadfb762db',
        label: 'Surface brûlée au 1er degré',
        unit: '%',
        value: (bilan) => {
            if (bilan.burn_surface && bilan.burn_surface?.first_degree_burn_surface
                && bilan.burn_surface?.first_degree_burn_surface !== -1)
                return (Math.floor(bilan.burn_surface?.first_degree_burn_surface * 100) / 100)?.toFixed(2);
        },
    },
    {
        '@type': 'integer',
        key: 'b1f7eacc-61be-426a-8dd8-ff4b37f91fba',
        label: 'Surface brûlée au 2e degré',
        unit: '%',
        value: (bilan) => {
            if (bilan.burn_surface && bilan.burn_surface?.Second_degree_burn_surface
                && bilan.burn_surface?.Second_degree_burn_surface !== -1)
                return (Math.floor(bilan.burn_surface?.Second_degree_burn_surface * 100) / 100)?.toFixed(2);
        },
    },
    {
        '@type': 'integer',
        key: 'e5b72cf2-55f2-497a-952a-ef87bf41a95c',
        label: 'Surface brûlée au 3e degré',
        unit: '%',
        value: (bilan) => {
            if (bilan.burn_surface && bilan.burn_surface?.third_degree_burn_surface
                && bilan.burn_surface?.third_degree_burn_surface !== -1)
                return (Math.floor(bilan.burn_surface?.third_degree_burn_surface * 100) / 100)?.toFixed(2);
        },
    },
];
exports.hypotheseDiag = [
    {
        '@type': 'text',
        key: '745f36cf-0bbc-423b-a583-40a220de9bdb',
        label: 'Hypothèses diagnostiques',
        value: (bilan) => (bilan.geste.conclusion === 'NR' ? null : bilan.geste.conclusion),
    },
];
exports.poidsTaille = [
    {
        '@type': 'integer',
        key: '796b99bd-b64a-4676-8e84-a9e6d9fe893f',
        label: 'Poids',
        unit: 'kg',
        value: (bilan) => (bilan.victime.poids === -1 ? null : bilan.victime.poids),
    },
    {
        '@type': 'integer',
        key: '8bc9a6f9-c3ba-4d42-8dde-f93c1afd90c7',
        label: 'Taille',
        unit: 'cm',
        value: (bilan) => (bilan.victime.taille === -1 ? null : bilan.victime.taille),
    },
];
exports.imc = [
    {
        '@type': 'integer',
        key: 'ea946f09-bf98-4ae2-8a5f-aeeecf2f8807',
        label: 'IMC',
        unit: 'kg/m²',
        value: (bilan) => {
            if (bilan.victime.poids !== -1 && bilan.victime.taille !== -1) {
                const tailleMetre = bilan.victime.taille / 100;
                const imc = bilan.victime.poids / (tailleMetre * tailleMetre);
                return (Math.floor(imc * 100) / 100).toFixed(2);
            }
            return null;
        },
    },
];
exports.prenomNom = [
    {
        '@type': 'text',
        // Ne pas changer l'UUID
        key: 'e44fd8db-6bb1-4cfa-bfc7-f4a8288c40fd',
        label: 'Prénom',
        value: (bilan) => bilan.victime?.prenom?.toLowerCase(),
    },
    {
        '@type': 'text',
        // Ne pas changer l'UUID
        key: 'b1ca1cb8-11dc-41c6-99b0-f56059e2488f',
        label: 'Nom',
        value: (bilan) => bilan.victime?.nom,
    },
];
exports.nomNaissance = [
    {
        '@type': 'text',
        key: 'b742ef0c-7555-48a8-89c7-7d51b9c2f50b',
        label: 'Nom de naissance',
        value: (bilan) => bilan.victime.jeunefille,
    },
];
exports.ageForAgeEstimeObj = {
    '@type': 'text',
    key: '7de03ff3-9c64-42e0-b72d-a78d9f02c039',
    label: 'Âge',
    permission: ['web:bilan:age_estime'],
    value: (bilan) => {
        if (bilan.victime.date_naissance === '' || bilan.victime.age === '')
            return null;
        switch (bilan.victime.age_unit) {
            case 1:
                return `${bilan.victime.age} jour${typeof bilan.victime?.age === 'number' && bilan.victime.age > 1 ? 's' : ''}`;
            case 2:
                return `${bilan.victime.age} mois`;
            default:
                return `${bilan.victime.age} an${typeof bilan.victime?.age === 'number' && bilan.victime.age > 1 ? 's' : ''}`;
        }
    },
};
exports.ageEstimeForAgeEstimeObj = {
    '@type': 'text',
    key: '135dc775-2c45-419b-8fbb-2ad22c41ddb7',
    label: 'Âge estimé',
    permission: ['web:bilan:age_estime'],
    value: (bilan) => {
        if (bilan.victime.date_naissance !== '' || bilan.victime.age === '')
            return null;
        switch (bilan.victime.age_unit) {
            case 1:
                return `${bilan.victime.age} jour${typeof bilan.victime?.age === 'number' && bilan.victime.age > 1 ? 's' : ''}`;
            case 2:
                return `${bilan.victime.age} mois`;
            default:
                return `${bilan.victime.age} an${typeof bilan.victime?.age === 'number' && bilan.victime.age > 1 ? 's' : ''}`;
        }
    },
};
exports.ageEstime = [exports.ageForAgeEstimeObj, exports.ageEstimeForAgeEstimeObj];
exports.ageObj = {
    '@type': 'text',
    key: 'e6db7994-f21f-4fb6-92c0-183650a60921',
    label: 'Âge',
    permission: ['!web:bilan:age_estime'],
    value: (bilan) => {
        if (bilan.victime.age === '')
            return null;
        switch (bilan.victime.age_unit) {
            case 1:
                return `${bilan.victime.age} jour${typeof bilan.victime?.age === 'number' && bilan.victime.age > 1 ? 's' : ''}`;
            case 2:
                return `${bilan.victime.age} mois`;
            default:
                return `${bilan.victime.age} an${typeof bilan.victime?.age === 'number' && bilan.victime.age > 1 ? 's' : ''}`;
        }
    },
};
exports.age = [exports.ageObj];
exports.dateNaissanceObj = {
    '@type': 'text',
    key: 'cdac6bbd-ae23-449b-aae6-27b2620d346c',
    label: 'Date de naissance',
    value: (bilan) => bilan.victime.date_naissance,
};
exports.dateNaissance = [
    exports.dateNaissanceObj,
    {
        '@type': 'text',
        key: '6cb9ed56-d389-4a93-9fe7-8cf8a6a8c957',
        label: 'Lieu de naissance (code INSEE)',
        value: (bilan) => bilan.victime.insee,
    },
    {
        '@type': 'text',
        key: '347af386-777c-4de3-944f-d395934de281',
        label: 'Pays de naissance',
        value: (bilan) => bilan.victime?.birth_country,
    },
];
exports.victimeAdresse = [
    {
        '@type': 'text',
        key: 'f73dc029-3d37-4b08-8ed7-d7f231bbec02',
        label: 'Adresse',
        value: (bilan) => bilan.victime?.adresse,
    },
    {
        '@type': 'text',
        key: '7e521648-5fb1-4cfc-bae8-21e6215a6407',
        label: 'Adresse, complément',
        value: (bilan) => bilan.victime?.adresse_seconde,
    },
    {
        '@type': 'text',
        key: '77330d32-bd75-41bd-858a-82584698db71',
        label: 'Ville',
        value: (bilan) => bilan.victime.ville,
    },
    {
        '@type': 'integer',
        key: '252488df-546c-4129-b4d5-808a60405a7c',
        label: 'Code postal',
        value: (bilan) => bilan.victime.code_postal,
    },
];
exports.secuObj = {
    '@type': 'text',
    key: '4d68e221-fb24-4dc4-a2ca-9f067856df10',
    label: 'Numéro de sécurité sociale',
    value: (bilan) => bilan.victime?.secu,
};
exports.securiteSociale = [
    exports.secuObj,
    {
        '@type': 'text',
        key: '53a305e2-cbde-45b9-a77b-c65ef56e4613',
        label: 'NIRPP',
        value: (bilan) => bilan.victime?.nirpp,
    },
    {
        '@type': 'text',
        key: '2bceb54c-e23e-436d-8b11-0621ca2bccea',
        label: 'INS',
        value: (bilan) => bilan.victime.ins,
    },
];
exports.sexeObj = {
    '@type': 'select',
    key: '1030e86c-270d-409e-8a4b-ad131ff20f16',
    label: 'Sexe',
    options: data_1.SEX_OPTIONS,
    value: (bilan) => {
        if ([1, 2, '1', '2'].includes(bilan.victime.civilite) &&
            bilan.victime.sexe &&
            [0, '0'].includes(bilan.victime.sexe))
            return null;
        return bilan.victime.sexe;
    },
};
exports.sexe = [exports.sexeObj];
exports.drm = [
    {
        '@type': 'integer',
        key: '158a75cb-2e3d-473b-a5ba-3a8c331bc824',
        label: 'DRM',
        value: (bilan) => bilan.info_tech.conformite,
    },
];
exports.headerPdf = [
    ...exports.drm,
    ...exports.prenomNom,
    ...exports.dateNaissance,
    ...exports.heureTransmissionInitiale,
    ...exports.primoIntervenant,
];
exports.footerPdf = [...exports.heureTransmissionInitiale, ...exports.idExporteur, ...exports.idRedacteur];
exports.mutuelleObj = {
    '@type': 'text',
    key: 'd1ec55c3-a42d-4162-ba1d-0136cef4507e',
    label: 'Mutuelle',
    value: (bilan) => bilan.victime.mutuelle,
};
exports.caisseObj = {
    '@type': 'text',
    key: '6d09161f-1278-477b-a14b-d833f172c623',
    label: 'Caisse assurance maladie',
    value: (bilan) => bilan.victime.caisse_assurance_maladie,
};
exports.heureNaissanceObj = {
    '@type': 'time',
    key: '0372ca44-943c-4711-8dcf-c813e975bb11',
    label: 'Heure de naissance',
    value: (bilan) => `${bilan.victime?.heure_naissance}`,
};
exports.identite = [
    {
        '@type': 'text',
        key: 'a64db190-69eb-470d-b5cf-45c125d4921c',
        label: 'SINUS',
        value: (bilan) => bilan.info_tech.sinus_serial,
    },
    ...exports.prenomNom,
    ...exports.nomNaissance,
    {
        '@type': 'select',
        key: 'c1255e95-2715-418f-a406-9ba6e8c8b53a',
        label: 'Civilité',
        options: data_1.CIVILITY_OPTIONS,
        value: (bilan) => bilan.victime.civilite,
    },
    {
        '@type': 'tristate',
        key: '71f2ecef-03ad-48b4-99a1-3b556e83c974',
        label: 'Mineur',
        value: (bilan) => bilan.victime?.mineur,
    },
    ...exports.ageEstime,
    ...exports.age,
    ...exports.sexe,
    ...exports.dateNaissance,
    exports.heureNaissanceObj,
    {
        '@type': 'text',
        key: '21ff87d0-5b98-4d44-b24f-8d14ef29b910',
        label: 'Nationalité',
        value: (bilan) => bilan.victime.nationalite,
    },
    ...exports.poidsTaille,
    {
        '@type': 'text',
        key: 'c2e3e8b8-567e-4f9f-9bdc-daf07d5c7873',
        label: 'Type de victime',
        value: (bilan) => bilan.victime.pdf_salarie,
    },
    {
        '@type': 'text',
        key: '482c5d7b-531d-4fb2-b04f-d85e797d7b38',
        label: 'Téléphone',
        value: (bilan) => bilan.victime.telephone,
    },
    {
        '@type': 'text',
        key: '6a39d7e6-8d34-4649-82a1-92659ffb6367',
        label: 'Courriel',
        value: (bilan) => bilan.victime.email,
    },
    ...exports.victimeAdresse,
    ...exports.securiteSociale,
    {
        '@type': 'select',
        key: 'f60835fa-dd5b-4a3f-87b8-3bc65129d9c2',
        label: "Type du document d'identité",
        options: [
            { value: 1, label: 'CNI' },
            { value: 2, label: 'Passeport' },
            { value: 3, label: 'Titre de séjour' },
            { value: 4, label: 'Acte de naissance' },
            { value: 5, label: 'Livret de famille' },
            { value: 6, label: 'Permis de conduire' },
            { value: 7, label: "Demande d'asile" },
            { value: 8, label: 'Document circulatoire' },
            { value: 9, label: 'Autre document' },
        ],
        value: (bilan) => bilan.victime?.identity_document_type,
    },
    exports.mutuelleObj,
    {
        '@type': 'tristate',
        key: '3760a78e-74bd-422f-bdc8-eb668e0ee339',
        label: "Dispose d'une assurance",
        color: 'green',
        value: (bilan) => bilan.victime?.has_assurance,
    },
    {
        '@type': 'text',
        key: 'ed52885d-d7c3-4367-b45b-7e3e529ae649',
        label: 'Assurances',
        value: (bilan) => bilan.victime?.assurance?.split('@#').join(', '),
    },
    {
        '@type': 'text',
        key: 'a791e2e3-f605-4753-ba95-a83cde4000d2',
        label: 'Assurances - Commentaires',
        value: (bilan) => bilan.victime?.commentaire_assurance,
    },
    exports.caisseObj,
    {
        '@type': 'tristate',
        key: '806c4994-7aa8-48bd-9d09-e0d59904e295',
        label: 'VAT à jour',
        value: (bilan) => bilan.victime.vat_a_jour,
    },
    {
        '@type': 'text',
        key: 'ee62f0d3-c420-4d1a-9411-347b6c6a9035',
        label: 'Effet personnel',
        value: (bilan) => bilan.victime.effet_personnel,
    },
    {
        '@type': 'select',
        key: 'cde2c941-2c62-46e9-afbc-99b41a5502d1',
        label: 'Origine du patient',
        options: [
            { value: 1, label: 'Visiteur' },
            { value: 2, label: 'Exposant' },
            { value: 3, label: 'Presta orga' },
            { value: 4, label: 'Orga' },
            { value: 5, label: 'Presta parc' },
            { value: 6, label: 'Personnel' },
        ],
        value: (bilan) => bilan.victime.position_origine,
    },
    {
        '@type': 'text',
        key: '3c64cc8a-aa16-4b1a-8040-562dc5227dc9',
        label: 'Origine du patient',
        value: (bilan) => bilan.victime.position_origine_str,
    },
];
exports.identiteSamu13 = [
    ...exports.sexe,
    ...exports.ageEstime,
    ...exports.age,
    ...exports.dateNaissance,
    exports.heureNaissanceObj,
    {
        '@type': 'text',
        key: '21ff87d0-5b98-4d44-b24f-8d14ef29b910',
        label: 'Nationalité',
        value: (bilan) => bilan.victime.nationalite,
    },
    {
        '@type': 'text',
        key: '482c5d7b-531d-4fb2-b04f-d85e797d7b38',
        label: 'Téléphone',
        value: (bilan) => bilan.victime.telephone,
    },
    {
        '@type': 'text',
        key: 'a64db190-69eb-470d-b5cf-45c125d4921c',
        label: 'SINUS',
        value: (bilan) => bilan.info_tech.sinus_serial,
    },
    {
        '@type': 'text',
        key: '4d3aa184-ae15-440d-9d73-b4f2c7d729f7',
        label: 'Maladies',
        value: (bilan) => bilan.victime?.maladies?.split('@#').join(', '),
    },
    {
        '@type': 'text',
        key: '277c4d3f-c6d4-41be-8b5d-64f41659ef72',
        label: 'Hospitalisations',
        value: (bilan) => bilan.victime?.hospitalisations?.split('@#').join(', '),
    },
    {
        '@type': 'text',
        key: 'e39cbb4a-a154-421d-87db-956eecce8ab7',
        label: 'Traitements',
        value: (bilan) => bilan.victime?.traitements?.split('@#').join(', '),
    },
    {
        '@type': 'text',
        key: 'e47ed194-075d-4d5f-90f0-b3cfed112c0e',
        label: 'Allergies',
        value: (bilan) => bilan.victime?.antecedents?.split('@#').join(', '),
    },
];
// TODO
exports.lesionnel = [
    {
        '@type': 'lesionnel',
        key: '714127ba-6406-49a4-a3e6-46f88c4dbd7e',
        values: {
            front: (bilan, version) => (version === 'v1' ? bilan.lesionnel_avant : bilan.lesionnel_avant_v2),
            back: (bilan, version) => (version === 'v1' ? bilan.lesionnel_arriere : bilan.lesionnel_arriere_v2),
            handRight: (bilan) => {
                return { ...bilan.lesionnel_avant_v2, ...bilan.lesionnel_arriere_v2 } || {};
            },
            handLeft: (bilan) => {
                return { ...bilan.lesionnel_avant_v2, ...bilan.lesionnel_arriere_v2 } || {};
            },
            footRight: (bilan) => {
                return { ...bilan.lesionnel_avant_v2, ...bilan.lesionnel_arriere_v2 } || {};
            },
            footLeft: (bilan) => {
                return { ...bilan.lesionnel_avant_v2, ...bilan.lesionnel_arriere_v2 } || {};
            },
            headFront: (bilan) => bilan.lesionnel_avant_v2 || {},
        },
    },
];
exports.lesionnelProtocol = [
    {
        '@type': 'select',
        key: '2912877e-08b1-46f0-94ad-89f19728abb4',
        label: 'Protocole',
        options: [
            { value: 0, label: 'NR' },
            { value: 1, label: 'ACR Adulte' },
            { value: 2, label: 'ACR enfant' },
            { value: 3, label: 'Choc hémorragique' },
            { value: 4, label: 'Détresse circu allergique' },
            { value: 5, label: 'Douleur thoracique non trauma' },
            { value: 6, label: 'Dyspnée asthmatique' },
            { value: 7, label: 'Dyspnée insuffisance cardiaque' },
            { value: 8, label: 'Malaise' },
            { value: 9, label: 'Crise convulsive' },
            { value: 10, label: 'Convulsions fébriles' },
            { value: 11, label: 'Tr conscience' },
            { value: 12, label: 'Douleur aigue' },
            { value: 13, label: 'Prise en charge douleur / MEOPA' },
            { value: 14, label: 'Accouchement inopiné' },
            { value: 15, label: 'Brûlure grave' },
            { value: 16, label: 'Accident décompression plongée' },
            { value: 17, label: "Coup de chaleur d'exercice" },
        ],
        value: (bilan) => bilan.geste.protocole,
    },
];
// TODO
exports.medicaments = [
    {
        '@type': 'medicaments',
        key: '2bf03c27-3977-44f3-b344-35f20d9b5780',
        value: (bilan) => {
            const injected = [];
            bilan.medicaments.forEach(medic => {
                injected.push({
                    heure: `${medic.heure}:${medic.minute}`,
                    dose: medic.dose,
                    unite: data_1.MEDIC_UNITS.get(medic.unite) || 'NR',
                    nom: medic.nom,
                    holder: medic.ampoule_holder_identification || 'NR',
                    lot: medic.lot || 'NR',
                    comment: medic.commentaire || 'NR',
                });
            });
            (bilan.injections || []).forEach(injection => {
                if (injection.v2 && injection.deleted_at === null) {
                    injected.push({
                        heure: utils.fmtTime(injection.heure_administration),
                        dose: injection.quantity,
                        unite: injection.weight_dependant ? injection.unit_numerator : injection.unit ?? 'NR',
                        nom: injection.drug,
                        holder: injection.ampoule_holder_identification ?? 'NR',
                        lot: 'NR',
                        protocole: injection.intervention_protocol !== null
                            ? injection.intervention_protocol.name
                            : injection.nursing_protocol_name ?? 'NR',
                        voie: injection.drug_route_name ?? 'NR',
                        comment: injection.comment ?? 'NR',
                    });
                }
                (injection.medications || []).forEach(medication => {
                    injected.push({
                        heure: utils.fmtTime(medication.injected_at),
                        dose: medication.quantity,
                        unite: medication.unit ? data_1.MEDIC_UNITS.get(medication.unit) : 'NR',
                        nom: medication.name,
                        holder: medication.ampoule_holder_identification || 'NR',
                        lot: medication.batch_identification || 'NR',
                        protocole: medication.nursing_protocol_name || 'NR',
                        voie: injection.route_of_administration || 0,
                        comment: injection.comment || 'NR',
                    });
                });
                (injection.iv_fluids || []).map(ivFluid => {
                    injected.push({
                        heure: utils.fmtTime(ivFluid.injected_at),
                        dose: ivFluid.quantity,
                        unite: 'mL',
                        nom: ivFluid.name,
                        holder: ivFluid.ampoule_holder_identification || 'NR',
                        lot: ivFluid.batch_identification || 'NR',
                        voie: injection.route_of_administration || 0,
                        comment: injection.comment || 'NR',
                    });
                });
            });
            return injected;
        },
    },
];
// Utilisé seul dans la section Vital du NRC
// À ajouter à neurologique pour une section complète D du ABCDE et Neurologique du NRC
exports.neurologiqueVital = [
    {
        '@type': 'tristate',
        key: '1db36f12-1d5c-9v15-81e9-ac604e5909b7',
        label: 'Inconscience',
        color: 'red',
        value: (bilan) => bilan.neurologique.inconscience,
    },
];
/** À ajouter au neurologique - Partie FAST */
exports.neurologiqueFast = [
    {
        '@type': 'select',
        key: '94d73429-091e-43e0-b765-05e4b251adbe',
        label: 'FAST -> F',
        options: [
            { value: 1, label: 'Aucune' },
            { value: 2, label: 'Gauche' },
            { value: 4, label: 'Droite' },
            { value: 6, label: 'Les deux' },
        ],
        value: (bilan) => bilan.neurologique.fast_f,
    },
    {
        '@type': 'select',
        key: '4e5cde76-b01c-4152-88e2-cbd9a270b5fc',
        label: 'FAST -> A',
        options: [
            { value: 1, label: 'Aucune' },
            { value: 2, label: 'Gauche' },
            { value: 4, label: 'Droite' },
            { value: 6, label: 'Les deux' },
        ],
        value: (bilan) => bilan.neurologique.fast_a,
    },
    {
        '@type': 'multiselect',
        key: 'bdc1f5c6-6da6-4662-b419-8f5232f1ba7c',
        label: 'FAST -> A (Bilatéral)',
        options: [
            { value: 1, label: 'Rien à signaler' },
            { value: 2, label: 'Supérieur gauche' },
            { value: 4, label: 'Supérieur droit' },
            { value: 8, label: 'Inférieur gauche' },
            { value: 16, label: 'Inférieur droit' },
        ],
        value: (bilan) => bilan.neurologique?.fast_a_bilateral,
    },
    {
        '@type': 'tristate',
        key: '9ed838fc-d60a-4079-a50a-04f347dcc9fc',
        label: 'FAST -> S',
        value: (bilan) => bilan.neurologique.fast_s,
    },
    {
        '@type': 'dateTime',
        key: '1e8d2d9c-1007-42cb-96f1-41cb99b65ed5',
        label: 'FAST -> T',
        value: (bilan) => {
            return {
                time: bilan.neurologique.fast_t_time,
                date: bilan.neurologique.fast_t_date,
            };
        },
    },
    {
        '@type': 'text',
        key: '8dd7b103-a07e-4e49-b380-df7deead5c11',
        label: 'FAST -> Commentaires',
        value: (bilan) => bilan.neurologique?.commentaire_fast,
    },
];
/** À ajouter au neurologique - Fait partie du FAST du SDIS 38 */
exports.neuroTroubleParoleFast = [
    {
        '@type': 'tristate',
        key: 'c1060a92-1ccd-4271-b93e-5e5d92e5cf3e',
        label: 'Trouble de la parole',
        color: 'red',
        value: (bilan) => bilan.neurologique.trouble_parole,
    },
    {
        '@type': 'multiselect',
        key: 'bdf8e3d1-41ea-43d8-8c82-e2c15bfba2a1',
        label: 'Trouble de la parole',
        options: [
            { value: 1, label: "Aphasie d'expression", kind: 'negative' },
            { value: 2, label: 'Absence de trouble', kind: 'positive' },
            { value: 3, label: 'Aphasie de compréhension', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique.trouble_parole_detail,
    },
];
/** À ajouter au neurologique - Fait partie du FAST du SDIS 38 */
exports.neuroHeureAppDeficitFast = [
    {
        '@type': 'time',
        key: '20dee6d9-0edc-4c61-af49-dec12cb554c9',
        label: "Heure d'apparition des signes",
        value: (bilan) => `${bilan.neurologique?.heure_apparition_deficit_neurologique}`,
    },
];
exports.pci = [
    {
        '@type': 'tristate',
        key: '6fe0b4cf-0daa-4c0b-a883-759570574952',
        label: 'PCI',
        color: 'red',
        value: (bilan) => bilan.neurologique.pci_value,
    },
];
exports.pciDureeSec = [
    {
        '@type': 'integer',
        key: '5e40dce8-7de9-4ae4-9532-7b571ae27888',
        label: 'Durée de PCI',
        unit: ' sec',
        value: (bilan) => {
            if (bilan.neurologique.pci === -1)
                return null;
            return bilan.neurologique.pci;
        },
    },
];
exports.pciDureeMinSec = [
    {
        '@type': 'text',
        key: '5e40dce8-7de9-4ae4-9532-7b571ae27888',
        label: 'Durée de PCI',
        value: (bilan) => {
            if (bilan.neurologique.pci === null || bilan.neurologique.pci < 1)
                return null;
            return `${bilan.neurologique.pci_minutes}min ${bilan.neurologique.pci}sec`;
        },
    },
];
exports.agitation = [
    {
        '@type': 'tristate',
        key: '3c7785dd-96d2-4c54-b7de-f1378f55f4ac',
        label: 'Agitation',
        color: 'red',
        value: (bilan) => bilan.neurologique.agitation,
    }
];
exports.orientationField = [
    {
        '@type': 'tristate',
        key: '7c7785dd-96d2-4c54-b7de-g0653f55f4pi',
        label: 'Orientation',
        value: (bilan) => bilan.neurologique.orientation,
        color: 'green',
        contentInverted: true,
    }
];
exports.pupillesBilateral = [
    {
        '@type': 'multiselect',
        key: '1c205f1d-b1f5-4a87-ad3a-a2e2600efb4a',
        label: 'Pupilles (bilatéral)',
        options: data_1.PUPILLES_BILATERAL_OPTS,
        value: (bilan) => bilan.medic_info.pupilles_bilateral,
    }
];
exports.convulsions = [
    {
        '@type': 'tristate',
        key: '4a32e143-6464-4145-80ce-66c9092b9ac1',
        label: 'Convulsions',
        color: 'red',
        value: (bilan) => bilan.neurologique.convulsions,
    }
];
exports.convulsionsDureeSec = [
    {
        '@type': 'integer',
        key: '933605a6-4e1e-4145-980e-06cf1dd1d3f2',
        label: 'Convulsions - Durée',
        unit: ' sec',
        value: (bilan) => bilan.neurologique?.convulsions_duree,
    }
];
exports.convulsionsInterval = [
    {
        '@type': 'integer',
        key: '22767bf2-4a0e-4216-abaa-758743d60265',
        label: 'Convulsions - Intervales',
        unit: ' min',
        value: (bilan) => bilan.neurologique?.convulsions_interval,
    }
];
/** À ajouter au neurologique */
exports.neurologiqueSansFast = [
    ...exports.neurologiqueVital,
    {
        '@type': 'select',
        key: '34a0df93-d446-41db-9d60-1d205f43e505',
        label: 'AVPU',
        options: data_1.AVPU_OPTS,
        value: (bilan) => bilan.neurologique.avpu,
        permission: ['!assessment:d:primaire:evda'],
    },
    {
        '@type': 'select',
        key: '8819bec8-c684-433c-b6f3-4bfcade1fe9e',
        label: 'EVDA',
        options: data_1.EVDA_OPTS,
        value: (bilan) => bilan.neurologique.avpu,
        permission: ['assessment:d:primaire:evda'],
    },
    ...exports.convulsions,
    {
        '@type': 'select',
        key: '2c90ed16-e7b8-436f-8a4d-f60a9aa17447',
        label: 'Convulsions - Type',
        options: [
            { value: 1, label: 'Crise en cours' },
            { value: 2, label: 'Crise convulsive arrêtée' },
            { value: 3, label: 'Non' },
        ],
        value: (bilan) => bilan.neurologique.convulsions_type,
    },
    {
        '@type': 'integer',
        key: 'ecbc570b-d974-4b15-b0f7-c25ea212091b',
        label: 'Convulsions - Nombres',
        value: (bilan) => bilan.neurologique?.convulsions_nb,
    },
    {
        '@type': 'tristate',
        key: '99124345-9bc4-4388-bcaf-780b3f500109',
        label: 'Convulsions - Répétitives',
        color: 'red',
        value: (bilan) => bilan.neurologique.convulsions_repetitives,
    },
    {
        '@type': 'integer',
        key: 'd4d443af-d5c7-49cf-94fc-dd3f4c569bf7',
        label: 'Convulsions - Nb répétitions',
        value: (bilan) => bilan.neurologique.convulsions_repetitions,
    },
    {
        '@type': 'integer',
        key: 'ef11516e-4c90-447d-8ae4-1d1cc55b77c2',
        label: 'Convulsions - Durée',
        unit: ' min',
        value: (bilan) => bilan.neurologique?.convulsions_duree_minutes,
    },
    ...exports.convulsionsDureeSec,
    ...exports.convulsionsInterval,
    {
        '@type': 'tristate',
        key: '03d22b7b-280e-41ee-873a-57bcf92eee9f',
        label: 'Trauma crânien',
        color: 'red',
        value: (bilan) => bilan.neurologique.trauma_cranien,
    },
    ...exports.pci,
    ...exports.pciDureeSec,
    {
        '@type': 'select',
        key: '46d13f8a-ae61-452d-8536-9c0e0e5b3e98',
        label: 'PCI',
        options: [
            { value: 1, label: 'Non', kind: 'positive' },
            { value: 2, label: 'Amnésie des faits', kind: 'negative' },
            { value: 3, label: 'Oui', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique?.pci_select,
    },
    {
        '@type': 'integer',
        key: 'cc4b4064-2e5d-4a47-a2a4-d96fbb9f0fb1',
        label: 'Durée de PCI',
        unit: ' min',
        value: (bilan) => {
            if (bilan.neurologique.pci < 60)
                return null;
            return Math.floor(bilan.neurologique.pci / 60);
        },
    },
    {
        '@type': 'tristate',
        key: '4d4812d9-e60e-4577-81fd-580a23a4750a',
        label: 'Durée de PCI indéterminée',
        value: (bilan) => utils.boolToChar(bilan.neurologique.pci_duree_indeterminee),
    },
    {
        '@type': 'tristate',
        key: 'b9958395-28c9-45e0-97c7-474a8c3d9ff5',
        label: 'PC',
        value: (bilan) => bilan.neurologique.pc,
    },
    {
        '@type': 'integer',
        key: 'c9b18904-bd0a-4985-99fe-946c43a9918b',
        label: 'PC - Durée',
        unit: ' sec',
        value: (bilan) => !bilan.neurologique?.duree_pc || bilan.neurologique?.duree_pc < 0 ? null : bilan.neurologique?.duree_pc,
    },
    {
        '@type': 'integer',
        key: '3a67716f-3ccd-4d3c-acc7-847de12c7fa7',
        label: 'PC - Intervalle libre',
        unit: ' sec',
        value: (bilan) => !bilan.neurologique.pc_intervalle_libre || bilan.neurologique.pc_intervalle_libre < 0
            ? null
            : bilan.neurologique.pc_intervalle_libre,
    },
    {
        '@type': 'integer',
        key: '06b0b86a-578a-497e-9ea9-8fcc86bf65a4',
        label: 'PCS',
        unit: ' sec',
        value: (bilan) => !bilan.neurologique.pcs || bilan.neurologique.pcs < 0 ? null : bilan.neurologique.pcs,
    },
    {
        '@type': 'tristate',
        key: 'a24ae000-c17b-48fd-8c90-d21120c47970',
        label: 'Pupilles anormales',
        color: 'red',
        value: (bilan) => bilan.neurologique.pupilles_anormales,
    },
    {
        '@type': 'tristate',
        key: '0171f6c5-4f4b-4873-bdef-9bb865e62e3c',
        label: 'Pupilles symétriques',
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.neurologique.pupilles_symetriques,
    },
    {
        '@type': 'multiselect',
        key: '4d51a8d8-b8de-4252-974b-c5ef8973d457',
        label: 'Pupilles',
        options: data_1.PUPILLES_OPTS,
        value: (bilan) => bilan.medic_info.pupilles,
    },
    ...exports.pupillesBilateral,
    {
        '@type': 'tristate',
        key: 'b5214eae-a3da-498e-ba97-b5ebb9dfe895',
        label: 'Fourmillements',
        color: 'red',
        value: (bilan) => bilan.neurologique.fourmillement,
    },
    {
        '@type': 'tristate',
        key: 'b1189c08-39da-479b-908c-d7bd837d621b',
        label: 'Absence motricité des extrémités',
        color: 'red',
        contentInverted: true,
        value: (bilan) => bilan.neurologique.motricite_extremites,
    },
    {
        '@type': 'multiselect',
        key: 'b778a620-9141-4581-b371-13b2a3b1e666',
        label: 'Absence sensibilité des extrémités',
        options: [
            { value: 1, label: 'RAS', kind: 'positive' },
            { value: 2, label: 'Superieur', kind: 'negative' },
            { value: 3, label: 'Inferieur', kind: 'negative' },
            { value: 4, label: 'Droit', kind: 'negative' },
            { value: 5, label: 'Gauche', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique.sensibilite_extremites,
    },
    {
        '@type': 'multiselect',
        key: '012cd61d-2e34-489a-8c18-431116fc9063',
        label: 'Absence motricité des extrémités (bilatéral)',
        options: [
            { value: 0, label: 'RAS', kind: 'positive' },
            { value: 1, label: 'Supérieur gauche', kind: 'negative' },
            { value: 2, label: 'Supérieur droit', kind: 'negative' },
            { value: 3, label: 'Inférieur gauche', kind: 'negative' },
            { value: 4, label: 'Inférieur droit', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique.motricite_bilateral,
    },
    {
        '@type': 'multiselect',
        key: '365f35d0-ff28-47fb-a5e1-b50ac3379e5b',
        label: 'Absence sensibilité des extrémités (bilatéral)',
        options: [
            { value: 0, label: 'RAS', kind: 'positive' },
            { value: 1, label: 'Supérieur gauche', kind: 'negative' },
            { value: 2, label: 'Supérieur droit', kind: 'negative' },
            { value: 3, label: 'Inférieur gauche', kind: 'negative' },
            { value: 4, label: 'Inférieur droit', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique.sensibilite_bilateral,
    },
    {
        '@type': 'multiselect',
        key: 'caee87af-2ea9-49e6-8f76-6f22d8c8dbc6',
        label: 'Motricité des extrémités (bilatéral)',
        options: [
            { value: 0, label: 'RAS', kind: 'positive' },
            { value: 1, label: 'Supérieur gauche', kind: 'positive' },
            { value: 2, label: 'Supérieur droit', kind: 'positive' },
            { value: 3, label: 'Inférieur gauche', kind: 'positive' },
            { value: 4, label: 'Inférieur droit', kind: 'positive' },
        ],
        value: (bilan) => bilan.neurologique.motricite_bilateral_positif,
    },
    {
        '@type': 'multiselect',
        key: 'a68e7003-9b23-43d1-9ae6-a72365b4d78c',
        label: 'Sensibilité des extrémités (bilatéral)',
        options: [
            { value: 0, label: 'RAS', kind: 'positive' },
            { value: 1, label: 'Supérieur gauche', kind: 'positive' },
            { value: 2, label: 'Supérieur droit', kind: 'positive' },
            { value: 3, label: 'Inférieur gauche', kind: 'positive' },
            { value: 4, label: 'Inférieur droit', kind: 'positive' },
        ],
        value: (bilan) => bilan.neurologique.sensibilite_bilateral_positif,
    },
    {
        '@type': 'tristate',
        key: '1515c5c7-d06a-4bef-938a-5d47eaa83fae',
        label: 'Confusion',
        color: 'red',
        value: (bilan) => bilan.neurologique.confusion,
    },
    {
        '@type': 'tristate',
        key: '89672fad-74a1-4a5f-a100-a385f821d41f',
        label: 'Anxiété',
        color: 'red',
        value: (bilan) => bilan.neurologique.anxiete,
    },
    {
        '@type': 'select',
        key: 'a49f62b9-98e5-4c08-9bc0-e7299ecf0d82',
        label: 'Température',
        options: [
            { value: 1, label: 'Normale', kind: 'positive' },
            { value: 2, label: 'Hypothermie', kind: 'negative' },
            { value: 3, label: 'Hyperthermie', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique.temperature_select,
    },
    /** Pas besoin dans le bilan - Affichage dans les surveillances
     <TemplateFieldSelect>{
     '@type': 'select',
     key: '61554a31-0495-4554-a480-8f0c2417257a',
     label: 'Température - Zone de prise',
     options: TEMPERATURE_ZONE_OPTS,
     value:(bilan: SyoApiBilan) => bilan.neurologique?.temperature_zone_select,
     }, */
    {
        '@type': 'tristate',
        key: '790ad860-7c15-4133-9622-a57977373aa5',
        label: 'Vomissements',
        color: 'red',
        value: (bilan) => bilan.neurologique.vomissements,
    },
    {
        '@type': 'tristate',
        key: '941e8da2-6920-4088-b244-646e279981f6',
        label: 'Céphalées',
        color: 'red',
        value: (bilan) => bilan.neurologique?.cephalees,
    },
    {
        '@type': 'multitristate',
        key: 'e4139286-1171-4129-8ede-3be390f03b62',
        label: 'Céphalées',
        options: (bilan) => [
            { value: bilan.neurologique?.cephalees_droite, label: 'Droite' },
            { value: bilan.neurologique?.cephalees_gauche, label: 'Gauche' },
            { value: bilan.neurologique?.cephalees_parietal, label: 'Pariétal' },
            { value: bilan.neurologique?.cephalees_occipital, label: 'Occipital' },
            { value: bilan.neurologique?.cephalees_aucun, label: 'Aucun' },
        ],
    },
    {
        '@type': 'tristate',
        key: '96edad29-1d96-4177-b4ae-21730fb3332a',
        label: 'Nausées',
        color: 'red',
        value: (bilan) => bilan.neurologique.nausees,
    },
    {
        '@type': 'tristate',
        key: '7c513392-428a-4d39-bd7a-2aea7cd83d69',
        label: 'Somnolence',
        color: 'red',
        value: (bilan) => bilan.neurologique.somnolence,
    },
    ...exports.agitation,
    ...exports.orientationField,
    {
        '@type': 'multiselect',
        key: '3345b8a1-1298-4700-9b82-1f5ed95501f1',
        label: 'Orientation',
        options: [
            { value: 1, label: 'Temps' },
            { value: 2, label: 'Espace' },
        ],
        value: (bilan) => bilan.neurologique.orientation_temps_espace,
    },
    {
        '@type': 'tristate',
        key: 'c6073971-0192-4c9c-b016-08ccc11e12ca',
        label: 'Orientation - Temporo-spatiale',
        color: 'green',
        value: (bilan) => bilan.neurologique?.orientation_temporo_spatiale,
    },
    {
        '@type': 'select',
        key: 'f700d5f4-0578-41f2-882d-03ff6ae30c20',
        label: 'Désorientation - Temporo-spatiale',
        options: [
            { value: 1, label: 'Désorientation temporelle', kind: 'negative' },
            { value: 2, label: 'Désorientation spatiale', kind: 'negative' },
            { value: 3, label: 'Désorientation temporo-spatiale', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique?.desorientation_temporo_spatiale,
    },
    {
        '@type': 'tristate',
        key: 'de8c2e79-65aa-47c4-8bed-dd80839fe0ca',
        label: 'Désorientation',
        color: 'green',
        value: (bilan) => bilan.neurologique?.desorientation,
    },
    {
        '@type': 'tristate',
        key: 'c73706de-ef8a-42c5-8ab3-741f7d5578f2',
        label: 'Obnubilation',
        color: 'red',
        value: (bilan) => bilan.neurologique?.obnubilee,
    },
    {
        '@type': 'tristate',
        key: '080b7039-63fd-40ae-8432-3eac3d8657c6',
        label: 'Paralysie faciale',
        color: 'red',
        value: (bilan) => bilan.neurologique.paralysie_faciale,
    },
    {
        '@type': 'select',
        key: '49ee5ec8-8838-4c56-9c35-2dd3ab658cf5',
        label: 'Paralysie faciale (zonale)',
        options: [
            { value: 1, label: 'RAS', kind: 'positive' },
            { value: 2, label: 'Totale', kind: 'negative' },
            { value: 3, label: 'Gauche', kind: 'negative' },
            { value: 4, label: 'Droite', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique.paralysie_faciale_zonale,
    },
    {
        '@type': 'tristate',
        key: '9c17cc29-13cb-44ce-b7e4-a029ab8c68ae',
        label: "Trouble de l'équilibre",
        color: 'red',
        value: (bilan) => bilan.neurologique.trouble_equilibre,
    },
    {
        '@type': 'tristate',
        key: '62ba4b6e-6c7f-40bc-a0ca-6ebfa7c5e90c',
        label: 'Réponds aux ordres',
        color: 'green',
        value: (bilan) => bilan.neurologique.repond_ordre,
    },
    {
        '@type': 'tristate',
        key: 'a6b18921-d9a2-456c-b16c-18fbf233aaab',
        label: 'Orientation spaciale',
        color: 'green',
        value: (bilan) => bilan.neurologique.orientation_spatiale,
    },
    {
        '@type': 'tristate',
        key: '5c9a26ce-4bd8-477e-8488-44fee23bb181',
        label: 'Orientation temporelle',
        color: 'green',
        value: (bilan) => bilan.neurologique.orientation_temporelle,
    },
    {
        '@type': 'text',
        key: '5601f9eb-98ca-42ec-87d0-fe9f4b343a14',
        label: 'Mouvements / Convulsions',
        value: (bilan) => bilan.neurologique.mouvements,
    },
    {
        '@type': 'text',
        key: 'd449fc6a-698a-4149-ab29-5c973cbf5afc',
        label: 'Déficit',
        value: (bilan) => bilan.neurologique.deficit,
    },
    {
        '@type': 'tristate',
        key: '50ae55b0-544e-43ca-b86c-fe0f718e342a',
        label: 'Obnubilation',
        color: 'red',
        value: (bilan) => bilan.neurologique.smur_obnubilation,
    },
    {
        '@type': 'tristate',
        key: '6c258f80-c065-4fd9-935f-9d0d0138f748',
        label: 'Syndrome méningé',
        color: 'red',
        value: (bilan) => bilan.neurologique.sd_meninge,
    },
    {
        '@type': 'multiselect',
        key: 'eb571eaf-12ad-4058-8603-1938e04d35fc',
        label: 'Conscience',
        options: [
            { value: 1, label: 'Conscient' },
            { value: 2, label: 'Agité' },
            { value: 3, label: 'Confus' },
            { value: 4, label: 'Désorienté' },
            { value: 5, label: 'Somnolent' },
            { value: 6, label: 'Obnubilé' },
            { value: 7, label: 'Inconscient' },
        ],
        value: (bilan) => bilan.neurologique.smur_conscience,
    },
    {
        '@type': 'text',
        key: '59f827fb-269f-4bea-8758-e8c45cb9225c',
        label: 'Intervalles libres',
        value: (bilan) => bilan.neurologique?.smur_intervalle_libre,
    },
    {
        '@type': 'multiselect',
        key: 'ff6194a6-61c5-49db-9b8a-6480c62f074e',
        label: 'Déficit',
        options: [
            { value: 1, label: 'Sensitif', kind: 'negative' },
            { value: 2, label: 'Moteur', kind: 'negative' },
            { value: 3, label: 'Aucun', kind: 'positive' },
        ],
        value: (bilan) => bilan.neurologique.smur_deficit,
    },
    {
        '@type': 'time',
        key: '844275eb-b1e1-4390-9e90-bd793281fee9',
        label: 'Heure de début du déficit',
        value: (bilan) => bilan.neurologique.smur_heure_debut_deficit === null || bilan.neurologique.smur_heure_debut_deficit === 'NR'
            ? null
            : bilan.neurologique.smur_heure_debut_deficit,
    },
    {
        '@type': 'dateTime',
        key: '252b4cd5-4389-4627-bf5a-3b71177fd57b',
        label: 'Heure de début du déficit',
        value: (bilan) => {
            return {
                time: bilan.neurologique.smur_heure_debut_deficit_time,
                date: bilan.neurologique.smur_heure_debut_deficit_date,
            };
        },
    },
    {
        '@type': 'multiselect',
        key: '6b148655-8b9e-46bf-8d79-973ddae25215',
        label: 'Déficit moteur',
        options: [
            { value: 1, label: 'Membre sup G', kind: 'negative' },
            { value: 2, label: 'Membre sup D', kind: 'negative' },
            { value: 3, label: 'Membre inf G', kind: 'negative' },
            { value: 4, label: 'Membre inf D', kind: 'negative' },
        ],
        value: (bilan) => bilan.neurologique.smur_deficit_moteur,
    },
    {
        '@type': 'tristate',
        key: '6e861942-8dc6-4c47-a01a-d48e03a2f925',
        label: "Perte d'urines",
        color: 'red',
        value: (bilan) => bilan.neurologique.perte_urine,
    },
    {
        '@type': 'tristate',
        key: '82cb30ac-3491-4946-a15a-5bb9297ab935',
        label: 'Morsure de la langue',
        color: 'red',
        value: (bilan) => bilan.neurologique.morsure_langue,
    },
    {
        '@type': 'tristate',
        key: '087b6dc7-602f-4e60-8804-840e0d4cc157',
        label: 'Clonies des membres droits',
        color: 'red',
        value: (bilan) => bilan.neurologique.clonies_membres_droits,
    },
    {
        '@type': 'tristate',
        key: 'fcac6ce0-6a5c-4ece-a224-347a86c94889',
        label: 'Clonies des membres gauches',
        color: 'red',
        value: (bilan) => bilan.neurologique.clonies_membres_gauches,
    },
    {
        '@type': 'tristate',
        key: 'bb0a259d-120e-47d5-b8a9-c0a580979723',
        label: 'Révulsions occulaires',
        color: 'red',
        value: (bilan) => bilan.neurologique.revulsions_occulaires,
    },
    {
        '@type': 'tristate',
        key: '4b1a425b-5a5f-4080-966a-2fcdfe97cbae',
        label: 'Rotation de tête',
        color: 'red',
        value: (bilan) => bilan.neurologique.rotation_tete,
    },
    {
        '@type': 'tristate',
        key: '2fafae47-3182-4128-89b8-8f9e32753c6d',
        label: 'Regard dévié',
        color: 'red',
        value: (bilan) => bilan.neurologique.regard_devie,
    },
    {
        '@type': 'integer',
        key: 'df0fedad-15d2-4ca9-a429-84c3e276d7ac',
        label: 'Temps de récupération',
        unit: ' secondes',
        value: (bilan) => bilan.neurologique?.temps_recuperation,
    },
    {
        '@type': 'text',
        key: '024f4ff5-fb71-4b98-9885-362676486ae5',
        label: 'Commentaires',
        value: (bilan) => bilan.neurologique.commentaire,
    },
];
// D du ABCDE - Neurologique du NRC
exports.neurologique = [
    ...exports.neurologiqueSansFast,
    ...exports.neurologiqueFast,
    ...exports.neuroTroubleParoleFast,
    ...exports.neuroHeureAppDeficitFast,
];
/** A ajouté au NIHSS - Fait partie du FAST du 38 */
exports.nihssParalysieFacialeFast = [
    {
        '@type': 'select',
        key: 'cdccdb31-95f4-4dd6-8dde-a1c9911be5fa',
        label: 'Paralysie faciale',
        options: [
            { value: 0, label: 'Absence', kind: 'positive' },
            { value: 1, label: 'PF modérée', kind: 'intermediate' },
            { value: 2, label: 'PF centrale franche', kind: 'intermediate' },
            { value: 3, label: 'PF périph ou diplégie', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.paralysie_faciale,
    },
];
/** A ajouté au NIHSS - Fait partie du FAST du 38 */
exports.nihssMotriciteMembreFast = [
    {
        '@type': 'select',
        key: '48fa2aab-50a0-41c3-829c-8f5d4da3482a',
        label: 'Motricité membre Sup. D',
        options: [
            { value: 0, label: 'Normale', kind: 'positive' },
            { value: 1, label: 'Affaissement incomplet', kind: 'intermediate' },
            { value: 2, label: 'Affaissement complet', kind: 'intermediate' },
            { value: 3, label: 'Contraction musculaire', kind: 'intermediate' },
            { value: 4, label: 'Pas de mouvement', kind: 'negative' },
            { value: 9, label: 'Cotation impossible' },
        ],
        value: (bilan) => bilan.nihss?.motricite_membre_superieur_droit,
    },
    {
        '@type': 'select',
        key: '39aade52-1081-4e86-943a-547a81468803',
        label: 'Motricité membre Sup. G',
        options: [
            { value: 0, label: 'Normale', kind: 'positive' },
            { value: 1, label: 'Affaissement incomplet', kind: 'intermediate' },
            { value: 2, label: 'Affaissement complet', kind: 'intermediate' },
            { value: 3, label: 'Contraction musculaire', kind: 'intermediate' },
            { value: 4, label: 'Pas de mouvement', kind: 'negative' },
            { value: 9, label: 'Cotation impossible' },
        ],
        value: (bilan) => bilan.nihss?.motricite_membre_superieur_gauche,
    },
    {
        '@type': 'select',
        key: 'bc96c501-3dfc-409d-9eba-eadaeefa3365',
        label: 'Motricité membre Inf. D',
        options: [
            { value: 0, label: 'Normale', kind: 'positive' },
            { value: 1, label: 'Affaissement incomplet', kind: 'intermediate' },
            { value: 2, label: 'Affaissement complet', kind: 'intermediate' },
            { value: 3, label: 'Contraction musculaire', kind: 'intermediate' },
            { value: 4, label: 'Pas de mouvement', kind: 'negative' },
            { value: 9, label: 'Cotation impossible' },
        ],
        value: (bilan) => bilan.nihss?.motricite_membre_inferieur_droit,
    },
    {
        '@type': 'select',
        key: 'e8e7665b-c8b4-4539-aeb5-2d69227673fa',
        label: 'Motricité membre Inf. G',
        options: [
            { value: 0, label: 'Normale', kind: 'positive' },
            { value: 1, label: 'Affaissement incomplet', kind: 'intermediate' },
            { value: 2, label: 'Affaissement complet', kind: 'intermediate' },
            { value: 3, label: 'Contraction musculaire', kind: 'intermediate' },
            { value: 4, label: 'Pas de mouvement', kind: 'negative' },
            { value: 9, label: 'Cotation impossible' },
        ],
        value: (bilan) => bilan.nihss?.motricite_membre_inferieur_gauche,
    },
];
/** A ajouté au NIHSS */
exports.nihssSansFast = [
    {
        '@type': 'select',
        key: '21c2a55e-4b92-40f2-b2c2-cfa25daa05c8',
        label: 'Vigilance',
        options: [
            { value: 0, label: 'Normale', kind: 'positive' },
            { value: 1, label: 'Altération légère', kind: 'intermediate' },
            { value: 2, label: 'Réaction douleur seule', kind: 'intermediate' },
            { value: 3, label: 'Coma', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.vigilance,
    },
    {
        '@type': 'select',
        key: '03cbec78-40a6-4170-b77a-e8e622970918',
        label: 'Orientation',
        options: [
            { value: 0, label: 'Normale (2 rép.)', kind: 'positive' },
            { value: 1, label: 'Altérée (1 rép.)', kind: 'intermediate' },
            { value: 2, label: 'Déficiente (0 rép.)', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.orientation,
    },
    {
        '@type': 'select',
        key: 'dbd4c56a-4ddf-40af-b2cb-b583f045032a',
        label: 'Commandes (yeux, poing)',
        options: [
            { value: 0, label: 'Normale (2 ordres)', kind: 'positive' },
            { value: 1, label: 'Altérées (1 ordre)', kind: 'intermediate' },
            { value: 2, label: 'Nulle (0)', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.commandes,
    },
    {
        '@type': 'select',
        key: 'f54811f3-0c0b-4867-9779-b69dd2dc3cb5',
        label: 'Oculomotricité',
        options: [
            { value: 0, label: 'Normale (2 ordres)', kind: 'positive' },
            { value: 1, label: 'Altérées (1 ordre)', kind: 'intermediate' },
            { value: 2, label: 'Nulle (0)', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.oculomotricite,
    },
    {
        '@type': 'select',
        key: '4b6b1237-b6c9-4450-83fd-654d4ab95849',
        label: 'Champ visuel',
        options: [
            { value: 0, label: 'Normal', kind: 'positive' },
            { value: 1, label: 'Altération incomplète', kind: 'intermediate' },
            { value: 2, label: 'HLH', kind: 'intermediate' },
            { value: 3, label: 'Cécité ou coma', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.champ_visuel,
    },
    {
        '@type': 'select',
        key: 'e2535ed1-408f-468f-bb9f-b17788db7c20',
        label: 'Ataxie',
        options: [
            { value: 0, label: 'Absence', kind: 'positive' },
            { value: 1, label: '1 membre', kind: 'intermediate' },
            { value: 2, label: '2 membres', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.ataxie,
    },
    {
        '@type': 'select',
        key: '54e8973f-5a6f-48a6-880e-fa50fda38b9b',
        label: 'Sensibilité',
        options: [
            { value: 0, label: 'Normale', kind: 'positive' },
            { value: 1, label: 'Altérée', kind: 'intermediate' },
            { value: 2, label: 'Atteinte sévère', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.sensibilite,
    },
    {
        '@type': 'select',
        key: 'bcaab7ef-4a02-418c-a9f7-08319c853f18',
        label: 'Langage',
        options: [
            { value: 0, label: 'Normal', kind: 'positive' },
            { value: 1, label: 'Altération', kind: 'intermediate' },
            { value: 2, label: 'Aphasie sévère', kind: 'intermediate' },
            { value: 3, label: 'Mutisme / Aphasie totale', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.langage,
    },
    {
        '@type': 'select',
        key: 'b31be5b5-ab66-4b8e-b67b-b39c212fe166',
        label: 'Dysarthie',
        options: [
            { value: 0, label: 'Absente', kind: 'positive' },
            { value: 1, label: 'Discrète', kind: 'intermediate' },
            { value: 2, label: 'Sévère', kind: 'negative' },
            { value: 9, label: 'Cotation impossible' },
        ],
        value: (bilan) => bilan.nihss?.dysarthrie,
    },
    {
        '@type': 'select',
        key: 'b8e33129-aabe-4cdc-ac4c-72955a6683b6',
        label: 'Extinction, négligence',
        options: [
            { value: 0, label: 'Absence', kind: 'positive' },
            { value: 1, label: 'Atteinte partielle', kind: 'intermediate' },
            { value: 2, label: 'Atteinte sévère', kind: 'negative' },
        ],
        value: (bilan) => bilan.nihss?.extinction_negligence,
    }
];
exports.nihssScore = [
    {
        '@type': 'text',
        key: 'cd83fb14-c652-47e0-bc50-7b889043ec33',
        label: 'Score',
        value: (bilan) => bilan.nihss?.score,
    }
];
/** NIHSS complet + partie du FAST du 38 */
exports.nihss = [...exports.nihssScore, ...exports.nihssSansFast, ...exports.nihssParalysieFacialeFast, ...exports.nihssMotriciteMembreFast];
exports.fast = [
    ...exports.neurologiqueFast,
    ...exports.nihssParalysieFacialeFast,
    ...exports.nihssMotriciteMembreFast,
    ...exports.neuroTroubleParoleFast,
    ...exports.neuroHeureAppDeficitFast,
];
exports.accouchement = [
    {
        '@type': 'integer',
        key: '02e9ac67-5035-4c1a-82d6-f23b17557212',
        label: 'Malinas',
        value: (bilan) => {
            const parite = bilan.obstetrique?.malinas_parite;
            const travail = bilan.obstetrique?.malinas_travail;
            const duree = bilan.obstetrique?.malinas_duree_contraction;
            const inter = bilan.obstetrique?.malinas_intervalle_contraction;
            const perte = bilan.obstetrique?.malinas_perte_eaux;
            if (parite === 0 || travail === 0 || duree === 0 || inter === 0 || perte === 0) {
                return null;
            }
            return parite + travail + duree + inter + perte - 5;
        },
    },
    {
        '@type': 'tristate',
        key: '2a40a9c5-e56e-4287-8315-b804e860dd86',
        label: 'Première grossesse',
        color: 'red',
        value: (bilan) => bilan.obstetrique?.premiere_grossesse,
    },
    {
        '@type': 'integer',
        key: 'cc436469-04a9-43c5-8a7b-579648d157d7',
        label: 'Nombre de grossesses',
        value: (bilan) => bilan.obstetrique?.nombre_grossesses,
    },
    {
        '@type': 'integer',
        key: 'b4b16f23-9018-4aec-8ff2-49b811e36da4',
        label: 'Parité',
        color: (bilan) => bilan.obstetrique?.nombre_pars && bilan.obstetrique?.nombre_pars > 1 ? 'red' : 'green',
        value: (bilan) => bilan.obstetrique?.nombre_pars,
    },
    {
        '@type': 'date',
        key: '23ef0667-d1d1-4f2f-b43b-b3738fb9375b',
        label: 'Date des dernières règles',
        value: (bilan) => bilan.obstetrique?.date_dernieres_regles,
    },
    {
        '@type': 'date',
        key: '17927c9e-fd58-4786-8bd0-da9e56cda1c7',
        label: 'Date du terme',
        value: (bilan) => bilan.obstetrique?.date_terme,
    },
    {
        '@type': 'text',
        key: 'e6d48938-b6d8-41e8-aa1e-763d634619a7',
        label: 'Date du terme actuel',
        value: (bilan) => bilan.obstetrique?.terme_actuel,
    },
    {
        '@type': 'multiselect',
        key: '8598d3b1-ed8b-4393-bb33-bd297662e8de',
        label: 'Particularités grossesses',
        options: [
            { value: 1, label: 'Hémorragie', kind: 'negative' },
            { value: 2, label: 'Grossesses multiple', kind: 'negative' },
            { value: 3, label: 'Hypertension artérielle', kind: 'negative' },
            { value: 4, label: 'Diabète', kind: 'negative' },
            { value: 5, label: 'Problème de placenta', kind: 'negative' },
        ],
        value: (bilan) => bilan.obstetrique?.particularites_grossesses,
    },
    {
        '@type': 'select',
        key: '408c7e6f-0624-45e0-afcf-1ea885822d6d',
        label: 'Durée du travail',
        options: data_1.MALINAS_TRAVAIL_OPTS,
        value: (bilan) => bilan.obstetrique?.malinas_travail,
    },
    {
        '@type': 'integer',
        key: 'e99f4ff4-56c9-40f4-bcc3-24db4c5401ee',
        label: 'Intervalle contractions',
        unit: ' min',
        color: (bilan) => parseInt(bilan.obstetrique?.intervalle_contraction || '', 10) < 5 ? 'red' : 'green',
        value: (bilan) => bilan.obstetrique?.contraction === -1 ? parseInt(bilan.obstetrique?.intervalle_contraction || '', 10) : null,
    },
    {
        '@type': 'floatTime',
        key: 'c6b301d5-f1b3-40af-bb39-5f02c0100b17',
        label: 'Intervalle contractions (min:sec)',
        color: (bilan) => (parseInt(`${bilan.obstetrique?.contraction}` || '', 10) < 5 ? 'red' : 'green'),
        value: (bilan) => bilan.obstetrique?.contraction,
    },
    {
        '@type': 'integer',
        key: '38b2e612-f6e3-4821-87ab-dd424ee5e11f',
        label: 'Durée des contractions',
        unit: ' sec',
        color: (bilan) => bilan.obstetrique?.duree_contractions && bilan.obstetrique?.duree_contractions > 59 ? 'red' : 'green',
        value: (bilan) => bilan.obstetrique?.duree_contractions,
    },
    {
        '@type': 'select',
        key: 'f774ef4f-6720-4245-afe4-608935c27319',
        label: 'Perte des eaux',
        options: data_1.MALINAS_PERTE_EAUX_OPTS,
        value: (bilan) => bilan.obstetrique?.malinas_perte_eaux,
    },
    {
        '@type': 'integer',
        key: 'dbcd7570-4686-474c-82f1-f7de8918aa01',
        label: 'Saignement estimé',
        unit: ' mL',
        color: (bilan) => bilan.obstetrique?.saignement_estime && bilan.obstetrique?.saignement_estime > 0 ? 'red' : 'green',
        value: (bilan) => bilan.obstetrique?.saignement_estime,
    },
    {
        '@type': 'tristate',
        key: 'ecb7c72e-799f-466c-9ac3-8f54f3d3b4ec',
        label: 'Envie de pousser',
        color: 'red',
        value: (bilan) => bilan.obstetrique?.envie_pousser,
    },
    {
        '@type': 'tristate',
        key: '62a9cad2-3bde-4988-90e7-54cd4930d2bb',
        label: 'Tête ou membres visibles',
        color: 'red',
        value: (bilan) => bilan.obstetrique?.tete_membre_visible,
    },
    {
        '@type': 'tristate',
        key: '3d17d9f9-0f99-45a1-b91d-c6565be7d4f0',
        label: 'Accouchement réalisé',
        color: 'red',
        value: (bilan) => bilan.obstetrique?.accouchement_realise,
    },
    {
        '@type': 'dateTime',
        key: 'f45b2128-a867-4b3e-abc8-0a47b9652022',
        label: "Date et heure de l'accouchement",
        value: (bilan) => {
            return {
                time: bilan.obstetrique?.heure_accouchement_time,
                date: bilan.obstetrique?.heure_accouchement_date,
            };
        },
    },
    {
        '@type': 'select',
        key: 'dce59fe7-3010-442f-8d02-9a6e7f611988',
        label: 'Présentation enfant',
        options: [
            { value: 1, label: 'Céphalique', kind: 'positive' },
            { value: 2, label: 'Siège', kind: 'negative' },
            { value: 3, label: 'Transverse', kind: 'negative' },
        ],
        value: (bilan) => bilan.obstetrique?.presentation_enfant,
    },
    {
        '@type': 'select',
        key: '2dc91104-895f-4f17-b288-e1ac46036db1',
        label: 'Couleur liquide amniotique',
        options: [
            { value: 1, label: 'Clair', kind: 'positive' },
            { value: 2, label: 'Teinté', kind: 'negative' },
            { value: 3, label: 'Hémorragique', kind: 'negative' },
        ],
        value: (bilan) => bilan.obstetrique?.couleur_liquide_amniotique,
    },
    {
        '@type': 'dateTime',
        key: '2927c57d-7af6-4244-ac4d-17a5fc5866e7',
        label: 'Date et heure de délivrance',
        value: (bilan) => {
            return {
                time: bilan.obstetrique?.heure_delivrance_time,
                date: bilan.obstetrique?.heure_delivrance_date,
            };
        },
    },
    ...exports.gesteSectionCordon,
    {
        '@type': 'multiselect',
        key: '5383ff75-97e5-4d3d-b3cc-529564665cf5',
        label: 'Gestes',
        options: [
            { value: 1, label: 'Aucune action' },
            { value: 2, label: "Aide à l'accouchement" },
            { value: 3, label: 'Section du cordon ombilicale' },
            { value: 4, label: 'Pose de clamps' },
        ],
        value: (bilan) => bilan.obstetrique?.gestes,
    },
    {
        '@type': 'text',
        key: 'da7409a1-c61b-4f1e-8d45-d6bb02c763aa',
        label: 'Commentaires',
        value: (bilan) => bilan.obstetrique?.commentaire,
    },
];
exports.obstetriqueApgarT1 = [
    {
        '@type': 'integer',
        key: '5c9ff267-9c52-431b-9dcd-88dbcf3c681c',
        label: 'Score Apgar T+1',
        value: (bilan) => {
            const fc = bilan.obstetrique?.apgar_t1.fc;
            const fr = bilan.obstetrique?.apgar_t1.fr;
            const reac = bilan.obstetrique?.apgar_t1.reactivite;
            const tonus = bilan.obstetrique?.apgar_t1.tonus;
            const color = bilan.obstetrique?.apgar_t1.coloration;
            let result = fr + fc + reac + tonus + color;
            if (result === 0) {
                return null;
            }
            return result - 5;
        },
    },
    {
        '@type': 'select',
        key: 'fe19d45c-5e5f-4ded-a0a0-2b3f1ea1ba2d',
        label: 'Fréquence cardiaque (T+1)',
        options: [
            { value: 1, label: 'Absent', kind: 'negative' },
            { value: 2, label: '< 100', kind: 'negative' },
            { value: 3, label: '> 100', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t1.fc,
    },
    {
        '@type': 'select',
        key: '307ffa29-1368-4c09-9969-40d07c351dd0',
        label: 'Mouvement respiratoire (T+1)',
        options: [
            { value: 1, label: 'Absente', kind: 'negative' },
            { value: 2, label: 'Irrégulière', kind: 'negative' },
            { value: 3, label: 'Régulière', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t1.fr,
    },
    {
        '@type': 'select',
        key: '3135d747-3816-4d75-afef-6a03e63cd02c',
        label: 'Tonus musculaire (T+1)',
        options: [
            { value: 1, label: 'Aucune', kind: 'negative' },
            { value: 2, label: 'Léger tonus', kind: 'negative' },
            { value: 3, label: 'Bon tonus', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t1.tonus,
    },
    {
        '@type': 'select',
        key: '6d04abcb-68e7-493a-8c36-47617e39134a',
        label: 'Réactivité stimuli cutané (T+1)',
        options: [
            { value: 1, label: 'Aucune', kind: 'negative' },
            { value: 2, label: 'Grimaces / Légers mouvements', kind: 'negative' },
            { value: 3, label: 'Cris', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t1.reactivite,
    },
    {
        '@type': 'select',
        key: '2086ca85-23ec-4d67-adaa-18aa2c6637f9',
        label: 'Coloration (T+1)',
        options: [
            { value: 1, label: 'Cyanose / Pâleur', kind: 'negative' },
            { value: 2, label: 'Extrémités cyanosées, corps rose, corps rose', kind: 'negative' },
            { value: 3, label: 'Totalement rose', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t1.coloration,
    },
];
exports.obstetriqueApgarT5 = [
    {
        '@type': 'integer',
        key: '1bd9a872-2154-4f4d-b82b-b06da8099666',
        label: 'Score Apgar T+5',
        value: (bilan) => {
            const fc = bilan.obstetrique?.apgar_t5.fc;
            const fr = bilan.obstetrique?.apgar_t5.fr;
            const reac = bilan.obstetrique?.apgar_t5.reactivite;
            const tonus = bilan.obstetrique?.apgar_t5.tonus;
            const color = bilan.obstetrique?.apgar_t5.coloration;
            let result = fr + fc + reac + tonus + color;
            if (result === 0) {
                return null;
            }
            return result - 5;
        },
    },
    {
        '@type': 'select',
        key: '328ae9e4-d599-48e9-a1ec-f766ddc8896f',
        label: 'Fréquence cardiaque (T+5)',
        options: [
            { value: 1, label: 'Absent', kind: 'negative' },
            { value: 2, label: '< 100', kind: 'negative' },
            { value: 3, label: '> 100', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t5.fc,
    },
    {
        '@type': 'select',
        key: '14735f8f-4c3c-4960-81e8-4fa8511ff08e',
        label: 'Mouvement respiratoire (T+5)',
        options: [
            { value: 1, label: 'Absente', kind: 'negative' },
            { value: 2, label: 'Irrégulière', kind: 'negative' },
            { value: 3, label: 'Régulière', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t5.fr,
    },
    {
        '@type': 'select',
        key: 'c627ecad-0053-4cde-90b1-ccc890722d25',
        label: 'Tonus musculaire (T+5)',
        options: [
            { value: 1, label: 'Aucune', kind: 'negative' },
            { value: 2, label: 'Léger tonus', kind: 'negative' },
            { value: 3, label: 'Bon tonus', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t5.tonus,
    },
    {
        '@type': 'select',
        key: 'd2732956-dd49-435d-883a-20cddd124b84',
        label: 'Réactivité stimuli cutané (T+5)',
        options: [
            { value: 1, label: 'Aucune', kind: 'negative' },
            { value: 2, label: 'Grimaces / Légers mouvements', kind: 'negative' },
            { value: 3, label: 'Cris', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t5.reactivite,
    },
    {
        '@type': 'select',
        key: '625e9528-1659-4789-8b9a-56572eb5c524',
        label: 'Coloration (T+5)',
        options: [
            { value: 1, label: 'Cyanose / Pâleur', kind: 'negative' },
            { value: 2, label: 'Extrémités cyanosées, corps rose', kind: 'negative' },
            { value: 3, label: 'Totalement rose', kind: 'positive' },
        ],
        value: (bilan) => bilan.obstetrique?.apgar_t5.coloration,
    },
    {
        '@type': 'tristate',
        key: 'fc84f5aa-51e2-4c05-b7d7-8b05670ca8ed',
        label: 'Section du cordon (si ACR)',
        color: 'red',
        contentInverted: true,
        value: (bilan) => bilan.obstetrique?.section_cordon,
    },
];
exports.obstetriqueApgar = [
    {
        '@type': 'table',
        key: 'ac785c59-29d0-427a-bdde-945382899d2f',
        label: 'APGAR',
        value: (bilan) => bilan?.excel_apgars || [],
        template: 'OBSTETRIQUE_APGAR',
    },
];
exports.obstetriqueApgarExcel = [
    {
        '@type': 'time',
        key: '37c104fd-fdc0-41c1-8398-b59307320a02',
        label: 'Heure naissance',
        value: elem => elem?.heure_naissance,
    },
    {
        '@type': 'select',
        key: 'f076eff8-6d73-431d-ba64-4bb362a8d557',
        label: 'FR (T+1)',
        options: [
            { value: 1, label: 'Absente', kind: 'negative' },
            { value: 2, label: 'Irrégulière', kind: 'negative' },
            { value: 3, label: 'Régulière', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t1?.fr,
    },
    {
        '@type': 'select',
        key: '1ac633f7-7c64-4e1f-aa7a-46a8d034e98e',
        label: 'FC (T+1)',
        options: [
            { value: 1, label: 'Absent', kind: 'negative' },
            { value: 2, label: '< 100', kind: 'negative' },
            { value: 3, label: '> 100', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t1?.fc,
    },
    {
        '@type': 'select',
        key: 'fb22b4e2-081f-4ba0-85ba-5a91a7ca37f3',
        label: 'Tonus (T+1)',
        options: [
            { value: 1, label: 'Aucune', kind: 'negative' },
            { value: 2, label: 'Léger tonus', kind: 'negative' },
            { value: 3, label: 'Bon tonus', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t1?.tonus,
    },
    {
        '@type': 'select',
        key: '99c439db-fadf-42a7-9af9-84a1527b36ea',
        label: 'Réactive (T+1)',
        options: [
            { value: 1, label: 'Aucune', kind: 'negative' },
            { value: 2, label: 'Grimaces / Légers mouvements', kind: 'negative' },
            { value: 3, label: 'Cris', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t1?.reactivite,
    },
    {
        '@type': 'select',
        key: 'd8d09b8a-b64c-414c-93c7-b7870d37da89',
        label: 'Coloration (T+1)',
        options: [
            { value: 1, label: 'Cyanose / Pâleur', kind: 'negative' },
            { value: 2, label: 'Extrémités cyanosées, corps rose', kind: 'negative' },
            { value: 3, label: 'Totalement rose', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t1?.coloration,
    },
    {
        '@type': 'select',
        key: '9c937cb6-b709-404a-8dcb-da3e80a8f471',
        label: 'FR (T+5)',
        options: [
            { value: 1, label: 'Absente', kind: 'negative' },
            { value: 2, label: 'Irrégulière', kind: 'negative' },
            { value: 3, label: 'Régulière', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t5?.fr,
    },
    {
        '@type': 'select',
        key: '332bca86-1092-49aa-b57b-0947a78a2668',
        label: 'FC (T+5)',
        options: [
            { value: 1, label: 'Absent', kind: 'negative' },
            { value: 2, label: '< 100', kind: 'negative' },
            { value: 3, label: '> 100', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t5?.fc,
    },
    {
        '@type': 'select',
        key: '20252e7e-6698-481a-9fc0-c8d2a6a3a931',
        label: 'Tonus (T+5)',
        options: [
            { value: 1, label: 'Aucune', kind: 'negative' },
            { value: 2, label: 'Léger tonus', kind: 'negative' },
            { value: 3, label: 'Bon tonus', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t5?.tonus,
    },
    {
        '@type': 'select',
        key: '1cbb45f2-c391-4e63-9b56-19e8b30d0937',
        label: 'Réactive (T+5)',
        options: [
            { value: 1, label: 'Aucune', kind: 'negative' },
            { value: 2, label: 'Grimaces / Légers mouvements', kind: 'negative' },
            { value: 3, label: 'Cris', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t5?.reactivite,
    },
    {
        '@type': 'select',
        key: '49b8ad9f-860d-41bd-a9ca-4a130f767509',
        label: 'Coloration (T+5)',
        options: [
            { value: 1, label: 'Cyanose / Pâleur', kind: 'negative' },
            { value: 2, label: 'Extrémités cyanosées, corps rose', kind: 'negative' },
            { value: 3, label: 'Totalement rose', kind: 'positive' },
        ],
        value: elem => elem?.apgar_t5?.coloration,
    },
];
const makeObstetriqueApgarExcel = () => {
    return [
        {
            '@type': 'tableItem',
            key: '46a08067-8355-4e12-8147-0db0f72372f5',
            children: [...exports.obstetriqueApgarExcel],
        },
    ];
};
exports.makeObstetriqueApgarExcel = makeObstetriqueApgarExcel;
exports.apgar = [...exports.obstetriqueApgarT1, ...exports.obstetriqueApgarT5];
exports.apgarWithCategory = [
    {
        '@type': 'category',
        key: '4a91cf14-4f5e-4feb-89ea-cfd088c24d8b',
        columns: 1,
        className: 'cardGridLarge',
        subtitle: 'APGAR T+1',
        children: [...exports.obstetriqueApgarT1],
    },
    {
        '@type': 'category',
        key: '321bfd0f-8b15-4f72-8a20-81fb61955cd9',
        columns: 1,
        className: 'cardGridLarge',
        subtitle: 'APGAR T+5',
        children: [...exports.obstetriqueApgarT5],
    },
];
exports.obstetrique = [...exports.accouchement, ...exports.apgar, ...exports.obstetriqueApgar];
exports.obstetriqueWithCategory = [...exports.accouchement, ...exports.apgarWithCategory, ...exports.obstetriqueApgar];
exports.obvaSelectObj = {
    '@type': 'select',
    key: '17a8c5a6-49a3-4b64-b202-c9d05b83ddbd',
    label: 'OBVA / Voies aériennes',
    options: [
        { value: 0, label: 'Libres', kind: 'positive' },
        { value: 1, label: 'Obstruction partielle', kind: 'negative' },
        { value: 2, label: 'Obstruction totale', kind: 'negative' },
        { value: 3, label: 'Encombrée', kind: 'negative' },
    ],
    value: (bilan) => bilan.respiration.obva_select,
};
exports.obvaVoieAerienne = [exports.obvaSelectObj];
// A du ABCDE - Vital du NRC
exports.obva = [
    ...exports.obvaVoieAerienne,
    {
        '@type': 'tristate',
        key: '637035d0-4af6-4c90-9d05-e7404a4bea32',
        color: 'red',
        label: 'OBVA',
        value: (bilan) => {
            if (bilan.respiration.obva_select != null) {
                return null;
            }
            return bilan.respiration.obva;
        },
    },
    {
        '@type': 'multiselect',
        key: 'a707555c-dfd9-4875-863a-24754d638e9a',
        label: 'OBVA - Causes',
        options: [
            { value: 1, label: 'Aucune cause' },
            { value: 2, label: 'Corps étranger', kind: 'negative' },
            { value: 3, label: 'Traumatisme cervical', kind: 'negative' },
            { value: 4, label: 'Asthme', kind: 'negative' },
            { value: 5, label: 'Laryngite', kind: 'negative' },
            { value: 6, label: 'Autres', kind: 'negative' },
            { value: 7, label: 'Encombrement', kind: 'negative' },
            { value: 8, label: 'Vomissements / Salive / Sang', kind: 'negative' },
            { value: 9, label: 'Suie', kind: 'negative' },
            { value: 10, label: 'Bruits / Bruits anormaux', kind: 'negative' },
            { value: 11, label: 'Langue', kind: 'negative' },
            { value: 12, label: 'Réaction allergique', kind: 'negative' },
            { value: 13, label: 'Œdème', kind: 'negative' },
            { value: 14, label: 'Liquide', kind: 'negative' },
        ],
        value: (bilan) => bilan.respiration.cause_obva,
    },
    {
        '@type': 'text',
        key: 'a6125134-32c6-4993-aaef-67b9c823fe1b',
        label: 'OBVA - Commentaire',
        value: (bilan) => bilan.respiration.cause_obva_commentaire,
    },
];
// À ajouter au pqrst pour un opqrst complet
exports.opqrst = [
    {
        '@type': 'text',
        key: '463d6e37-82de-42b7-a459-ecb414f089b8',
        label: 'Symptôme·s',
        value: (bilan) => bilan.circonstance.symptome,
    },
    {
        '@type': 'text',
        key: '3c8ee225-973d-47d4-b318-905660ea5270',
        label: 'Origine / Onset',
        value: (bilan) => bilan.circonstance.onset,
    },
];
// Utilisé dans le sampler du ABCDE (S du sampler)
// À ajouter au pqrst pour un pqrst complet
exports.signeSampler = [
    {
        '@type': 'text',
        key: '4802b280-8f41-4b7e-862f-3906c775880a',
        label: 'Signes ou symptômes / Plainte',
        value: (bilan) => (bilan.victime?.plainte === 'NR' ? null : bilan.victime.plainte),
    },
];
// Utilisé dans le sampler du ABCDE (A du sampler)
// À ajouter au MHTA pour un MHTA complet (A du MHTA)
exports.allergieSampler = [
    {
        '@type': 'tristate',
        key: '72ed42df-8503-4cdf-a76b-a00c5482b619',
        label: 'Allergies',
        value: (bilan) => bilan.victime.antecedents_yn,
    },
    {
        '@type': 'text',
        key: 'e47ed194-075d-4d5f-90f0-b3cfed112c0e',
        label: 'Allergies (détails)',
        value: (bilan) => bilan.victime?.antecedents,
    },
];
// Utilisé dans le sampler du ABCDE (M du sampler)
// À ajouter au MHTA pour un MHTA complet (T du MHTA)
exports.medicamentSampler = [
    {
        '@type': 'text',
        key: 'e39cbb4a-a154-421d-87db-956eecce8ab7',
        label: cUser => (utils.hasPerm(cUser, 'assessment:sampler') ? 'Médicaments' : 'Traitements'),
        value: (bilan) => bilan.victime?.traitements,
    },
    {
        '@type': 'tristate',
        key: '0ba9fc9a-0115-4a73-92a4-ac51d6ff6790',
        label: 'Anti-coagulant',
        value: (bilan) => bilan.victime.anticoagulant,
    },
];
// Utilisé dans le sampler du ABCDE (P du sampler)
// À ajouter au MHTA pour un MHTA complet (H du MHTA)
exports.passeMedSampler = [
    {
        '@type': 'text',
        key: '277c4d3f-c6d4-41be-8b5d-64f41659ef72',
        label: cUser => (utils.hasPerm(cUser, 'assessment:sampler') ? 'Passé médical' : 'Hospitalisations'),
        value: (bilan) => bilan.victime?.hospitalisations,
    },
];
// Utilisé dans le sampler du ABCDE (L du sampler)
exports.lunchSampler = [
    {
        '@type': 'text',
        key: '8b4bb662-effe-49d7-9949-6d52611e484d',
        label: 'Lunch (Dernier repas)',
        value: (bilan) => bilan.victime.heure_dernier_repas,
    },
    {
        '@type': 'dateTime',
        key: '8dc46366-cl26-dzq8-cg7t-8f48581037e9',
        label: 'Lunch (Dernier repas)',
        value: (bilan) => {
            return {
                time: bilan.victime.heure_dernier_repas_time,
                date: bilan.victime.heure_dernier_repas_date,
            };
        },
    },
];
// Utilisé dans le sampler du ABCDE (R du sampler)
// À ajouter au MHTA pour un MHTA complet (M du MHTA)
exports.risquesSampler = [
    {
        '@type': 'text',
        key: '4d3aa184-ae15-440d-9d73-b4f2c7d729f7',
        label: cUser => utils.hasPerm(cUser, 'assessment:sampler') ? 'Risques surajoutés / Facteur de risque' : 'Maladies',
        value: (bilan) => bilan.victime?.maladies,
    },
    {
        '@type': 'multiselect',
        key: '4d959d27-8ef3-4506-95e1-6eed6e7d82f7',
        label: 'Risques',
        options: [
            { value: 1, label: 'ATCD familiaux', kind: 'negative' },
            { value: 2, label: 'Facteurs aggravants', kind: 'negative' },
            { value: 3, label: 'Obésité', kind: 'negative' },
            { value: 4, label: 'Sédentarité', kind: 'negative' },
            { value: 5, label: 'Autres', kind: 'negative' },
            { value: 6, label: 'Toxiques', kind: 'negative' },
            { value: 7, label: 'Tabagisme', kind: 'negative' },
            { value: 8, label: 'Alcool', kind: 'negative' },
            { value: 9, label: 'Stupéfiant', kind: 'negative' },
            { value: 10, label: 'Stresse', kind: 'negative' },
            { value: 11, label: 'Diabète', kind: 'negative' },
            { value: 12, label: 'Problème de cholestérol / lipides', kind: 'negative' },
            { value: 13, label: 'Hypertension', kind: 'negative' },
        ],
        value: (bilan) => bilan.victime.risques,
    },
    {
        '@type': 'text',
        key: 'e5bd1c32-ae23-4701-b377-7114d0b876b5',
        label: 'Risques',
        value: (bilan) => bilan.victime?.risques_str,
    },
    {
        '@type': 'text',
        key: 'ce11b9fb-fcdb-44ba-b7fb-87b7a373fd60',
        label: 'Risques, autres',
        value: (bilan) => bilan.victime?.risques_autres,
    },
];
// Utilisé dans le sampler du ABCDE (E du sampler)
exports.evenementSampler = [
    {
        '@type': 'text',
        key: '8f406e5f-25e5-4e12-b738-3767da14d4eb',
        label: 'Événement déclencheur',
        value: (bilan) => bilan.circonstance.evenement_declencheur,
    },
];
exports.observationsSampler = [
    {
        '@type': 'text',
        key: '5cc99794-b4f0-4475-b830-ef2f6ed591e2',
        label: 'Commentaires',
        value: (bilan) => bilan.victime?.commentaire_sampler,
    },
];
exports.pPqrst = [
    {
        '@type': 'text',
        key: '30bc32a6-3771-4854-9eff-662a6d759c96',
        label: 'Provoqué par',
        value: (bilan) => bilan.circonstance.provoque_par,
    },
];
exports.qrPqrst = [
    {
        '@type': 'text',
        key: '44bd53a0-10f9-4eb2-97ca-07b50887017f',
        label: 'Qualité',
        value: (bilan) => (bilan.circonstance.qualite === 'NR' ? null : bilan.circonstance.qualite),
    },
    {
        '@type': 'multiselect',
        key: '99332bcb-88e0-47ae-8a3f-836868ded88a',
        label: 'Qualité de la douleur',
        options: [
            { value: 1, label: 'Picotements', kind: 'negative' },
            { value: 2, label: 'Brûlure', kind: 'negative' },
            { value: 3, label: 'Serre dans la poitrine', kind: 'negative' },
        ],
        value: (bilan) => bilan.circonstance.qualite_multi,
    },
    {
        '@type': 'text',
        key: '39f95fe1-4331-4b25-83a3-50de4e09cfce',
        label: 'Région',
        value: (bilan) => (bilan.circonstance.region === 'NR' ? null : bilan.circonstance.region),
    },
];
exports.sPqrst = [
    {
        '@type': 'text',
        key: 'c21e1996-f9eb-4710-9d8f-e3f67b4ae1b9',
        label: 'Sévérité',
        value: (bilan) => bilan.circonstance.severite === '-1' ? null : `${bilan.circonstance.severite} / 10`,
    },
];
exports.tPqrst = [
    {
        '@type': 'integer',
        key: '77e54456-54e7-4acd-b9be-d7e716aaa8f1',
        label: 'Temps depuis incident',
        unit: 'heure(s)',
        value: (bilan) => (bilan.circonstance.temps === '' ? null : bilan.circonstance.temps),
    },
    {
        '@type': 'dateTime',
        key: 'e090f849-8d49-4e07-8c1f-cc7046b8bbdc',
        label: "Temps depuis l'incident",
        value: (bilan) => {
            return {
                time: bilan.circonstance.incident_time,
                date: bilan.circonstance.incident_date,
            };
        },
    },
];
// À ajouter au pqrst pour un pqrst complet (QRST du pqrst)
exports.qrstPQRST = [...exports.qrPqrst, ...exports.sPqrst, ...exports.tPqrst];
exports.pqrst = [
    ...exports.pPqrst,
    ...exports.qrstPQRST,
    {
        '@type': 'text',
        key: 'c442df5e-4a19-4d89-a63d-dd06d293ec5f',
        label: 'Commentaires',
        value: (bilan) => bilan.circonstance?.commentaire_pqrst,
    },
];
exports.respirationReguliereNRC = [
    {
        '@type': 'tristate',
        key: 'd49b3f89-1fa7-4d9e-8bba-a3dbbe304e19',
        label: 'Respiration régulière',
        color: 'green',
        value: (bilan) => bilan.respiration.reguliere,
    },
];
exports.respirationReguliereABCDE = [
    {
        '@type': 'tristate',
        key: '3e4fb6d0-64ca-4d6d-8098-4528b0a46298',
        label: 'Irrégulière',
        color: 'red',
        contentInverted: true,
        value: (bilan) => bilan.respiration.reguliere,
    },
];
// Utilisé seul dans la section Vital du NRC
// À ajouter à respiration pour une section complète B du ABCDE et Respiratoire du NRC
exports.respiratoireVital = [
    {
        '@type': 'tristate',
        key: 'fb5bc095-b240-4632-b114-f91fb83c0937',
        label: cUser => utils.hasPerm(cUser, 'assessment:bilan:b:primaire:libelle:arret_respiratoire_pause_10sec')
            ? 'Arrêt respiratoire ou pauses > 10sec'
            : 'Arrêt respiratoire ou pauses > 6sec',
        color: 'red',
        value: (bilan) => bilan.respiration.arret_respiratoire,
    },
];
// B du ABCDE - Respiration du NRC
exports.respiration = [
    {
        '@type': 'tristate',
        key: '04286729-81d1-491f-9298-dca159f472d9',
        label: 'Détresse respiratoire',
        color: 'red',
        value: (bilan) => bilan.respiration.difficile,
    },
    ...exports.respiratoireVital,
    {
        '@type': 'tristate',
        key: '7b78a31b-1b44-4a0e-9e3b-6bdb0e9b76d0',
        label: 'Absence de ventillation',
        color: 'red',
        value: (bilan) => bilan.respiration?.ventilation_absente,
    },
    {
        '@type': 'tristate',
        key: 'c2577439-0d0e-4db3-9010-47ea04172639',
        label: 'Signes de lutte respiratoire',
        color: 'red',
        value: (bilan) => bilan.respiration.signes_lutte_respi,
    },
    {
        '@type': 'tristate',
        key: 'bad4f194-51de-4320-8970-c4169e1e2f95',
        label: 'Normale',
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.respiration.normale,
    },
    {
        '@type': 'tristate',
        key: 'fdacaa82-46c3-4f87-bff6-0d8e966ae827',
        label: 'Irrégulière',
        color: 'red',
        value: (bilan) => bilan.respiration?.irreguliere,
    },
    {
        '@type': 'integer',
        key: '21212165-12c7-45c3-a62b-d9f79aa29088',
        label: 'Taux CO capillaire',
        value: (bilan) => bilan.respiration?.taux_co_capillaire,
    },
    {
        '@type': 'tristate',
        key: 'aec690cd-31a2-4a34-a9a1-dbcb4098d73d',
        label: 'Emphysème sous cutané',
        color: 'red',
        value: (bilan) => bilan.respiration.emphyseme,
    },
    {
        '@type': 'tristate',
        key: 'a8924261-9186-4daf-a576-645fd8168d8d',
        label: 'Pneumothorax',
        color: 'red',
        value: (bilan) => bilan.respiration.pneumothorax,
    },
    {
        '@type': 'tristate',
        key: 'be4ae346-7f3c-4dda-bb2f-fe13d06369fd',
        label: 'BPCO',
        value: (bilan) => utils.boolToChar(bilan.respiration.bpco),
    },
    {
        '@type': 'tristate',
        key: 'b89b16ac-72da-41ec-9af7-51a4646c186e',
        label: 'Cyanose',
        color: 'red',
        value: (bilan) => bilan.respiration.cyanose,
    },
    {
        '@type': 'tristate',
        key: 'ebeea2c1-dbba-4fc8-b2ef-64f8dbe4e761',
        label: 'Sueurs',
        color: 'red',
        value: (bilan) => bilan.respiration.sueurs,
    },
    {
        '@type': 'tristate',
        key: '0fbcc360-1731-4d84-ab44-76a2bcf1ff2a',
        label: 'Ample',
        color: 'green',
        value: (bilan) => bilan.respiration.ample,
    },
    {
        '@type': 'select',
        key: '476ae77d-3905-4473-9b6f-cc747be35714',
        label: 'Amplitude',
        options: [
            { value: 1, label: 'Normale', kind: 'positive' },
            { value: 2, label: 'Superficielle', kind: 'negative' },
        ],
        value: (bilan) => bilan.respiration.amplitude,
    },
    {
        '@type': 'tristate',
        key: '46c0d331-1302-4b9c-be32-3551ff7b4ef8',
        label: 'Difficulté à parler',
        color: 'red',
        value: (bilan) => bilan.respiration?.difficulte_a_parler,
    },
    {
        '@type': 'select',
        key: 'b1c71339-8ec5-4ecf-9898-8f0c3e257fa5',
        label: 'Difficulté à parler',
        options: [
            { value: 0, label: 'Peut compter au-delà de 10 sans reprise de respiration', kind: 'positive' },
            { value: 1, label: 'Oui', kind: 'negative' },
        ],
        value: (bilan) => bilan.respiration?.difficulte_parler,
    },
    {
        '@type': 'select',
        key: 'e84608af-4728-4a6a-a269-d86ad01849df',
        label: 'Débit parole',
        options: [
            { value: 1, label: 'Normal', kind: 'positive' },
            { value: 2, label: 'Difficile', kind: 'negative' },
            { value: 3, label: 'Impossible', kind: 'negative' },
        ],
        value: (bilan) => bilan.respiration?.debit_parole,
    },
    {
        '@type': 'tristate',
        key: 'c9c379d5-6269-469a-93f0-8aa9e8324aea',
        label: 'Symétrique',
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.respiration.symetrique,
    },
    {
        '@type': 'tristate',
        key: 'cedb90b7-8880-43b1-acff-02de0271c1bb',
        label: 'Superficielle',
        color: 'red',
        value: (bilan) => bilan.respiration.superficielle,
    },
    {
        '@type': 'tristate',
        key: 'ac30cca4-4b2f-46a2-a736-ea2e5a317f4a',
        label: 'Pauses respiratoires',
        color: 'red',
        value: (bilan) => bilan.respiration.pauses,
    },
    {
        '@type': 'tristate',
        key: 'c7ae41f2-171c-4f95-921f-9a3ff48acd97',
        label: 'Dyspnée',
        color: 'red',
        value: (bilan) => bilan.medic_info.dyspnee,
    },
    {
        '@type': 'multiselect',
        key: '4c25cc56-3367-4447-a169-d7b655a139e3',
        label: 'Dyspnée (type)',
        options: [
            { value: 1, label: 'Non', kind: 'positive' },
            { value: 2, label: 'Inspiratoire', kind: 'negative' },
            { value: 3, label: 'Expiratoire', kind: 'negative' },
            { value: 4, label: 'Sévère', kind: 'negative' },
            { value: 5, label: 'Modérée', kind: 'negative' },
        ],
        value: (bilan) => bilan.medic_info.dyspnee_type,
    },
    {
        '@type': 'tristate',
        key: 'b330282b-70c8-4b5d-ac20-0897f50644cc',
        label: 'Bruyante',
        color: 'red',
        value: (bilan) => bilan.respiration.bruyante,
    },
    {
        '@type': 'multiselect',
        key: '4eadc80d-f7db-4d18-a766-5639b7192f37',
        label: 'Bruyante (type)',
        options: [
            { value: 1, label: 'Aucun', kind: 'positive' },
            { value: 2, label: 'Ronflement', kind: 'negative' },
            { value: 3, label: 'Sifflements', kind: 'negative' },
            { value: 4, label: 'Crépitements', kind: 'negative' },
            { value: 5, label: 'Autre', kind: 'negative' },
            { value: 6, label: 'Râles', kind: 'negative' },
            { value: 7, label: 'Encombrements', kind: 'negative' },
            { value: 8, label: 'Silence auscultatoire', kind: 'negative' },
        ],
        value: (bilan) => bilan.respiration.bruyante_type,
    },
    {
        '@type': 'tristate',
        key: '8f0db2a2-23d9-4908-8982-0c0d18b46cd5',
        label: 'Bruit anormaux',
        color: 'red',
        value: (bilan) => bilan.respiration.bruits_anormaux,
    },
    {
        '@type': 'tristate',
        key: '30449ec3-3d78-4bfa-9e13-371949dcb3a5',
        label: 'Battement des ailes du nez',
        color: 'red',
        value: (bilan) => bilan.respiration.battement_ailes_nez,
    },
    {
        '@type': 'tristate',
        key: '78c41901-09f0-4e2f-9a70-c3a387499ae3',
        label: 'Tirage',
        color: 'red',
        value: (bilan) => bilan.medic_info.tirage,
    },
    {
        '@type': 'tristate',
        key: '09be37c1-2866-4d8d-9610-3b80fa7aad5a',
        label: 'Tirage',
        color: 'red',
        value: (bilan) => bilan.respiration?.tirage,
    },
    {
        '@type': 'multiselect',
        key: 'efb5f47c-1dfa-4769-8916-e85c4e8c598f',
        label: 'Tirage',
        options: [
            { value: 1, label: 'Sterno-cléido-mastoïdien', kind: 'negative' },
            { value: 2, label: 'Costal', kind: 'negative' },
            { value: 3, label: 'Balancement thoraco-abdominal', kind: 'negative' },
        ],
        value: (bilan) => bilan.medic_info?.tirage_select,
    },
    {
        '@type': 'tristate',
        key: '8a7849f7-530c-40f6-8a69-72914ae7701e',
        label: 'Épanchement',
        color: 'red',
        value: (bilan) => bilan.respiration.epanchement,
    },
    {
        '@type': 'tristate',
        key: '79fb2a2f-5267-48f1-a6ae-2115a787e7f8',
        label: 'Encombrement',
        color: 'red',
        value: (bilan) => bilan.medic_info.encombrement,
    },
    {
        '@type': 'tristate',
        key: 'ffd76cb7-eb07-4d8e-9454-b65530d11014',
        label: cUser => utils.hasPerm(cUser, 'assessment:b:primaire:Label:AsymetrieThoraciqueToAuscultationAsymetrique')
            ? 'Auscultation asymétrique'
            : 'Asymétrie thoracique',
        color: 'red',
        permission: ['!assessment:b:secondaire:symetrique_thoracique:visible'],
        value: (bilan) => bilan.respiration.asymetrie_thoracique,
    },
    {
        '@type': 'select',
        key: '7279c4c5-0554-4857-971c-127c0fc2b2cc',
        label: 'Auscultation',
        options: [
            { value: 0, label: 'Normale', kind: 'positive' },
            { value: 1, label: 'Sibilant', kind: 'negative' },
            { value: 2, label: 'Crépitant', kind: 'negative' },
            { value: 3, label: 'Autre', kind: 'negative' },
        ],
        value: (bilan) => bilan.respiration.auscultation,
    },
    {
        '@type': 'text',
        key: '1b04ea68-627e-43a8-8f21-adb40b27959c',
        label: 'Auscultation - Commentaire',
        value: (bilan) => bilan.respiration.commentaire_auscultation,
    },
    {
        '@type': 'tristate',
        key: 'ffd76cb7-eb07-4d8e-9454-b65530d11015',
        label: 'Symétrique',
        color: 'green',
        permission: ['assessment:b:secondaire:symetrique_thoracique:visible'],
        value: (bilan) => bilan.respiration.asymetrie_thoracique,
    },
    {
        '@type': 'tristate',
        key: '096469e5-478a-42b2-a23a-35ad52768cc5',
        label: 'Balancement thoraco-abdominal',
        color: 'red',
        value: (bilan) => bilan.respiration.balancement_thoraco_abdo,
    },
    {
        '@type': 'multiselect',
        key: '11cf7fcb-760f-4d53-8c48-4272510f984d',
        label: 'Épanchement liquidien',
        options: [
            { value: 1, label: 'Pneumothorax', kind: 'negative' },
            { value: 2, label: 'Hémothorax', kind: 'negative' },
            { value: 3, label: 'Autre', kind: 'negative' },
            { value: 4, label: 'Aucun', kind: 'positive' },
        ],
        value: (bilan) => bilan.respiration.smur_epanchement_liquidien,
    },
    {
        '@type': 'text',
        key: 'b5cf6c9f-5b13-4525-b43a-9daefdd607fd',
        label: cUser => utils.hasPerm(cUser, 'assessment:b:secondaire:commentaire:visible') ? 'Commentaires' : 'Auscultation pulmonaire',
        value: (bilan) => bilan.respiration.commentaire,
    },
    {
        '@type': 'tristate',
        key: 'f1de4757-3147-42d4-8bfa-dab770b826c6',
        label: 'Plaie soufflante',
        color: 'red',
        value: (bilan) => bilan.respiration.plaie_soufflante,
    },
    {
        '@type': 'select',
        key: 'eb3f8742-c2ba-48e0-b858-84ead21f0f6f',
        label: 'Fréquence / Estimation FV',
        options: [
            { value: 2, label: 'Normale', kind: 'positive' },
            { value: 4, label: 'Lente', kind: 'negative' },
            { value: 8, label: 'Rapide', kind: 'negative' },
        ],
        value: (bilan) => bilan.respiration.freqence_evaluation,
    },
    {
        '@type': 'tristate',
        key: 'af9bd92e-2181-46b9-88c0-c2b82536fb20',
        label: 'Insu manuelle',
        value: (bilan) => bilan.respiration.insu_manuelle,
    },
    /*{ // AFFICHER DANS LA SURVEILLANCE INITIALE
    "@type": "integer",
    key: "6044584d-6de3-4e6c-9340-a98c815ed857",
    label: "hbco",
    unit: "%",
    value: (bilan) => bilan.respiration.hbco,
  },*/
    {
        '@type': 'tristate',
        key: '6c4dfc54-8364-4160-a201-920865aded97',
        label: 'Notion de traumatisme thoracique',
        color: 'red',
        value: (bilan) => bilan.respiration?.notion_trauma_thoracique,
    },
];
exports.rcp = [
    {
        '@type': 'time',
        key: 'b76f3561-6f95-154g-gf35-e846a76ac36a',
        label: 'Heure de pose DSA',
        value: (bilan) => bilan.geste.heure_pose,
    },
    {
        '@type': 'dateTime',
        key: '162d8fcc-a997-42d5-a3ca-4295e1d85f2f',
        label: `Heure de mise en route du DSA`,
        value: (bilan) => {
            return {
                date: bilan.geste.heure_mise_en_route_dsa_date,
                time: bilan.geste.heure_mise_en_route_dsa_time,
            };
        },
    },
    {
        '@type': 'select',
        key: 'd6123841-57c5-486e-b5bd-6a3475ae45ff',
        label: 'Le DSA a-t-il posé un problème ?',
        options: [
            { value: 1, label: 'Aucun' },
            { value: 2, label: 'Électrodes' },
            { value: 3, label: 'Batteries' },
            { value: 4, label: 'Autres' },
        ],
        value: (bilan) => bilan.geste.dsa_problem,
    },
    {
        '@type': 'text',
        label: 'Autre raison',
        value: (bilan) => bilan.geste.dsa_problem_other,
    },
    {
        '@type': 'multiselect',
        key: '6d9d57c6-0125-4e57-bfb2-8640d10e7b6d',
        label: 'Circonstances',
        options: [
            { value: 1, label: 'Accident traumatique' },
            { value: 2, label: 'TS' },
            { value: 3, label: 'Pendaison' },
            { value: 4, label: 'Noyade' },
            { value: 5, label: 'Malaise' },
            { value: 6, label: '« Fin de vie » (soins palliatif / HAD, …)' },
            { value: 7, label: 'Directives anticipées' },
            { value: 8, label: 'Autres' },
        ],
        value: (bilan) => bilan.geste.c3dam_circonstances,
    },
    {
        '@type': 'dateTime',
        key: 'ade3a3c3-3381-4754-9cad-c75ee83a2ae7',
        label: 'Dernière fois vu vivant',
        value: (bilan) => {
            return {
                time: bilan.geste.c3dam_dernier_fois_vu_vivant_time,
                date: bilan.geste.c3dam_dernier_fois_vu_vivant_date,
            };
        },
    },
    {
        '@type': 'integer',
        key: '534b4d9c-ec60-40a9-b381-039f7b1ed74d',
        label: 'Délai estimé entre ACR et RCP (no flow)',
        unit: ' min',
        value: (bilan) => bilan.geste.c3dam_estimation_noflow_minutes,
    },
    {
        '@type': 'tristate',
        key: '6c10db46-4148-440e-b8e0-d4ba885e74eb',
        label: 'Antécédents, contexte fin de vie connus',
        color: 'green',
        contentInverted: true,
        value: (bilan) => bilan.geste.c3dam_atcd_contexte_fin_de_vie_connus,
    },
    {
        '@type': 'integer',
        key: '593b0bdd-e5f3-463f-b3e3-0d3add646fc8',
        label: 'Durée du MCE',
        unit: ' min',
        value: (bilan) => bilan.geste.c3dam_mce_duree,
    },
    {
        '@type': 'tristate',
        key: 'ac527a49-a043-4e9c-a1f6-2bba85fa8c4e',
        label: 'Arrêt de la RCP après bilan médecin',
        color: 'red',
        value: (bilan) => bilan.geste.c3dam_arret_rcp_apres_bilan_medecin,
    },
    {
        '@type': 'text',
        key: 'fd20105e-c0e5-40a2-9bcd-2d64f3150b58',
        label: 'Commentaires',
        value: (bilan) => bilan.geste?.c3dam_commentaire,
    },
    ...exports.gesteRCP,
    {
        '@type': 'tristate',
        key: 'b24a8d24-61d2-8465-1547-916c218f5765',
        label: "Reprise de l'activité cardiaque",
        color: 'green',
        value: (bilan) => utils.boolToChar(bilan.geste.reprise_activite_cardiaque),
    },
    {
        '@type': 'select',
        key: '26ebba2f-27bf-49ae-85ed-fe8acbff1379',
        label: "Reprise de l'activité cardiaque",
        options: [
            { value: 0, label: 'Avant médicalisation' },
            { value: 1, label: 'Après médicalisation' },
            { value: 2, label: "Pas de reprise d'une activité cardiaque", kind: 'negative' },
        ],
        value: (bilan) => bilan.geste.reprise_activite_cardiaque,
    },
    {
        '@type': 'time',
        key: 'b76f3561-0e96-482v-gf35-e846a76ac36a',
        label: "Heure de reprise de l'activité cardiaque",
        value: (bilan) => bilan.geste.heure_reprise_activite_cardiaque,
    },
    ...exports.gestePlancheMasser,
    ...exports.gesteGuedel,
    ...exports.gesteInsufflation,
    {
        '@type': 'multiselect',
        key: '6a3a7744-97e4-4428-9867-1b8c1e86b994',
        label: 'Pas de RCP (raisons)',
        options: [
            { value: 1, label: 'Raideur cadavérique' },
            { value: 2, label: 'Putréfaction' },
            { value: 3, label: 'Tête séparée du tronc' },
        ],
        value: (bilan) => bilan.geste.pas_rcp_raison,
    },
    {
        '@type': 'select',
        key: '20ae5fdd-f5de-4c68-81af-55b1f1fc2dcf',
        label: 'RCP arrêt par',
        options: [
            { value: 1, label: 'Présence médicale' },
            { value: 2, label: 'Sur décision du médecin régulateur' },
        ],
        value: (bilan) => bilan.geste.rcp_arret_par,
    },
    {
        '@type': 'dateTime',
        key: 'a808a062-5d3f-48b7-813a-730a60ae005b',
        label: 'Arrêt RCP par téléphone',
        value: (bilan) => {
            return {
                time: bilan.geste.rcp_arret_telephone_time,
                date: bilan.geste.rcp_arret_telephone_date,
            };
        },
    },
    {
        '@type': 'text',
        key: 'b5cf6c9f-5b13-4525-b43a-9daefdd607fd',
        label: 'Commentaires',
        value: (bilan) => bilan.geste.rcp_commentaire,
    },
];
exports.mhta = [
    ...exports.risquesSampler,
    ...exports.passeMedSampler,
    ...exports.medicamentSampler,
    ...exports.allergieSampler,
    {
        '@type': 'text',
        key: '0cbc3144-ff16-4829-a82f-c3018dfa0af9',
        label: 'Commentaires',
        value: (bilan) => bilan.victime?.commentaire_mhta,
    },
];
exports.sampler = [
    ...exports.signeSampler,
    ...exports.allergieSampler,
    ...exports.medicamentSampler,
    ...exports.passeMedSampler,
    ...exports.lunchSampler,
    ...exports.evenementSampler,
    ...exports.risquesSampler,
    ...exports.observationsSampler,
];
exports.accidentField = [
    {
        '@type': 'tristate',
        key: 'b2784e18-e135-458c-a7f7-c3df43bc151b',
        label: 'Accident',
        value: (bilan) => bilan.circonstance?.accident,
    }
];
exports.accidentsAutre = [
    {
        '@type': 'select',
        key: 'e4ebb20c-65b1-4de5-812c-9391780a8e68',
        label: 'Autre trauma',
        options: [
            { value: 1, label: 'Arme blanche' },
            { value: 2, label: 'Arme à feu' },
            { value: 3, label: 'Pendaison / Strangulation' },
            { value: 4, label: 'Noyade' },
            { value: 5, label: 'Électrisation' },
            { value: 6, label: 'Chute' },
        ],
        value: (bilan) => bilan.lesionnel.autre_trauma,
    },
    {
        '@type': 'multiselect',
        key: 'a63ed1b3-cefd-49ab-bd58-2a97c674903d',
        label: 'Autre trauma',
        options: [
            { value: 1, label: 'Arme blanche' },
            { value: 2, label: 'Arme à feu' },
            { value: 3, label: 'Pendaison / Strangulation' },
            { value: 4, label: 'Noyade' },
            { value: 5, label: 'Électrisation' },
            { value: 6, label: 'Chute' },
        ],
        value: (bilan) => bilan.lesionnel.autre_trauma_multi,
    },
    {
        '@type': 'tristate',
        key: '5c383bb6-6429-4854-9db2-e085672d0a31',
        label: 'Accident du travail',
        value: (bilan) => (bilan.circonstance.accident_travail === true ? 'y' : null),
    },
    ...exports.accidentField
];
exports.secoursRoutier = [
    {
        '@type': 'select',
        key: 'e26d358f-28fd-408b-98d5-67daae9d64c0',
        label: 'Accident de la circulation',
        options: [
            { value: 1, label: 'Piéton' },
            { value: 2, label: 'Deux roues' },
            { value: 3, label: 'VL' },
            { value: 4, label: 'PL' },
            { value: 5, label: 'Bus' },
            { value: 6, label: 'Autres' },
        ],
        value: (bilan) => bilan.geste.sr_type_accident,
    },
    {
        '@type': 'multiselectDouble',
        key: '062248f0-f3b9-464e-80cd-821334f6007a',
        label: 'Accident de la circulation',
        textJonction: ' contre ',
        options: [
            { value: 1, label: 'Piéton' },
            { value: 2, label: 'Vélo' },
            { value: 3, label: 'Moto' },
            { value: 4, label: 'VL' },
            { value: 5, label: 'PL' },
            { value: 6, label: 'Bus' },
            { value: 7, label: 'Autres' },
        ],
        value: (bilan) => bilan.geste.accident_circu_left,
        valueBis: (bilan) => bilan.geste.accident_circu_right,
    },
    {
        '@type': 'text',
        key: 'e6d2c4a5-c53a-4edc-ae01-5927261460c5',
        label: 'Accident de la circulation (autres)',
        value: (bilan) => bilan.geste.sr_type_accident_autre,
    },
    {
        '@type': 'select',
        key: '80cf72f6-4031-4b63-8542-8dced2fc17c5',
        label: 'Type de choc',
        options: [
            { value: 1, label: 'Frontal' },
            { value: 2, label: 'Latéral' },
            { value: 3, label: 'Fronto-latéral' },
            { value: 4, label: 'Arrière' },
            { value: 5, label: 'Tonneaux' },
            { value: 6, label: 'Obstacle fixe' },
            { value: 7, label: 'Rotatoire (Angulaire)' },
            { value: 8, label: 'Autre' },
        ],
        value: (bilan) => bilan.geste.sr_type_choc,
    },
    {
        '@type': 'multiselect',
        key: '3bf6f268-6d20-4bdb-a3b3-ebedc22e1249',
        label: 'Type de choc',
        options: [
            { value: 1, label: 'Frontal' },
            { value: 2, label: 'Latéral' },
            { value: 3, label: 'Fronto-latéral' },
            { value: 4, label: 'Arrière' },
            { value: 5, label: 'Tonneaux' },
            { value: 6, label: 'Obstacle fixe' },
            { value: 7, label: 'Rotatoire (Angulaire)' },
            { value: 8, label: 'Autre' },
        ],
        value: (bilan) => bilan.geste.sr_type_choc_multiselect,
    },
    {
        '@type': 'multitristate',
        key: 'eac69709-82fc-4f15-a8b2-2d0c81e5bfe6',
        label: 'Type de choc',
        options: (bilan) => [
            { value: bilan.geste?.sr_type_choc_frontal, label: 'Frontal' },
            { value: bilan.geste?.sr_type_choc_lateral, label: 'Latéral' },
            { value: bilan.geste?.sr_type_choc_fronto_lateral, label: 'Fronto-latéral' },
            { value: bilan.geste?.sr_type_choc_arriere, label: 'Arrière' },
            { value: bilan.geste?.sr_type_choc_tonneaux, label: 'Tonneaux' },
            { value: bilan.geste?.sr_type_choc_rotatoire, label: 'Rotatoire' },
            { value: bilan.geste?.sr_type_choc_obstacle_fixe, label: 'Obstacle fixe' },
            { value: bilan.geste?.sr_type_choc_autre, label: 'Autre' },
        ],
    },
    {
        '@type': 'text',
        key: '954b7925-7342-424f-988b-8214af202d4a',
        label: 'Autre choc',
        value: (bilan) => bilan.geste.sr_autre_choc,
    },
    {
        '@type': 'select',
        key: '00485b79-cc1a-4c49-92a4-acb756f3b710',
        label: 'Position de la victime',
        options: [
            { value: 1, label: 'Passager arrière' },
            { value: 2, label: 'Passager avant' },
            { value: 3, label: 'Conducteur VL' },
            { value: 4, label: 'Conducteur PL' },
            { value: 5, label: 'Passager PL' },
            { value: 6, label: 'Motard' },
            { value: 7, label: 'Vélo' },
            { value: 8, label: 'Piéton' },
            { value: 9, label: 'Autre' },
        ],
        value: (bilan) => bilan.geste.sr_victime,
    },
    {
        '@type': 'select',
        key: '7759bdba-a510-49a9-b6fb-5fb6400bf0aa',
        label: 'Position dans le véhicule',
        options: [
            { value: 1, label: 'Conducteur' },
            { value: 2, label: 'Passager avant' },
            { value: 3, label: 'Passager arrière' },
        ],
        value: (bilan) => bilan.geste.sr_position_dans_vehicule,
    },
    {
        '@type': 'text',
        key: '0e5ef4a8-adf0-4395-96b8-825a06fa8bf7',
        label: 'Autre position',
        value: (bilan) => bilan.geste.sr_autre_position,
    },
    {
        '@type': 'select',
        key: 'f367814c-6461-4b66-8655-ec572f1cce96',
        label: 'Position du véhicule',
        options: [
            { value: 1, label: 'Sur le toit' },
            { value: 2, label: 'Sur le côté' },
            { value: 3, label: 'Sur les roues' },
            { value: 4, label: 'Instable' },
            { value: 5, label: 'Immergé' },
            { value: 6, label: 'En feu' },
        ],
        value: (bilan) => bilan.geste.sr_position_du_vehicule,
    },
    {
        '@type': 'integer',
        key: 'f3d0caa1-8061-4eb7-881d-b403b7844513',
        label: 'Cinétique estimée',
        unit: ' km/h',
        value: (bilan) => bilan.geste.sr_cinetique,
    },
    {
        '@type': 'select',
        key: 'f48d032f-b118-4c23-a0ce-c426c7669bc9',
        label: 'Cinétique estimée (km/h)',
        options: [
            { value: 1, label: 'Faible' },
            { value: 2, label: 'Moyenne' },
            { value: 3, label: 'Forte' },
        ],
        value: (bilan) => bilan.geste.sr_cinetique_select,
    },
    {
        '@type': 'integer',
        key: '9eea3f95-e1da-4f62-9766-f84ad131f18e',
        label: 'Distance véhicules',
        unit: 'm',
        value: (bilan) => bilan.geste?.sr_distance_vehicules,
    },
    {
        '@type': 'multiselect',
        key: '8eefe2ad-12cb-4327-bc7c-6e418d37de52',
        label: 'Équipement de sécurité (victime)',
        options: [
            { value: 1, label: 'Déclenchements airbags' },
            { value: 2, label: 'Appui tête' },
            { value: 3, label: 'Ceinture' },
            { value: 4, label: 'Équipement de motard' },
            { value: 5, label: 'Casque' },
            { value: 6, label: 'Siège bébé' },
        ],
        value: (bilan) => bilan.geste.sr_equipement_victime,
    },
    {
        '@type': 'text',
        key: 'dfc8b618-310d-4854-aa16-e574a80276f3',
        label: 'Équipement du motard',
        value: (bilan) => bilan.geste.sr_equipement_motard,
    },
    {
        '@type': 'select',
        key: 'a44fcec5-ab97-4f80-a24f-a342f841bbb3',
        label: "Situation à l'arrivée",
        options: [
            { value: 1, label: 'Sortie du véhicule', kind: 'positive' },
            { value: 2, label: 'Coincée / Piégée', kind: 'negative' },
            { value: 3, label: 'Incarcérée', kind: 'negative' },
            { value: 4, label: 'Ejectée / projetée', kind: 'negative' },
            { value: 5, label: 'Sous le véhicule', kind: 'negative' },
            { value: 6, label: 'Assise dans le véhicule', kind: 'negative' },
            { value: 7, label: 'Sorti seul', kind: 'positive' },
            { value: 8, label: 'Blessé non piégé', kind: 'negative' },
        ],
        value: (bilan) => bilan.geste.sr_position_victime_arrivee_secours,
    },
    {
        '@type': 'integer',
        key: '9a8a2dd0-1248-4d9c-981b-82efb27ef0fe',
        label: 'Ejectée / projetée - Nombre de mètres',
        unit: ' m',
        value: (bilan) => bilan.geste.sr_ejectee_nombre_metre,
    },
    {
        '@type': 'tristate',
        key: '8074a0e4-5186-4064-9467-c6d51dad3264',
        label: 'Personne ceinturée',
        color: 'green',
        value: (bilan) => bilan.geste.sr_ceinture,
    },
    {
        '@type': 'tristate',
        key: 'a4b8cc5f-3375-4376-9be7-a18ccb73d152',
        label: 'Airbag déclenché',
        color: 'green',
        colorWithPerm: cUser => (utils.hasPerm(cUser, 'assessment:gestes:sr:airbag:red') ? 'red' : 'green'),
        value: (bilan) => bilan.geste.sr_airbag,
    },
    {
        '@type': 'tristate',
        key: 'be5443d9-2f88-4878-af58-8e5a00eaa909',
        label: 'Désincarcération',
        value: (bilan) => bilan.geste?.desincarceration,
    },
    {
        '@type': 'integer',
        key: 'b69fcabb-8b10-4970-8f62-7600c7c51e9a',
        label: 'Désincarcération',
        unit: ' min',
        value: (bilan) => bilan.geste.sr_desincarceration,
    },
    {
        '@type': 'tristate',
        key: '0ca7ebb7-ca59-4cc0-831a-f52393744bd0',
        label: 'Casque',
        color: 'green',
        value: (bilan) => bilan.geste?.sr_casque,
    },
    {
        '@type': 'text',
        key: '63467a35-e814-4687-b8c5-f47ffea0834c',
        label: 'TMD',
        value: (bilan) => bilan.geste?.sr_tmd,
    },
    {
        '@type': 'text',
        key: 'cdd09dc0-c8f2-4a3c-b39b-ac59891715a3',
        label: 'Autre chargement',
        value: (bilan) => bilan.geste?.sr_autre_chargement,
    },
    {
        '@type': 'tristate',
        key: 'ce8e248f-b7cc-4424-b671-7579168bea6a',
        label: 'Cinétique',
        color: 'green',
        value: (bilan) => bilan.geste?.sr_cinetique_tristate,
    },
    ...exports.gesteDegagementUrg,
    ...exports.gesteRetraitCasque,
    ...exports.gesteRetraitCasqueAvantSecours,
    ...exports.accidentsAutre,
];
exports.mortInattendueExamenSecoursDecouverte = [
    {
        '@type': 'time',
        key: 'c6dbdeef-0f3e-4f3e-b7ec-c0fb578b37c5',
        label: 'Heure découverte enfant',
        value: (bilan) => bilan.mort_inattendue?.decouverte_heure,
    },
    {
        '@type': 'text',
        key: '06032906-d029-44db-b0a7-599ddc9694a5',
        label: 'Par qui ?',
        value: (bilan) => bilan.mort_inattendue?.decouverte_nom_personne,
    },
    {
        '@type': 'select',
        key: '0bceae62-5241-4cc1-ad07-e60c9e81b424',
        label: 'Respiration',
        options: [
            { value: 1, label: 'Absente' },
            { value: 2, label: 'Gasp' },
            { value: 3, label: 'Présente' },
        ],
        value: (bilan) => bilan.mort_inattendue?.decouverte_respiration,
    },
    {
        '@type': 'tristate',
        key: 'd94fb714-4708-4193-9871-548f46b0ef76',
        label: 'Coeur (arrêt)',
        value: (bilan) => bilan.mort_inattendue?.decouverte_coeur_arret,
    },
    {
        '@type': 'select',
        key: 'c09c066d-1d90-42ff-a876-16af87b91a67',
        label: "Coloration de l'enfant",
        options: [
            { value: 1, label: 'Pâleur' },
            { value: 2, label: 'Cyanose' },
            { value: 3, label: 'Grise' },
            { value: 4, label: 'Marbrure' },
            { value: 5, label: 'Ictérique' },
            { value: 6, label: 'Normale' },
        ],
        value: (bilan) => bilan.mort_inattendue?.decouverte_coloration,
    },
    {
        '@type': 'tristate',
        key: 'b78dd6a3-81ed-4157-8e62-5928bbbc6958',
        label: 'Geste réa avant arrivée des secours',
        color: 'green',
        value: (bilan) => bilan.mort_inattendue?.decouverte_geste,
    },
    {
        '@type': 'integer',
        key: '1763fc1b-1a3c-4e91-927d-6560cad55e35',
        label: 'Durée',
        unit: ' min',
        value: (bilan) => bilan.mort_inattendue?.decouverte_geste_duree,
    },
    {
        '@type': 'multiselect',
        key: 'ab8f7f0f-696e-4367-9ada-9f11c26a9192',
        label: 'Quels gestes ?',
        options: [
            { value: 1, label: 'Bouche à bouche' },
            { value: 2, label: 'MCE' },
            { value: 3, label: 'Secousses' },
        ],
        value: (bilan) => bilan.mort_inattendue?.decouverte_gestes,
    },
    {
        '@type': 'select',
        key: 'db1d9af0-a964-48fa-af37-9664ce56408f',
        label: "Réponse de l'enfant",
        options: [
            { value: 1, label: 'Éveil' },
            { value: 2, label: 'Éveil puis endormissement' },
            { value: 3, label: 'Somnolence' },
            { value: 4, label: 'Pas de réaction' },
        ],
        value: (bilan) => bilan.mort_inattendue?.decouverte_reponse_enfant,
    },
    {
        '@type': 'tristate',
        key: '3a413eba-8469-4a24-8afe-4186d5853f11',
        label: 'Vomissements',
        value: (bilan) => bilan.mort_inattendue?.decouverte_vomissement,
    },
];
exports.mortInattendueExamenSecoursArrivee = [
    {
        '@type': 'select',
        key: 'b86276a3-72d1-4128-a195-5d63ea3fe8f5',
        label: 'Respiration',
        options: [
            { value: 1, label: 'Absente' },
            { value: 2, label: 'Gasp' },
            { value: 3, label: 'Présente' },
        ],
        value: (bilan) => bilan.mort_inattendue?.arrivee_respiration,
    },
    {
        '@type': 'tristate',
        key: '23533d09-039d-4896-ad06-72a43c2340e2',
        label: 'FC',
        value: (bilan) => bilan.mort_inattendue?.arrivee_coeur_arret,
    },
    {
        '@type': 'select',
        key: '1b848b87-c8d2-40c5-a85d-e7c429ea0167',
        label: "Coloration de l'enfant",
        options: [
            { value: 1, label: 'Pâleur' },
            { value: 2, label: 'Cyanose' },
            { value: 3, label: 'Grise' },
            { value: 4, label: 'Marbrure' },
            { value: 5, label: 'Ictérique' },
            { value: 6, label: 'Normale' },
        ],
        value: (bilan) => bilan.mort_inattendue?.arrivee_coloration,
    },
    {
        '@type': 'tristate',
        key: '68e6f244-698b-4bed-a20f-e0c69126be63',
        label: 'Lividités',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.lividite,
    },
    {
        '@type': 'text',
        key: '92e10053-d25c-4be4-a1c7-289f9e3f2386',
        label: 'Lividités - Commentaire',
        value: (bilan) => bilan.mort_inattendue?.lividite_commentaire,
    },
    {
        '@type': 'tristate',
        key: '0cce66e2-6194-4212-acc8-f6f930d43886',
        label: 'Rigidité',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.rigidite,
    },
    {
        '@type': 'multiselect',
        key: 'f36f8e45-c74e-40d5-8fe3-a9292c326db5',
        label: 'Rigidité - Localisation',
        options: [
            { value: 1, label: 'Mêchoire' },
            { value: 2, label: 'Membres' },
        ],
        value: (bilan) => bilan.mort_inattendue?.rigidite_localisation,
    },
    {
        '@type': 'tristate',
        key: 'bbc71e55-f53f-4442-b57c-3421e7303b1f',
        label: 'Hypotonie',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.hypotonie,
    },
    {
        '@type': 'tristate',
        key: 'f32c55aa-a649-439a-be5c-e988bd304ed5',
        label: 'Déshydratation',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.deshydratation,
    },
    {
        '@type': 'multiselect',
        key: '5ff67c45-241a-481c-af0e-db4c4d12aa12',
        label: 'Déshydratation - Localisation',
        options: [
            { value: 1, label: 'Plu cutané' },
            { value: 2, label: 'Enfoncement des yeux' },
        ],
        value: (bilan) => bilan.mort_inattendue?.deshydratation_precision,
    },
    {
        '@type': 'tristate',
        key: '8dd321a2-f506-4a7c-99ca-1bc8b98df8af',
        label: 'Éruption',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.eruption,
    },
    {
        '@type': 'text',
        key: '9b5b2aa5-d848-4972-9051-fec6c48acb20',
        label: 'Éruption - Localisation érythème',
        value: (bilan) => bilan.mort_inattendue?.eruption_localisation_erytheme,
    },
    {
        '@type': 'text',
        key: '51799ae9-1509-4e66-bdbc-c7f9f59439a5',
        label: 'Éruption - Localisation purpura',
        value: (bilan) => bilan.mort_inattendue?.eruption_localisation_purpura,
    },
    {
        '@type': 'text',
        key: '39c451da-bacb-4f0e-8a0e-dee806ae953d',
        label: 'Éruption - Localisation Vésicule',
        value: (bilan) => bilan.mort_inattendue?.eruption_localisation_vesicule,
    },
    {
        '@type': 'tristate',
        key: 'b6027f57-b9fb-44d0-9a34-864d0ee4d75b',
        label: 'Sueurs',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.sueur,
    },
    {
        '@type': 'tristate',
        key: '33dae4e8-c1a0-42da-a11e-9eef581a4b4a',
        label: 'Rejets',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.rejet,
    },
    {
        '@type': 'multiselect',
        key: 'd8043e3e-06e4-4f71-bafd-694763093e87',
        label: 'Rejets - Localisation',
        options: [
            { value: 1, label: 'Nez' },
            { value: 2, label: 'Bouche' },
            { value: 3, label: 'Vêtements' },
            { value: 4, label: 'Draps' },
        ],
        value: (bilan) => bilan.mort_inattendue?.rejet_localisation,
    },
    {
        '@type': 'multiselect',
        key: '0288e64c-bbd7-41b2-85cf-be4d3f526f83',
        label: 'Rejets - Précision',
        options: [
            { value: 1, label: 'Aliments' },
            { value: 2, label: 'Sang' },
            { value: 3, label: 'Sérosité' },
        ],
        value: (bilan) => bilan.mort_inattendue?.rejet_precision,
    },
    {
        '@type': 'tristate',
        key: 'b542ab4d-517a-433b-a5b5-998865b0fe46',
        label: 'Ecchymoses ou traumatismes',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.ecchymose,
    },
    {
        '@type': 'text',
        key: '0ae30a54-7ceb-445d-8d64-5124bb2f46a4',
        label: 'Ecchymoses ou traumatismes - Localisation',
        value: (bilan) => bilan.mort_inattendue?.ecchymose_localisation,
    },
    {
        '@type': 'tristate',
        key: 'f7a6a277-13ed-4ec3-b30e-962b98d0d784',
        label: 'Fontanelles ouvertes',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.fontanelle_ouverte,
    },
    {
        '@type': 'tristate',
        key: '2fa4c4a1-073e-418b-b3ba-2795430d8e70',
        label: 'Cicatrices',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.cicatrice,
    },
    {
        '@type': 'text',
        key: '06d6584d-355f-430b-8d20-4976dacfda03',
        label: 'Cicatrices - Localisation',
        value: (bilan) => bilan.mort_inattendue?.cicatrice_localisation,
    },
];
exports.mortInattenduePriseEnCharge = [
    {
        '@type': 'time',
        key: 'f626a74d-7c48-4d62-bf6a-e000be48a6b4',
        label: 'Heure début',
        value: (bilan) => bilan.mort_inattendue?.heure_debut,
    },
    {
        '@type': 'time',
        key: 'eb9ecc20-cc93-45f0-8d38-07d461191f86',
        label: 'Heure fin',
        value: (bilan) => bilan.mort_inattendue?.heure_fin,
    },
    {
        '@type': 'tristate',
        key: '12327704-4aa3-4c62-a876-36017168294b',
        label: 'Voies aériennes libres',
        value: (bilan) => bilan.mort_inattendue?.voies_aeriennes_libres,
    },
    {
        '@type': 'text',
        key: 'eb77e253-bb66-4701-b142-94ba444de4c5',
        label: 'Précisions',
        value: (bilan) => bilan.mort_inattendue?.voies_aeriennes_libres_precision,
    },
    {
        '@type': 'tristate',
        key: '6dca7a6e-f2a7-4ea7-a114-d467ec1c8850',
        label: 'Reprise activité cardiaque',
        color: 'green',
        value: (bilan) => bilan.mort_inattendue?.reprise_activite_cardiaque,
    },
    {
        '@type': 'tristate',
        key: '4915fde5-7bb8-42fb-9c6a-f38016a77c9e',
        label: 'Survenue de vomissements',
        color: 'red',
        value: (bilan) => bilan.mort_inattendue?.prisecharge_vomissement,
    },
    {
        '@type': 'multiselect',
        key: 'af954edb-9d1c-43c2-a778-4921364596c0',
        label: 'Gestes effectués',
        options: [
            { value: 1, label: 'MCE' },
            { value: 2, label: 'Ventilation au masque' },
            { value: 3, label: 'Intubation' },
            { value: 4, label: 'VIO' },
        ],
        value: (bilan) => bilan.mort_inattendue?.geste_effectue,
    },
    {
        '@type': 'multiselect',
        key: '9c3e79c4-a927-4bb5-89e2-814e8244be7a',
        label: 'Gestes par',
        options: [
            { value: 1, label: 'Parents' },
            { value: 2, label: 'Grands-parents' },
            { value: 3, label: "Garde d'enfant" },
            { value: 4, label: 'Assistante maternelle' },
            { value: 5, label: 'Personnel de crèche' },
            { value: 6, label: 'Pompiers' },
            { value: 7, label: 'Ambulanciers' },
            { value: 8, label: 'Médecin' },
        ],
        value: (bilan) => bilan.mort_inattendue?.geste_par,
    },
];
exports.mortInattendueEnvironnement = [
    {
        '@type': 'select',
        key: '29567384-1fcb-40fd-a102-f5641c20a082',
        label: 'Lieu du décès',
        options: [
            { value: 1, label: 'Domicile' },
            { value: 2, label: 'Crèche' },
            { value: 3, label: 'Assistante maternelle' },
            { value: 4, label: 'Extérieur' },
            { value: 5, label: 'Autre' },
        ],
        value: (bilan) => bilan.mort_inattendue?.lieu_deces,
    },
    {
        '@type': 'select',
        key: '1e90e4d4-da4c-46ec-8d6e-21ff9f0e0813',
        label: "L'enfant dormait avec quelqu'un ?",
        options: [
            { value: 1, label: 'Non' },
            { value: 2, label: 'Oui dans la pièce' },
            { value: 3, label: 'Oui dans le même lit' },
        ],
        value: (bilan) => bilan.mort_inattendue?.dors_avec_quelquun,
    },
    {
        '@type': 'text',
        key: '2df4a13f-3a65-4231-a752-ab5625482ebb',
        label: 'Si oui: avec qui ?',
        value: (bilan) => bilan.mort_inattendue?.dors_avec_qui,
    },
    {
        '@type': 'text',
        key: '6b6df19b-4229-4512-b01e-8e143971f539',
        label: 'Prise de médicaments ou autres ?',
        value: (bilan) => bilan.mort_inattendue?.prise_medicament_ou_autre,
    },
    {
        '@type': 'text',
        key: 'b4c80b23-0eb4-47e4-b3ef-25d0e0cb6ff4',
        label: 'Environnement pièce (tabacs, autre)',
        value: (bilan) => bilan.mort_inattendue?.environnement_piece,
    },
    {
        '@type': 'select',
        key: 'b33b5c85-550f-4a58-bbae-f450e64ff3d3',
        label: 'Position de sommeil au couché',
        options: [
            { value: 1, label: 'Sur le dos' },
            { value: 2, label: 'Sur le ventre' },
            { value: 3, label: 'Sur le côté' },
            { value: 4, label: 'Assis' },
        ],
        value: (bilan) => bilan.mort_inattendue?.position_sommeil_couche,
    },
    {
        '@type': 'select',
        key: '5889456f-d4f8-4121-9dbb-770239681504',
        label: 'Position de sommeil trouvé',
        options: [
            { value: 1, label: 'Sur le dos' },
            { value: 2, label: 'Sur le ventre' },
            { value: 3, label: 'Sur le côté' },
            { value: 4, label: 'Assis' },
        ],
        value: (bilan) => bilan.mort_inattendue?.position_sommeil_trouve,
    },
    {
        '@type': 'select',
        key: 'c44e1214-14df-4f8e-940a-e04706eb9e12',
        label: 'Type de couchage',
        options: [
            { value: 1, label: 'Lit à barreaux' },
            { value: 2, label: 'Lit parapluie' },
            { value: 3, label: 'Berceau' },
            { value: 4, label: 'Couffin' },
            { value: 5, label: 'Siège coque' },
            { value: 6, label: 'Transat' },
            { value: 7, label: 'Lit adulte' },
            { value: 8, label: 'Canapé' },
            { value: 9, label: 'Fauteuil' },
            { value: 10, label: 'Poussette' },
            { value: 11, label: 'Landau' },
            { value: 12, label: 'Écharpe' },
            { value: 13, label: 'Autre' },
        ],
        value: (bilan) => bilan.mort_inattendue?.type_couchage,
    },
    {
        '@type': 'select',
        key: '5a9d162f-8483-40c5-bd8c-bc3b49a38839',
        label: 'Type de matelas',
        options: [
            { value: 1, label: 'Ferme' },
            { value: 2, label: 'Mou' },
        ],
        value: (bilan) => bilan.mort_inattendue?.type_matelas,
    },
    {
        '@type': 'integer',
        key: '94618457-2561-41ec-bbfa-aa7b3b277358',
        label: 'Ecartement lit barreaux',
        unit: ' cm',
        value: (bilan) => bilan.mort_inattendue?.ecartement_lit_barreaux,
    },
    {
        '@type': 'tristate',
        key: 'b6670cdf-9167-4543-af02-82852a6d90e8',
        label: 'Matelas surajouté',
        value: (bilan) => bilan.mort_inattendue?.matelas_surajoute,
    },
    {
        '@type': 'tristate',
        key: '01b5f1e2-5b42-4bc3-adcd-f10dbec6ee7d',
        label: 'Enfant coincé',
        value: (bilan) => bilan.mort_inattendue?.environnement_enfant_coince,
    },
    {
        '@type': 'integer',
        key: 'da58f977-7750-469a-ad2a-0f71c6371fc6',
        label: 'Température ambiante',
        unit: ' °C',
        value: (bilan) => bilan.mort_inattendue?.temperature_ambiante,
    },
    {
        '@type': 'select',
        key: '29fbb1cc-8fc3-4bd1-a9de-fd2a06f0fdd1',
        label: 'Température évaluée',
        options: [
            { value: 1, label: 'Chaude (>25°C)' },
            { value: 2, label: 'Froide (<15°C)' },
            { value: 3, label: 'Normale' },
        ],
        value: (bilan) => bilan.mort_inattendue?.temperature_evaluee,
    },
    {
        '@type': 'time',
        key: '302c5139-064c-43cc-a611-4269a589ab9b',
        label: 'Heure température',
        value: (bilan) => bilan.mort_inattendue?.heure_temperature,
    },
    {
        '@type': 'text',
        key: '4af931ce-a2c7-4193-b990-dbe8c0211fda',
        label: 'Habillage',
        value: (bilan) => bilan.mort_inattendue?.habillage,
    },
    {
        '@type': 'select',
        key: '5e9d5518-c6bc-42ba-9792-941533436d8a',
        label: "Possibilité d'une intoxication",
        options: [
            { value: 1, label: 'CO' },
            { value: 2, label: 'Fumées' },
            { value: 3, label: 'Médicaments' },
            { value: 4, label: 'Autre' },
        ],
        value: (bilan) => bilan.mort_inattendue?.possibilite_intoxication,
    },
    {
        '@type': 'text',
        key: 'b90667ef-f0e7-4d95-abf0-8091d2547a1e',
        label: 'Composition dernier repas',
        value: (bilan) => bilan.mort_inattendue?.composition_dernier_repas,
    },
    {
        '@type': 'time',
        key: 'd163b264-600b-4fb1-88a3-f71ca6757bfb',
        label: 'Heure couchage',
        value: (bilan) => bilan.mort_inattendue?.heure_couchage,
    },
    {
        '@type': 'time',
        key: 'ec0c97ab-d1fd-4093-a5eb-3c8f3c5fdab6',
        label: 'Heure dernier contact vivant',
        value: (bilan) => bilan.mort_inattendue?.heure_dernier_contact_vivant,
    },
    {
        '@type': 'tristate',
        key: '0b443aef-a749-403b-a40c-b6a504bceeb9',
        label: 'Tétine au couché',
        value: (bilan) => bilan.mort_inattendue?.tetine_au_couche,
    },
];
exports.mortInattendueEnvironnementCouchage = [
    {
        '@type': 'tristate',
        key: '60e56cc4-7d4f-4847-8ee2-0967c9b11cd7',
        label: 'Tour de lit',
        value: (bilan) => bilan.mort_inattendue?.environnement_tour_lit,
    },
    {
        '@type': 'tristate',
        key: 'c17e8607-5c20-4656-b4d6-6b8faffbbe6b',
        label: 'Oreiller(s)',
        value: (bilan) => bilan.mort_inattendue?.environnement_oreiller,
    },
    {
        '@type': 'tristate',
        key: 'cd390b48-956d-462b-a7a3-5d728560a2f1',
        label: 'Couverture',
        value: (bilan) => bilan.mort_inattendue?.environnement_couverture,
    },
    {
        '@type': 'tristate',
        key: 'f20955c4-1900-47a4-8601-0d1fe414f48b',
        label: 'Couette',
        value: (bilan) => bilan.mort_inattendue?.environnement_couette,
    },
    {
        '@type': 'tristate',
        key: '522118c3-a989-4d40-aa66-fafce2df1b18',
        label: 'Peluche',
        value: (bilan) => bilan.mort_inattendue?.environnement_peluche,
    },
    {
        '@type': 'tristate',
        key: '88ba6d2b-b087-4a3f-8fd6-158fc166b6c0',
        label: 'Coussin de positionnement',
        value: (bilan) => bilan.mort_inattendue?.environnement_coussin_positionnement,
    },
    {
        '@type': 'tristate',
        key: 'a45df102-1a7d-46e4-a703-85d69dcc456b',
        label: 'Tête recouverte',
        value: (bilan) => bilan.mort_inattendue?.environnement_tete_recouverte,
    },
    {
        '@type': 'tristate',
        key: '49048a57-cfa8-4536-a517-b930de7d4cb8',
        label: 'Autre',
        value: (bilan) => bilan.mort_inattendue?.environnement_autre,
    },
];
exports.mortInattendueFlatten = [
    ...exports.mortInattendueExamenSecoursDecouverte,
    ...exports.mortInattendueExamenSecoursArrivee,
    ...exports.mortInattenduePriseEnCharge,
    ...exports.mortInattendueEnvironnement,
    ...exports.mortInattendueEnvironnementCouchage
];
exports.mortInattendue = [
    {
        '@type': 'category',
        key: 'a398451c-aa0e-45e8-b2fa-4c4ccf8c2d2e',
        columns: 1,
        title: "Examen à l'arrivé des secours",
        children: [
            // Description lors de la découvete de l'enfant
            {
                '@type': 'category',
                key: 'a8b3afb8-1f89-4f04-a50a-fcf5642710d5',
                columns: 4,
                className: 'cardGridLarge',
                subtitle: "Description lors de la découverte de l'enfant",
                children: [...exports.mortInattendueExamenSecoursDecouverte],
            },
            // Description à l'arrivée de léquipe d'intervention
            {
                '@type': 'category',
                key: 'c0995206-3204-4c2b-9e24-fa00039e4d1b',
                columns: 4,
                className: 'cardGridLarge',
                subtitle: "Description à l'arrivée de léquipe d'intervention",
                children: [...exports.mortInattendueExamenSecoursArrivee],
            },
        ],
    },
    // Prise en charge sur le lieu du décés
    {
        '@type': 'category',
        key: 'b7bc243e-4d6d-40c6-b216-f4a645212961',
        columns: 4,
        className: 'cardGridLarge',
        title: 'Prise en charge sur le lieu du décés',
        children: [...exports.mortInattenduePriseEnCharge],
    },
    // Environnement de l'enfant avant sont décés
    {
        '@type': 'category',
        key: 'f5219d6b-81cc-4ee3-9dba-086c07e0bda8',
        columns: 1,
        title: "Environnement de l'enfant avant sont décés",
        children: [
            {
                '@type': 'category',
                key: 'c28c5dcd-71c6-4391-8c52-b8e02184758e',
                columns: 4,
                className: 'cardGridLarge',
                children: [...exports.mortInattendueEnvironnement],
            },
            // Objets dans le couchage se trouvant près de la figure, nez ou bouche
            {
                '@type': 'category',
                key: '4089c0c8-3665-456b-9a3e-96d06ec1ccae',
                columns: 4,
                className: 'cardGridLarge',
                subtitle: 'Objets dans le couchage se trouvant près de la figure, nez ou bouche',
                children: [...exports.mortInattendueEnvironnementCouchage],
            },
        ],
    },
];
exports.transportPediaInitial = [
    {
        '@type': 'text',
        key: 'e1f2a5dc-4d67-4503-9a82-e47c781580b3',
        label: 'Numéro de dossier',
        value: (bilan) => bilan.transfert_pedia?.numero_dossier,
    },
    {
        '@type': 'select',
        key: '1aac3a8e-ee01-47fd-815e-124027f8906a',
        label: 'Type de patient',
        options: [
            { value: 1, label: 'Néonat', kind: 'negative' },
            { value: 2, label: 'Pédiatrique', kind: 'negative' },
            { value: 3, label: 'Adulte', kind: 'negative' },
        ],
        value: (bilan) => bilan.transfert_pedia?.type_patient,
    },
    {
        '@type': 'text',
        key: '9f010257-6ec2-4190-882d-267a209a4c60',
        label: 'Médecin régulateur',
        value: (bilan) => bilan.transfert_pedia?.medecin_regulateur,
    },
    {
        '@type': 'text',
        key: '12a0db8c-2e4f-462a-8190-f57fc88ea780',
        label: 'Médecin transporteur',
        value: (bilan) => bilan.transfert_pedia?.medecin_transporteur,
    },
    {
        '@type': 'text',
        key: '2761c2a0-feaf-4892-bbf9-92a901baa288',
        label: 'Ambulancier',
        value: (bilan) => bilan.transfert_pedia?.ambulancier,
    },
    {
        '@type': 'text',
        key: 'cf236104-15ef-47a5-80a3-e6e41657696d',
        label: 'Service origine',
        value: (bilan) => bilan.transfert_pedia?.origine,
    },
    {
        '@type': 'text',
        key: '931e48bf-5c2b-4411-a644-adf6334b357e',
        label: 'Médecin origine',
        value: (bilan) => bilan.transfert_pedia?.medecin_origine,
    },
    {
        '@type': 'text',
        key: '764d15b2-64cf-44a2-b188-be3426ea629c',
        label: 'Destination',
        value: (bilan) => bilan.transfert_pedia?.destination,
    },
    {
        '@type': 'text',
        key: 'adfe3d6d-f584-4f03-8323-fbe2826a40c2',
        label: 'Médecin destination',
        value: (bilan) => bilan.transfert_pedia?.medecin_destination,
    },
    {
        '@type': 'text',
        key: '22d679a2-49bf-49e1-bb41-704b7aa39ce7',
        label: 'APGAR',
        value: (bilan) => bilan.transfert_pedia?.apgar,
    },
    {
        '@type': 'text',
        key: '79c2fcd9-8137-4c0f-a458-eeaf7f884cb2',
        label: 'P.N.',
        value: (bilan) => bilan.transfert_pedia?.pn,
    },
    {
        '@type': 'text',
        key: '608b3372-69f3-4684-b26a-02e7e361dab7',
        label: 'P. actuel',
        value: (bilan) => bilan.transfert_pedia?.p_actuel,
    },
];
exports.transportPediaConditionnement = [
    {
        '@type': 'tristate',
        key: 'e66ee178-989c-4086-bde2-ff49671f0890',
        label: 'Cathé court',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_cathe_court,
    },
    {
        '@type': 'tristate',
        key: '14bbd612-1031-435b-93d8-c0404723f654',
        label: 'Epicran',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_epicran,
    },
    {
        '@type': 'tristate',
        key: '1e6ef516-55dc-410b-a90c-de80df491279',
        label: 'KTVO',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_ktvo,
    },
    {
        '@type': 'tristate',
        key: 'fdaf7b19-e4e1-418a-aca2-3b3eb34d0084',
        label: 'Sonde gastrique',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_sonde_gastrique,
    },
    {
        '@type': 'tristate',
        key: '5bfd4886-73da-42b7-9993-014ac0b50a11',
        label: 'Ventilation',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_ventilation,
    },
    {
        '@type': 'tristate',
        key: '9dcaf59f-3612-4fa2-8bd2-ac07a9b83958',
        label: 'Intubation',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_intubation,
    },
    {
        '@type': 'text',
        key: 'cd26e0f8-bb55-433b-bda6-82df399d356d',
        label: 'Intubation - Repère narine',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_intubation_repere_narine,
    },
    {
        '@type': 'text',
        key: '649a8472-4bc7-4181-b408-199d1b0b721b',
        label: 'Intubation - Calibre',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_intubation_calibre,
    },
    {
        '@type': 'tristate',
        key: '61505173-eb1f-4724-abef-089b253d4d85',
        label: 'Hood',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_hood,
    },
    {
        '@type': 'integer',
        key: '1dd38c76-e4a1-4547-b7d7-68639a9643b4',
        label: 'Hood - FIO2',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_hood_fio2,
    },
    {
        '@type': 'integer',
        key: '3e8079d2-f783-4b2e-881e-8cb35ad5e6e4',
        label: 'FIO2',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_ventilation_fio2,
    },
    {
        '@type': 'integer',
        key: '37a3560d-764d-4f30-8562-00e76ffa5468',
        label: 'F',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_ventilation_f,
    },
    {
        '@type': 'integer',
        key: '16a4014d-9767-46af-a4fd-3a101e62dc6f',
        label: 'PiMax',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_ventilation_pi_max,
    },
    {
        '@type': 'integer',
        key: '777b2229-67f2-4adf-8297-82226ada7487',
        label: 'PEP',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_ventilation_pep,
    },
    {
        '@type': 'tristate',
        key: 'da2cf22a-e96d-47ac-86ba-fdbd761c2fdd',
        label: 'Exsufflation',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_exsufflation,
    },
    {
        '@type': 'tristate',
        key: 'bfe2dfad-2e41-4605-8d16-1353584b0d7f',
        label: 'Drain pleural',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_drain_pleural,
    },
    {
        '@type': 'integer',
        key: '6573f51d-56e3-4dc8-b40b-8d16b87f086a',
        label: 'Glucose',
        unit: '%',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_glucose,
    },
    {
        '@type': 'integer',
        key: '106b4389-6b55-40a6-a88c-a68126f5ce3c',
        label: 'Gavage',
        unit: 'ml',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_gavage,
    },
    {
        '@type': 'integer',
        key: 'f2f42987-2352-46b3-a926-5802bea68967',
        label: 'Perf',
        unit: 'ml/h',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_perf,
    },
    {
        '@type': 'text',
        key: '82957614-36fd-4180-a521-7bb93deb9b2c',
        label: 'Drogues / remplissage',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_drogue,
    },
    {
        '@type': 'tristate',
        key: '60cb7af1-9c21-467d-b60c-a1a9bb13112e',
        label: 'Vit k1',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_vit_k1,
    },
    {
        '@type': 'tristate',
        key: '2e421f0a-7aba-4c6e-9957-5b8793d6435e',
        label: 'Collyre',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_origine_collyre,
    },
];
exports.transportPediaPriseEnChargeSmur = [
    {
        '@type': 'integer',
        key: '37d0a5de-32ce-45c8-8c24-6006a78bf202',
        label: 'Température',
        unit: '°C',
        value: (bilan) => bilan.transfert_pedia?.prise_en_charge_temperature,
    },
    {
        '@type': 'integer',
        key: 'fac30241-e5f1-4037-8b33-cc210dec2b6e',
        label: 'TRC',
        unit: 'secondes',
        value: (bilan) => bilan.transfert_pedia?.prise_en_chargeTrc,
    },
    {
        '@type': 'integer',
        key: '46369c4c-849e-461e-8ffb-d1ccaac7015b',
        label: 'FC',
        unit: 'bpm',
        value: (bilan) => bilan.transfert_pedia?.prise_en_charge_fc,
    },
    {
        '@type': 'integer',
        key: '9f98df96-db85-4a82-a5eb-19f4750c1627',
        label: 'SPO2',
        unit: '%',
        value: (bilan) => bilan.transfert_pedia?.prise_en_charge_sat,
    },
    {
        '@type': 'integer',
        key: '4dd98e53-6403-4904-8e0c-de2d16518873',
        label: 'FR',
        unit: 'mvt/min',
        value: (bilan) => bilan.transfert_pedia?.prise_en_charge_fr,
    },
    {
        '@type': 'integer',
        key: '2eef3d00-fd13-4398-9b36-dfa2fb97bd9b',
        label: 'Silverman',
        value: (bilan) => bilan.transfert_pedia?.prise_en_charge_silverman,
    },
    {
        '@type': 'integer',
        key: '9fe839e2-f203-47b0-86c1-eeb851b88421',
        label: 'Glycémie',
        value: (bilan) => bilan.transfert_pedia?.prise_en_charge_glycemie,
    },
    {
        '@type': 'select',
        key: 'c805dd7b-73cd-437e-b217-8398a0a2ae8f',
        label: 'Unité',
        options: [
            { value: 1, label: 'g/L' },
            { value: 2, label: 'mmol/L' },
            { value: 3, label: 'mg/dL' },
        ],
        value: (bilan) => bilan.transfert_pedia?.prise_en_charge_glycemie_unite,
    },
];
exports.transportPediaConditionnementSmur = [
    {
        '@type': 'tristate',
        key: '8401e9a6-b105-44d6-bac3-bb0ca333d24c',
        label: 'Cathé court',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_cathe_court,
    },
    {
        '@type': 'tristate',
        key: 'acff3151-7c0e-4d3c-a391-20c501d0ed6a',
        label: 'Epicran',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_epicran,
    },
    {
        '@type': 'tristate',
        key: '35ef4a47-de05-48de-bffc-1af96ea35111',
        label: 'KTVO',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_ktvo,
    },
    {
        '@type': 'tristate',
        key: '86f89c32-36a1-4147-bcc9-32ed74fe0fe4',
        label: 'Sonde gastrique',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_sonde_gastrique,
    },
    {
        '@type': 'tristate',
        key: '3436f9f2-95b1-4284-87d2-646a2a3778c0',
        label: 'Intubation',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_intubation,
    },
    {
        '@type': 'text',
        key: 'fafcef05-a8d0-4f70-a035-bc8bc97c0ef3',
        label: 'Intubation - Repère narine',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_intubation_repere_narine,
    },
    {
        '@type': 'text',
        key: 'c7d0953a-9296-4dbf-8df2-1b44c1a733c9',
        label: 'Intubation - Calibre',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_intubation_calibre,
    },
    {
        '@type': 'tristate',
        key: '2e0d1d3f-55d1-4155-a8ce-c5cd75581127',
        label: 'Hood',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_hood,
    },
    {
        '@type': 'integer',
        key: 'a0e48df0-f9aa-4185-9686-234e7482565c',
        label: 'Hood - FIO2',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_hood_fio2,
    },
    {
        '@type': 'tristate',
        key: 'd8a46cf7-3e52-4c16-8f9a-5ef40c42fbda',
        label: 'TcPO2',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_tcpo2,
    },
    {
        '@type': 'tristate',
        key: 'fa281bec-c3b0-4a3b-bbc6-f5e87cf4ad4a',
        label: 'SpO2',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_spo2,
    },
    {
        '@type': 'tristate',
        key: '8fbf28d0-9da0-43b1-8075-d2bf4cc7a298',
        label: 'Scope',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_scope,
    },
    {
        '@type': 'tristate',
        key: 'd17d8b37-1449-41dc-94bc-81e44bceca61',
        label: 'Exsufflation',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_exsufflation,
    },
    {
        '@type': 'tristate',
        key: '80188603-6fbd-4609-9f12-628b94b53074',
        label: 'Drain pleural',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_drain_pleural,
    },
    {
        '@type': 'integer',
        key: 'd8727491-8cdf-436a-bf38-d3a2b183aef4',
        label: 'Glucose',
        unit: '%',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_glucose,
    },
    {
        '@type': 'integer',
        key: '7c1d8342-a4b5-40e0-92fc-a0a922b248df',
        label: 'Gavage',
        unit: 'ml',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_gavage,
    },
    {
        '@type': 'integer',
        key: '6e6bb2b3-12fd-4f4e-9299-94aac48309d6',
        label: 'Perf',
        unit: 'ml/h',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_perf,
    },
    {
        '@type': 'text',
        key: '47c655dd-1396-4e95-9cd2-f4f1ab8b7359',
        label: 'Drogues / remplissage',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_drogue,
    },
    {
        '@type': 'tristate',
        key: 'b32e414a-f5ab-4c83-864b-36c03d75c714',
        label: 'Vit k1',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_vit_k1,
    },
    {
        '@type': 'tristate',
        key: '43d31fb7-7beb-475d-85d7-1e42f6588ae0',
        label: 'Collyre',
        value: (bilan) => bilan.transfert_pedia?.conditionnement_smur_collyre,
    },
    {
        '@type': 'select',
        key: '4f42a665-6025-4c57-9e3a-36c2f7c54cd4',
        label: 'Évolution pendant le transport',
        options: [
            { value: 1, label: 'Stabilité' },
            { value: 2, label: 'Amélioration' },
            { value: 3, label: 'Aggravation' },
        ],
        value: (bilan) => bilan.transfert_pedia?.evolution_transport,
    },
    {
        '@type': 'select',
        key: '016e76db-6452-46f5-8a68-efee87c1fea4',
        label: 'Autres',
        options: [
            { value: 1, label: 'Allaitement maternel' },
            { value: 2, label: 'Placenta' },
            { value: 3, label: 'Prélévements' },
            { value: 4, label: 'Dossier' },
        ],
        value: (bilan) => bilan.transfert_pedia?.autre,
    },
];
exports.transportPediaVentilationControlee = [
    {
        '@type': 'integer',
        key: '90c88521-cad6-4f87-ae97-b2093c4d531d',
        label: 'Fq',
        value: (bilan) => bilan.transfert_pedia?.ventil_controlee_fq,
    },
    {
        '@type': 'integer',
        key: '5fd6b274-b944-44e1-ad85-8356938b336d',
        label: 'FIO2',
        value: (bilan) => bilan.transfert_pedia?.ventil_controlee_fio2,
    },
    {
        '@type': 'integer',
        key: '308a2b49-0919-4fcc-b991-e3f16233b7f1',
        label: 'PiMax',
        value: (bilan) => bilan.transfert_pedia?.ventil_controlee_pimax,
    },
    {
        '@type': 'integer',
        key: '76447ba7-01d2-4e44-a5b6-d9992c3bdfb6',
        label: 'I/E',
        value: (bilan) => bilan.transfert_pedia?.ventil_controlee_ie,
    },
    {
        '@type': 'integer',
        key: 'cfed0ab4-1856-48b2-b907-7f78dda80a83',
        label: 'PEP',
        value: (bilan) => bilan.transfert_pedia?.ventil_controlee_pep,
    },
];
exports.transportPediaFlatten = [
    ...exports.transportPediaInitial,
    ...exports.transportPediaConditionnement,
    ...exports.transportPediaPriseEnChargeSmur,
    ...exports.transportPediaConditionnementSmur,
    ...exports.transportPediaVentilationControlee
];
exports.transportPedia = [
    {
        '@type': 'category',
        key: '48dedf94-1676-4635-ae5b-1dca8e294c1c',
        columns: 4,
        className: 'cardGridLarge',
        children: [...exports.transportPediaInitial],
    },
    // Conditionnement par le service d'origine
    {
        '@type': 'category',
        key: '05023637-28e3-4bf8-9bd3-b756888f47d9',
        columns: 4,
        className: 'cardGridLarge',
        subtitle: "Conditionnement par le service d'origine",
        children: [...exports.transportPediaConditionnement],
    },
    // A la prise en charge par le SMUR
    {
        '@type': 'category',
        key: '41a462e0-9f0d-4c2e-931c-b7bf98521841',
        columns: 4,
        className: 'cardGridLarge',
        subtitle: 'À la prise en charge par le SMUR',
        children: [...exports.transportPediaPriseEnChargeSmur],
    },
    // Conditionnement par le SMUR
    {
        '@type': 'category',
        key: '7ebce270-e619-4a3d-98ee-aee9266b8288',
        columns: 4,
        className: 'cardGridLarge',
        subtitle: 'Conditionnement par le SMUR',
        children: [...exports.transportPediaConditionnementSmur],
    },
    // Ventillation controlée
    {
        '@type': 'category',
        key: '7ebce270-e619-4a3d-98ee-aee9266b8288',
        columns: 4,
        className: 'cardGridLarge',
        subtitle: 'Ventillation controlée',
        children: [...exports.transportPediaVentilationControlee],
    },
];
// TODO
exports.surveillances = [
    {
        '@type': 'surveillances',
        key: 'e355f10f-46d4-4230-b050-a691ff4afc9b',
        value: (bilan) => bilan,
    },
];
// TODO
exports.multiparam = [
    {
        '@type': 'multiparam',
        key: '999bd087-9a81-4d72-82ed-aecdfdfa4f1f',
        value: (bilan) => bilan,
    },
];
exports.hemorragie = [
    {
        '@type': 'tristate',
        key: '4a3758e1-d029-4ae0-bd03-d0667428769f',
        label: 'Hémorragie',
        color: 'red',
        value: (bilan) => bilan.circulatoire.hemorragie,
    }
];
exports._85_xabcde = [
    ...exports.hemorragie,
    ...exports.controleHemorragie,
    ...exports.hemorragieControleeHeure,
];
exports._85_xabcdeGeste = [
    ...exports.gestePansementCompressif,
    ...exports.positionAttente
];
exports.xAbcde = [
    ...exports.neurologiqueVital,
    ...exports.obvaVoieAerienne,
    ...exports.hemorragie,
    {
        '@type': 'tristate',
        key: '6186b705-8839-47c3-8fc8-8916dd577a6e',
        label: 'Traumatisme du rachis',
        color: 'red',
        value: (bilan) => bilan.lesionnel.traumatisme_rachis,
    },
    {
        '@type': 'tristate',
        key: '17736b8b-700f-4560-b2f3-2e7254d2a041',
        label: 'Arrêt cardio-respiratoire',
        color: 'red',
        value: (bilan) => bilan.respiration?.arret_cardio_respiratoire,
    },
    {
        '@type': 'tristate',
        key: '304b36f2-19d9-4a33-a0e6-e74152836a58',
        label: 'Respiration agonique',
        color: 'red',
        value: (bilan) => bilan.respiration?.ventilation_agonique,
    },
];
// SCCARR -> Situation
exports.situation = [
    {
        '@type': 'text',
        key: '75d4227b-0cc2-46b0-b33b-687657da8169',
        label: 'Pathologie',
        value: (bilan) => bilan.circonstance.situation_pathologies_str,
    },
    {
        '@type': 'text',
        key: 'd3864330-5711-4b92-9dd5-d9f1852d467e',
        label: 'Situation',
        value: (bilan) => bilan.circonstance.situation,
    },
    {
        '@type': 'tristate',
        key: 'bf10cf10-a12f-4e47-9785-9394663d39d7',
        label: 'SSO',
        color: 'red',
        value: (bilan) => bilan.circonstance.situation_sso,
    },
    {
        '@type': 'tristate',
        key: '4af9493d-7144-4a1f-b5b2-3f090e95448e',
        label: 'AMU',
        color: 'red',
        value: (bilan) => bilan.circonstance.situation_amu,
    },
];
exports.gassppe = [
    {
        '@type': 'multiselect',
        key: '526b3c42-0069-43ad-8add-a1dc32fdfda6',
        label: 'GASSPPE',
        options: [
            { value: 1, label: 'Douleur thoracique non trauma', kind: 'negative' },
            { value: 2, label: 'Détresse respi type OAP', kind: 'negative' },
            { value: 3, label: 'Trauma sévère', kind: 'negative' },
            { value: 4, label: 'Suspi purpura fulminans', kind: 'negative' },
            { value: 5, label: 'Trouble conscience', kind: 'negative' },
        ],
        value: (bilan) => (bilan.lesionnel.gasspee_str?.length === 0 ? bilan.lesionnel.gasspee : null),
    },
    {
        '@type': 'text',
        key: 'ea8f8305-fb36-49cb-b6a5-603f167cb1dd',
        label: 'GASSPPE',
        value: (bilan) => bilan.lesionnel.gasspee_str?.split('@#').join(', '),
    },
];
// SCCARR -> PISU
exports.pisu = [
    {
        '@type': 'text',
        key: '6b75a159-e029-46a4-91a1-2b4c2bd55bd4',
        label: 'PISU',
        value: (bilan) => bilan.geste.pisu?.split('@#').join(', '),
    },
    {
        '@type': 'tristate',
        key: '65fb8b3b-88a9-4a8a-a88f-ce0f1805afc1',
        label: 'Aucun PISU',
        value: (bilan) => utils.boolToChar(bilan.geste.aucun_pisu),
    },
    {
        '@type': 'tristate',
        key: 'e3a04e84-ba30-428d-a888-a426bfb624ae',
        label: 'Aucun GASSPPE',
        value: (bilan) => utils.boolToChar(bilan.geste.aucun_gassppe),
    },
    {
        '@type': 'tristate',
        key: '3f5d8ed2-2917-4383-86bd-3247a9afcda4',
        label: 'Refus thérapeutique',
        value: (bilan) => utils.boolToChar(bilan.geste.refus_therapeutique),
    },
    {
        '@type': 'tristate',
        key: '9fde8ef2-7d2f-4a57-93f7-cba091068c41',
        label: 'Contact MAD',
        value: (bilan) => bilan.geste.contact_mad,
    },
    {
        '@type': 'text',
        key: 'ae166613-f7ea-4256-a14a-2f9daa608411',
        label: 'Consigne MAD',
        value: (bilan) => bilan.geste.consigne_mad,
    },
];
exports.aAbcde = [...exports.obva];
exports.bAbcde = [...exports.respirationReguliereABCDE, ...exports.respiration];
exports.cAbcde = [...exports.circulatoireABCDE, ...exports.circulatoire];
exports._85_cAbcde = [
    ...exports.detresseCirculatoire,
    ...exports.pouls,
    ...exports.paleurs,
    ...exports.sensationDeSoif,
    ...exports.marbrures,
    ...exports.trc
];
exports.dAbcde = [...exports.neurologique];
exports._85_dAbcde = [
    ...exports.neurologiqueVital,
    ...exports.pci,
    ...exports.pciDureeMinSec,
    ...exports.convulsions,
    ...exports.convulsionsDureeSec,
    ...exports.convulsionsInterval,
    ...exports.pupillesBilateral,
    ...exports.agitation,
    ...exports.orientationField,
];
exports.eAbcde = [...exports.expositionLesionnel];
exports._85_eAbcde = [...exports.expositionLesionnel, ...exports.boitesASang];
exports.xAbcdeGeste = [
    ...exports.gestePansementCompressif,
    ...exports.gesteLiberationOBVA,
    ...exports.gesteMaintienTete,
    ...exports.gestePositionArrivee,
];
exports._85_aAbcdeGeste = [
    ...exports.stabilisationRachis,
    ...exports.claquesDos,
    ...exports.lvaSimple,
    ...exports.compressionAbdo,
    ...exports.gesteCollierCervical
];
exports.aAbcdeGeste = [
    ...exports.gesteA,
    ...exports.gesteRetournementCollier,
    ...exports.gesteRetraitCasque,
    ...exports.gesteLiberationOBVA,
    ...exports.gesteGuedel,
];
exports.bAbcdeGeste = [...exports.gestePosition, ...exports.gesteB, ...exports.gesteInsufflation, ...exports.gesteGuedel];
exports.cAbcdeGeste = [
    ...exports.gestePosition,
    ...exports.gestePansementCompressif,
    ...exports.gesteC,
    ...exports.gesteKitProtection,
];
exports.dAbcdeGeste = [...exports.gestePosition, ...exports.gesteD];
exports.eAbcdeGeste = [
    ...exports.gesteE,
    ...exports.gesteKitProtection,
    ...exports.gesteACT,
    ...exports.gesteDegagementUrg,
    ...exports.gesteMaintienTete,
    ...exports.gesteRetournementCollier,
    ...exports.gesteRetraitCasque,
];
exports._85_eAbcdeGeste = [
    ...exports.gesteE,
    ...exports.traitementLesions,
    ...exports.attelleDepression,
    ...exports.gesteRetournementUrgence
];
exports.gesteEffectueSansABCDE = [
    ...exports.gesteSmur,
    ...exports.gesteInsufflation,
    ...exports.gesteGuedel,
    ...exports.gesteMaintienTete,
    ...exports.gestePosition,
    ...exports.gesteRetournementCollier,
    ...exports.gesteDegagementUrg,
    ...exports.gesteRetraitCasque,
    ...exports.gesteKitProtection,
    ...exports.gestePansementCompressif,
    ...exports.gesteLiberationOBVA,
    ...exports.gesteSmur35,
    ...exports.gesteSmur35v2,
    ...exports.gesteAutres,
];
exports.gesteEffectue = [
    ...exports.gesteA,
    ...exports.gesteB,
    ...exports.gesteC,
    ...exports.gesteD,
    ...exports.gesteE,
    ...exports.gesteEffectueSansABCDE,
];
exports.allGeste = [
    ...exports.gesteA,
    ...exports.gesteB,
    ...exports.gesteC,
    ...exports.gesteD,
    ...exports.gesteE,
    ...exports.gesteSmur,
    ...exports.gesteInsufflation,
    ...exports.gesteGuedel,
    ...exports.gesteMaintienTete,
    ...exports.gestePosition,
    ...exports.gesteRetournementCollier,
    ...exports.gesteDegagementUrg,
    ...exports.gesteRetraitCasque,
    ...exports.gesteKitProtection,
    ...exports.gestePansementCompressif,
    ...exports.gesteLiberationOBVA,
    ...exports.gesteSmur35,
    ...exports.gesteSmur35v2_2_Cols,
    ...exports.gesteAutres,
    ...exports.gesteTechnique,
];
/** COMPTE RENDU SMUR 35 */
exports.crsMonitoring = [...exports.gesteScope, ...exports.acrEtco2Max];
exports.crsAbordsVascu = [...exports.gesteVvp, ...exports.gesteIntraOsseuseSelect];
exports.crsPositionTransport = [...exports.gestePosition, ...exports.gesteIntraOsseuseSelect];
exports.crsSondage = [...exports.gesteSondages];
exports.crsVentiOxy = [...exports.gesteSmurOxygenation];
exports.crsVentiPreOxy = [...exports.gesteSmurVni];
exports.crsVentiIntu = [...exports.gesteSmurIntubation];
exports.crsVenti = [...exports.crsVentiOxy, ...exports.crsVentiPreOxy, ...exports.crsVentiIntu];
exports.crsVni = [...exports.gesteSmurVniDetails];
exports.crsRcp = [...exports.gesteSmurMce, ...exports.gestePlancheMasser];
exports.crsImmo = [
    ...exports.gesteCollierCervical,
    ...exports.gesteMatelasDepression,
    ...exports.gesteCeinturePelvienne,
    ...exports.gesteEcharpe,
];
exports.crsDamage = [...exports.gesteDamageControl];
